export const QUESTIONS = [
  {
    "id": 1,
    "question": "What software package allows a Linux server to share folders and printers with Windows and Mac clients?",
    "choice_a": "Postfix",
    "choice_b": "Apache",
    "choice_c": "Samba",
    "choice_d": "Kerberos",
    "correct_answer": "C",
    "explanation": "The Samba software package allows Linux servers and clients to communicate with Windows and Mac clients or servers using the Microsoft SMB protocol, so option C is correct. The Postfix software package provides email service for Linux servers, not Windows services, so option A is incorrect. The Apache package is a web server; it doesn\u2019t allow Linux servers to share folders with Windows and Mac clients, so option B is incorrect. The Kerberos package provides authentication services; it does not allow Linux servers to share folders, so option D is incorrect. The Docker package provides container services for deploying applications on a Linux server; it does not allow the Linux server to share folders with Windows or Mac clients, so option E is incorrect.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      297,
      236,
      283,
      241,
      250
    ],
    "source": "316328_Assessment Test",
    "choice_e": "Docker"
  },
  {
    "id": 2,
    "question": "Which software package allows developers to deploy applications using the exact same environment in which they were developed?",
    "choice_a": "Postfix",
    "choice_b": "Apache",
    "choice_c": "Samba",
    "choice_d": "Kerberos",
    "correct_answer": "E",
    "explanation": "The Docker package provides a method for developers to capture the entire development environment for an application and deploy it into a production environment as a container, so option E is correct. The Postfix package provides email services for a Linux server; it doesn\u2019t deploy applications, so option A is incorrect. The Apache package provides web server services for a Linux server; it doesn\u2019t deploy application environments, so option B is incorrect. The Samba package allows a Linux server to interact in a Windows network with Windows clients and servers; it does not provide an environment for deploying applications, so option C is incorrect. The Kerberos package provides authentication services for Linux servers; it doesn\u2019t deploy applications, so option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      38,
      435,
      204,
      211,
      21
    ],
    "source": "316328_Assessment Test",
    "choice_e": "Docker"
  },
  {
    "id": 3,
    "question": "The <code>cat -n File.txt</code> command is entered at the command line. What will be the result?",
    "choice_a": "The text file <code>File.txt</code> will be displayed.",
    "choice_b": "The text file <code>File.txt</code> will be displayed along with any special hidden characters in the file.",
    "choice_c": "The text file <code>File.txt</code> will be displayed along with any special symbols representing end-of-line characters.",
    "choice_d": "The text file <code>File.txt</code> will be displayed along with line numbers.",
    "correct_answer": "D",
    "explanation": "The <code>cat -n File.txt</code> command will display the <code>File.txt</code> text file along with line numbers. Therefore, option D is correct. The command in option A will simply display the <code>File.tx</code>t file. Thus, option A is a wrong answer. To see any special hidden characters within the <code>File.txt</code> file, you would need to enter the command <code>cat -A File.txt</code>. Therefore, option B is an incorrect choice. End-of-line characters need a different <code>cat</code> command option, such as the <code>-E</code> switch. Therefore, option C is a wrong choice. The <code>cat</code> command does not have a switch that will allow a text file\u2019s contents to be displayed in reverse order. Thus, option E is an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      59,
      57,
      63,
      60,
      58
    ],
    "source": "316328_Assessment Test",
    "choice_e": "The text file <code>File.txt</code> will be displayed in reverse order."
  },
  {
    "id": 4,
    "question": "Which of the following are stream editors? (Choose all that apply.)",
    "choice_a": "<code>vim</code>",
    "choice_b": "<code>sed</code>",
    "choice_c": "<code>awk</code>",
    "choice_d": "<code>gawk</code>",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "The <code>sed</code>, <code>awk</code>, and <code>gawk</code> utilities are all stream editors. Therefore, options B, C, and D are correct. Both <code>vim</code> and <code>nano</code> are considered to be text editors. Therefore, options A and E are incorrect choices.Type: MC-MS.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      70,
      71,
      72,
      67,
      73
    ],
    "source": "316328_Assessment Test",
    "choice_e": "<code>nano</code>"
  },
  {
    "id": 5,
    "question": "Which command in GRUB2 defines the location of the <code>/boot</code> folder to the first partition on the first hard drive on the system?",
    "choice_a": "<code>set root=hd(0,1)</code>",
    "choice_b": "<code>set root=hd(1,0)</code>",
    "choice_c": "<code>set root=hd(1,1)</code>",
    "choice_d": "<code>set root=hd(0,0)</code>",
    "correct_answer": "A",
    "explanation": "GRUB2 identifies the hard drives starting at 0, but the partitions start at 1, so the first partition on the first hard drive would be 0,1 and option A is correct. Option B (1,0) defines the second hard drive and an incorrect partition number, so it is incorrect. Option C defines the first partition but the second hard drive, so it is incorrect. Option D defines the first hard drive but an incorrect partition, so it is incorrect. Option E uses the keyword <code>first</code>, which is not recognized by GRUB2, so it is incorrect.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      80,
      86,
      158,
      160,
      162
    ],
    "source": "316328_Assessment Test",
    "choice_e": "<code>set root=first</code>"
  },
  {
    "id": 6,
    "question": "If you see read or write errors appear in the system log, what tool should you use to correct any bad sections of the hard drive?",
    "choice_a": "<code>mount</code>",
    "choice_b": "<code>unmount</code>",
    "choice_c": "<code>fsck</code>",
    "choice_d": "<code>dmesg</code>",
    "correct_answer": "C",
    "explanation": "The <code>fsck</code> program can perform a filesystem check and repair multiple types of filesystems on partitions, so option C is correct. The <code>mount</code> program is used to append a partition to a virtual directory; it can\u2019t correct a partition that contains errors, so option A is incorrect. The <code>unmount</code> command removes a partition from the virtual directory, so option B is incorrect. Option D (the <code>dmesg</code> command) displays boot messages, and option E (the <code>mkinitrd</code> command) creates an initrd RAM disk, so both are incorrect.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      85,
      167,
      164,
      162,
      166
    ],
    "source": "316328_Assessment Test",
    "choice_e": "<code>mkinitrd</code>"
  },
  {
    "id": 7,
    "question": "The <code>init</code> program is started on a Linux system and has a process ID number. What typically is that process\u2019s ID number?",
    "choice_a": "0",
    "choice_b": "1",
    "choice_c": "2",
    "choice_d": "10",
    "correct_answer": "B",
    "explanation": "The <code>init</code> program is typically started immediately after the Linux system has traversed the boot process, and it has a process ID (PID) number of 1. Therefore, option B is the correct answer. The Linux kernel has the 0 PID number, and thus, option A is a wrong answer. Options C, D, and E are also incorrect choices.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      87,
      321,
      322,
      323,
      88
    ],
    "source": "316328_Assessment Test",
    "choice_e": "Unknown"
  },
  {
    "id": 8,
    "question": "You need to determine the default target of a systemd system. Which of the following commands should you use?",
    "choice_a": "<code>grep initdefault /etc/inittab</code>",
    "choice_b": "<code>runlevel</code>",
    "choice_c": "<code>systemctl is-enabled</code>",
    "choice_d": "<code>systemd get-target</code>",
    "correct_answer": "E",
    "explanation": "The <code>systemctl get-default</code> command will display a systemd system\u2019s default target. Therefore, option E is the correct answer. The <code>grep initdefault /etc/inittab</code> command will extract the default runlevel for a SysV init system. Thus, option A is a wrong answer. The <code>runlevel</code> command will display a SysV init system\u2019s previous and current runlevel. Therefore, option B is an incorrect answer. The <code>systemctl is-enabled</code> command shows whether or not a particular service, whose name is passed as a command argument, is configured to start at system boot. Thus, option C is a wrong choice. Option D is a made-up command and therefore the wrong answer.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      88,
      91,
      87,
      97,
      101
    ],
    "source": "316328_Assessment Test",
    "choice_e": "<code>systemctl get-default</code>"
  },
  {
    "id": 9,
    "question": "Your X11 session has become hung. What keystrokes do you use to restart the session?",
    "choice_a": "Ctrl+C",
    "choice_b": "Ctrl+Z",
    "choice_c": "Ctrl+Q",
    "choice_d": "Ctrl+Alt+Delete",
    "correct_answer": "E",
    "explanation": "The Ctrl+Alt+Backspace will kill your X11 session and then restart it, putting you at the login screen (display manager.) Therefore, option E is the correct answer. The Ctrl+C combination sends an interrupt signal but does not restart an X11 session. Thus, option A is a wrong answer. The Ctrl+Z keystroke combination sends a stop signal, but it will not restart the X11 session. Therefore, option B is also an incorrect answer. The Ctrl+Q combination will release a terminal that has been paused by Ctrl+S. However, it does not restart an X11 session, so it too is a wrong choice. The Ctrl+Alt+Delete keystroke combination can be set to do a number of tasks, depending on your desktop environment. In some cases, it brings up a shutdown, logout, or reboot menu. However, it does not restart the X11 session, so option D is an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      121,
      348,
      115,
      120,
      16
    ],
    "source": "316328_Assessment Test",
    "choice_e": "Ctrl+Alt+Backspace"
  },
  {
    "id": 10,
    "question": "What folder contains the time zone template files in Linux?",
    "choice_a": "/<code>etc/timezone</code>",
    "choice_b": "/<code>etc/localtime</code>",
    "choice_c": "/<code>usr/share/zoneinfo</code>",
    "choice_d": "/<code>usr/share/timezone</code>",
    "correct_answer": "C",
    "explanation": "Both Debian-based and Red Hat\u2013based Linux distributions store the time zone template files in the <code>/usr/share/zoneinfo</code> folder, so option C is correct. The <code>/etc/timezone</code> and <code>/etc/localtime</code> files contain the current time zone file for Debian- and Red Hat\u2013based systems, not the time zone template files, so options A and B are incorrect. The <code>/usr/share/timezone</code> and <code>/usr/share/localtime</code> folders don\u2019t exist in either Debian-based or Red Hat\u2013based Linux distributions, so options D and E are also incorrect.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      11,
      12,
      13,
      162,
      342
    ],
    "source": "316328_Assessment Test",
    "choice_e": "/<code>usr/share/localtime</code>"
  },
  {
    "id": 11,
    "question": "What <code>systemd</code> command allows you to view and change the time, date, and time zone?",
    "choice_a": "<code>timedatectl</code>",
    "choice_b": "<code>localectl</code>",
    "choice_c": "<code>date</code>",
    "choice_d": "<code>time</code>",
    "correct_answer": "A",
    "explanation": "The <code>timedatectl</code> program is part of the systemd package and allows you to both view and change the current time, date, and time zone for the Linux system, so option A is correct. The <code>localectl</code> program is also part of the systemd package, but it handles localization information and not time and date information, so option B is incorrect. The <code>date</code> command allows you to view and change the time and date but not the time zone setting, so option C is incorrect. The <code>time</code> command displays the elapsed CPU time used by an application, not the current time, date, and time zone, so option D is incorrect. The <code>locale</code> command allows you to view the localization settings for the Linux system, not the time, date, or time zone, so option E is also incorrect.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      134,
      133,
      132,
      87,
      88
    ],
    "source": "316328_Assessment Test",
    "choice_e": "<code>locale</code>"
  },
  {
    "id": 12,
    "question": "Which of the following files contain user account creation directives used by the <code>useradd</code> command? (Choose all that apply.)",
    "choice_a": "The <code>/etc/default/useradd</code> file",
    "choice_b": "The <code>/etc/useradd</code> file",
    "choice_c": "The <code>/etc/adduser.conf</code> file",
    "choice_d": "The <code>/etc/login.defs</code> file",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "The <code>/etc/default/useradd</code> file and <code>/etc/login.defs</code> file are files that contain user account creation directives used by the <code>useradd</code> command. Therefore, options A and D are the correct answers. Option B\u2019s <code>/etc/useradd</code> file is a made-up file name, and thus option B is a wrong choice. The <code>/etc/adduser.conf</code> file is only on Linux distributions that use the <code>adduser</code> utility to create accounts. Thus, option C is an incorrect answer. The <code>/etc/login.def</code> file is a made-up filename, and thus option E is also an incorrect choice.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      138,
      140,
      137,
      144,
      139
    ],
    "source": "316328_Assessment Test",
    "choice_e": "The <code>/etc/login.def</code> file"
  },
  {
    "id": 13,
    "question": "You need to display the various quotas on all your filesystems employing quota limits. Which of the following commands should you use?",
    "choice_a": "<code>edquota -t</code>",
    "choice_b": "<code>quotaon -a</code>",
    "choice_c": "<code>quotacheck -cu</code>",
    "choice_d": "<code>quotacheck -cg</code>",
    "correct_answer": "E",
    "explanation": "The <code>repquota -a</code> command will display the various quotas on all your filesystems employing quota limits. Therefore, option E is the correct answer. The <code>edquota -t</code> command will edit quota grace periods for the system. Therefore, option A is a wrong answer. The <code>quotaon -a</code> command will automatically turn on quotas for all mounted non-NFS filesystems in the <code>/etc/fstab</code> file, but it does not display filesystems\u2019 quotas. Thus, option B is an incorrect choice. The <code>quotacheck</code> utility creates either the <code>aquota.group</code> file, if the <code>-cg</code> options are used, or the <code>aquota.user</code> file, if the <code>-cu</code> switches are used, or both files if <code>-cug</code> is employed. However, it does nothing for displaying filesystems\u2019 quotas. Thus, options C and D are incorrect answers.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      167,
      164,
      166,
      191,
      15
    ],
    "source": "316328_Assessment Test",
    "choice_e": "<code>repquota -a</code>"
  },
  {
    "id": 14,
    "question": "What drive and partition does the raw device file <code>/dev/sdb1</code> reference?",
    "choice_a": "The first partition on the second SCSI storage device",
    "choice_b": "The second partition on the first SCSI storage device",
    "choice_c": "The first partition on the second PATA storage device",
    "choice_d": "The second partition on the first PATA storage device",
    "correct_answer": "A",
    "explanation": "Option A is the correct answer because Linux uses the <code>/dev/sd <i>xx</i></code> format for SCSI and SATA raw devices. The device is represented by a letter, starting with a, and the partition is represented by a number, starting at 1. So <code>/dev/sdb1</code> references the first partition on the second SCSI or SATA device. Option B would be referenced by the <code>/dev/sda2</code> file, so it is incorrect. Option C would be referenced by the <code>/dev/hdb1</code> file, so it is incorrect. Option D would be referenced by <code>/dev/hda2</code>, so option D is incorrect, and option E would be referenced by <code>/dev/sdb2</code>, so it is incorrect.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      139,
      146,
      147,
      327,
      322
    ],
    "source": "316328_Assessment Test",
    "choice_e": "The second partition on the second SATA storage device"
  },
  {
    "id": 15,
    "question": "What tool creates a logical volume from multiple physical partitions?",
    "choice_a": "<code>mkfs</code>",
    "choice_b": "<code>pvcreate</code>",
    "choice_c": "<code>lvcreate</code>",
    "choice_d": "<code>fdisk</code>",
    "correct_answer": "C",
    "explanation": "The <code>lvcreate</code> program creates a logical volume from multiple partitions that you can use as a single logical device to build a file system and mount it to the virtual directory, so option C is correct. The <code>mkfs</code> program creates a filesystem on a partition, but doesn\u2019t create a logical volume, so option A is incorrect. The <code>pvcreate</code> program identifies a physical volume from a partition but doesn\u2019t create the logical volume, so option B is incorrect. The <code>fdisk</code> program creates and modifies physical partitions, not logical volumes, so option D is incorrect. The <code>vgcreate</code> program creates a volume group for grouping physical partitions, but doesn\u2019t create the logical volume, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      171,
      166,
      167,
      158,
      161
    ],
    "source": "316328_Assessment Test",
    "choice_e": "<code>vgcreate</code>"
  },
  {
    "id": 16,
    "question": "Which of the following can be used as backup utilities? (Choose all that apply.)",
    "choice_a": "The <code>gzip</code> utility",
    "choice_b": "The <code>zip</code> utility",
    "choice_c": "The <code>tar</code> utility",
    "choice_d": "The <code>rsync</code> utility",
    "correct_answer": [
      "B",
      "C",
      "D",
      "E"
    ],
    "explanation": "The <code>zip</code>, <code>tar</code>, <code>rsync</code>, and <code>dd</code> utilities all can be used to create data backups. Therefore, options B, C, D, and E are correct answers. The <code>gzip</code> utility can be used after a backup is created or employed through <code>tar</code> options to compress a backup, so option A is the only wrong choice.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      191,
      188,
      186,
      198,
      184
    ],
    "source": "316328_Assessment Test",
    "choice_e": "The <code>dd</code> utility"
  },
  {
    "id": 17,
    "question": "A system administrator has created a backup archive and transferred the file to another system across the network. Which utilities can be used to check the archive files integrity? (Choose all that apply.)",
    "choice_a": "The <code>rsync</code> utility",
    "choice_b": "The <code>md5sum</code> utility",
    "choice_c": "The <code>sftp</code> utility",
    "choice_d": "The <code>scp</code> utility",
    "correct_answer": [
      "B",
      "E"
    ],
    "explanation": "Both the <code>md5sum</code> and <code>sha512sum</code> utilities produce hashes on files, which can be compared to determine if file corruption occurred, such as when transferring a file over the network. Therefore, options B and E are the correct answers. The utilities mentioned in options A, C, and D will allow you to securely transfer files but not check a file\u2019s integrity. Therefore, options A, C, and D are incorrect choices.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      244,
      252,
      250,
      251,
      287
    ],
    "source": "316328_Assessment Test",
    "choice_e": "The <code>sha512sum</code> utility"
  },
  {
    "id": 18,
    "question": "What tool should you use to install a <code>.deb</code> package file?",
    "choice_a": "<code>dpkg</code>",
    "choice_b": "<code>tar</code>",
    "choice_c": "<code>gcc</code>",
    "choice_d": "<code>rpm</code>",
    "correct_answer": "A",
    "explanation": "The <code>dpkg</code> program is used for installing and removing Debian-based packages that use the <code>.deb</code> file format, so option A is correct. The <code>tar</code> program is used for creating and extracting tape archive formatted files that use the <code>.tar</code> file extension, so option B is incorrect. The <code>gcc</code> program is used for compiling source code into executable programs, so option C is incorrect. The <code>rpm</code> program is used for installing and removing Red Hat\u2013based packages that use the <code>.rpm</code> file format, so option D is incorrect. The <code>gzip</code> program compresses files and adds the <code>.gz</code> file extension to them, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      205,
      206,
      211,
      204,
      201
    ],
    "source": "316328_Assessment Test",
    "choice_e": "<code>gzip</code>"
  },
  {
    "id": 19,
    "question": "What tool do you use to install an <code>.rpm</code> package file?",
    "choice_a": "<code>dpkg</code>",
    "choice_b": "<code>tar</code>",
    "choice_c": "<code>gcc</code>",
    "choice_d": "<code>rpm</code>",
    "correct_answer": "D",
    "explanation": "The <code>rpm</code> program is used for installing and removing Red Hat\u2013based packages that use the <code>.rpm</code> file format, so option D is correct. The <code>dpkg</code> program is used for installing and removing Debian-based packages that use the <code>.deb</code> file format, so option A is incorrect. The <code>tar</code> program is used for creating and extracting tape archive formatted files that use the <code>.tar</code> file extension, so option B is incorrect. The <code>gcc</code> program is used for compiling source code into executable programs, so option C is incorrect. The <code>gzip</code> program compresses files and adds the <code>.gz</code> file extension to them, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      206,
      211,
      205,
      204,
      201
    ],
    "source": "316328_Assessment Test",
    "choice_e": "<code>gzip</code>"
  },
  {
    "id": 20,
    "question": "The <code>lsmod</code> utility provides the same information as what other utility or file(s)?",
    "choice_a": "The <code>modinfo</code> utility",
    "choice_b": "The <code>/proc/modules</code> file",
    "choice_c": "The <code>/etc/modules.conf</code> file",
    "choice_d": "The <code>insmod</code> utility",
    "correct_answer": "B",
    "explanation": "The <code>/proc/modules</code> file has the same information that is displayed by the <code>lsmod</code> utility (though the <code>lsmod</code> utility formats it much nicer). Therefore, option B is the correct answer. The <code>modinfo</code> utility provides detailed module data, while <code>lsmod</code> only shows brief information. Thus, option A is a wrong answer. The <code>/etc/modules.conf</code> file is a kernel module configuration file, and it does not provide the same information as the <code>lsmod</code> utility. Therefore, option C is also an incorrect answer. The <code>insmod</code> command is used to dynamically load kernel modules, and thus it is a wrong answer. The <code>/run/modprobe.d/*.conf</code> files are kernel module configuration files, and they do not provide the same information as the <code>lsmod</code> utility. Therefore, option E is also an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      218,
      216,
      212,
      213,
      215
    ],
    "source": "316328_Assessment Test",
    "choice_e": "The <code>/run/modprobe.d/*.conf</code> files"
  },
  {
    "id": 21,
    "question": "Which utility should be used to remove a module along with any dependent modules?",
    "choice_a": "The <code>rmmod</code> utility",
    "choice_b": "The <code>modinfo</code> utility",
    "choice_c": "The <code>cut</code> utility",
    "choice_d": "The <code>depmod</code> utility",
    "correct_answer": "E",
    "explanation": "The <code>modprobe</code> utility along with its <code>-r</code> switch is the utility to employ for removing (unloading) a kernel module along with any of its dependencies. Therefore, option E is the correct answer. The <code>rmmod</code> utility will remove a kernel module but not any of its dependencies. Thus, option A is a wrong answer. The <code>modinfo</code> command does not unload kernel modules but instead displays detailed information concerning a specified module. Therefore, option B is an incorrect choice. The <code>cut</code> utility is used to filter text files and display the filtered text to STDOUT. It is not involved in kernel module removal, and thus option C is a wrong choice. The <code>depmod</code> utility is used to create a list of modules and their dependencies. But it is not used to remove modules. Therefore, option D is an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      218,
      216,
      213,
      212,
      215
    ],
    "source": "316328_Assessment Test",
    "choice_e": "The <code>modprobe</code> utility"
  },
  {
    "id": 22,
    "question": "What special bit should you set to prevent users from deleting shared files created by someone else?",
    "choice_a": "SUID",
    "choice_b": "GUID",
    "choice_c": "Sticky bit",
    "choice_d": "Read",
    "correct_answer": "C",
    "explanation": "The sticky bit assigned to a directory restricts all of the files in that directory so that only the file owner can delete the file, even if a user account is in the group that has write permissions, so option C is correct. The SUID bit allows a standard user to run an application with the file owner permissions but doesn\u2019t block users from deleting shared files, so option A is incorrect. The GUID bit is used on a directory to ensure that all files created in the directory have the same group as the directory, but it doesn\u2019t prevent users in that group from deleting files, so option B is incorrect. The Read and Write standard permission bits control access to read to a file or write to a file, but they don\u2019t block users from deleting a file, so options D and E are both incorrect.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      335,
      334,
      336,
      338,
      43
    ],
    "source": "316328_Assessment Test",
    "choice_e": "Write"
  },
  {
    "id": 23,
    "question": "What command can you use to change the owner assigned to a file?",
    "choice_a": "<code>chmod</code>",
    "choice_b": "<code>chown</code>",
    "choice_c": "<code>chage</code>",
    "choice_d": "<code>ulimit</code>",
    "correct_answer": "B",
    "explanation": "The <code>chown</code> command allows you to set both the owner and group assigned to a file, so option B is correct. The <code>chmod</code> command allows you to change the permissions for the file, but not the owner of the file, so option A is incorrect. The <code>chage</code> command manages password aging for user accounts, not owners of files, so option C is incorrect. The <code>ulimit</code> command allows the administrator to restrict system resources assigned to users but doesn\u2019t assign users to files, so option D is incorrect. The <code>chgrp</code> command allows you to change the group assigned to a file but not the owner, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      53,
      334,
      50,
      148,
      147
    ],
    "source": "316328_Assessment Test",
    "choice_e": "<code>chgrp</code>"
  },
  {
    "id": 24,
    "question": "Which directory contains the various PAM configuration files?",
    "choice_a": "The <code>/etc/pam/</code> directory",
    "choice_b": "The <code>/etc/pam_modules/</code> directory",
    "choice_c": "The <code>/etc/modules/</code> directory",
    "choice_d": "The <code>/etc/pam.d/</code> directory",
    "correct_answer": "D",
    "explanation": "The <code>/etc/pam.d/</code> directory contains the various PAM configuration files. Therefore, option D is the correct answer. The other directory names are made up. Thus, options A, B, C, and E are incorrect answers.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      238,
      237,
      239,
      240,
      241
    ],
    "source": "316328_Assessment Test",
    "choice_e": "The <code>/etc/pam_modules.d/</code> directory"
  },
  {
    "id": 25,
    "question": "Which of the following can override the settings in the <code>~/.ssh/config</code> file?",
    "choice_a": "The settings in the <code>/etc/ssh/ssh_config</code> file.",
    "choice_b": "The <code>ssh</code> utility\u2019s command-line options.",
    "choice_c": "You cannot override the settings in this file.",
    "choice_d": "The settings in the <code>/etc/ssh/sshd_config</code> file.",
    "correct_answer": "B",
    "explanation": "The settings within the <code>~/.ssh/config</code> file can be overridden by various <code>ssh</code> utility options provided at the command line. Therefore, option B is the correct answer. The settings in the <code>/etc/ssh/ssh_config</code> file can be overridden by both the settings in the <code>~/.ssh/config</code> file and the <code>ssh</code> utility\u2019s command-line options, so option A is a wrong answer. The <code>/etc/ssh/sshd_config</code> file is the <code>sshd</code> daemon\u2019s configuration file, and it deals with providing the SSH services, not in setting the configuration for the SSH client. Therefore, both options D and E are incorrect choices.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      251,
      249,
      253,
      252,
      254
    ],
    "source": "316328_Assessment Test",
    "choice_e": "The settings in the <code>sshd</code> daemon\u2019s configuration file."
  },
  {
    "id": 26,
    "question": "What command can you use to display new entries in a log file in real time as they occur?",
    "choice_a": "<code>head</code>",
    "choice_b": "<code>tail</code>",
    "choice_c": "<code>tail -f</code>",
    "choice_d": "<code>head -f</code>",
    "correct_answer": "C",
    "explanation": "The <code>-f</code> option of the <code>tail</code> command displays new additions to a file in real time, so option C is correct. The <code>head</code> and <code>tail</code> commands by themselves just list the existing entries in a file, so options A and B are incorrect. The <code>head</code> command doesn\u2019t support the <code>-f</code> option, so option D is incorrect. The <code>vi</code> editor also only displays existing data in a file and not newly added data, so option E is incorrect.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      266,
      259,
      262,
      258,
      260
    ],
    "source": "316328_Assessment Test",
    "choice_e": "<code>vi</code>"
  },
  {
    "id": 27,
    "question": "What command do you use to display entries in the <code>systemd-journald</code> journal?",
    "choice_a": "<code>journalctl</code>",
    "choice_b": "<code>syslogd</code>",
    "choice_c": "<code>klogd</code>",
    "choice_d": "<code>systemd-journald</code>",
    "correct_answer": "A",
    "explanation": "The <code>systemd-journald</code> application uses its own binary file format for the journal file and requires the <code>journalctl</code> file to read it, so option A is correct. The <code>syslogd</code> and <code>klogd</code> applications are syslog loggers and not able to read the <code>systemd-journald</code> journal file, so options B and C are incorrect. The <code>systemd-journald</code> application itself only adds event messages to the journal and doesn\u2019t read it, so option D is incorrect. Since the journal file is in binary format, you can\u2019t read it using standard text editor programs, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      90,
      49,
      47,
      152,
      321
    ],
    "source": "316328_Assessment Test",
    "choice_e": "<code>vi</code>"
  },
  {
    "id": 28,
    "question": "The <code>/etc/services</code> file may be used by firewalls for what purpose?",
    "choice_a": "To designate what remote services to block",
    "choice_b": "To store their ACL rules",
    "choice_c": "To map a service name to a port and protocol",
    "choice_d": "To determine if the port can be accessed",
    "correct_answer": "C",
    "explanation": "The <code>/etc/services</code> file may be used by a firewall, such as UFW, to map a particular service name to its port and protocol. Thus, option C is the correct answer. The file is not used to designate remote services to block or store a firewall\u2019s ACL rules. Therefore, options A and B are wrong answers. The Linux firewall applications do not use the <code>/etc/services</code> file to determine if a port can be accessed or what local services can send out packets. Thus, options D and E are incorrect choices.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      369,
      272,
      273,
      270,
      298
    ],
    "source": "316328_Assessment Test",
    "choice_e": "To designate what local services can send out packets"
  },
  {
    "id": 29,
    "question": "Which of the following is true about netfilter? (Choose all that apply.)",
    "choice_a": "It is used by <code>firewalld</code>.",
    "choice_b": "It is used by UFW.",
    "choice_c": "It provides code hooks into the Linux kernel for firewall technologies to use.",
    "choice_d": "It is used by <code>iptables</code>.",
    "correct_answer": [
      "A",
      "B",
      "C",
      "D"
    ],
    "explanation": "Used by <code>firewalld</code>, UFW, and <code>iptables</code>, netfilter provides code hooks into the Linux kernel for firewall technologies to use in order to implement fully functional firewall capabilities. Therefore, options A, B, C, and D are all correct answers. Unfortunately, netfilter cannot provide firewall services on its own. Thus, option E is the only incorrect choice.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      270,
      271,
      273,
      276,
      275
    ],
    "source": "316328_Assessment Test",
    "choice_e": "It provides firewall services without the need for other applications."
  },
  {
    "id": 30,
    "question": "Which of the following is a measurement of the maximum amount of data that can be transferred over a particular network segment?",
    "choice_a": "Bandwidth",
    "choice_b": "Throughput",
    "choice_c": "Saturation",
    "choice_d": "Latency",
    "correct_answer": "A",
    "explanation": "Bandwidth is a measurement of the maximum data amount that can be transferred between two network points over a period of time. Therefore, option A is the correct answer. Throughput is a measurement of the actual data amount that is transferred between two network points, and thus option B is a wrong answer. Saturation occurs when network traffic exceeds capacity, but it is not a measurement. Thus, option C is an incorrect answer. Latency is the time between a source sending a packet and the packet\u2019s destination receiving it. Therefore, option D is a wrong choice. Routing is the process of forwarding IP packets to the appropriate destination. Thus, option E is also an incorrect answer.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      301,
      305,
      113,
      308,
      304
    ],
    "source": "316328_Assessment Test",
    "choice_e": "Routing"
  },
  {
    "id": 31,
    "question": "Which tool will allow you to view disk I/O specific to swapping?",
    "choice_a": "<code>ipcs -m</code>",
    "choice_b": "<code>cat /proc/meminfo</code>",
    "choice_c": "<code>free</code>",
    "choice_d": "<code>swapon -s</code>",
    "correct_answer": "E",
    "explanation": "The <code>vmstat</code> utility provides a lot of memory statistics, including disk I/O specific to swapping. Therefore, option E is the correct answer. The <code>ipcs -m</code> command allows you to see shared memory segments instead of disk I/O specific to swapping. Thus, option A is the wrong answer. The <code>cat /proc/meminfo</code> command displays detailed information concerning a system\u2019s RAM. Therefore, option B is an incorrect answer. The <code>free</code> command shows memory items such as free memory, used memory, and buffer/cache usage. Thus, option C is a wrong choice. The <code>swapon -s</code> command displays swap space elements such as type, name, and priority. Therefore, option D is also an incorrect choice.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      318,
      317,
      316,
      319,
      312
    ],
    "source": "316328_Assessment Test",
    "choice_e": "<code>vmstat</code>"
  },
  {
    "id": 32,
    "question": "What command-line command allows you to view the applications currently running on the Linux system?",
    "choice_a": "<code>lsof</code>",
    "choice_b": "<code>kill</code>",
    "choice_c": "<code>ps</code>",
    "choice_d": "<code>w</code>",
    "correct_answer": "C",
    "explanation": "The <code>ps</code> command with the proper options displays the active applications running on the Linux system, so option C is correct. The <code>lsof</code> command displays the files currently open by applications but not all of the running applications, so option A is incorrect. The <code>kill</code> command stops a running application based on its process ID; it doesn\u2019t display all of the running applications, so option B is incorrect. The <code>w</code> command displays all of the current users on the system but not all of the running applications, so option D is incorrect. The <code>nice</code> command allows you to start a new application with a specified priority level, but it doesn\u2019t allow you to display the currently running applications, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      321,
      323,
      322,
      326,
      325
    ],
    "source": "316328_Assessment Test",
    "choice_e": "<code>nice</code>"
  },
  {
    "id": 33,
    "question": "What command-line commands allow you to send process signals to running applications? (Choose two.)",
    "choice_a": "<code>renice</code>",
    "choice_b": "<code>pkill</code>",
    "choice_c": "<code>nice</code>",
    "choice_d": "<code>kill</code>",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "The <code>pkill</code> and <code>kill</code> commands allow you to send Linux process signals to running applications, so options B and D are correct. The <code>renice</code> command allows you to change the priority level of a running application but not send process signals to it, so option A is incorrect. The <code>nice</code> command allows you to start an application with a specified priority level but not send process signals to applications that are already running, so option C is incorrect. The <code>pgrep</code> command allows you to display running applications, but it doesn\u2019t send process signals to them, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      327,
      326,
      406,
      325,
      415
    ],
    "source": "316328_Assessment Test",
    "choice_e": "<code>pgrep</code>"
  },
  {
    "id": 34,
    "question": "Annika puts the file line <code>PS1=\"My Prompt: \"</code> into her account\u2019s <code>$HOME/.bash_profile</code> file. This setting changes her prompt the next time she logs into the system. However, when she starts a subshell, it is not working properly. What does Annika need to do to fix this issue?",
    "choice_a": "Add the file line to the <code>$HOME/.profile</code> file instead.",
    "choice_b": "Nothing. A user\u2019s prompt cannot be changed in a subshell.",
    "choice_c": "Add <code>export</code> prior to <code>PS1</code> on the same line in the file.",
    "choice_d": "Change her default shell to <code>/bin/dash</code> for this to work.",
    "correct_answer": "C",
    "explanation": "The problem is directly related to a missing <code>export</code> command prior to the <code>PS1=\"My Prompt: \"</code> in Annika\u2019s environment file. When this environment variable is exported and when it is set, it will be set in any started subshells. Thus, option C is the correct answer. Since Annika\u2019s environment file exists, the <code>$HOME/.profile</code> file is not used. Thus, option A is a wrong answer. A user prompt can be changed in a subshell, so option B is also an incorrect answer. Changing Annika\u2019s default shell will not fix this issue, so option D is a wrong choice. If Annika changes the last field in her password record to <code>/sbin/false</code>, she will no longer be able to log into the system using her account. Therefore, option E is an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      80,
      438,
      86,
      16,
      115
    ],
    "source": "316328_Assessment Test",
    "choice_e": "Change the last field in her password record to <code>/sbin/false</code>."
  },
  {
    "id": 35,
    "question": "A user, who is not the owner or a group member of a particular directory, attempts to use the <code>ls</code> command on the directory and gets a permission error. What does this mean?",
    "choice_a": "The directory does not have display (<code>d</code>) set for other permissions.",
    "choice_b": "The directory does not have execute (<code>x</code>) set for other permissions.",
    "choice_c": "The directory does not have write (<code>w</code>) set for other permissions.",
    "choice_d": "The directory does not have list (<code>l</code>) set for other permissions.",
    "correct_answer": "E",
    "explanation": "In order for a user to list files in a directory, the directory needs to have read (<code>r</code>) set for other permissions if the user is not the directory\u2019s owner or does not belong to the directory\u2019s set group. Therefore, option E is the correct answer. There is no display (<code>d</code>) permission setting, so option A is a wrong answer. The execute (<code>x</code>) permission allows a user to change their present working directory to that directory as long as all the parent directories also have that permission set. Thus, option B is a wrong choice. The write (<code>w</code>) permission allows a user to create files within that directory, so option C is an incorrect answer. There is no list (<code>l</code>) permission setting, so option D is also an incorrect choice.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      335,
      334,
      39,
      53,
      336
    ],
    "source": "316328_Assessment Test",
    "choice_e": "The directory does not have read (<code>r</code>) set for other permissions."
  },
  {
    "id": 36,
    "question": "Which directories contain dynamic files that display kernel and system information? (Choose two.)",
    "choice_a": "<code>/dev</code>",
    "choice_b": "<code>/proc</code>",
    "choice_c": "<code>/etc</code>",
    "choice_d": "<code>/sys</code>",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "The Linux kernel uses the <code>/proc</code> and <code>/sys</code> directories to produce dynamic files that contain information about the kernel and system, so options B and D are correct. The <code>/dev</code> folder contains files for communicating with devices, not kernel and system information, so option A is incorrect. The <code>/etc</code> directory contains application configuration files, not files created by the kernel for displaying kernel and system information, so option C is incorrect. The <code>/dev/mapper</code> directory is used for virtual files mapped to physical device files for LVM and LUKS, not kernel information, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      342,
      162,
      346,
      75,
      1
    ],
    "source": "316328_Assessment Test",
    "choice_e": "<code>/dev/mapper</code>"
  },
  {
    "id": 37,
    "question": "What directory contains configuration information for the X Windows System in Linux?",
    "choice_a": "<code>/dev</code>",
    "choice_b": "<code>/proc</code>",
    "choice_c": "<code>/etc/X11</code>",
    "choice_d": "<code>/sys</code>",
    "correct_answer": "C",
    "explanation": "The <code>/etc/X11</code> directory contains configuration files used by both the X.org and XFree86 applications for controlling the X Windows graphical environment on the Linux system, so option C is correct. The <code>/dev</code> directory contains device files used to send and receive data from devices, not the X Windows configuration files, so option A is incorrect. The kernel uses the <code>/proc</code> and <code>/sys</code> directories to create dynamic files that show kernel and system information, not contain X Windows configuration files, so options B and D are incorrect. The <code>/proc/interrupts</code> file contains information about hardware interrupts currently used by hardware devices on the system, not X Windows configuration files, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      121,
      348,
      342,
      162,
      80
    ],
    "source": "316328_Assessment Test",
    "choice_e": "<code>/proc/interrupts</code>"
  },
  {
    "id": 38,
    "question": "How would you fix a \u201cmount point does not exist\u201d problem?",
    "choice_a": "Employ the <code>fsck</code> utility to fix the bad disk sector.",
    "choice_b": "Employ the <code>badblocks</code> utility to fix the bad disk sector.",
    "choice_c": "Use super user privileges, if needed, and create the directory via the <code>vgchange</code> command.",
    "choice_d": "Use super user privileges, if needed, and create the directory via the <code>mkdir</code> command.",
    "correct_answer": "D",
    "explanation": "This problem concerns a missing directory. Therefore, to fix it, use super user privileges, if needed, and create the directory via the <code>mkdir</code> command. Thus, option D is the correct answer. The problem does not concern a bad disk sector (and you cannot fix bad disk sectors with the <code>badblocks</code> utility), so options A and B are wrong answers. You would employ the <code>vgchange</code> command for a missing volume in a logical volume but not a missing directory. Therefore, option C is an incorrect answer. While the <code>mountpoint</code> command does allow you to see if a particular directory is a mount point, it does not allow you to create a missing directory. Thus, option E is an incorrect choice as well.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      40,
      41,
      43,
      103,
      39
    ],
    "source": "316328_Assessment Test",
    "choice_e": "Use super user privileges, if needed, and create the directory via the <code>mountpoint</code> command."
  },
  {
    "id": 39,
    "question": "Peter is trying to complete his network application, Spider, but is running into a problem with accessing a remote server\u2019s files and there are no network problems occurring at this time. He thinks it has something to do with the remote server\u2019s ACLs being too restrictive. You need to investigate this issue. Which of the following might you use for troubleshooting this problem? (Choose all that apply.)",
    "choice_a": "The <code>firewall-cmd</code> command",
    "choice_b": "The <code>ufw</code> command",
    "choice_c": "The <code>iptables</code> command",
    "choice_d": "The <code>getacl</code> command",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "Since the problem involves a remote server, you need to investigate the firewall access control lists (ACLs) on both the local and remote systems. Therefore, depending upon their firewall employed, you may use the <code>firewall-cmd</code>, <code>ufw</code>, or <code>iptables</code> command in the troubleshooting process. Thus, options A, B, and C are the correct answers. The <code>getacl</code> and <code>setacl</code> commands deal with file inheritance issues, and therefore options D and E are incorrect choices.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      267,
      273,
      278,
      223,
      296
    ],
    "source": "316328_Assessment Test",
    "choice_e": "The <code>setacl</code> command"
  },
  {
    "id": 40,
    "question": "Which Bash shell script command allows you to iterate through a series of data until the data is complete?",
    "choice_a": "<code>if</code>",
    "choice_b": "<code>case</code>",
    "choice_c": "<code>for</code>",
    "choice_d": "<code>exit</code>",
    "correct_answer": "C",
    "explanation": "The <code>for</code> command allows you to iterate through a series of data one by one until the data set is exhausted, so option C is correct. The <code>if</code> and <code>case</code> statements perform a single test on an object to determine if a block of commands should be run; they don\u2019t iterate through data, so options A and B are incorrect. The <code>exit</code> command stops the shell script and exits to the parent shell, so option D is incorrect. The <code>$()</code> command redirects the output of a command to a variable in the shell script, so option E is incorrect.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      390,
      389,
      387,
      385,
      386
    ],
    "source": "316328_Assessment Test",
    "choice_e": "<code>$()</code>"
  },
  {
    "id": 41,
    "question": "Which environment variable allows you to retrieve the numeric user ID value for the user account running a shell script?",
    "choice_a": "<code>$USER</code>",
    "choice_b": "<code>$UID</code>",
    "choice_c": "<code>$BASH</code>",
    "choice_d": "<code>$HOME</code>",
    "correct_answer": "B",
    "explanation": "The <code>$UID</code> environment variable contains the numeric user ID value of the user account running the shell script, so option B is correct. The <code>$USER</code> environment variable contains the text user name of the user account running the shell script, not the numerical user ID value, so option A is incorrect. The <code>$BASH</code> environment variable contains the path to the executable Bash shell, so option C is incorrect. The <code>$HOME</code> environment variable contains the location of the home directory of the user account running the shell, so option D is incorrect. The <code>$1</code> positional variable contains the first parameter listed on the command-line command when the shell script was run, so option E is incorrect.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      383,
      384,
      386,
      380,
      385
    ],
    "source": "316328_Assessment Test",
    "choice_e": "<code>$1</code>"
  },
  {
    "id": 42,
    "question": "What does placing an ampersand sign (<code>&</code>) after a command on the command line do?",
    "choice_a": "Disconnects the command from the console session",
    "choice_b": "Schedules the command to run later",
    "choice_c": "Runs the command in background mode",
    "choice_d": "Redirects the output to another command",
    "correct_answer": "C",
    "explanation": "The ampersand sign (<code>&</code>) tells the shell to run the specified command in background mode in the console session, so option C is correct. The <code>nohup</code> command is used to disconnect the command from the console session, so option A is incorrect. The <code>at</code> command is used to schedule a command to run later, so option B is incorrect. The pipe symbol (<code>|</code>) redirects the output from the command to another command, so option D is incorrect. The greater-than symbol (<code>></code>) redirects the output from the command to a file, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      404,
      415,
      408,
      405,
      410
    ],
    "source": "316328_Assessment Test",
    "choice_e": "Redirects the output to a file"
  },
  {
    "id": 43,
    "question": "When will the cron table entry <code>0 0 1 * * myscript</code> run the specified command?",
    "choice_a": "At 1 a.m. every day",
    "choice_b": "At midnight on the first day of every month",
    "choice_c": "At midnight on the first day of every week",
    "choice_d": "At 1 p.m. every day",
    "correct_answer": "B",
    "explanation": "The cron table format specifies the times to run the script by minute, hour, day of month, month, and day of week. Thus the format <code>0 0 1 * *</code> will run the command at 00:00 (midnight) on the first day of the month for every month. That makes option B correct, and options A, C, D, and E incorrect.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      412,
      413,
      414,
      410,
      411
    ],
    "source": "316328_Assessment Test",
    "choice_e": "At midnight every day"
  },
  {
    "id": 44,
    "question": "Which of the following packages will provide you with the utilities to set up Git VCS on a system?",
    "choice_a": "<code>git-vcs</code>",
    "choice_b": "<code>GitHub</code>",
    "choice_c": "<code>gitlab</code>",
    "choice_d": "<code>Bitbucket</code>",
    "correct_answer": "E",
    "explanation": "This <code>git</code> package provides utilities to set up Git VCS on a system, so option E is the correct answer. The <code>git-vcs</code> package is made up, so option A is a wrong answer. The <code>GitHub</code>, <code>gitlab</code>, and <code>Bitbucket</code> packages are also made up, but they have similar names as cloud-based remote repositories used with Git (GitHub, GitLab, BitBucket). Therefore, options B, C, and D are also incorrect choices.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      204,
      211,
      205,
      206,
      207
    ],
    "source": "316328_Assessment Test",
    "choice_e": "<code>git</code>"
  },
  {
    "id": 45,
    "question": "If you do not tack on the <code>-m</code> option with an argument to the <code>git commit</code> command, what will happen?",
    "choice_a": "The command will throw an error message and fail.",
    "choice_b": "The commit will take place, but no tracking will occur.",
    "choice_c": "You are placed in an editor for the <code>COMMIT_EDITMSG</code> file.",
    "choice_d": "Your commit will fail, and the file is removed from the index.",
    "correct_answer": "C",
    "explanation": "If the <code>-m</code> option with an argument is not tacked onto the <code>git commit</code> command, you are placed into the <code>vim</code> editor to edit the <code>COMMIT_EDITMSG</code> file. Thus, option C is the correct answer. All the other options are made up and therefore incorrect.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      422,
      420,
      417,
      419,
      421
    ],
    "source": "316328_Assessment Test",
    "choice_e": "Nothing. This is an optional switch."
  },
  {
    "id": 46,
    "question": "At a virtualization conference, you overhear someone talking about using blobs on their cloud-based virtualization service. Which virtualization service are they using?",
    "choice_a": "Amazon Web Services",
    "choice_b": "KVM",
    "choice_c": "Digital Ocean",
    "choice_d": "GitHub",
    "correct_answer": "E",
    "explanation": "The Microsoft Azure cloud-based virtualization service provides blobs, which are large unstructured data storage that offered over the Internet and can be manipulated with .NET code. Therefore, option E is the correct answer. Amazon Web Services (AWS) and Digital Ocean are both cloud-based virtualization services, but they do not employ storage called blob, so options A and C are wrong answers. KVM is a hypervisor, not a cloud-based virtualization service, so option B is an incorrect answer. GitHub is a cloud-based remote repository used in version control, so option D is also an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      445,
      9,
      429,
      447,
      432
    ],
    "source": "316328_Assessment Test",
    "choice_e": "Microsoft Azure"
  },
  {
    "id": 47,
    "question": "\u201cA networking method for controlling and managing network communications via software that consists of a controller program as well as two APIs\u201d describes which of the following?",
    "choice_a": "Thick provisioning",
    "choice_b": "Thin provisioning",
    "choice_c": "SDN",
    "choice_d": "NAT",
    "correct_answer": "C",
    "explanation": "A software-defined network (SDN) is a networking method for controlling and managing network communications via software that consists of a controller program as well as two APIs. Thus, option C is the correct answer. Thick provisioning and thin provisioning refer to virtual storage configurations, not networking methods, so options A and B are wrong answers. Network address translation (NAT) is a virtualization network adapter configuration, which operates similarly to a NAT router in a network. Therefore, option D is an incorrect answer. A VLAN is a virtual (logical) LAN configuration, and thus, option E is an incorrect choice as well.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      447,
      446,
      443,
      106,
      105
    ],
    "source": "316328_Assessment Test",
    "choice_e": "VLAN"
  },
  {
    "id": 48,
    "question": "Your company decides it needs an orchestration system (also called an engine). Which of the following is one you could choose? (Choose all that apply.)",
    "choice_a": "Mesos",
    "choice_b": "Kubernetes",
    "choice_c": "Splunk",
    "choice_d": "Swarm",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Only Kubernetes and Swarm are orchestration systems. Therefore, options B and D are correct answers. Mesos needs Marathon to implement an orchestration engine, so option A is a wrong answer. Splunk can be used as a monitoring tool in an orchestrated environment, but it is not an orchestration system, so option D is also a wrong choice. Amazon Web Services (AWS) is cloud-based virtualization services on which you can use orchestration tools, but it is not an orchestration engine. Thus, option E is also an incorrect choice.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      461,
      462,
      460,
      459,
      456
    ],
    "source": "316328_Assessment Test",
    "choice_e": "AWS"
  },
  {
    "id": 49,
    "question": "Which of the following is used in container orchestration? (Choose all that apply.)",
    "choice_a": "Automated configuration management",
    "choice_b": "Self-healing",
    "choice_c": "DevOps",
    "choice_d": "Agentless monitoring",
    "correct_answer": [
      "A",
      "B",
      "D",
      "E"
    ],
    "explanation": "The concepts listed in options A, B, D, and E are all used in container orchestration. While DevOps benefits from container orchestration and often employs it, it is not used within container orchestration. Thus, option C is an incorrect choice.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      460,
      457,
      461,
      462,
      459
    ],
    "source": "316328_Assessment Test",
    "choice_e": "Build automation"
  },
  {
    "id": 50,
    "question": "What type of cloud service provides the full application environment so that everyone on the Internet can run it?",
    "choice_a": "PaaS",
    "choice_b": "Private",
    "choice_c": "Public",
    "choice_d": "SaaS",
    "correct_answer": "D",
    "explanation": "The software as a service (SaaS) cloud service type provides full applications, allowing anyone to connect to your application, so option D is correct. The platform as a service (PaaS) cloud service type doesn\u2019t include an application; you must provide it yourself, so option A is incorrect. Private, public, and hybrid are all methods of implementing cloud services, not cloud service types, so options B, C, and E are all incorrect.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      429,
      430,
      9,
      437,
      8
    ],
    "source": "316328_Assessment Test",
    "choice_e": "Hybrid"
  },
  {
    "id": 51,
    "question": "What type of hypervisor is the Oracle VirtualBox application?",
    "choice_a": "PaaS",
    "choice_b": "SaaS",
    "choice_c": "Type II",
    "choice_d": "Type I",
    "correct_answer": "C",
    "explanation": "The Oracle VirtualBox hypervisor installs on top of a host operating system, making it a Type II hypervisor, so option C is correct. PaaS and SaaS are types of cloud services, not hypervisors, so options A and B are incorrect. A private cloud service is a method for implementing cloud services in an internal network, not a type of hypervisor, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      7,
      8,
      429,
      430,
      432
    ],
    "source": "316328_Assessment Test",
    "choice_e": "Private"
  },
  {
    "id": 52,
    "question": "What file should you place console and terminal file names into to prevent users from logging into the Linux system as the root user account from those locations?",
    "choice_a": "<code>/etc/cron.deny</code>",
    "choice_b": "<code>/etc/hosts.deny</code>",
    "choice_c": "<code>/etc/securetty</code>",
    "choice_d": "<code>/etc/login.warn</code>",
    "correct_answer": "C",
    "explanation": "The <code>/etc/securetty</code> file provides a list of locations from which users can\u2019t log in using the root user account, so option C is correct. The <code>/etc/cron.deny</code> file prevents users from scheduling jobs, not logging in as the root user account, so option A is incorrect. The <code>/etc/hosts.deny</code> file blocks access from remote network hosts; it doesn\u2019t block root access from local terminals or the console, so option B is incorrect. The <code>/etc/login.warn</code> and <code>/etc/motd</code> files contain messages that are displayed at login time; they don\u2019t block users from logging in as the root user account, so options D and E are incorrect.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      242,
      289,
      231,
      243,
      296
    ],
    "source": "316328_Assessment Test",
    "choice_e": "<code>/etc/motd</code>"
  },
  {
    "id": 53,
    "question": "What Linux program logs user file and directory access?",
    "choice_a": "<code>chroot</code>",
    "choice_b": "LUKS",
    "choice_c": "<code>auditd</code>",
    "choice_d": "<code>klist</code>",
    "correct_answer": "C",
    "explanation": "The <code>auditd</code> program monitors system activity, including user file and directory access, and logs events based on rules you create. Thus, option C is correct. The <code>chroot</code> utility restricts applications to a specific location in the virtual filesystem but doesn\u2019t log user file and directory access, so option A is incorrect. The LUKS system encrypts disk partitions but doesn\u2019t log user file and directory access, so option B is incorrect. The <code>klist</code> and <code>kinit</code> programs are used for Kerberos user authentication, not logging user file and directory access, so options D and E are both incorrect.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      295,
      287,
      281,
      231,
      243
    ],
    "source": "316328_Assessment Test",
    "choice_e": "<code>kinit</code>"
  },
  {
    "id": 54,
    "question": "You\u2019ve moved your present working directory to a new location in the Linux virtual directory structure and need to go back to the previous directory, where you were just located. Which command should you employ?",
    "choice_a": "<code>cd</code>",
    "choice_b": "<code>exit</code>",
    "choice_c": "<code>cd ~</code>",
    "choice_d": "<code>cd -</code>",
    "correct_answer": "D",
    "explanation": "The <code>cd -</code> command will return your process to its previous directory in the virtual directory system, so option D is the correct answer. The <code>cd</code> and <code>cd ~</code> commands both return your process to your home directory, which was not necessarily the previous directory. Therefore, options A and C are wrong answers. The <code>exit</code> command causes your process to exit its current shell, not return to the previous directory, so option B is also an incorrect answer. The <code>return</code> command is used in Bash shell scripts to return from a function or return from a sourced script. Thus, option E is also an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      163,
      162,
      16,
      63,
      56
    ],
    "source": "316328_Assessment Test",
    "choice_e": "<code>return</code>"
  },
  {
    "id": 55,
    "question": "To copy a directory with the <code>cp</code> command, which option do you need to use?",
    "choice_a": "<code>-i</code>",
    "choice_b": "<code>-R</code>",
    "choice_c": "<code>-v</code>",
    "choice_d": "<code>-u</code>",
    "correct_answer": "B",
    "explanation": "The <code>-R</code> option used with the <code>cp</code> command allows you to copy a directory\u2019s contents. You can also employ the <code>-r</code> or <code>--recursive</code> options to achieve the same results. Therefore, option B is the correct answer. The <code>-i</code> option will ask before overwriting a preexisting directory but not copy recursively, so option A is a wrong answer. The <code>-v</code> option will provide verbose information for the copy, which is helpful, but does not allow a recursive copy to occur. Thus, option C is also an incorrect answer. The <code>-u</code> option is handy in that it will only allow the <code>cp</code> command to overwrite preexisting files with the same name, if the files being copied are newer. However, it is not used to recursively copy, so option D is also an incorrect answer. The <code>-f</code> option forces a copy to occur and overwrites any preexisting files with the same name but does not force a recursive copy. Thus, option E is an incorrect choice.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      41,
      40,
      43,
      39,
      53
    ],
    "source": "316328_Assessment Test",
    "choice_e": "<code>-f</code>"
  },
  {
    "id": 56,
    "question": "Which web server has gained popularity as a high-performance load balancer?",
    "choice_a": "Apache",
    "choice_b": "nginX",
    "choice_c": "Lighthttpd",
    "choice_d": "PostgreSQL",
    "correct_answer": "B",
    "explanation": "The nginX web server also has the ability to perform as a load balancer with multiple systems, so option B is correct. The Apache and Lighthttpd web servers aren\u2019t capable of performing load balancing functions, so options A and C are incorrect. The PostgreSQL and MySQL servers are database servers, not web servers, so options D and E are both incorrect.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      22,
      37,
      34,
      19,
      88
    ],
    "source": "316328_Practice Exam",
    "choice_e": "MySQL"
  },
  {
    "id": 57,
    "question": "Which open source database implements advanced database features but can be slower to use?",
    "choice_a": "MongoDB",
    "choice_b": "MySQL",
    "choice_c": "PostgreSQL",
    "choice_d": "NoSQL",
    "correct_answer": "C",
    "explanation": "The PostgreSQL open source database server is well known for utilizing advanced database features commonly found in commercial database servers, but it can be somewhat slower when processing data, making option C correct. The MongoDB, MySQL, and NoSQL open source databases are designed for speed and implement varying levels of advanced database features, but they don\u2019t provide all of the advanced features of commercial databases, so options A, B, and D are incorrect. The Oracle database implements advanced database features but is not an open source database, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      23,
      203,
      201,
      200,
      204
    ],
    "source": "316328_Practice Exam",
    "choice_e": "Oracle"
  },
  {
    "id": 58,
    "question": "What protocol does a mail server use to send email messages to remote mail servers?",
    "choice_a": "SMTP",
    "choice_b": "SNMP",
    "choice_c": "NTP",
    "choice_d": "DHCP",
    "correct_answer": "A",
    "explanation": "Simple Mail Transport Protocol (SMTP) is used to send email messages between email servers, so option A is correct. The Simple Network Management Protocol (SNMP) is used for monitoring network devices, not sending email messages, so option B is incorrect. The Network Time Protocol (NTP) is used for synchronizing the time between network devices, not sending email messages, so option C is incorrect. The Dynamic Host Configuration Protocol (DHCP) is used for sending IP address and other configuration features to network devices, but not email messages, so option D is incorrect. The Network File System (NFS) protocol is used for sharing disk space between network devices, not sending email messages, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      106,
      104,
      114,
      165,
      82
    ],
    "source": "316328_Practice Exam",
    "choice_e": "NFS"
  },
  {
    "id": 59,
    "question": "Which logging program do systemd systems use?",
    "choice_a": "<code>rsyslogd</code>",
    "choice_b": "<code>ntpd</code>",
    "choice_c": "<code>dhcpd</code>",
    "choice_d": "<code>journald</code>",
    "correct_answer": "D",
    "explanation": "Systemd systems use the <code>journald</code> program for logging system events, so option D is correct. The <code>rsyslogd</code> program is commonly used by SysV init systems for logging events, but not systemd systems, so option A is incorrect. The <code>ntpd</code>, <code>dhcpd</code>, and <code>httpd</code> programs provide network services for time, configuration, and web services respectively, but not logging services, so options B, C, and E are all incorrect.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      88,
      89,
      92,
      87,
      91
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>httpd</code>"
  },
  {
    "id": 60,
    "question": "What server role should you implement to speed up web browsing for local clients?",
    "choice_a": "A web proxy",
    "choice_b": "A DHCP server",
    "choice_c": "A web server",
    "choice_d": "A container",
    "correct_answer": "A",
    "explanation": "A web proxy server has the ability to cache pages retrieved from remote web servers, and relay those web pages to local clients when the same web page is requested again, helping to speed up web browsing for local clients, making option A correct. A DHCP server only provides IP and host configuration settings to network devices, not speed up web browsing, so option B is incorrect. A standard web server must retrieve web pages individually for each client, so it doesn\u2019t speed up web browsing for the individual clients, making option C incorrect. A container helps make software development easier by duplicating the development environment into a form that can be transportable between multiple servers, but doesn\u2019t help speed up web browsing for clients, making option D incorrect. An SMTP server is used to provide email service, not web services, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      448,
      446,
      106,
      104,
      114
    ],
    "source": "316328_Practice Exam",
    "choice_e": "An SMTP server"
  },
  {
    "id": 61,
    "question": "You need to delete files in a directory as well as any empty subdirectories. You want to be asked permission before deleting each file and received detailed information as the command executes. Which command and option combination should you use?",
    "choice_a": "<code>rmdir -v <i>directory</i></code>",
    "choice_b": "<code>rmdir -vp <i>directory</i></code>",
    "choice_c": "<code>rm -ivf <i>directory</i></code>",
    "choice_d": "<code>rm -Id <i>directory</i></code>",
    "correct_answer": "E",
    "explanation": "The <code>rm -ivd <i> directory</i></code> command will delete the files and any empty subdirectories in the <code><i>directory</i></code> directory. In addition, it will ask permission before deleting each file and provide detailed information. Therefore, option E is the correct answer. The <code>rmdir -v <i>directory</i></code> command will only attempt to delete the <code><i>directory</i></code> directory, and only if it is empty. Therefore, option A is a wrong answer. The <code>rmdir -vp <i>directory</i></code> command will only attempt to delete the <code><i>directory</i></code> directory files, but not any subdirectories in it. Thus, option B is also an incorrect answer. The <code>rm -ivf <i>directory</i></code> command does not delete any empty subdirectories in the <code><i>directory</i></code> directory. Therefore, option C is a wrong choice. The <code>rm -Id <i>directory</i></code> command does not provide verbose information and will only ask before deleting three files. Thus, option D is also an incorrect choice.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      43,
      41,
      39,
      40,
      53
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>rm -ivd <i> directory</i></code>"
  },
  {
    "id": 62,
    "question": "Which of the following are ways to identify that a text file is hard linked to another file? (Choose all that apply.)",
    "choice_a": "The file shares an inode number with another file.",
    "choice_b": "The file does not share an inode number with another file.",
    "choice_c": "The file has a file indicator code of <code>l</code> in its long listing.",
    "choice_d": "The file has a link count greater than 1.",
    "correct_answer": [
      "A",
      "D",
      "E"
    ],
    "explanation": "Indicators that a text file is hard linked to another file are the file shares an inode number with another file, the text file has a link count greater than 1, and the file shares the same data with another file. Thus, options A, D, and E are all correct answer. Soft (symbolic) linked files do not share an inode number with another file and have a file indicator code of <code>l</code> in their long listing. Therefore, both options B and C are incorrect choices.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      44,
      46,
      50,
      55,
      53
    ],
    "source": "316328_Practice Exam",
    "choice_e": "The file shares the same data with another file."
  },
  {
    "id": 63,
    "question": "You need to set a watch on the <code>/var/log/secure</code> file. Using super user privileges, which command should you employ?",
    "choice_a": "<code>watch /var/log/secure</code>",
    "choice_b": "<code>watch -b /var/log/secure</code>",
    "choice_c": "<code>tail -f /var/log/secure</code>",
    "choice_d": "<code>tail /var/log/secure</code>",
    "correct_answer": "C",
    "explanation": "The <code>tail -f /var/log/secure</code> command will set a watch on the <code>/var/log/secure</code> file and display a few recent log file entries immediately as well as additional messages as they are added to the log file. Therefore, option C is the correct answer. The <code>watch</code> command allows you to execute a program periodically and view the command\u2019s output. Therefore, options A, B, and E are wrong answers. The <code>tail /var/log/secure</code> command will not set a watch but instead only display the last 10 lines of the log file. Thus, option D is also an incorrect choice.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      266,
      259,
      258,
      260,
      256
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>watch -v /var/log/secure</code>"
  },
  {
    "id": 64,
    "question": "You need to locate files within the <code>/tmp</code> directory or one of its subdirectories. These files should be empty. Assuming you have super user privileges, what command should you use?",
    "choice_a": "<code>find / -name tmp</code>",
    "choice_b": "<code>find /tmp -empty</code>",
    "choice_c": "<code>find /tmp -empty 0</code>",
    "choice_d": "<code>find /tmp/* -name empty</code>",
    "correct_answer": "B",
    "explanation": "The <code>find /tmp -empty</code> command will locate files within the <code>/tmp</code> directory or one of its subdirectories, which are empty. Therefore, option B is the right answer. The <code>find / -name tmp</code> command starts at the root directory instead of the <code>/tmp</code> directory and searches for files/directories whose names are <code>tmp</code>. Thus, option A is a wrong answer. The <code>find /tmp -empty 0</code> command adds an incorrect additional argument, <code>0</code>, at the end of the command, so option C is also an incorrect answer. The <code>find /tmp/* -name empty</code> command searches for files/directories whose names are <code>tmp</code> and adds an unnecessary wildcard, <code>*</code>, to the directory name to search. Thus, option D is also a wrong choice. The <code>find / -empty</code> command starts at the root directory instead of the <code>/tmp</code> directory. Therefore, option E is an incorrect choice.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      53,
      52,
      40,
      41,
      43
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>find / -empty</code>"
  },
  {
    "id": 65,
    "question": "Which of the following are filter commands? (Choose all that apply.)",
    "choice_a": "<code>egrep</code>",
    "choice_b": "<code>sort</code>",
    "choice_c": "<code>grep</code>",
    "choice_d": "<code>cut</code>",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "In the option list, only the <code>egrep</code>, <code>grep</code>, and <code>cut</code> commands are considered to be filter commands, because they filter out text. Therefore, options A, C, and D are correct. The <code>sort</code> and <code>pr</code> commands are formatting commands, and thus options B and D are incorrect choices.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      57,
      63,
      70,
      66,
      64
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>pr</code>"
  },
  {
    "id": 66,
    "question": "Which of the following symbols could be used to redirect STDOUT? (Choose all that apply.)",
    "choice_a": "<code>2></code>",
    "choice_b": "<code>>></code>",
    "choice_c": "<code><<</code>",
    "choice_d": "<code>></code>",
    "correct_answer": [
      "B",
      "D",
      "E"
    ],
    "explanation": "The <code>>></code> symbols will allow you to redirect STDOUT from a command and append the redirected content to a file. Therefore, option B is a correct choice. The <code>></code> symbol will allow you to redirect STDOUT from a command and place the redirected content to a file, creating it if the file does not previously exist or overwriting its contents if it does already exits. Therefore, option D is a correct choice. The | symbol, called the pipe, will allow you to redirect STDOUT from a command to STDIN of another command. Therefore, option E is also a correct answer. Option A redirects STDERR, represented by the <code>2</code> file descriptor, so therefore it is a wrong answer. Option C is an incorrect choice because the <code><<</code> symbols are for STDIN redirection associated with a here document.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      66,
      61,
      62,
      64,
      56
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>|</code>"
  },
  {
    "id": 67,
    "question": "Within the <code>nano</code> text editor\u2019s help subsystem, you\u2019ll see some metacharacter key combinations denoted by <code>M-<i>k</i></code>. Which of the following keys may the <code>M</code> represent? (Choose all that apply.)",
    "choice_a": "Ctrl",
    "choice_b": "Esc",
    "choice_c": "Alt",
    "choice_d": "<code>^</code>",
    "correct_answer": [
      "B",
      "C",
      "E"
    ],
    "explanation": "For the metacharacter key combinations, the <code>M</code> represents the Esc, Alt, or Meta key, depending on your keyboard\u2019s setup. Thus, options B, C, and E are correct answers. The Ctrl key is typically used in conjunction with other <code>nano</code> text editor key combination functions, such as Ctrl+O to output the text editor\u2019s buffer to a file. Therefore, option A is a wrong answer. The <code>^</code> is a symbol used to denote use of the Ctrl key within certain <code>nano</code> text editor key combinations, and thus option D is also an incorrect choice.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      49,
      47,
      48,
      407,
      54
    ],
    "source": "316328_Practice Exam",
    "choice_e": "Meta"
  },
  {
    "id": 68,
    "question": "The command <code>echo \"a b c d\" | gawk '{print $1}'</code> is issued at the command line. What will be displayed?",
    "choice_a": "<code>a</code>",
    "choice_b": "<code>b</code>",
    "choice_c": "<code>c</code>",
    "choice_d": "<code>d</code>",
    "correct_answer": "A",
    "explanation": "The <code>gawk</code> utility defines a data field as characters separated by a space with a text line. The <code>$1</code> data field is the first data field in a text line. Therefore, the command will display <code>a</code> to STDOUT, and option A is the correct answer. For <code>b</code> to display, the <code>$1</code> in the <code>gawk</code> command needs to be changed to <code>$2</code>. Thus, option B is the wrong answer. For <code>c</code> to display, the <code>$1</code> in the gawk command needs to be changed to <code>$3</code>. Therefore, option C is also a wrong choice. For <code>d</code> to display, the <code>$1</code> in the <code>gawk</code> command needs to be changed to <code>$4</code>. Thus, option D is an incorrect answer. For <code>a b c d</code> to display, the <code>$1</code> in the gawk command needs to be changed to <code>$0</code>. Therefore, option E is also an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      71,
      63,
      59,
      60,
      56
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>a b c d</code>"
  },
  {
    "id": 69,
    "question": "During the boot process, what software loads the operating system into memory and starts it?",
    "choice_a": "A bootloader",
    "choice_b": "The <code>fsck</code> command",
    "choice_c": "The Windows OS",
    "choice_d": "The <code>mount</code> command",
    "correct_answer": "A",
    "explanation": "After the firmware for a workstation or server loads it runs the bootloader program on the primary hard drive. The bootloader software then loads the actual operating system into memory and starts it, thus making option A correct. The <code>fsck</code> and <code>mount</code> programs are used to manage partitions after the operating system boots, they aren\u2019t part of the boot process, so options B and D are incorrect. The Windows OS software is an operating system and not part of the initial boot process, so option C is incorrect. The <code>mkinitrd</code> program creates a virtual partition that\u2019s loaded into memory at boot time to help load device modules, but doesn\u2019t load the operating system into memory, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      74,
      76,
      81,
      78,
      438
    ],
    "source": "316328_Practice Exam",
    "choice_e": "The <code>mkinitrd</code> command"
  },
  {
    "id": 70,
    "question": "After booting, what command should you use to look for any errors that occurred during the boot process?",
    "choice_a": "<code>fsck</code>",
    "choice_b": "<code>init</code>",
    "choice_c": "<code>mount</code>",
    "choice_d": "<code>dmesg</code>",
    "correct_answer": "D",
    "explanation": "Errors that occur while the Linux system is booting are sent to the kernel ring buffer. The <code>dmesg</code> program allows you to view the entries in the kernel ring buffer, making option D correct. The <code>fsck</code> program allows you to find and fix errors on a partition, but doesn\u2019t allow you to view errors as they occur during boot time, making option A incorrect. The <code>init</code> process starts processes during boot time, but doesn\u2019t allow you to view any errors generated, so option B is incorrect. The <code>mount</code> program allows you to mount a partition into the virtual directory, but not view any errors that occurred during boot time, so option C is incorrect. The <code>mkinitrd</code> program creates a virtual directory that\u2019s loaded into memory during boot time, but doesn\u2019t allow you to view any errors that are generated, so option E is incorrect.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      214,
      262,
      259,
      256,
      217
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>mkinitrd</code>"
  },
  {
    "id": 71,
    "question": "Which is the most popular bootloader used on Linux systems?",
    "choice_a": "GRUB Legacy",
    "choice_b": "LILO",
    "choice_c": "GRUB2",
    "choice_d": "SYSLINUX",
    "correct_answer": "C",
    "explanation": "The GRUB2 bootloader program is commonly used by most Linux systems, so option C is correct. The GRUB2 bootload replaced the original GRUB Legacy bootloader, so option A is incorrect. The LILO bootloader was the original Linux bootloader program, replaced by GRUB, so option B is incorrect. The SYSLINUX and ISOLINUX bootloaders are specialty bootloaders used for special situations, and are not commonly used by most Linux distributions, so options D and E are both incorrect.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      81,
      80,
      78,
      82,
      83
    ],
    "source": "316328_Practice Exam",
    "choice_e": "ISOLINUX"
  },
  {
    "id": 72,
    "question": "Which file contains the configuration for the GRUB2 bootloader?",
    "choice_a": "<code>mkinitrd</code>",
    "choice_b": "<code>grub.cfg</code>",
    "choice_c": "<code>grub-install</code>",
    "choice_d": "<code>mkinitramfs</code>",
    "correct_answer": "B",
    "explanation": "The unified GRUB2 configuration file is located in the <code>grub.cfg</code> file, making option B correct. The <code>grub-install</code> program reads configuration options from several text files to build the <code>grub.cfg</code> file, but isn\u2019t the configuration file itself, so option C is incorrect. The <code>mkinitrd</code> and <code>mkinitramfs</code> files are used to create virtual directory files used by GRUB2 at boot time, but don\u2019t contain the GRUB2 configuration file, making options A and D incorrect. The <code>fsck</code> program fixes errors on partitions and isn\u2019t part of the GRUB2 process, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      80,
      84,
      86,
      81,
      438
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>fsck</code>"
  },
  {
    "id": 73,
    "question": "What command should you use to repair a partition that won\u2019t mount?",
    "choice_a": "<code>mount</code>",
    "choice_b": "<code>umount</code>",
    "choice_c": "<code>dmesg</code>",
    "choice_d": "<code>mkinitrd</code>",
    "correct_answer": "E",
    "explanation": "The <code>fsck</code> program is a script that calls other programs required to fix errors on different types of partitions, so option E is correct. The <code>mount</code> and <code>umount</code> commands are used to add or remove a partition from the virtual directory, not repair partitions, so options A and B are both incorrect. The <code>dmesg</code> program allows us to view messages in the kernel ring buffer, not repair partitions, so option C is incorrect. The <code>mkinitrd</code> program creates a virtual directory that\u2019s loaded into memory during boot time, not repair partitions, so option D is incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      85,
      169,
      170,
      167,
      75
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>fsck</code>"
  },
  {
    "id": 74,
    "question": "You are troubleshooting a systemd system and issue the command <code>systemctl is-system-running</code>. The command displays <code>degraded</code>. Which of the following best describes what is going on?",
    "choice_a": "The system is fully in working order.",
    "choice_b": "The system has one or more failed units.",
    "choice_c": "The system is in emergency mode.",
    "choice_d": "The system is in recovery mode.",
    "correct_answer": "B",
    "explanation": "When the <code>systemctl is-system-running</code> command displays <code>degraded</code>, this means that the system has one or more failed units, such as a service or a socket. Therefore, option B is the correct answer. If the system was fully in working order, the command would display the running status. Thus, option A is a wrong answer. If the system was in emergency or recovery mode, the command would display the maintenance status. Therefore, both options C and D are wrong choices. If the system was starting to shut down, the command would display the stopping status. Thus, option E is also an incorrect choice.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      88,
      89,
      95,
      93,
      97
    ],
    "source": "316328_Practice Exam",
    "choice_e": "The system is starting to shut down."
  },
  {
    "id": 75,
    "question": "Which of the following sections would you find in a systemd service unit file? (Choose all that apply.)",
    "choice_a": "<code>[Unit]</code>",
    "choice_b": "<code>[Automount]</code>",
    "choice_c": "<code>[Mount]</code>",
    "choice_d": "<code>[Service]</code>",
    "correct_answer": [
      "A",
      "D",
      "E"
    ],
    "explanation": "You would find three sections in a systemd service unit file. They are <code>[Unit]</code>, <code>[Service]</code>, and <code>[Install]</code>. Therefore, options A, D and E are correct answers. The <code>[Automount]</code> section is only in systemd automount unit files. Thus, option B is a wrong answer. The <code>[Mount]</code> section is only in systemd mount unit files, and therefore, option C is also an incorrect choice.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      89,
      88,
      103,
      90,
      91
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>[Install]</code>"
  },
  {
    "id": 76,
    "question": "You are troubleshooting a rather serious problem on a systemd server. Using super user privileges, you enter the <code>systemctl isolate emergency</code> command. Once you are logged back into the system, you issue the <code>systemctl is-system-running</code> command. What is displayed?",
    "choice_a": "<code>yes</code>",
    "choice_b": "<code>true</code>",
    "choice_c": "<code>false</code>",
    "choice_d": "<code>emergency</code>",
    "correct_answer": "E",
    "explanation": "When you jump to the emergency target, issuing the <code>systemctl is-system-running</code> command will display the <code>maintenance</code> status. Therefore, option E is the correct answer. The other items are not displayed by the <code>systemctl is-system-running</code> command at any time, so therefore, options A, B, C and D are all incorrect choices.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      93,
      88,
      87,
      101,
      90
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>maintenance</code>"
  },
  {
    "id": 77,
    "question": "You are auditing an old SysVinit system and checking the status of each service that runs on the system. When you decide to check the DHCP service, using the command <code>chkconfig dhcp</code> on the command line, you get no response. What does this mean?",
    "choice_a": "The DHCP service is not running.",
    "choice_b": "The DHCP service either is not running or has failed.",
    "choice_c": "You need to issue an additional command.",
    "choice_d": "You need to issue a different command.",
    "correct_answer": "C",
    "explanation": "When you issued the <code>chkconfig</code> command and pass it a service name, the command will check if the service is enabled at the current runlevel. However, it does not display the results to STDOUT. Instead the results, true (0) or false (1), are sent to the ? variable. Therefore, you need to issue an additional command to see the results, which is <code>echo $?</code>. Therefore, option C is the correct answer. The <code>ckconfig dhcp</code> command does not determine if the DHCP service is running or not, or failed, so options A and B are wrong answers. You do not need to issue a different command, just an additional command, so option D is a wrong choice. Also, the command\u2019s primary purpose is to determine whether or not the service is enabled at the current runlevel, so option E is an incorrect choice.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      214,
      259,
      266,
      262,
      257
    ],
    "source": "316328_Practice Exam",
    "choice_e": "The DHCP service program files are not installed."
  },
  {
    "id": 78,
    "question": "What network settings does the <code>ip</code> command set (select all that apply)?",
    "choice_a": "IP address",
    "choice_b": "subnet mask",
    "choice_c": "default router",
    "choice_d": "DNS servers",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "The <code>ip</code> command allows you to set the IP address, subnet mask, and default router for a network interface, making options A, B, and C correct. It doesn\u2019t allow you to set the DNS or NTP servers for a connection, making options D and E incorrect.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      105,
      104,
      106,
      114,
      16
    ],
    "source": "316328_Practice Exam",
    "choice_e": "NTP servers"
  },
  {
    "id": 79,
    "question": "What command displays features and parameters for network cards?",
    "choice_a": "<code>ethtool</code>",
    "choice_b": "<code>iwconfig</code>",
    "choice_c": "<code>iwlist</code>",
    "choice_d": "<code>netstat</code>",
    "correct_answer": "A",
    "explanation": "The <code>ethtool</code> program displays hardware information about network interface cards, making option A correct. The <code>iwconfig</code> and <code>iwlist</code> programs display information about wireless networks, not the network cards, making options B and C incorrect. The <code>netstat</code> and <code>route</code> programs display information about the network statistics, not the network cards, so options D and E are both incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      104,
      105,
      106,
      114,
      341
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>route</code>"
  },
  {
    "id": 80,
    "question": "What command can you use to list the hosts defined on a domain?",
    "choice_a": "<code>netstat</code>",
    "choice_b": "<code>dig</code>",
    "choice_c": "<code>ping6</code>",
    "choice_d": "<code>host</code>",
    "correct_answer": "B",
    "explanation": "The <code>dig</code> command displays information from a DNS server responsible for a specific zone, and will list information about the hosts defined in the DNS database, making option B correct. The <code>host</code> command only displays information for a single host on the network, not all the hosts in a domain, so option D is incorrect. The <code>netstat</code>, <code>ping6</code>, and <code>ss</code> commands display network packet statistics, not information about hosts, so options A, C, and E are all incorrect.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      114,
      104,
      63,
      58,
      60
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>ss</code>"
  },
  {
    "id": 81,
    "question": "What application would you use to determine the port an application is listening for connections on?",
    "choice_a": "<code>ip</code>",
    "choice_b": "<code>host</code>",
    "choice_c": "<code>ss</code>",
    "choice_d": "<code>dig</code>",
    "correct_answer": "C",
    "explanation": "The <code>ss</code> command displays socket statistics for all network connections on the Linux system, so option C is correct. The <code>ip</code> and <code>ifconfig</code> commands display IP network information about the network cards, but don\u2019t display information about connected application ports, so options A and E are both incorrect. The <code>host</code> and <code>dig</code> commands allow you to retrieve DNS information about specific hosts or domains, but not application port information, so options B and D are also both incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      114,
      105,
      106,
      104,
      63
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>ifconfig</code>"
  },
  {
    "id": 82,
    "question": "What command would you use to display the available wireless networks in your area?",
    "choice_a": "<code>iwconfig</code>",
    "choice_b": "<code>ifconfig</code>",
    "choice_c": "<code>ip</code>",
    "choice_d": "<code>arp</code>",
    "correct_answer": "E",
    "explanation": "The <code>iwlist</code> command lists all of the wireless networks detected by the wireless network card installed on the system, so option E is correct. The <code>iwconfig</code> command allows you to set and display the configuration settings for a wireless network card, but doesn\u2019t list all of the available wireless networks the card detects, so option A is incorrect. The <code>ifconfig</code> and <code>ip</code> commands allow you to set the IP network settings for a wireless network card, but neither allows you to view the available wireless networks, so options B and C are incorrect. The <code>arp</code> command displays network device addresses that communicate with the system, but doesn\u2019t display wireless networks, so option D is incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      105,
      106,
      104,
      114,
      16
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>iwlist</code>"
  },
  {
    "id": 83,
    "question": "Which of the following is true about the GNOME desktop environment. (Choose all that apply.)",
    "choice_a": "GNOME is an open source project.",
    "choice_b": "GNOME uses SDDM as its windows manager.",
    "choice_c": "GNOME uses Files as its default file manager.",
    "choice_d": "GNOME is a fork of MATE.",
    "correct_answer": [
      "A",
      "C",
      "E"
    ],
    "explanation": "GNOME is an open source project supported by the GNOME Foundation. Therefore option A is a correct choice. Files is the default file manager for the GNOME desktop, so option C is correct. The Dash is the default favorites bar for the GNOME desktop, making option E also correct. GNOME uses the GNOME Display Manager (GDM) for its display manager, not SDDM, so option B is incorrect. MATE is a fork from GNOME version 2, GNOME is not a fork of MATE, so option E is also an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      116,
      115,
      118,
      119,
      3
    ],
    "source": "316328_Practice Exam",
    "choice_e": "GNOME uses the Dash as its favorites bar."
  },
  {
    "id": 84,
    "question": "Which of the following sections would you find in the <code>/etc/X11/xorg.conf</code> file? (Choose all that apply.)",
    "choice_a": "Service",
    "choice_b": "Input Device",
    "choice_c": "Desktop",
    "choice_d": "Monitor",
    "correct_answer": [
      "B",
      "D",
      "E"
    ],
    "explanation": "The Input Device, Monitor, and Screen sections are all sections you would find in the <code>/etc/X11/xorg.conf</code> file. Therefore, options B, D, and E are correct choices. You would also find the Modes, Device, Module, Files, Server Flags, and Server Layout sections. The Service and Desktop sections are made up, and therefore options A and C are incorrect choices.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      121,
      348,
      119,
      115,
      120
    ],
    "source": "316328_Practice Exam",
    "choice_e": "Screen"
  },
  {
    "id": 85,
    "question": "You are troubleshooting a problem with a user\u2019s graphical user interface, which is being served by X11. You notice that the X Display Manager Control Protocol is being used as the display manager. What does this implicate?",
    "choice_a": "The control protocol is being used by X11 to provide a basic desktop environment.",
    "choice_b": "A Wayland display server is being used and needs to be replaced by an X11 server.",
    "choice_c": "The <code>/etc/X11/xdm-config</code> file should be reviewed.",
    "choice_d": "This protocol is used in place of the Weston compositor.",
    "correct_answer": "E",
    "explanation": "The X Display Manager Control Protocol (XDMCP) can be employed as a very basic display manager. A display manager controls the login screen provided to the user for authentication. Therefore, option E is the correct answer. XDMCP is not used by X11 to provide a basic desktop environment, so option A is a wrong answer. XDMCP\u2019s use does not indicate the Wayland display server is being used, and therefore, option B is also an incorrect answer. If you were having problems with the display manager, then the correct file to review would be the <code>/etc/X11/xdm/xdm-config</code> file, and not the <code>/etc/X11/xdm-config</code> file. Thus option C is a wrong choice. XDMCP is not a compositor, so option D is also an incorrect answer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      115,
      119,
      121,
      348,
      117
    ],
    "source": "316328_Practice Exam",
    "choice_e": "The XDMCP is used for the user authentication interface."
  },
  {
    "id": 86,
    "question": "A coworker at a remote location has a laptop that is running a Linux desktop environment. He needs your help to access a remote desktop session at the server, where he is currently logged into a text-based session. You tell him to employ SSH port forwarding and use its remote mode. Which <code>ssh</code> command switches should you tell him to employ? (Choose all that apply.)",
    "choice_a": "<code>-N</code>",
    "choice_b": "<code>-Y</code>",
    "choice_c": "<code>-f</code>",
    "choice_d": "<code>-R</code>",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "You need to indicate to the OpenSSH server that no terminal is required, because you are only establishing a tunnel. Therefore, the <code>-N</code> switch is needed and option A is a correct answer. The <code>-f</code> switch will send the OpenSSH tunnel into the background, freeing up his command-line interface so he can type in remote desktop commands. Thus, option C is a correct answer as well. The <code>-R</code> switch is used for remote mode SSH port forwarding and will allow him to specify the local system as well as the local and remote ports to be used. Therefore, option D is also a correct choice. The <code>-Y</code> switch is not used in SSH port forwarding, so option B is a wrong answer. The <code>-L</code> switch is used for local mode of the <code>ssh</code> command, Therefore, option E is also an incorrect answer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      128,
      129,
      126,
      127,
      122
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>-L</code>"
  },
  {
    "id": 87,
    "question": "Which character set uses 1 byte to store characters?",
    "choice_a": "ASCII",
    "choice_b": "UTF-8",
    "choice_c": "UTF-16",
    "choice_d": "Unicode",
    "correct_answer": "B",
    "explanation": "The UTF-8 character set uses all 8 bits, or 1 byte, to store characters, thus option B is correct. The ASCII character set only uses 7 bits, so option A is incorrect. The UTF-16 character set uses 2 bytes, Unicode uses 3 bytes, and UTF-32 uses 4 bytes, so options C, D, and E are all incorrect.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      16,
      16
    ],
    "source": "316328_Practice Exam",
    "choice_e": "UTF-32"
  },
  {
    "id": 88,
    "question": "Which character set uses 3 bytes for storage to work with all international languages?",
    "choice_a": "ASCII",
    "choice_b": "UTF-8",
    "choice_c": "UTF-16",
    "choice_d": "Unicode",
    "correct_answer": "D",
    "explanation": "The Unicode character set uses 3 bytes to store character information, providing space for all international characters, making it ideal for use with any language. Thus, option D is correct. The ASCII character set uses 7 bits, and the UTF-8 character set uses 1 byte, neither of which is large enough to support all international characters, making options A and B incorrect. The UTF-16 character set uses 2 bytes to store characters, which provides for more characters, but still not enough to cover all languages, so option C is incorrect. The <code>LC_ALL</code> answer is an environment variable used to indicate the character set to use, it\u2019s not a character set itself, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      8,
      16,
      8,
      16
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>LC_ALL</code>"
  },
  {
    "id": 89,
    "question": "What command should you use on a systemd system to set the localization?",
    "choice_a": "<code>timedatectl</code>",
    "choice_b": "<code>time</code>",
    "choice_c": "<code>localectl</code>",
    "choice_d": "<code>date</code>",
    "correct_answer": "C",
    "explanation": "The <code>localectl</code> command is available on systemd systems to set the character sets, thus option C is correct. The <code>timedatectl</code> command sets the time and date on systemd systems, but not the localization, so option A is incorrect. The <code>time</code>, <code>date</code>, and <code>locale</code> commands are legacy Linux commands and not used on systemd systems, so options B, D, and E are all incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      132,
      130,
      87,
      88,
      133
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>locale</code>"
  },
  {
    "id": 90,
    "question": "What <code>systemd</code> command should you use to retrieve the time from the workstation or server hardware?",
    "choice_a": "<code>timedatectl</code>",
    "choice_b": "<code>date</code>",
    "choice_c": "<code>time</code>",
    "choice_d": "<code>locale</code>",
    "correct_answer": "A",
    "explanation": "On Linux systems that utilize the systemd system, the <code>timedatectl</code> command is available to retrieve the time from the workstation or server hardware, so option A is correct. The <code>localectl</code> command is a <code>systemd</code> command, but used to set localization, not retrieve time, so option E is incorrect. The <code>date</code>, <code>time</code>, and <code>locale</code> commands are part of the legacy Linux system and not used on systemd systems, so options B, C, and D are all incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      134,
      135,
      133,
      87,
      88
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>localectl</code>"
  },
  {
    "id": 91,
    "question": "Which command can you use to display the time and date using a specific format?",
    "choice_a": "<code>time</code>",
    "choice_b": "<code>timedatectl</code>",
    "choice_c": "<code>hwclock</code>",
    "choice_d": "<code>localectl</code>",
    "correct_answer": "E",
    "explanation": "The <code>date</code> command allows you to specify a template to define the format of the time and date as output, so option E is correct. The <code>time</code> command only displays the time and not the date, so option A is incorrect. The <code>timedatectl</code> command displays the time and date, but doesn\u2019t allow you to format the output, so option B is incorrect. The <code>hwclock</code> command displays the current time as set on the workstation or server hardware, and doesn\u2019t allow you to format the output, so option C is incorrect. The <code>localectl</code> command displays localization settings on systemd systems, not the time and date, so option D is incorrect. The <code>date</code> command only displays the date and not the time, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      59,
      60,
      58,
      63,
      56
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>date</code>"
  },
  {
    "id": 92,
    "question": "You have been informed that an employee is to be terminated today. The company does not want the account deleted but does not want the employee logging into the Linux server either. You check the system using the <code>who</code> command and see that the employee is not currently logged into the system. Which of the following commands could you use to prevent the employee from logging into the system as desired by the company? (Choose all that apply.)",
    "choice_a": "The <code>usermod -L</code> command",
    "choice_b": "The <code>usermod -U</code> command",
    "choice_c": "The <code>passwd -l</code> command",
    "choice_d": "The <code>passwd -L</code> command",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "The <code>usermod -L</code> and <code>passwd -l</code> commands will both work to lock the employee out of the system without deleting the user account. Therefore, options A and C are the correct answers. The <code>usermod -U</code> command unlocks a locked account, so option B is a wrong answer. The <code>passwd -L</code> command is a made-up command, so option D is also an incorrect answer. The <code>userdel -r</code> command would delete the user account and all its <code>$HOME</code> directory files. This is not what the company wants, and therefore, option E is also an incorrect choice.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      142,
      143,
      151,
      139,
      137
    ],
    "source": "316328_Practice Exam",
    "choice_e": "The <code>userdel -r</code> command"
  },
  {
    "id": 93,
    "question": "You need to create a user account via the <code>useradd</code> utility. After checking this distribution\u2019s account creation configuration files, you discover that the <code>HOME</code> directive points to a different location than desired. Which <code>useradd</code> option will allow you to create the home in an alternative location?",
    "choice_a": "<code>-m</code>",
    "choice_b": "<code>-d</code>",
    "choice_c": "<code>--create-home</code>",
    "choice_d": "<code>-D</code>",
    "correct_answer": "B",
    "explanation": "The <code>-d</code> switch on the <code>useradd</code> command will allow you to create the home in an alternative location and not the one specified by the <code>HOME</code> directive. Therefore, option B is the correct answer. Both the <code>-m</code> and the <code>--create-home</code> switches will create a directory, if the <code>CREATE_HOME</code> directive is either not set or set to no. However, they do not allow you to specify the location. Therefore, options A and C are wrong answers. The switches in options D and E only allow you to display the directives within the <code>/etc/default/useradd</code> account creation configuration file. Thus, options D and E are incorrect choices.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      140,
      138,
      144,
      142,
      139
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>--defaults</code>"
  },
  {
    "id": 94,
    "question": "You issue the command <code>id -gn 1138</code> at the command line. Assume the user exists. Which of the following best describes what will display?",
    "choice_a": "The user\u2019s (UID 1138) current group\u2019s GID",
    "choice_b": "The user\u2019s (UID 1138) group membership GIDs",
    "choice_c": "The user\u2019s (UID 1138) username",
    "choice_d": "The user\u2019s (UID 1138) current group\u2019s name",
    "correct_answer": "D",
    "explanation": "If you issue the command <code>id -gn 1138</code> at the command line and the user exists, you will see displayed the user\u2019s current group\u2019s name. Therefore, option D is the correct answer. To see the user\u2019s (UID 1138) current group\u2019s GID, the command is <code>id -g 1138</code>. Thus, option A is a wrong answer. To see the user (UID 1138) group membership GIDs, the command is <code>id -G 1138</code>. Thus, option B is also an incorrect answer. To view the user (UID 1138) username, the command is <code>id -un 1138</code>. Therefore, option C is a wrong choice. To see the user (UID 1138) group membership names, the command is <code>id -Gn 1138</code>. Thus, option E is also an incorrect choice.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      151,
      334,
      137,
      139,
      152
    ],
    "source": "316328_Practice Exam",
    "choice_e": "The user\u2019s (UID 1138) group membership names"
  },
  {
    "id": 95,
    "question": "You enter the command <code>edquota -u JKirk</code> and see zeros (<code>0</code>) under all the soft columns. What does this mean?",
    "choice_a": "Neither block nor inode soft quotas have been configured for this user.",
    "choice_b": "Neither block nor inode hard quotas have been configured for this user.",
    "choice_c": "The user is currently experiencing a grace period.",
    "choice_d": "The user is currently not experiencing a grace period.",
    "correct_answer": "A",
    "explanation": "The <code>edquota -u JKirk</code> command would display zeros (0) under all the soft columns if neither block nor inode soft quotas have been configured for this user. Therefore, option A is the correct answer. If neither block nor inode hard quotas have been configured for this user, you would see zeros displayed under the hard columns. Thus, option B is a wrong answer. If the user is currently experiencing a grace period, you would see numbers in the grace column of the <code>quota -u JKirk</code> command. Therefore, option C is an incorrect answer. If the user is currently not experiencing a grace period, you would see nothing in the grace column of the <code>quota -u JKirk</code> command. Thus, option D is also a wrong choice. Whether or not the user is logged into the system does not affect information displayed by the <code>edquota -u JKirk</code> command. Therefore, option E is an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      166,
      167
    ],
    "source": "316328_Practice Exam",
    "choice_e": "The user is not currently logged into the system."
  },
  {
    "id": 96,
    "question": "What raw device file would Linux create for the first SCSI drive connected to the system?",
    "choice_a": "<code>/dev/hdb</code>",
    "choice_b": "<code>/dev/sdb</code>",
    "choice_c": "<code>/dev/hda</code>",
    "choice_d": "<code>/dev/sda</code>",
    "correct_answer": "D",
    "explanation": "Linux assigns SCSI devices to the <code>/dev/sd</code> family of device files. The first device is assigned letter <code>a</code>, so the first SCSI device would be assigned device file <code>/dev/sda</code>, making option D correct. The <code>/dev/hdb</code> file references the second SATA drive on the system, so option A is incorrect. The <code>/dev/sdb</code> file references the second SCSI drive, so option B is incorrect. The <code>/dev/hda</code> file references the first SATA drive on the system, so option C is incorrect. The <code>/dev/sda1</code> file references the first partition on the first SCSI drive, not the entire drive, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      39,
      50,
      331,
      40,
      49
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>/dev/sda1</code>"
  },
  {
    "id": 97,
    "question": "Which tools are command-line tools for creating and modifying partitions? (Choose all that apply.)",
    "choice_a": "<code>gdisk</code>",
    "choice_b": "<code>gparted</code>",
    "choice_c": "<code>fdisk</code>",
    "choice_d": "<code>parted</code>",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "The common command-line tools for partitioning hard drives in Linux are <code>gdisk</code>, <code>fdisk</code>, and <code>parted</code>, making options A, C, and D all correct. The <code>gparted</code> tool is a graphical tool for partitioning hard drives, not a command-line tool, so option B is incorrect. The <code>fsck</code> command-line tool allows you to repair partitions but not create them, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      160,
      161,
      158,
      166,
      85
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>fsck</code>"
  },
  {
    "id": 98,
    "question": "Which tool should you use to fix a corrupted filesystem?",
    "choice_a": "<code>fsck</code>",
    "choice_b": "<code>gparted</code>",
    "choice_c": "<code>mount</code>",
    "choice_d": "<code>parted</code>",
    "correct_answer": "A",
    "explanation": "The <code>fsck</code> program is a front-end script that calls the appropriate program for repairing different types of filesystems on a Linux system, so option A is correct. The <code>gparted</code> and <code>parted</code> programs help create and modify partitions, but not the filesystems on the partitions, so options B and D are both incorrect. The <code>mount</code> and <code>umount</code> commands are used for adding or removing, respectively, partitions to the Linux virtual directory, not for repairing filesystems, so options C and E are both incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      170,
      166,
      164,
      167,
      346
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>umount</code>"
  },
  {
    "id": 99,
    "question": "Which tool do you need to use to partition a GPT indexed hard drive? (Choose all that apply).",
    "choice_a": "<code>parted</code>",
    "choice_b": "<code>fdisk</code>",
    "choice_c": "<code>gdisk</code>",
    "choice_d": "<code>gparted</code>",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "The <code>gdisk</code> and <code>gparted</code> tools allow you to partition both standard and GPT indexed hard drives, so option C is correct. The <code>parted</code>, and <code>fdisk</code> partition tools don\u2019t work on GPT indexed hard drives, so options A and B are both incorrect. The <code>fsck</code> program fixes corrupted partitions, but can\u2019t create or partition a GPT indexed hard drive, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      160,
      158,
      161,
      77,
      156
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>fsck</code>"
  },
  {
    "id": 100,
    "question": "You need to move several data files securely to a remote Windows system. What is the best utility group to employ for creating the archive?",
    "choice_a": "The <code>tar</code> utility",
    "choice_b": "The <code>zip</code> utility",
    "choice_c": "The <code>rsync</code> utility",
    "choice_d": "The <code>dd</code> utility",
    "correct_answer": "B",
    "explanation": "The Windows operating system can use this zip archive file format. Therefore the <code>zip</code> utility is the best one to use and option B is the correct answer. The <code>tar</code>, <code>rsync</code>, and <code>dd</code> utilities are not good choices due to incompatibility issues. Therefore, options A, C, and D are wrong choices. The <code>gzip</code> utility does not create archives, so option E is an incorrect answer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      183,
      186,
      198,
      191,
      184
    ],
    "source": "316328_Practice Exam",
    "choice_e": "The <code>gzip</code> utility"
  },
  {
    "id": 101,
    "question": "A system admin created an archive file using the <code>tar</code> utility and employed an option to apply compression automatically to the file. The system admin used an archive file extension of <code>.txz</code>. Which compression utility did the system admin claim the <code>tar</code> utility used?",
    "choice_a": "The <code>xz</code> utility",
    "choice_b": "The <code>gzip</code> utility",
    "choice_c": "The <code>bzip2</code> utility",
    "choice_d": "The <code>zip</code> utility",
    "correct_answer": "A",
    "explanation": "When a <code>.txz</code> file extension is used on a tarball, it implies that <code>xz</code> compression was used. Therefore, option A is the correct answer. The <code>gzip</code>, and <code>bzip2</code> utilities can be employed by the <code>tar</code> utility. However, the file extensions that imply their use are different than the one used by the system admin. Therefore, options B and C are wrong choices. The <code>zip</code> utility and <code>zlib</code> library are not used with the <code>ta</code>r utility, so options D and E are incorrect choices.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      182,
      181,
      185,
      186,
      184
    ],
    "source": "316328_Practice Exam",
    "choice_e": "The <code>zlib</code> library"
  },
  {
    "id": 102,
    "question": "You need to move several data files securely to a remote Linux system. What is the best utility group to employ for moving the newly created archive file?",
    "choice_a": "The <code>tar</code> utility",
    "choice_b": "The <code>zip</code> utility",
    "choice_c": "The <code>rsync</code> utility",
    "choice_d": "The <code>dd</code> utility",
    "correct_answer": "C",
    "explanation": "The <code>rsync</code> utility will allow you to employ OpenSSH to securely transfer the files to the remote Linux system. Therefore, option C is the correct answer. The <code>tar</code>, <code>zip</code>, and <code>dd</code> utilities can create backups but are not involved in secure file transfers. Therefore, options A, B, and D are wrong choices. The <code>gzip</code> utility does not transfer files, so option E is an incorrect answer.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      190,
      194,
      198,
      195,
      196
    ],
    "source": "316328_Practice Exam",
    "choice_e": "The <code>gzip</code> utility"
  },
  {
    "id": 103,
    "question": "Which of the following is true concerning the MD5- and SHA-based utilities? (Choose all that apply.)",
    "choice_a": "Both can be used in cryptographic functions.",
    "choice_b": "Both can be used to check a transferred file\u2019s integrity.",
    "choice_c": "The <code>tar</code> utility can use them via options.",
    "choice_d": "The SHA-based utilities produce longer hash values than the MD5-based utility.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Both the MD5- and SHA-based utilities can be used to check a transferred file\u2019s integrity. Also, the SHA-based utilities produce longer hash values than the MD5-based utility. Therefore, options B and D are correct answers. The MD5-based utility, md5sum, is no longer considered safe to use in cryptographic functions. Therefore, option A is a wrong answer. The <code>tar</code> command does not have the ability to employ these utilities via command-line switches, so option C is also an incorrect answer. Option E is also an incorrect choice because the opposite is true.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      246,
      244,
      247,
      250,
      254
    ],
    "source": "316328_Practice Exam",
    "choice_e": "The MD5-based utility produces longer hash values than the SHA-based utilities."
  },
  {
    "id": 104,
    "question": "What tools should you use to package an application source code so that it can be extracted in any Linux distribution?",
    "choice_a": "<code>dpkg</code>",
    "choice_b": "<code>rpm</code>",
    "choice_c": "<code>yum</code>",
    "choice_d": "<code>apt</code>",
    "correct_answer": "E",
    "explanation": "The tape archive utility, <code>tar</code>, is available on all Linux distributions and is commonly used to bundle application source code file for all distributions, so option E is correct. The <code>dpkg</code> and <code>apt-get</code> utilities only work on Debian-based Linux systems, so options A and D are incorrect. The <code>rpm</code> and <code>yum</code> utilities only work on Red Hat\u2013based Linux systems, so options B and C are both incorrect.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      184,
      183,
      187,
      11,
      181
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>tar</code>"
  },
  {
    "id": 105,
    "question": "What tar command-line options are commonly used to create a compressed tarball file?",
    "choice_a": "<code>-Uvh</code>",
    "choice_b": "<code>-zcvf</code>",
    "choice_c": "<code>-zxvf</code>",
    "choice_d": "<code>-xvf</code>",
    "correct_answer": "B",
    "explanation": "To create a compressed tarball you need to use the <code>\u2013z</code> option to compress it, the <code>\u2013c</code> option to create it, the <code>\u2013v</code> option for verbose mode, and the <code>\u2013f</code> option to specify the output file, so option B is correct. The <code>\u2013Uvh</code> options aren\u2019t <code>tar</code> command options, but are for the <code>rpm</code> package file, so option A is incorrect. The <code>\u2013zxvf</code> combination of options extracts a compressed tarball file, not creates one, so option C is incorrect. The <code>\u2013xvf</code> combination of options extracts an uncompressed tar ball file, it doesn\u2019t create a compressed tar ball, so option D is incorrect. The <code>\u2013cvf</code> combination of options creates a new tar ball file, but doesn\u2019t compress it, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      188,
      192,
      193,
      185,
      191
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>-cvf</code>"
  },
  {
    "id": 106,
    "question": "What tool do you use in Ubuntu to install an application package?",
    "choice_a": "<code>dpkg</code>",
    "choice_b": "<code>rpm</code>",
    "choice_c": "<code>yum</code>",
    "choice_d": "<code>dnf</code>",
    "correct_answer": "A",
    "explanation": "Ubuntu uses the Debian-based package management systems, so to install an Ubuntu application package you use the <code>dpkg</code> utility, making option A correct. The <code>rpm</code>, <code>yum</code>, and <code>dnf</code> programs are all used in the Red Hat\u2013based package management system, and will not work by default on an Ubuntu system, so options B, C, and D are all incorrect. The <code>tar</code> command is used to create and extract tarball files, not Ubuntu packages, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      205,
      204,
      207,
      206,
      211
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>tar</code>"
  },
  {
    "id": 107,
    "question": "Which tools can you use in Red Hat Linux to install an application package? (Choose all that apply.)",
    "choice_a": "<code>dpkg</code>",
    "choice_b": "<code>rpm</code>",
    "choice_c": "<code>yum</code>",
    "choice_d": "<code>dnf</code>",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "The <code>rpm</code>, <code>yum</code>, and <code>dnf</code> package tools all work with Red Hat\u2013based distribution packages, so options B, C, and D are all correct. The <code>dpkg</code> tool only works with Debian-based packages, so option A is incorrect. The <code>tar</code> command is used to create and extract tarball files, not Red Hat packages, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      206,
      211,
      207,
      205,
      210
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>tar</code>"
  },
  {
    "id": 108,
    "question": "A kernel module file has what file extension?",
    "choice_a": "<code>.dep</code>",
    "choice_b": "<code>.conf</code>",
    "choice_c": "<code>.sh</code>",
    "choice_d": "<code>.ko</code>",
    "correct_answer": "D",
    "explanation": "Kernel module files have a <code>.ko</code> file extension. Therefore, option D is the correct answer. The <code>.dep</code> file extension is used for the module\u2019s dependency file. Thus, option A is a wrong answer. The <code>.conf</code> file extension is often used by configuration files, and therefore, option B is an incorrect answer. The <code>.sh</code> file extension is used by shell scripts. Thus, option C is a wrong choice. The <code>.lib</code> file extension is often used by library files. Therefore, option E is also an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      213,
      216,
      212,
      1,
      215
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>.lib</code>"
  },
  {
    "id": 109,
    "question": "Kernel modules are stored in what directory?",
    "choice_a": "A <code>/lib/modules/</code> subdirectory",
    "choice_b": "A <code>/etc/modprobe.d/</code> subdirectory",
    "choice_c": "A <code>/run/modprobe.d/</code> subdirectory",
    "choice_d": "A <code>/lib/modprobe.d/</code> subdirectory",
    "correct_answer": "A",
    "explanation": "Kernel modules are stored in a <code>/lib/modules/</code> subdirectory. Thus, option A is the correct answer. Options B, C, D, and E are all potential locations of kernel module configuration files and not kernel modules. Thus, those options are incorrect choices.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      213,
      216,
      218,
      215,
      342
    ],
    "source": "316328_Practice Exam",
    "choice_e": "A <code>/usr/lib/modprobe.d/</code> subdirectory"
  },
  {
    "id": 110,
    "question": "Which file is shared by both the <code>modprobe</code> and the <code>depmod</code> utility?",
    "choice_a": "The <code>/etc/modules.conf</code> file",
    "choice_b": "The <code>/proc/modules</code> file",
    "choice_c": "The <code>/etc/group</code> file",
    "choice_d": "The <code> /etc/modprobe.d</code> file",
    "correct_answer": "E",
    "explanation": "The <code>modules.dep</code> file, which resides in the <code>/lib/modules/<i>Kernel-Version</i></code>/ directory, is used by the <code>modprobe</code> utility to determine module dependencies and updated by the <code>depmod</code> utility. Therefore, option E is the correct answer. The <code>/etc/modules.conf</code> file is a module configuration file used on older Linux distributions, thus option A is a wrong answer. The <code>/proc/modules</code> file has the same information that the <code>lsmod</code> utility displays, but it is not used by the <code>depmod</code> utility, so option B is a wrong choice. The <code>/etc/group</code> file is used for user groups but not kernel modules. Therefore, option C is an incorrect choice. The <code>/etc/modprobe.d</code> file is actually a directory, which stores some of the module configuration files. Thus, option D is an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      216,
      213,
      212,
      215,
      218
    ],
    "source": "316328_Practice Exam",
    "choice_e": "The <code>modules.dep</code> file"
  },
  {
    "id": 111,
    "question": "Which of the following utilities can be used to unload a kernel module? (Choose all that apply.)",
    "choice_a": "<code>rm</code>",
    "choice_b": "<code>rmmod</code>",
    "choice_c": "<code>insmod</code>",
    "choice_d": "<code>modprobe</code>",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Both the <code>rmmod</code> and the <code>modprobe</code> utilities can be used to unload (remove) kernel modules. You do have to use the <code>-r</code> switch with the <code>modprobe</code> command to remove a kernel module. Therefore, options B and D are correct answers. The <code>rm</code> command is used for removing files and not kernel modules, so option A is a wrong answer. The <code>insmod</code> utility is used to load a kernel module. Thus, option C is an incorrect answer. The <code>modinfo</code> command provides detailed information concerning a particular kernel module. Therefore, option E is also an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      218,
      216,
      212,
      215,
      213
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>modinfo</code>"
  },
  {
    "id": 112,
    "question": "What command do you use to change the basic permissions for a file?",
    "choice_a": "<code>chown</code>",
    "choice_b": "<code>chgrp</code>",
    "choice_c": "<code>chmod</code>",
    "choice_d": "<code>chage</code>",
    "correct_answer": "C",
    "explanation": "The <code>chmod</code> command uses either octal and character modes to assign file privileges to owners, groups, and others, so option C is correct. The <code>chown</code> command changes the owner of a file, not the permissions, so option A is incorrect. The <code>chgrp</code> command changes the group a file belongs to, not the permissions, so option B is incorrect. The <code>chage</code> command allows you to modify password settings for a user account, not permissions on a file, so option D is incorrect. The <code>ulimit</code> command allows you to restrict system resources for a user, not change permissions on a file, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      334,
      335,
      53,
      148,
      50
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>ulimit</code>"
  },
  {
    "id": 113,
    "question": "What command do you use to display the ACL permissions assigned to a file?",
    "choice_a": "<code>ls -Z</code>",
    "choice_b": "<code>getfacl</code>",
    "choice_c": "<code>ls -l</code>",
    "choice_d": "<code>chmod</code>",
    "correct_answer": "B",
    "explanation": "The <code>getfacl</code> command displays the advanced ACL permissions assigned to a file or directory, so option B is correct. The <code>ls</code> command with the <code>\u2013Z</code> option displays SELinux permissions, not ACL permissions, so option A is incorrect. The <code>ls</code> command with the <code>\u2013l</code> option displays the basic permissions assigned to a file, but not the ACL permissions, so option C is incorrect. The <code>chmod</code> command allows you to change basic permissions for a file, but not display ACL permissions, so option D is incorrect. The <code>setfacl</code> command allows you to set ACL permissions on a file, but not display them, so option E is incorrect.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      223,
      220,
      221,
      222,
      219
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>setfacl</code>"
  },
  {
    "id": 114,
    "question": "What command do you use to display the SELinux security context assigned to a file?",
    "choice_a": "<code>ls -Z</code>",
    "choice_b": "<code>getfacl</code>",
    "choice_c": "<code>ls -l</code>",
    "choice_d": "<code>chmod</code>",
    "correct_answer": "A",
    "explanation": "The SELinux advanced security system uses the standard <code>ls</code> command with the <code>\u2013Z</code> option to display SELinux security context assigned to files, so option A is correct. The <code>getfacl</code> and <code>setfacl</code> commands are related to the ACL permissions, not SELinux permissions, so options B and E are both incorrect. The <code>\u2013l</code> option of the <code>ls</code> command as well as the <code>chmod</code> command both are used for basic security permissions and not SELinux permissions, so options C and D are both incorrect.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      366,
      357,
      359,
      320,
      214
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>setfacl</code>"
  },
  {
    "id": 115,
    "question": "On an Ubuntu system, how do you run an application with root privileges?",
    "choice_a": "<code>su</code>",
    "choice_b": "<code>wheel</code>",
    "choice_c": "<code>sudo</code>",
    "choice_d": "<code>visudo</code>",
    "correct_answer": "C",
    "explanation": "The Ubuntu Linux system prevents users from using the <code>su</code> command to become the root user account, so you must use the <code>sudo</code> command to run individual applications with root privileges, making option C correct. Since <code>su</code> is not useful in Ubuntu, option A is incorrect. <code>Wheel</code> and <code>adm</code> are names of groups commonly used to assign administrator privileges to users in Linux, they\u2019re not commands to run applications with root privileges, so options B and E are both incorrect. The <code>visudo</code> command only allows you to edit a text file with root privileges, it doesn\u2019t allow you to run another application, so option D is incorrect.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      230,
      232,
      289,
      227,
      255
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>adm</code>"
  },
  {
    "id": 116,
    "question": "Which of the following is a PAM module involved with enforcing strong passwords? (Choose all that apply.)",
    "choice_a": "<code>pam_pwhistory.so</code>",
    "choice_b": "<code>pam_unix.so</code>",
    "choice_c": "<code>pam_pwquality.so</code>",
    "choice_d": "p <code>am_tally2.so</code>",
    "correct_answer": [
      "A",
      "B",
      "C",
      "E"
    ],
    "explanation": "The <code>pam_pwhistory.so</code>, <code>pam_unix.so</code>, and <code>pam_pwquality.so</code> are all involved with enforcing strong passwords for PAM-aware applications, so options A, B, and C are correct answers. The <code>pam_cracklib.so</code> is an earlier version of the <code>pam_pwquality.so</code> module, so option E is also a correct choice. The <code>pam_tally2.so</code> helps to prevent brute-force attacks by locking accounts after so many failed login attempts. Therefore, option D is an incorrect choice.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      239,
      238,
      237,
      240,
      243
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>pam_cracklib.so</code>"
  },
  {
    "id": 117,
    "question": "Which of the following is true concerning PKI? (Choose all that apply.)",
    "choice_a": "Through the PKI framework, self-signed certificates are implemented.",
    "choice_b": "The PKI framework prevents brute-force attacks via implementing strong passwords.",
    "choice_c": "Via the PKI structure, CA signed certificates are implemented.",
    "choice_d": "PKI ensures that proper encryption algorithms are employed.",
    "correct_answer": [
      "C",
      "E"
    ],
    "explanation": "Signed certificates are implemented via the PKI framework. These certificates help to prove authenticity and validation of the keys as well as the keys\u2019 owner. Thus, options C and E are correct answers. Self-signed certifications are not provided via the PKI structure, so option A is a wrong answer. The PKI framework is not involved with implementing strong passwords or preventing brute-force attacks. Therefore, option B is an incorrect answer. Also, the PKI does not ensure that proper encryption algorithms are used, so option D is an incorrect choice as well.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      245,
      244,
      248,
      286,
      247
    ],
    "source": "316328_Practice Exam",
    "choice_e": "The PKI framework helps to protect key integrity."
  },
  {
    "id": 118,
    "question": "When using an SSH agent for authentication, what command is used to add a key to the agent session?",
    "choice_a": "The <code>ssh-keygen</code> command",
    "choice_b": "The <code>ssh-agent</code> command",
    "choice_c": "The <code>ssh-copy-id</code> command",
    "choice_d": "The <code> ssh-add</code> command",
    "correct_answer": "D",
    "explanation": "The <code>ssh-add</code> command allows you to add your identity key to the agent session to use for authentication. Therefore, option D is the correct answer. The <code>ssh-keygen</code> is for generating keys, and thus option A is the wrong answer. The <code>ssh-agent</code> command will start an agent session but does not add keys to the session, so option B is a wrong choice. The <code>ssh-copy-id</code> command allows you to copy an identity key to a remote system and add it to the <code>~/.ssh/authorized_keys</code> file for passwordless authentication. Therefore, option C is a wrong answer. The <code>scp</code> command allows you to copy files over a network via an SSH tunnel but not add files to an SSH agent session, and thus option E is an incorrect choice.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      254,
      252,
      253,
      251,
      248
    ],
    "source": "316328_Practice Exam",
    "choice_e": "The <code>scp</code> command"
  },
  {
    "id": 119,
    "question": "Which of the following best describes IPSec tunnel mode?",
    "choice_a": "The data is encrypted along with a message digest of the original plain text.",
    "choice_b": "Only the payload is encrypted.",
    "choice_c": "The data is turned into ciphertext via a hash algorithm.",
    "choice_d": "The payload is encrypted using a symmetric key, and a public key is used for confirming the systems\u2019 identity.",
    "correct_answer": "E",
    "explanation": "Used within VPN software, IPSec provides either tunnel or transport mode. Tunnel mode is when both the payload (data) and the routing headers are encrypted. Therefore, option E is the correct answer. Option A describes a digital signature, and thus it is a wrong answer. IPSec transport mode is described by option B, and therefore it also is a wrong choice. Option C describes the hashing process, so it is an incorrect answer. SSL/TLS and DTLS both use the security feature described in option D, so it as well is an incorrect choice.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      247,
      244,
      246,
      249,
      291
    ],
    "source": "316328_Practice Exam",
    "choice_e": "The payload and routing headers are encrypted."
  },
  {
    "id": 120,
    "question": "What syslog event severity level is the lowest?",
    "choice_a": "<code>emerg</code>",
    "choice_b": "<code>err</code>",
    "choice_c": "<code>debug</code>",
    "choice_d": "<code>warning</code>",
    "correct_answer": "C",
    "explanation": "The syslog protocol severity levels range from a low of 7 to a high of 0, The <code>debug</code> event is assigned a severity of 7, making it the lowest severity level, so option C is correct. The <code>emerg</code> event is at level 0, making it the highest, so option A is incorrect. The <code>err</code> event severity level is 3, the <code>warning</code> severity level is 4, and the <code>info</code> severity level is 6, making them all higher than the debug level, so options B, D, and E are all incorrect.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      295
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>info</code>"
  },
  {
    "id": 121,
    "question": "What <code>rsyslog</code> utility is commonly used to split log files into separate files based on a time or size of the file?",
    "choice_a": "<code>rsyslogd</code>",
    "choice_b": "<code>logrotate</code>",
    "choice_c": "<code>logger</code>",
    "choice_d": "<code>systemd-journald</code>",
    "correct_answer": "B",
    "explanation": "The <code>logrotate</code> utility normally runs in background and splits log files either when they reach a predetermined size, or after a predetermined number of days, so option B is correct. The <code>rsyslogd</code> and <code>syslogd</code> commands are the logger programs themselves, so options A and E are both incorrect. The <code>logger</code> command allows you to manually make an entry into the log files, but not split the log files, so option C is incorrect. The <code>systemd-journald</code> program is the logging program for systemd systems and can rotate the logs automatically, but doesn\u2019t work on <code>rsyslog</code> systems, so option D is incorrect.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      260,
      257,
      259,
      258,
      261
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>syslogd</code>"
  },
  {
    "id": 122,
    "question": "What configuration setting should you set in <code>systemd-journald</code> to also forward events to an <code>rsyslogd</code> server?",
    "choice_a": "<code>ForwardToSyslog</code>",
    "choice_b": "<code>Storage</code>",
    "choice_c": "<code>Compress</code>",
    "choice_d": "<code>Storage=volatile</code>",
    "correct_answer": "A",
    "explanation": "The <code>ForwardToSyslog</code> setting allows you to specify to forward the systemd events to an <code>rsyslogd</code> server, so option A is correct. The <code>Storage</code> setting determines how the logs are stored on the local server, not whether they\u2019re forwarded to an <code>rsyslogd</code> server, so options B, D, and E are all incorrect. The <code>Compress</code> setting determines if the log files are compressed, not whether they\u2019re forwarded to an <code>rsyslogd</code> server, so option C is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      21,
      90,
      103,
      102,
      413
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>Storage=persistent</code>"
  },
  {
    "id": 123,
    "question": "What <code>journalctl</code> command-line options should you use to display just the kernel events?",
    "choice_a": "<code>-a</code>",
    "choice_b": "<code>-r</code>",
    "choice_c": "<code>_TRANSPORT=kernel</code>",
    "choice_d": "<code>PRIORITY=0</code>",
    "correct_answer": "C",
    "explanation": "The <code>_TRANSPORT</code> command-line option determines what transport events to display, so setting that value to <code>kernel</code> displays only kernel-level events, making option C correct. The <code>\u2013a</code> command-line option displays all of the log fields for all of the events, so option A is incorrect. Using the <code>\u2013r</code> option reverses the output so that the newest entries are displayed first, but doesn\u2019t filter only the kernel events, so option B is incorrect. The <code>PRIORITY</code> option filters out only the entries with the specified priority, not only kernel events, so option D is incorrect. The <code>_HOSTNAME</code> option filters out only the entries from a specified hostname, not just the kernel entries, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      22
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>_HOSTNAME=localhost</code>"
  },
  {
    "id": 124,
    "question": "Which of the following describes the difference between the firewall ACL rule settings of reject and drop?",
    "choice_a": "Drop sends a denial message, and reject does not, but both block the packet.",
    "choice_b": "Reject sends a denial message, and drop does not, but both block the packet.",
    "choice_c": "Reject and drop both send a denial message, but only drop blocks the packet.",
    "choice_d": "Reject and drop both send a denial message, but only reject blocks the packet.",
    "correct_answer": "B",
    "explanation": "The firewall ACL rule settings of reject and drop both block an identified packet. However, only reject sends back a denial message. Drop just quietly acts. Therefore, option B is the correct answer. All the other options are incorrect.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      274,
      267,
      270,
      273,
      369
    ],
    "source": "316328_Practice Exam",
    "choice_e": "Reject and drop both block the packet, but neither sends a denial message."
  },
  {
    "id": 125,
    "question": "Which of the following describes firewall persistency?",
    "choice_a": "The firewall survives repeated malicious attacks on the system and continues to protect the system.",
    "choice_b": "The firewall survives repeated malicious attacks on the system as well as firewall misconfigurations.",
    "choice_c": "The firewall survives attacks on the system and can alert administrators of the attacks.",
    "choice_d": "The firewall can alert administrators of attacks and take needed action to block the attacks.",
    "correct_answer": "E",
    "explanation": "Firewall persistency is best described by the fact that the firewall configuration survives system reboots as well as the firewall being restarted or reloaded. Thus, option E is the correct answer. While a firewall may survive repeated malicious attacks on the system and continue to protect the system, this does not describe persistency. Therefore option A is a wrong answer. Surviving a firewall misconfiguration also does not describe persistency, so option B is also an incorrect answer. While the description in option C may be available within some firewall software packages, it does not describe persistency, so option C is a wrong choice. Option D describes an intrusion detection system (IDS) and not persistency. Therefore, option D is an incorrect choice as well.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      277,
      274,
      278,
      271,
      273
    ],
    "source": "316328_Practice Exam",
    "choice_e": "The firewall configuration survives system reboots as well as the firewall being restarted or reloaded."
  },
  {
    "id": 126,
    "question": "You want to add the NFS service to the <code>firewalld</code>\u2019s public zone. What command will accomplish this?",
    "choice_a": "<code>sudo firewalld-cmd --add-service=nfs --zone=public</code>",
    "choice_b": "<code>sudo firewalld-cmd --service=nfs --zone=public</code>",
    "choice_c": "<code>sudo firewall-cmd --add-service=nfs --zone=public</code>",
    "choice_d": "<code>sudo firewall-cmd --service=nfs --zone=public</code>",
    "correct_answer": "C",
    "explanation": "The <code>sudo firewall-cmd --add-service=nfs --zone=public</code> command will add the NFS service to the public zone in <code>firewalld</code>. Therefore, option C is the correct answer. There is no <code>firewalld-cmd</code> command, and thus options A and B are wrong answers. In addition, neither the <code>--service</code> nor the <code>--add</code> option is valid, so options D and E are also incorrect choices.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      272,
      271,
      268,
      278,
      369
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>sudo firewall-cmd --add=nfs --zone=public</code>"
  },
  {
    "id": 127,
    "question": "You want to peruse UFW profiles. Where are they stored?",
    "choice_a": "<code>/etc/default/ufw</code>",
    "choice_b": "<code>/etc/ufw/applications.d/</code>",
    "choice_c": "<code>/etc/services</code>",
    "choice_d": "<code>/etc/ufw/user.rules</code>",
    "correct_answer": "B",
    "explanation": "UFW profiles are stored in the <code>/etc/ufw/applications.d/</code> directory. Therefore, option B is the correct answer. The UFW configuration file is the <code>/etc/default/ufw</code> file. Thus, option A is the wrong answer. The <code>/etc/services</code> file is used by UFW to determine the appropriate port and protocol information for service names used in its command syntax. Therefore, option C is also an incorrect answer. Any user-added rules are stored in the <code>/etc/ufw/</code> directory, with IPv4 rules in the <code>user.rules</code> file and IPv6 rules in the <code>user6.rules</code> file. Thus, options D and E are incorrect choices.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      276,
      369,
      278,
      274,
      272
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>/etc/ufw/user6.rules</code>"
  },
  {
    "id": 128,
    "question": "Where is the <code>/usr/bin/nologin</code> file used, and why would you use it?",
    "choice_a": "When used as the default shell for a user defined in the <code>/etc/passwd</code> file, it prevents that user account from logging in.",
    "choice_b": "When used as the default shell for a user defined in the <code>/etc/passwd</code> file, it prevents the user from logging in only at the console.",
    "choice_c": "When used as the default shell in the <code>inittab</code> file, it prevents user accounts from logging in on a specific terminal.",
    "choice_d": "When used as the default shell in the <code>inittab</code> file, it prevents users from logging in on all terminals.",
    "correct_answer": "A",
    "explanation": "The <code>/usr/bin/nologin</code> file prevents a user account from logging in from any terminal when specified as the user\u2019s default shell in the <code>/etc/passwd</code> file, so option A is correct. When specified as the default shell, it applies to any terminal the user attempts to log in from, so option B is incorrect. The default shell is specified in the <code>/etc/passwd</code> file and not the <code>inittab</code> file, so options C, D, and E are all incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      139,
      143,
      137,
      138,
      339
    ],
    "source": "316328_Practice Exam",
    "choice_e": "When used in the <code>inttab</code> file, it prevents users from logging in only at the console."
  },
  {
    "id": 129,
    "question": "What can you do to limit an SFTP server program from allowing users to access system files?",
    "choice_a": "Run it as a separate process.",
    "choice_b": "Run it in background mode.",
    "choice_c": "Run it from the <code>tcpwrappers</code> program.",
    "choice_d": "Run it in a chroot jail.",
    "correct_answer": "D",
    "explanation": "When running an application using <code>chroot</code> you can restrict the application to a specific directory in the virtual directory, making option D the correct answer. Just running an application as a separate process doesn\u2019t change the assigned file or directory permissions assigned, so option A is incorrect. Likewise, running the process in background mode doesn\u2019t alter the permissions, so option B is incorrect. The <code>tcpwrappers</code> program can limit what network devices can connect to the application, but not what directories the application has access to, so option C is incorrect. Running the application without root privileges would help prevent overwriting system files, but wouldn\u2019t necessarily prevent reading system files, so option E is incorrect.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      293,
      296,
      227,
      225,
      231
    ],
    "source": "316328_Practice Exam",
    "choice_e": "Run it without root privileges."
  },
  {
    "id": 130,
    "question": "What method should you implement to encrypt an entire disk partition?",
    "choice_a": "<code>chroot</code>",
    "choice_b": "PKI",
    "choice_c": "LUKS",
    "choice_d": "Kerberos",
    "correct_answer": "C",
    "explanation": "The Linux Unified Key Setup (LUKS) specification provides a method for encrypting an entire disk partition on the fly so you don\u2019t need to encrypt individual files, making option C correct. The <code>chroot</code> program can restrict applications from accessing directories, but doesn\u2019t encrypt files, so option A is incorrect. PKI, Kerberos, and LDAP are all methods of authenticating users, not encrypting data, so options B, D, and E are all incorrect.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      291,
      300,
      247,
      244,
      293
    ],
    "source": "316328_Practice Exam",
    "choice_e": "LDAP"
  },
  {
    "id": 131,
    "question": "What TCP port should you disable to prevent users from using the Telnet service to access your Linux server?",
    "choice_a": "20",
    "choice_b": "21",
    "choice_c": "22",
    "choice_d": "23",
    "correct_answer": "D",
    "explanation": "The Telnet protocol uses plain text transmissions on TCP port 23, so option D is the correct answer. Ports 20 and 21 are used for FTP, not Telnet, so options A and B are incorrect. Port 22 is used for SSH encrypted connections, not Telnet, so option C is incorrect. Port 25 is used for sending SMTP email messages, not Telnet connections, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      194,
      126,
      129,
      127,
      128
    ],
    "source": "316328_Practice Exam",
    "choice_e": "25"
  },
  {
    "id": 132,
    "question": "Which of the following are potential causes of packet drop? (Choose all that apply.)",
    "choice_a": "An improperly connected network cable",
    "choice_b": "An adapter that is failing",
    "choice_c": "A firewall blocking traffic",
    "choice_d": "A saturated network segment",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "An improperly connected network cable, an adapter that is failing, and a saturated network segment all are potential causes of packet drop. Therefore, options A, B and D are correct answers. A firewall blocking traffic and an incorrectly entered FQDN are situations where a timeout may occur, but not packet loss. Thus, options C and E are incorrect choices.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      302,
      308,
      301,
      304,
      306
    ],
    "source": "316328_Practice Exam",
    "choice_e": "An incorrectly entered FQDN"
  },
  {
    "id": 133,
    "question": "Which of the following tools should you employ for disk space problems? (Choose all that apply.)",
    "choice_a": "<code>du</code>",
    "choice_b": "<code>iostat</code>",
    "choice_c": "<code>ioping</code>",
    "choice_d": "<code>df</code>",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "The <code>du</code> and <code>df</code> commands are the ones to use for situations where disk space is an issue. Therefore, options A and D are the correct answers. The <code>iostat</code> command displays items such as I/O wait, but nothing on disk space. Thus, option B is a wrong choice. The <code>ioping</code> utility is more for testing new disks on performance items. Therefore, option C is a wrong answer. The <code>iotop</code> utility is helpful in locating an application or process causing high I/O, but not disk space problems. Thus, option E is also an incorrect answer.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      168,
      156,
      158,
      161,
      85
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>iotop</code>"
  },
  {
    "id": 134,
    "question": "Which of the following best describes a load average?",
    "choice_a": "The amount of time a processor must wait on disk I/O",
    "choice_b": "A series of kernel actions that handle I/O requests",
    "choice_c": "The amount of time processes are waiting for or using the CPU",
    "choice_d": "High deviations from a network\u2019s average latency",
    "correct_answer": "C",
    "explanation": "Option C best describes load averages. Thus, it is the correct answer. Option A describes I/O wait, and therefore, it is a wrong answer. Option B is describing I/O scheduling. Thus, it is also an incorrect choice. Option D describes network jitter, and therefore it is a wrong answer. Option E is describing timeouts. Thus, it is an incorrect choice.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      323,
      324,
      328,
      37,
      135
    ],
    "source": "316328_Practice Exam",
    "choice_e": "Preset time periods that are used for handling unplanned network events"
  },
  {
    "id": 135,
    "question": "You want to view detailed information about your system\u2019s memory. Which command should you use?",
    "choice_a": "<code>ipcs -m</code>",
    "choice_b": "<code>cat /proc/meminfo</code>",
    "choice_c": "<code>free</code>",
    "choice_d": "<code>sar</code>",
    "correct_answer": "B",
    "explanation": "For detailed information concerning a system\u2019s RAM, use the <code>cat /proc/meminfo</code> command to view it. Therefore, option B is the correct answer. The <code>ipcs -m</code> command allows you to see shared memory segments instead of detailed RAM information. Thus, option A is the wrong answer. The <code>free</code> command shows memory items such as free memory, used memory, and buffer/cache usage. Thus, option C is an incorrect answer. The <code>sar</code> utility can provide memory performance information, but that is not what is needed here. Thus, option D is an incorrect answer. The <code>vmstat</code> utility provides a lot of memory statistics, including disk I/O specific to swapping as well as total blocks in and blocks out to the device. However, it does not provide detailed information about your system\u2019s memory, so option E is an incorrect choice.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      316,
      318,
      319,
      372,
      312
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>vmstat</code>"
  },
  {
    "id": 136,
    "question": "For the <code>ps</code> command, which type of parameters must you precede with a single dash?",
    "choice_a": "Unix-style parameters",
    "choice_b": "BSD-style parameters",
    "choice_c": "GNU long parameters",
    "choice_d": "Linux style",
    "correct_answer": "A",
    "explanation": "The <code>ps</code> command in Linux supports Unix-style, BSD-style, and GNU long parameters; thus, options D and E are both incorrect. To differentiate between the three, Unix-style parameters are preceded by a dash, so option A is correct. BSD-style parameters are not preceded by anything, making option B incorrect. GNU long parameters are preceded by a double dash, making option C incorrect.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      1,
      16,
      59,
      68,
      166
    ],
    "source": "316328_Practice Exam",
    "choice_e": "Numeric style"
  },
  {
    "id": 137,
    "question": "What output does the command <code>ps -e</code> produce?",
    "choice_a": "All processes running on the terminal",
    "choice_b": "All processes",
    "choice_c": "Only sleeping processes",
    "choice_d": "All processes run by the current shell",
    "correct_answer": "B",
    "explanation": "The <code>\u2013e</code> Unix-style parameter for the <code>ps</code> command displays the status of all processes running on the system, so option B is correct. To display processes running on a specific terminal, use the <code>\u2013t</code> parameter, not the <code>\u2013e</code> parameter, so option A is incorrect. The <code>\u2013e</code> parameter does display sleeping processes, but also active processes, so option C is incorrect. To only display processes run by the current shell, don\u2019t specify any parameters to the <code>ps</code> command, so option D is incorrect. To display all processes run by the current user, use the <code>\u2013x</code> parameter, not the <code>\u2013e</code> parameter, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      321,
      322,
      408,
      404,
      327
    ],
    "source": "316328_Practice Exam",
    "choice_e": "All processes run by the current user"
  },
  {
    "id": 138,
    "question": "What command displays the CPU and memory utilization updated in real time on the system?",
    "choice_a": "<code>ps</code>",
    "choice_b": "<code>lsof</code>",
    "choice_c": "<code>kill</code>",
    "choice_d": "<code>top</code>",
    "correct_answer": "D",
    "explanation": "The <code>top</code> command displays a table that\u2019s updated in real time, showing the current CPU and memory utilization on the system, making option D correct. The <code>ps</code> command can show the CPU and memory utilization, but just as a snapshot and not in real time, so option A is incorrect. The <code>lsof</code> command displays open files, not CPU and memory utilization, so option B is incorrect. The <code>kill</code> and <code>pkill</code> commands are used to stop processes, not display the CPU and memory utilization, so options C and E are both incorrect.,.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      318,
      316,
      315,
      111,
      214
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>pkill</code>"
  },
  {
    "id": 139,
    "question": "What command allows you to stop a running process, but only if you know the process ID?",
    "choice_a": "<code>renice</code>",
    "choice_b": "<code>kill</code>",
    "choice_c": "<code>pkill</code>",
    "choice_d": "<code>nice</code>",
    "correct_answer": "B",
    "explanation": "You can use the <code>kill</code> command can stop a running process, but you must know the process ID of the process, so option B is correct. The <code>renice</code> and <code>nice</code> commands allow you to change the scheduling priority of a process, not stop it, so options A and D are both incorrect. The <code>pkill</code> command allows you to kill a process based on its name, not process ID, so option C is incorrect. The <code>pgrep</code> command allows you to display a process status based on its name, but not stop it, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      326,
      327,
      325,
      321,
      415
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>pgrep</code>"
  },
  {
    "id": 140,
    "question": "A new user account, <code>Hansen7o9</code>, was created, but the user cannot log into the system. You suspect a password was not set for this account. What command should you use to investigate this suspicion?",
    "choice_a": "<code>sudo chage -l Hansen7o9</code>",
    "choice_b": "<code>sudo passwd -S Hansen7o9</code>",
    "choice_c": "<code>sudo getent passwd Hansen7o9</code>",
    "choice_d": "<code>sudo getent shadow Hansen7o9</code>",
    "correct_answer": "D",
    "explanation": "The <code>sudo getent shadow Hansen7o9</code> command will show only an exclamation point in the account\u2019s password field if a password has not been set for this account. Therefore, option D is the correct answer. The <code>chage -l</code> command shows password information, but not whether or not a password was set, so option A is a wrong answer. The <code>passwd -S</code> command will show an <code>L</code> indicating that the account is locked, but it does not tell you if the account was locked via a command or by just not setting a password for it, so option B is an incorrect choice. The <code>getent passwd</code> command shows fields for the <code>/etc/passwd</code> file and not the <code>/etc/shadow</code> file, where modern distributions store their accounts\u2019 password information. Therefore, option C is also a wrong answer. The <code>lastlog</code> command will not show anything for the <code>Hansen7o9</code> account because this account has not yet been used to log into the system. Thus, option E is an incorrect choice.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      143,
      139,
      141,
      152,
      330
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>sudo lastlog Hansen7o9</code>"
  },
  {
    "id": 141,
    "question": "The user <code>Hansen7o9</code> has tried multiple times to access her account but was using the wrong password. She thinks the system has now locked her out. Assuming your system employs PAM for authentication, which of the following utilities can you use to see if her account was locked out due to failed login attempts? (Choose all that apply.)",
    "choice_a": "<code>ausearch</code>",
    "choice_b": "<code>pam_tally2</code>",
    "choice_c": "<code>sealert</code>",
    "choice_d": "<code>faillock</code>",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Depending on <code>Hansen7o9</code>\u2019s system\u2019s employment of PAM, either the <code>pam_tally2</code> or <code>faillock</code> utility will allow her to see if the user was locked out of the system due to failed login attempts. Thus, options B and D are correct answer. The <code>ausearch</code> command is used with AppArmor and not PAM, so option A is a wrong answer. The <code>sealert</code> and <code>id -Z</code> commands are used with SELinux, and not PAM, so options C and E are incorrect choices as well.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      330,
      329,
      141,
      143,
      142
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>id -Z</code>"
  },
  {
    "id": 142,
    "question": "A user cannot create a file in his directory. You recognize that this is occurring for everyone using that same filesystem and suspect inode exhaustion. What command can you use to see if your suspicion is correct?",
    "choice_a": "<code>touch</code>",
    "choice_b": "<code>df -i</code>",
    "choice_c": "<code>df -h</code>",
    "choice_d": "<code>du -i</code>",
    "correct_answer": "B",
    "explanation": "When a filesystem runs out of inode numbers (inode exhaustion), no additional files can be created on it. To check if this is what is happening on a system, use the <code>df -i</code> command, which shows each filesystem\u2019s inode use and whether or not it is exhausted. Therefore, option B is the correct answer. While the <code>touch</code> command would allow you to try to create a file on this filesystem to see if it fails, it does not help in determining whether or not inode exhaustion is the problem, so option A is a wrong answer. The <code>df -h</code> command shows disk space usages for the various filesystems in human-readable format, but not inode usage, so option C is an incorrect answer. The <code>du</code> command cannot display inode usage and there is no <code>-i</code> option for this particular utility. Thus, options D and E are both incorrect choices.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      168,
      164,
      162,
      166,
      167
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>du -h</code>"
  },
  {
    "id": 143,
    "question": "You attempt to delete a file using super user privileges and receive a permission error. You determine that the file, <code>ST.txt</code>, has the immutable bit set. What command would you issue to remove this bit from the file?",
    "choice_a": "<code>lsattr ST.txt</code>",
    "choice_b": "<code>lsattr -l ST.txt</code>",
    "choice_c": "<code>chattr -i ST.txt</code>",
    "choice_d": "<code>chattr +i ST.txt</code>",
    "correct_answer": "C",
    "explanation": "To remove the immutable bit from the <code>ST.txt</code> file, you need to employ the <code>chattr -i ST.txt</code> command. Thus, option C is the correct answer. The <code>lsattr ST.txt</code> command displays the file\u2019s attributes allowing you to see whether or not the immutable bit is set, but it does not allow you to change it. Therefore, option A is a wrong answer. The <code>lsattr -l ST.txt</code> command displays a file\u2019s attributes using long names instead of abbreviations, which is handy, but it does not remove attributes, such as the immutable bit. Thus, option B is an incorrect answer. The <code>chattr +i ST.txt</code> command would add the immutable bit instead of removing the immutable bit from the <code>ST.txt</code> file\u2019s attributes. Therefore, option D is also a wrong answer. The <code>mv ST.txt SS.txt</code> command would fail if the file has the immutable bit set because you cannot rename (move) a file with that attribute. Also, the command does not remove the immutable bit, so option E is an incorrect choice.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      235,
      220,
      230,
      221,
      234
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>mv ST.txt SS.txt</code>"
  },
  {
    "id": 144,
    "question": "What directory does Linux use to store device files?",
    "choice_a": "<code>/proc</code>",
    "choice_b": "<code>/sys</code>",
    "choice_c": "<code>/dev</code>",
    "choice_d": "<code>/home</code>",
    "correct_answer": "C",
    "explanation": "Linux places all device files in the <code>/dev</code> directory, so option C is correct. The <code>/proc</code> and <code>/sys</code> directories contain files that indicate system and kernel statistics that are updated regularly, but not device files, so options A and B are incorrect. The <code>/home</code> directory contains user data folders, not device files, so option D is incorrect. The <code>/usr</code> directory contains user applications, not device files, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      39,
      331,
      40,
      43,
      41
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>/usr</code>"
  },
  {
    "id": 145,
    "question": "If the Linux system doesn\u2019t recognize a hardware device at boot time, what command can you use to check for errors?",
    "choice_a": "<code>dmesg</code>",
    "choice_b": "<code>lsusb</code>",
    "choice_c": "<code>lspci</code>",
    "choice_d": "<code>lsdev</code>",
    "correct_answer": "A",
    "explanation": "The kernel logs device errors detected at boot time in the kernel ring buffer. The <code>dmesg</code> program allows you to view the messages in the kernel ring buffer, so option A is correct. The <code>lsusb</code>, <code>lspci</code>, <code>lsblk</code>, and <code>lsdev</code> commands allow you to view current settings and statistics for various types of devices on the Linux system, but they don\u2019t allow you to view errors that occurred at boot time, so options B, C, D, and E are all incorrect.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      214,
      375,
      351,
      217,
      371
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>lsblk</code>"
  },
  {
    "id": 146,
    "question": "Which command displays current information about all the devices on the Linux system?",
    "choice_a": "<code>dmesg</code>",
    "choice_b": "<code>lsusb</code>",
    "choice_c": "<code>lspci</code>",
    "choice_d": "<code>lsdev</code>",
    "correct_answer": "D",
    "explanation": "The <code>lsdev</code> command displays information on all of the devices currently installed on the Linux system, so option D is correct. The <code>dmesg</code> command displays information from the kernel ring buffer, which may contain information about devices found at boot time, but not the current information on the device, so option A is incorrect. The <code>lsusb</code> command only displays information about USB devices, the <code>lspci</code> command only displays information about PCI devices, and the <code>lsblk</code> command only displays information about block devices, making options B, C, and E all incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      346,
      347,
      350,
      342,
      75
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>lsblk</code>"
  },
  {
    "id": 147,
    "question": "What program listens to kernel notifications about new hardware devices?",
    "choice_a": "<code>lsusb</code>",
    "choice_b": "<code>lspci</code>",
    "choice_c": "<code>udev</code>",
    "choice_d": "<code>lsblk</code>",
    "correct_answer": "C",
    "explanation": "The <code>udev</code> program runs in background, listening for kernel notifications about new hardware devices and attempting to add them to the <code>/dev</code> device directory automatically, making option C correct. The <code>lsusb</code>, <code>lspci</code>, and <code>lsblk</code> commands only display information about currently installed devices, not new devices, so options A, B, and D are all incorrect. The <code>dmesg</code> command displays kernel notifications added to the kernel ring buffer, but doesn\u2019t listen for new events to be added, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      350,
      342,
      347,
      75,
      346
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>dmesg</code>"
  },
  {
    "id": 148,
    "question": "On Linux, the SCSI framework consists of what integral parts? (Choose all that apply.)",
    "choice_a": "The device driver layer",
    "choice_b": "The SBA driver layer",
    "choice_c": "The HBA driver layer",
    "choice_d": "The SCSI routing layer",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "On Linux, the SCSI framework consists of three integral parts\u2014the device driver layer (upper), the SCSI routing layer (middle), and the host bus adapter (HBA) driver layer (lower). Problems typically occur in the upper and lower layers. Therefore, options A, C, and D, are the correct answers. There is no such thing as the SBA driver layer with SCSI, so option B is a wrong answer. Also the SCSI framework does not have a SCSI storage layer, so option E is an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      175,
      212,
      157,
      341,
      344
    ],
    "source": "316328_Practice Exam",
    "choice_e": "The SCSI storage layer"
  },
  {
    "id": 149,
    "question": "The user <code>Hansen7o9</code> ran a script, <code>Borg.sh</code>, which tried to run another program but got a privilege error. What should you check first?",
    "choice_a": "Check if <code>Hansen7o9</code> has the privileges to run the <code>Borg.sh</code> script by viewing the script\u2019s permissions.",
    "choice_b": "Check if <code>Hansen7o9</code> has the privileges to run the <code>Borg.sh</code> script by viewing the script\u2019s directory execute permissions.",
    "choice_c": "Check if <code>Hansen7o9</code> has the privileges to run the other program by viewing its permissions.",
    "choice_d": "Check if <code>Hansen7o9</code> has the privileges to run the other program by viewing its directory\u2019s execute permissions.",
    "correct_answer": "C",
    "explanation": "You should check if <code>Hansen7o9</code> has the privileges to run the other program by viewing its permissions via the <code>ls -l</code> command. Thus, option C is the correct answer. The user <code>Hansen7o9</code> can already run the script, <code>Borg.sh</code>, so options A and B are wrong answers. Directory execute permissions are not needed to run a script or program. Instead they allow a user to change their present working directory to that location, but the permission must be set throughout the directory tree. Therefore, options D and E are incorrect choices.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      334,
      39,
      335,
      53,
      147
    ],
    "source": "316328_Practice Exam",
    "choice_e": "Check if <code>Hansen7o9</code> has the privileges to run the other program by viewing its directory tree\u2019s execute permissions."
  },
  {
    "id": 150,
    "question": "A user goes to merge PDF files using the <code>/usr/bin/pdfunite</code> utility and it does not work. You recently updated the system and suspect the application had a library get updated. Before searching the package management log files for the updated library names, you must find the libraries used by this utility. What command should you issue?",
    "choice_a": "<code>rpm -qpdfunite --last</code>",
    "choice_b": "<code>grep pdfunite /var/log/apt/history.log</code>",
    "choice_c": "<code>grep pdfunite /etc/zypp/repos.d/*.*</code>",
    "choice_d": "<code>grep pdfunite /etc/yum.repos.d/*.*</code>",
    "correct_answer": "E",
    "explanation": "The <code>ldd /usr/bin/pdfunite</code> command will show you all the libraries used by the <code>pdfunite</code> program. Therefore, option E is the correct answer. The <code>rpm -qpdfunite --last</code> command and <code>grep pdfunite /var/log/apt/history.log</code> command attempt to find package installation information. However, they do not show an application\u2019s employed libraries (and the package for <code>pdfunite</code> is <code>poppler-utils</code>), so options A and B are wrong answers. The <code>/etc/zypp/repos.d/*.*</code> and <code>/etc/yum.repos.d/*.*</code> are repository databases and they do not contain information on which libraries an application uses. Thus, options C and D are also incorrect choices.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      50,
      52,
      55,
      206,
      204
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>ldd /usr/bin/pdfunite</code>"
  },
  {
    "id": 151,
    "question": "You recently installed additional RAM on a Linux server to help improve its performance. The primary application uses a great deal of memory and the new RAM has helped. However, at application peak usage times, the <code>free</code> utility shows there is plenty of free memory, but the system slows and sometimes hangs. Which of the following items should you use to troubleshoot this problem? (Choose all that apply.)",
    "choice_a": "<code>memtest</code> or <code>memtest86+</code>",
    "choice_b": "<code>localectl</code>",
    "choice_c": "<code>lshw --class memory</code>",
    "choice_d": "<code>cat /var/log/Xorg.0.log</code>",
    "correct_answer": [
      "A",
      "C",
      "E"
    ],
    "explanation": "You can conduct a memory test via a system reboot and accessing the <code>memtest</code> or <code>memtest86+</code> option in the server\u2019s boot menu. Therefore, option A is a correct answer. The <code>lshw --class memory</code> and <code>dmidecode -t memory</code> commands will allow you to determine hardware information concerning your memory, which may be of use as well in the troubleshooting process. Thus, options C and E are also correct answers. The <code>localectl</code> command on a Red Hat\u2013based distribution, with no options, displays your current key map. This is employed in key mapping troubleshooting, not RAM, so option B is a wrong answer. You view the <code>/var/log/Xorg.0.log</code> file for X11 video problems, so option D is also an incorrect choice.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      372,
      371,
      318,
      316,
      319
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>dmidecode -t memory</code>"
  },
  {
    "id": 152,
    "question": "What operator appends output to an existing file?",
    "choice_a": "<code>|</code>",
    "choice_b": "<code><</code>",
    "choice_c": "<code>></code>",
    "choice_d": "<code><<</code>",
    "correct_answer": "E",
    "explanation": "The <code>>></code> operator appends output from a command to a file, so option E is correct. The pipe symbol (<code>|</code>) redirects output to a command, not a file, so option A is incorrect. The <code><</code> operator redirects input from a file into a program, so option B is incorrect. The <code>></code> operator redirects output to a new file, or overwrites an existing file, it doesn\u2019t append data to an existing file, so option C is incorrect. The <code><<</code> symbol isn\u2019t a valid shell operator, so option D is incorrect.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      66,
      61,
      62,
      63,
      59
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>>></code>"
  },
  {
    "id": 153,
    "question": "What operator redirects output to another program?",
    "choice_a": "<code>|</code>",
    "choice_b": "<code><</code>",
    "choice_c": "<code>></code>",
    "choice_d": "<code><<</code>",
    "correct_answer": "A",
    "explanation": "The pipe symbol (<code>|</code>) redirects output from one command to another command, so option A is correct. The <code>></code> and <code>>></code> operators redirect output to a new file or append to an existing file, not a command, so options C and E are both incorrect. The <code><</code> operator redirects input from a file or command to a command, not output, so option B is incorrect. The <code><<</code> symbol is not a valid shell operator, so option D is incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      63,
      66,
      62,
      61,
      65
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>>></code>"
  },
  {
    "id": 154,
    "question": "How do you reference the first command-line argument in a shell script?",
    "choice_a": "<code>$a</code>",
    "choice_b": "<code>$A</code>",
    "choice_c": "<code>$1</code>",
    "choice_d": "<code>$0</code>",
    "correct_answer": "C",
    "explanation": "The <code>$1</code> special shell variable represents the first parameter specified on the command line when a command is submitted, so option C is correct. The <code>$a</code> and <code>$A</code> variables are normal user variables that can contain data, but don\u2019t interact with the command-line parameters, so options A and B are incorrect. The <code>$0</code> special shell variable represents the entire command line, including the command and all parameters, not just the first parameter, so option D is incorrect. The <code>#0</code> symbol is not a valid shell variable symbol, so option E is incorrect.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      384,
      383,
      386,
      380,
      385
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>#0</code>"
  },
  {
    "id": 155,
    "question": "What format would you use to store the output from the who command into the variable $users?",
    "choice_a": "<code>who > $users</code>",
    "choice_b": "<code>who | $users</code>",
    "choice_c": "<code>$users < who</code>",
    "choice_d": "<code>users=$(who)</code>",
    "correct_answer": "D",
    "explanation": "The <code>$() </code>operator redirects output from a command to a variable, so option D is correct. The <code>></code> operator redirects output from a command to a file, not a variable, so option A is incorrect. The pipe symbol (<code>|</code>) redirects output to another command, not a variable, so option B is incorrect. The <code><</code> operator redirects input from a file to a command, not output to a variable, so option C is incorrect. The <code>$[]</code> operator performs integer math, it doesn\u2019t redirect the output of a command, so option E is incorrect.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      387,
      388,
      383,
      378,
      382
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>users=$[ who ]</code>"
  },
  {
    "id": 156,
    "question": "What operator do you use to start a script in background mode?",
    "choice_a": "<code>|</code>",
    "choice_b": "<code><</code>",
    "choice_c": "<code>></code>",
    "choice_d": "<code>>></code>",
    "correct_answer": "E",
    "explanation": "Placing an ampersand (<code>&</code>) symbol after a command on the command line tells the kernel to run the command in background mode instead of in the foreground of the shell, so option E is correct. The pipe symbol (<code>|</code>) redirects output from a command to another command, it doesn\u2019t place the original command in background, so option A is incorrect. The <code><</code> operator redirects input for a command from a file, it doesn\u2019t place the command in background, so option B is incorrect. The <code>></code> and <code>>></code> operators redirect output to a file, they don\u2019t place the command in background mode, so options C and D are both incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      404,
      415,
      408,
      405,
      321
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>&</code>"
  },
  {
    "id": 157,
    "question": "What file does the <code>nohup</code> command place the script output in by default?",
    "choice_a": "<code>nohup.out</code> in the current directory",
    "choice_b": "<code>nohup.out</code> in the <code>/tmp</code> directory",
    "choice_c": "<code>out.nohup</code> in the current directory",
    "choice_d": "<code>out.nohup</code> in the <code>/tmp</code> directory",
    "correct_answer": "A",
    "explanation": "The <code>nohup</code> command disconnects the submitted command from the command line, and redirects all output from the command to the <code>nohup,out</code> file in the current directory, making option A correct. The <code>nohup.out</code> file is not placed in the <code>/tmp</code> directory, so option B is incorrect. The output file name is <code>nohup.out</code>, so options C, D, and E are all incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      405,
      404,
      414,
      49,
      47
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>output.txt</code> in the <code>/etc</code> directory"
  },
  {
    "id": 158,
    "question": "In Linux, what key combination pauses an application running in foreground?",
    "choice_a": "Ctrl+C",
    "choice_b": "Ctrl+Z",
    "choice_c": "Ctrl+D",
    "choice_d": "Ctrl+l",
    "correct_answer": "B",
    "explanation": "The Ctrl+Z key combination pauses an application and places it in sleep mode, so option B is correct. The Ctrl+C key combination stops a running process, it doesn\u2019t pause it, so option A is incorrect. The Ctrl+D key combination logs out from the terminal session, pausing any running processes, so option C is incorrect. The Ctrl+l key combination clears the terminal window, it doesn\u2019t pause the running application, so option D is incorrect. The Ctrl+A key combination moves the cursor to the beginning of the command line, it doesn\u2019t pause a running application, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      406,
      408,
      322,
      326,
      404
    ],
    "source": "316328_Practice Exam",
    "choice_e": "Ctrl+A"
  },
  {
    "id": 159,
    "question": "What command allows you to restart a paused job in background mode?",
    "choice_a": "<code>jobs</code>",
    "choice_b": "<code>fg</code>",
    "choice_c": "<code>bg</code>",
    "choice_d": "<code>at</code>",
    "correct_answer": "C",
    "explanation": "The <code>bg</code> command allows you to restart a sleeping application in background mode, so option C is correct. The <code>jobs</code> command allows you to list the jobs currently running or sleeping in your terminal session, it doesn\u2019t restart a sleeping program, so option A is incorrect. The <code>fg</code> command allows you to restart a sleeping application, but places it in foreground mode and not background mode, so option B is incorrect. The <code>at</code> and <code>cron</code> commands are used for scheduling an application to run at a future time in background mode, but they don\u2019t allow you to restart a sleeping program, so options D and E are both incorrect.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      408,
      415,
      404,
      409,
      322
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>cron</code>"
  },
  {
    "id": 160,
    "question": "Bruce employs the <code>git init</code> command. This sets up which conceptual Git environment elements? (Choose all that apply.)",
    "choice_a": "The working directory",
    "choice_b": "The staging area",
    "choice_c": "The index",
    "choice_d": "The local repository",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "The <code>git init</code> command creates the <code>.git/</code> directory within the working directory and initializes the conceptual elements of the staging area (also called the index), and the local repository. Therefore, options B, C, and D are correct answers. The working directory should already be created prior to using the <code>git init</code> command, so option A is a wrong answer. The remote repository is provided by a third party, so thus, option E is also an incorrect choice.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      417,
      419,
      420,
      422,
      421
    ],
    "source": "316328_Practice Exam",
    "choice_e": "The remote repository"
  },
  {
    "id": 161,
    "question": "A developer has created her working files and added them individually to the staging area using the <code>git add</code> command. However, that was a few hours ago, and she is ready to move her project to the local repository. What command can she issue to ensure that no files in her working directory are unregistered with the index?",
    "choice_a": "<code>git log</code>",
    "choice_b": "<code>git commit</code>",
    "choice_c": "<code>git branch</code>",
    "choice_d": "<code>git config --list</code>",
    "correct_answer": "E",
    "explanation": "The developer should issue the command <code>git status</code>, which will show her all the file\u2019s names, which have been added to the staging area (index) but have not yet been committed to the local repository. Therefore, option E is the correct answer. The <code>git log</code> command displays the commit history for the local repository, so option A is wrong answer. The <code>git commit</code> command begins the process of committing project files from the staging area to the local repository, so option B is also an incorrect answer. The <code>git branch</code> command shows the current project branch in use. Therefore, option C is a wrong choice. The <code>git config --list</code> command will show Git configuration information, so option D is also an incorrect choice.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      428,
      420,
      417,
      422,
      421
    ],
    "source": "316328_Practice Exam",
    "choice_e": "<code>git status</code>"
  },
  {
    "id": 162,
    "question": "You desire to see which Git branch is currently employed. You issue the <code>git branch</code> command to see all the project branches. How do you tell which one is current?",
    "choice_a": "The first branch listed is current.",
    "choice_b": "The last branch listed is current.",
    "choice_c": "The branch with an asterisk by it is current.",
    "choice_d": "The branch with the word <code>current</code> by it is current.",
    "correct_answer": "C",
    "explanation": "You can tell which branch is current by the <code>git branch</code> command\u2019s output, by looking for an asterisk. This indicates that branch is current. Therefore, option C is the correct answer. All the other answers are made up and thus incorrect.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      428,
      427,
      419,
      417,
      420
    ],
    "source": "316328_Practice Exam",
    "choice_e": "The branch with the word <code>active</code> by it is current."
  },
  {
    "id": 163,
    "question": "What are the three primary types of cloud services (select three)?",
    "choice_a": "Private",
    "choice_b": "Commercial",
    "choice_c": "Public",
    "choice_d": "Hybrid",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "Cloud services can be public, private, or a hybrid combination of both, making options A, C, and D correct. Cloud services are not classified as being commercial, so option B is incorrect. Linux is predominately used for cloud servers hosting cloud services, but isn\u2019t a classification for a type of cloud service, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      429,
      430,
      432,
      9,
      447
    ],
    "source": "316328_Practice Exam",
    "choice_e": "Linux"
  },
  {
    "id": 164,
    "question": "Which cloud service model provides only hardware to customers?",
    "choice_a": "IaaS \u2013 infrastructure as a service",
    "choice_b": "SaaS \u2013 software as a service",
    "choice_c": "PaaS \u2013 platform as a service",
    "choice_d": "Public",
    "correct_answer": "A",
    "explanation": "The infrastructure as a service (IaaS) cloud service model provides hardware for customers to load their own operating system and applications on, so option A is correct. The software as a service (SaaS) cloud service model provides complete applications to customers, not just the hardware, so option B is incorrect. The platform as a service (PaaS) cloud service model provides both hardware and software tools necessary for application development, not just the hardware, so option C is incorrect. Public and Private are types of cloud services, not cloud service models, so options D and E are both incorrect.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      429,
      430,
      9,
      437,
      447
    ],
    "source": "316328_Practice Exam",
    "choice_e": "Private"
  },
  {
    "id": 165,
    "question": "Which type of hypervisor runs directly on the hardware without an intermediary OS?",
    "choice_a": "Public",
    "choice_b": "Private",
    "choice_c": "IaaS",
    "choice_d": "Type I",
    "correct_answer": "D",
    "explanation": "Type I hypervisors run directly on the hardware, or close to it, without utilizing an operating system as an intermediary, making option D correct. Type II hypervisors run on top of a host operating system, getting access to the hardware through the standard operating system drivers, not directly with the hardware, making option E incorrect. Public and Private are cloud service models, not types of hypervisors, so options A and B are incorrect. IaaS is a type of cloud service, not a hypervisor, so option C is incorrect.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      8,
      430,
      429,
      441,
      6
    ],
    "source": "316328_Practice Exam",
    "choice_e": "Type II"
  },
  {
    "id": 166,
    "question": "What method should you use to develop an application in a test environment then move it into a production environment?",
    "choice_a": "Public cloud",
    "choice_b": "Container",
    "choice_c": "Private cloud",
    "choice_d": "IaaS",
    "correct_answer": "B",
    "explanation": "Containers allow you to create a portable environment that encapsulates the software libraries and files necessary for an application to run on any platform, making it easy to move the container to any platform and run the application without issues, so option B is correct. Public and Private clouds are cloud service models, which don\u2019t themselves help with moving applications, so options A and C are both incorrect. IaaS and SaaS are both types of cloud services to support applications, but don\u2019t standardize the application environment to move between servers, so options D and E are both incorrect.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      433,
      38,
      435,
      208,
      210
    ],
    "source": "316328_Practice Exam",
    "choice_e": "SaaS"
  },
  {
    "id": 167,
    "question": "Which of the following are directly associated with vmm? (Choose all that apply.)",
    "choice_a": "The Virtual Machine Manager application",
    "choice_b": "A virtual machine manager (VMM) also called a hypervisor",
    "choice_c": "The <code>virt-manager</code> command",
    "choice_d": "The <code>virt-viewer</code> client viewer",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "The vmm acronym is associated with the Virtual Machine Manager application, the <code>virt-manager</code> command, and the <code>virt-viewer</code> client viewer. Thus, options A, C, and D are correct answers. A virtual machine manager (VMM), which is also called a hypervisor, is not directly associated with the Virtual Machine Manager application. Therefore, option B is a wrong answer. While a voicemail message does share the acronym VMM, with a hypervisor, it is not directly associated with the Virtual Machine Manager application, so option E is an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      437,
      436,
      125,
      7,
      115
    ],
    "source": "316328_Practice Exam",
    "choice_e": "A voicemail message"
  },
  {
    "id": 168,
    "question": "Which of the following are involved in bootstrapping? (Choose all that apply.)",
    "choice_a": "Kickstart file",
    "choice_b": "Booting script",
    "choice_c": "AutoYaST",
    "choice_d": "Preseed",
    "correct_answer": [
      "A",
      "C",
      "D",
      "E"
    ],
    "explanation": "On Red Hat\u2013based distros, a kickstart file created from an anaconda file is involved in the bootstrap process, so options A and E are correct answers. On openSUSE, the AutoYaST application is involved with bootstrapping, so option C is also a correct choice. On Ubuntu, preseed is involved in the bootstrap process. Thus, option D is also a correct choice. Bootstrapping (booting and installing an operating system) is different than booting (starting up a system), so a booting script is not involved in the bootstrap process and option B is the only incorrect choice.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      439,
      453,
      457,
      450,
      455
    ],
    "source": "316328_Practice Exam",
    "choice_e": "Anaconda"
  },
  {
    "id": 169,
    "question": "A system administrator needs to overprovision his virtual storage with data persevering through VM reboots. Which storage type should he employ? (Choose all that apply.)",
    "choice_a": "Persistent",
    "choice_b": "Temporary",
    "choice_c": "Thick provisioning",
    "choice_d": "Thin provisioning",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "For the data to persevere through VM reboots, it needs to be persistent, so option A is a correct choice. To allow virtual storage to be overprovisioned (more space granted than available), the admin will need to employ thin provisioning, which only consumes the space is currently needs. Thus, option D is also a correct answer. Temporary (also called provisional) data will not allow the VM data to survive a reboot, so options B and E are wrong answers. Thick provisioning does not allow overprovisioning to occur. Thus, option C is also an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      443,
      444,
      156,
      175,
      167
    ],
    "source": "316328_Practice Exam",
    "choice_e": "Provisional"
  },
  {
    "id": 170,
    "question": "A system administrator needs her virtual systems to have a network that is internal to the host system and cannot reach the external network. Which adapter types should she use?",
    "choice_a": "Host-only",
    "choice_b": "Bridged",
    "choice_c": "NAT",
    "choice_d": "Multihomed",
    "correct_answer": "A",
    "explanation": "A host-only network adapter configuration will cause the hypervisor to create a network internal to the host system and not allow the VMs to reach the external network. Thus, option A is the correct answer. Both a bridged and NAT adapter will allow external network access, so options B and C are wrong answers. Multihomed and dual-homed are references to the number of NICs per virtual machine, so options D and E are also incorrect choices.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      446,
      448,
      106,
      437,
      8
    ],
    "source": "316328_Practice Exam",
    "choice_e": "Dual-homed"
  },
  {
    "id": 171,
    "question": "In container orchestration, the use of configuration management and policy as code to automatically deploy and/or create multiple containers goes by what name?",
    "choice_a": "Replication automation",
    "choice_b": "Infrastructure as code",
    "choice_c": "Build automation",
    "choice_d": "Agentless",
    "correct_answer": "C",
    "explanation": "Build automation is where configuration management and policy as code are used to automatically deploy and/or create multiple containers. Therefore, option C is the correct answer. Replication automation is another way of saying automatically creating multiple containers, so it is a subset of build automation. Thus, option A is a wrong answer. Infrastructure as code is an umbrella term that covers configuration management as well as policy as code. Therefore, option B is also an incorrect answer. Agentless is a type of orchestration monitoring tool (or engine), and thus option D is a wrong choice. In orchestration, inventory control ensures that the needed or desired number of containers is running. Therefore, option E is also an incorrect choice.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      458,
      456,
      457,
      450,
      461
    ],
    "source": "316328_Practice Exam",
    "choice_e": "Inventory control"
  },
  {
    "id": 172,
    "question": "With orchestration, you can enforce a static container environment. Why is this done?",
    "choice_a": "So that the app\u2019s infrastructure does not change",
    "choice_b": "To promote faster deployment of the container",
    "choice_c": "So that the version control system use is minimized",
    "choice_d": "To allow agentless monitoring of the container",
    "correct_answer": "A",
    "explanation": "In orchestration, a container can be configured with preset libraries, an operating system version, security settings, and so on. These infrastructure features can then be set to be immutable (static), so that only the app is modified. This prevents errors from being introduced to the app via supporting software updates. Therefore, option A is the correct choice. A static container environment does not promote faster deployment of the container, so option B is a wrong answer. Also, it does not minimize the use of the version control system (which for the container environment is predetermined and documented, then entered into the version control system). Therefore, option C is an incorrect answer. Monitoring software options would be chosen prior to the container environment becoming static, so option D is a wrong choice. The app\u2019s performance could be affected by a nonstatic (mutable) environment, but this is not the reason for enforcing a static container environment in orchestration. Therefore, option E is incorrect.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      456,
      452,
      451,
      460,
      458
    ],
    "source": "316328_Practice Exam",
    "choice_e": "So that the app\u2019s performance does not change"
  },
  {
    "id": 173,
    "question": "Your orchestration tool allows you to enter through its API the desired app container infrastructure documentation. It later uses this documentation for build automation. What is this process of documenting called?",
    "choice_a": "Infrastructure as code",
    "choice_b": "Build automation",
    "choice_c": "Thick provisioning",
    "choice_d": "Automated configuration management",
    "correct_answer": "D",
    "explanation": "Automated configuration management is the process of entering the configuration management and policy as code data into the orchestration utility\u2019s API. Therefore, option D is the correct answer. Infrastructure as code is the information entered, so option A is a wrong answer. Build automation uses the stored infrastructure as code data, so option B is also a wrong choice. Thick provisioning is a virtual storage concept. Thus, option C is also an incorrect answer. Policy as code is a subset of infrastructure as code, and therefore option E is an incorrect choice as well.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      456,
      458,
      450,
      457,
      461
    ],
    "source": "316328_Practice Exam",
    "choice_e": "Policy as code"
  },
  {
    "id": 174,
    "question": "When a container crashes, an orchestration system with the ability to self-heal will deploy production app containers until what directive is reached?",
    "choice_a": "Infrastructure as code",
    "choice_b": "Desired state",
    "choice_c": "K8s",
    "choice_d": "Continuous delivery",
    "correct_answer": "B",
    "explanation": "The desired state directive determines how many desired containers should be running at any one time. Therefore, if a container crashes, an orchestration system with the ability to self-heal will deploy production app containers until desired state is reached. Thus, option B is the correct answer. Infrastructure as code is used by this self-healing properly, but it is not the directive that determines the number of containers to be active. Therefore, option A is a wrong answer. K8s is another name for the Kubernetes orchestration system, and thus, option C is also an incorrect answer. Continuous delivery and continuous integration are DevOps concepts, not directives for the number of desired containers to be currently running. Therefore, options D and E are both incorrect choices.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      460,
      461,
      462,
      457,
      456
    ],
    "source": "316328_Practice Exam",
    "choice_e": "Continuous integration"
  },
  {
    "id": 175,
    "question": "What license model requires that you release any derivative software using the same license?",
    "choice_a": "MIT",
    "choice_b": "GPL",
    "choice_c": "Apache",
    "choice_d": "LGPL",
    "correct_answer": "B",
    "explanation": "The GPL license model requires that any derivative software be released also using the GPL license, so option B is correct. The MIT license doesn\u2019t require that you license derivative software, so option A is incorrect. The Apache license allows you to release derivative software using any license, so option C is incorrect. The LPGL license doesn\u2019t require that you release derivative software to the public, so option D is incorrect. Proprietary licenses don\u2019t allow you to release any derivative software, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      4,
      5,
      3,
      429,
      430
    ],
    "source": "316328_c01",
    "choice_e": "Proprietary"
  },
  {
    "id": 176,
    "question": "What CPU architecture is an open standard that can be used by any CPU manufacturer?",
    "choice_a": "x86",
    "choice_b": "x86_64",
    "choice_c": "RISC-V",
    "choice_d": "s390x",
    "correct_answer": "C",
    "explanation": "The RISC-V architecture is an open standard that can be used by any CPU manufacturer, so option C is correct. The x86 and x86_64 architectures are proprietary architectures released by Intel, so options A and B are incorrect. The s390x architecture is released by IBM and is not open, so option D is incorrect. The aarch64 architecture is released by the ARM corporation, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      2,
      3,
      4,
      5,
      1
    ],
    "source": "316328_c01",
    "choice_e": "aarch64"
  },
  {
    "id": 177,
    "question": "Which distribution group uses the Debian-based model?",
    "choice_a": "dpkg",
    "choice_b": "aarch64",
    "choice_c": "GPL",
    "choice_d": "RPM",
    "correct_answer": "A",
    "explanation": "The dpkg-based distribution group is based on the Debian Linux distribution, making option A correct. Option B, aarch64, is a CPU architecture type and not a distribution group, so it is incorrect. Options C (GPL) and E (LGPL) are license models and not distribution groups, so they are both incorrect. RPM-based distribution groups are based on the Red Hat Enterprise Linux distribution, not the Debian Linux distribution, so option D is incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      11,
      13,
      12,
      15,
      16
    ],
    "source": "316328_c01",
    "choice_e": "LGPL"
  },
  {
    "id": 178,
    "question": "Which web server is used in the popular LAMP stack?",
    "choice_a": "nginX",
    "choice_b": "Apache",
    "choice_c": "Lighthttpd",
    "choice_d": "PostgreSQL",
    "correct_answer": "B",
    "explanation": "The Apache web server has gained popularity as being combined with the Linux OS, the MySQL database server, and the PHP programming server, making the LAMP stack. The NginX server is a newer web server that is gaining in popularity but is not part of the LAMP stack. The Lighthttpd web server has a small memory and CPU footprint, making it ideal for embedded systems but not for large-scale LAMP applications. The PostgreSQL package is a database server and not a web server.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      22,
      23,
      20,
      19,
      21
    ],
    "source": "316328_c02"
  },
  {
    "id": 179,
    "question": "A ________ runs in the background and listens for client connection requests for a single application.",
    "choice_a": "Daemon",
    "choice_b": "Super-server",
    "choice_c": "Shell",
    "choice_d": "Graphical desktop",
    "correct_answer": "A",
    "explanation": "A daemon is a single application that runs in background listening for client connection requests, so option A is the correct answer. A super-server listens for more than one application, so option B doesn\u2019t apply. The shell doesn\u2019t listen for network connections; it launches applications interactively, so option C is incorrect. The graphical desktop also allows you to launch applications, but it doesn\u2019t listen for client connection requests, so option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      18,
      21,
      19,
      20,
      89
    ],
    "source": "316328_c02"
  },
  {
    "id": 180,
    "question": "Which open source database provided fast performance and became a popular choice for web applications?",
    "choice_a": "MongoDB",
    "choice_b": "PostgreSQL",
    "choice_c": "MySQL",
    "choice_d": "NoSQL",
    "correct_answer": "C",
    "explanation": "When first released, the MySQL database server focused on speed, making it a popular choice for high-volume Internet web applications, so option C is correct. The MongoDB database server provides object-oriented database features but doesn\u2019t focus on performance, so option A is incorrect. The PostgreSQL database focused on implementing fancy database features instead of speed, so option B is incorrect. NoSQL is a database storage method that incorporates object-oriented data records and is not a database server package itself, so option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      23,
      203,
      200,
      201,
      37
    ],
    "source": "316328_c02"
  },
  {
    "id": 181,
    "question": "How does a server know what client request is sent to which application daemon?",
    "choice_a": "IP addresses",
    "choice_b": "Ports",
    "choice_c": "Ethernet addresses",
    "choice_d": "Services",
    "correct_answer": "B",
    "explanation": "Linux services listen on well-known ports for requests from clients, so option B is correct. A server normally has a single IP address to support multiple applications, so option A is incorrect. The server also normally has only a single Ethernet address, so option C is incorrect. The clients can\u2019t launch individual services on the server, so option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      19,
      18,
      21,
      20,
      88
    ],
    "source": "316328_c02"
  },
  {
    "id": 182,
    "question": "What popular open source web servers can also perform as a load balancer? (Choose two.)",
    "choice_a": "nginX",
    "choice_b": "Apache",
    "choice_c": "PostgreSQL",
    "choice_d": "Lighthttpd",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "The nginX web server can also perform as a load balancer and send client requests to multiple backend web servers, so option A is correct. The Apache and lighthttpd web servers don\u2019t support this feature, so options B and D are incorrect. The PostgreSQL server is a database and not a web server, so option C is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      37,
      22,
      34,
      18,
      20
    ],
    "source": "316328_c02"
  },
  {
    "id": 183,
    "question": "What format does MongoDB use to store data elements in the database?",
    "choice_a": "Relational",
    "choice_b": "YaML",
    "choice_c": "JSON",
    "choice_d": "Encrypted",
    "correct_answer": "C",
    "explanation": "The MongoDB database server uses the JSON format for storing data records. The relational database is a type of database system and not a method for storing data, so option A is incorrect. YaML is a plaintext method for creating configuration files, but it is not used in MongoDB for storing data, so option B is incorrect. The MongoDB data is not normally encrypted, so option D is also incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      23,
      204,
      202,
      35,
      89
    ],
    "source": "316328_c02"
  },
  {
    "id": 184,
    "question": "Which part of the Linux mail process is responsible for sending emails to remote hosts?",
    "choice_a": "MUA",
    "choice_b": "MTA",
    "choice_c": "MDA",
    "choice_d": "Evolution",
    "correct_answer": "B",
    "explanation": "The MTA package is responsible for connecting with remote mail hosts to deliver email messages, so option B is correct. The MUA allows clients to connect to the email server to read their messages, so option A is incorrect. The MDA allows you to create rules for processing mail locally, not to remote servers, so option C is incorrect. Evolution is an email MUA client application, not a server MTA package. The Evolution package is a graphical email client, so option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      24,
      20,
      19,
      18,
      21
    ],
    "source": "316328_c02"
  },
  {
    "id": 185,
    "question": "Which part of the Linux mail process allows you to create filters to automatically redirect incoming mail messages?",
    "choice_a": "MUA",
    "choice_b": "MTA",
    "choice_c": "MDA",
    "choice_d": "Evolution",
    "correct_answer": "C",
    "explanation": "The MDA allows you to create filters to match email messages to redirect to other folders, so option C is correct. The MUA is the user interface and doesn\u2019t control how incoming mail is delivered by the server, so option A is incorrect. The MTA delivers email to remote hosts and accepts mail from remote hosts, so option B is incorrect. The Evolution package is a graphical MUA package for clients and does not allow you to create filters to deliver email messages, so option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      24,
      21,
      19,
      33,
      27
    ],
    "source": "316328_c02"
  },
  {
    "id": 186,
    "question": "What protocol should you use to mount folders from remote Linux servers on your local Linux server?",
    "choice_a": "SNMP",
    "choice_b": "NTP",
    "choice_c": "DHCP",
    "choice_d": "NFS",
    "correct_answer": "D",
    "explanation": "The NFS protocol is used to share folder areas on the network with clients, so option D is correct. SNMP is a network protocol used for managing remote devices, so option A is incorrect. NTP is a network protocol used for setting the time on servers, so option B is incorrect. DHCP is a network program used for assigning IP addresses to network devices, so option C is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      25,
      30,
      27,
      29,
      135
    ],
    "source": "316328_c02"
  },
  {
    "id": 187,
    "question": "The ________ software package allows your Windows workstations to mount a folder stored on a Linux server.",
    "choice_a": "ntpd",
    "choice_b": "Samba",
    "choice_c": "DHCPd",
    "choice_d": "Evolution",
    "correct_answer": "B",
    "explanation": "The Samba software package allows a Linux server to communicate with Windows servers and clients using the SMB protocol, so option B is correct. The ntpd daemon listens for requests from a remote time server, so option A is incorrect. The DHCPd package provides DHCP services on the Linux server to assign network IP addresses; it doesn\u2019t allow workstations to map folders on the Linux server, so option C is incorrect. The Evolution package is a graphical desktop program to accessing email in the mail folder and is not a server service, so option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      25,
      18,
      19,
      21,
      211
    ],
    "source": "316328_c02"
  },
  {
    "id": 188,
    "question": "Which two software packages are used in Linux to maintain log files? (Choose two.)",
    "choice_a": "rsyslogd",
    "choice_b": "journald",
    "choice_c": "ntpd",
    "choice_d": "DHCPd",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "The rsyslogd program is used by SysV init systems to log events, and the journald program is used by Systemd systems to log events, so options A and B are the correct answers. The ntpd program provides time services and not logging services, so option C is incorrect. The DHCPd program is used for assigning IP addresses on a local network and not logging services, so option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      87,
      88,
      92,
      99,
      47
    ],
    "source": "316328_c02"
  },
  {
    "id": 189,
    "question": "Which software program should you load on your Linux server to synchronize its time with a standard time server?",
    "choice_a": "DHCPd",
    "choice_b": "BIND",
    "choice_c": "ntpd",
    "choice_d": "Samba",
    "correct_answer": "C",
    "explanation": "The ntpd service uses NTP to synchronize the server time with a remote system, so option C is correct. The DHCPd program assigns IP addresses to devices on the local network but not time, so option A is incorrect. The BIND program provides hostname resolution services but not time services, so option B is incorrect. The Samba package allows a Linux server to interact with Windows clients and servers, but it doesn\u2019t provide time services, so option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      29,
      135,
      134,
      133,
      27
    ],
    "source": "316328_c02"
  },
  {
    "id": 190,
    "question": "What software package allows a Linux server to print to a network printer?",
    "choice_a": "DHCPd",
    "choice_b": "BIND",
    "choice_c": "ntpd",
    "choice_d": "CUPS",
    "correct_answer": "D",
    "explanation": "The CUPS application provides printer drivers and services that allow Linux systems to connect with local and remote printers, so option D is correct. The DHCPd program assigns IP addresses to devices on the local network but doesn\u2019t connect to remote printers, so option A is incorrect. The BIND application provides hostname resolution services but can\u2019t connect to printers, so option B is incorrect. The ntpd program allows you to synchronize the server time with a remote time clock, but doesn\u2019t connect to network printers, so option C is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      26,
      27,
      19,
      20,
      21
    ],
    "source": "316328_c02"
  },
  {
    "id": 191,
    "question": "If you see the named program running in background on your Linux server, what service does it provide?",
    "choice_a": "Network time",
    "choice_b": "Hostname resolution",
    "choice_c": "Dynamic IP address allocation",
    "choice_d": "Printing",
    "correct_answer": "B",
    "explanation": "The named program is part of the BIND application, which provides hostname resolution services, so option B is correct. The ntpd program is what provides network time, so option A is incorrect. The DHCPd program provides dynamic IP address allocation on a local network, so option C is incorrect. The CUPS application provides printing services on a Linux system, so option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      28,
      18,
      19,
      29,
      88
    ],
    "source": "316328_c02"
  },
  {
    "id": 192,
    "question": "Which authentication package used to be called by the name \u201cYellow Pages\u201d?",
    "choice_a": "Samba",
    "choice_b": "Kerberos",
    "choice_c": "NIS",
    "choice_d": "BIND",
    "correct_answer": "C",
    "explanation": "The NIS package was formerly called Yellow Pages (YP), but the name had to be changed due to trademark issues, so option C is correct. The Samba package, which provides Windows client and server services in Linux, refers to a popular Latin dance, not the Yellow Pages, so option A is incorrect. The Kerberos package, which does provide authentication services in Linux, refers to the three-headed hound that guards Hades, not the Yellow Pages, so option B is incorrect. The BIND application refers to binding a name to an IP address, which is a similar function to the Yellow Pages, but it wasn\u2019t formerly called Yellow Pages, so option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      31,
      333,
      32,
      18,
      19
    ],
    "source": "316328_c02"
  },
  {
    "id": 193,
    "question": "What package do you need to install to allow your Linux server to provide IP addresses to clients on your local network?",
    "choice_a": "DHCPd",
    "choice_b": "BIND",
    "choice_c": "ntpd",
    "choice_d": "Evolution",
    "correct_answer": "A",
    "explanation": "The DHCPd program provides DHCP server services on a local network, so option A is correct. The BIND package provides hostname resolution services; it doesn\u2019t assign IP addresses, so option B is incorrect. The ntpd package provides network time services but not address services, so option C is incorrect. Evolution is a client MUA package for reading email; it doesn\u2019t provide IP addresses to clients, so option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      27,
      28,
      211,
      204,
      207
    ],
    "source": "316328_c02"
  },
  {
    "id": 194,
    "question": "The ________ package allows you to create a secure tunnel across a private network to access your local network remotely.",
    "choice_a": "BIND",
    "choice_b": "ntpd",
    "choice_c": "OpenSSH",
    "choice_d": "OpenSSL",
    "correct_answer": "C",
    "explanation": "The OpenSSH package allows you to use certificates to establish a secure connection between two devices on the network, so option C is correct. The BIND package provides hostname resolution, not secure connections, so option A is incorrect. The ntpd package provides time services on the network, not secure connections, so option B is incorrect. The OpenSSL package allows you to create certificates used for encrypted communication but doesn\u2019t perform the communication itself, so option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      33,
      32,
      332,
      19,
      28
    ],
    "source": "316328_c02"
  },
  {
    "id": 195,
    "question": "What server role should you implement to block your local network clients from accessing sports websites during business hours?",
    "choice_a": "A DHCP server",
    "choice_b": "A web server",
    "choice_c": "A web proxy",
    "choice_d": "A container",
    "correct_answer": "C",
    "explanation": "A web proxy server allows you to intercept client web requests and block any requests based on rules you define, so option C is correct. A DHCP server assigns IP addresses to devices on the local network; it doesn\u2019t intercept web requests, so option A is incorrect. A web server hosts websites but doesn\u2019t intercept requests made by local clients, so option B is incorrect. A container allows developers to easily deploy web applications in different environments but doesn\u2019t intercept web requests from local clients, so option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      34,
      22,
      19,
      20,
      21
    ],
    "source": "316328_c02"
  },
  {
    "id": 196,
    "question": "What server role should you implement to increase performance on your company\u2019s website?",
    "choice_a": "A load balancer",
    "choice_b": "A web proxy",
    "choice_c": "A DHCP server",
    "choice_d": "A container",
    "correct_answer": "A",
    "explanation": "A load balancer sends client requests to one server within a cluster of servers to balance traffic among the servers, so option A is correct. A web proxy server intercepts web requests from clients but can only filter or pass the request to the destination host, so option B is incorrect. A DHCP server assigns IP addresses to devices on a local network but doesn\u2019t help increase performance of network applications, so option C is incorrect. A container allows a developer to easily deploy web applications to different environments but can\u2019t control what traffic goes to which server, so option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      37,
      22,
      34,
      18,
      20
    ],
    "source": "316328_c02"
  },
  {
    "id": 197,
    "question": "A ________ allows your developers to easily deploy applications between development, test, and production.",
    "choice_a": "A web proxy",
    "choice_b": "A DHCP server",
    "choice_c": "A container",
    "choice_d": "A cluster",
    "correct_answer": "C",
    "explanation": "A container allows developers to develop applications in a controlled environment that can easily be deployed to other servers, so option C is correct. A web proxy intercepts web requests from clients but doesn\u2019t control how applications are deployed, so option A is incorrect. A DHCP server assigns IP addresses to devices on the local network but doesn\u2019t control how applications are deployed, so option B is incorrect. A cluster can help with application performance by spreading the load among multiple servers but doesn\u2019t control how developers deploy the application to the servers, so option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      435,
      38,
      433,
      208,
      37
    ],
    "source": "316328_c02"
  },
  {
    "id": 198,
    "question": "You are looking at a directory that you have not viewed in a long time and need to determine which files are actually directories. Which command is the best one to use?",
    "choice_a": "<code>mkdir -v</code>",
    "choice_b": "<code>ls</code>",
    "choice_c": "<code>ls -F</code>",
    "choice_d": "<code>ls -i</code>",
    "correct_answer": "C",
    "explanation": "Option C will append an indicator code of <code>/</code> to every directory name, so therefore it is the best choice. The <code>mkdir -v</code> command creates a directory and lets you know whether it was successful, but it does not indicate directories, so option A is a wrong answer. The <code>ls</code> command only displays file and directory names, so option B is also a wrong answer. The <code>ls -i</code> command will display filenames along with their inode number, but it does not indicate directories, so option D is incorrect. Although option E will work on some distributions to produce a long listing that can indicate directories, this command is not aliased to <code>ls -l</code> on every distribution, so therefore it is not the best command to use.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      39,
      40,
      41,
      43,
      53
    ],
    "source": "316328_c03",
    "choice_e": "<code>ll</code>"
  },
  {
    "id": 199,
    "question": "You are using the <code>ls</code> command to look at a directory file\u2019s metadata but keep seeing metadata for the files within it instead. What command option will rectify this situation?",
    "choice_a": "<code>-a</code>",
    "choice_b": "<code>-d</code>",
    "choice_c": "<code>-F</code>",
    "choice_d": "<code>-l</code>",
    "correct_answer": "B",
    "explanation": "The <code>-d</code> switch on the <code>ls</code> command will allow you to view a directory file\u2019s metadata instead of seeing metadata for the files managed by that directory. Therefore, option B is the correct choice. Option A is a wrong answer because the <code>-a</code> switch forces the <code>ls</code> command to display hidden files, which are files starting with a dot (<code>.</code>). The <code>-F</code> switch will append an indicator code to each file but won\u2019t allow you to view a directory\u2019s metadata, so option C is a wrong choice. The <code>-l</code> option is already being employed because you are viewing metadata, so it does not need to be added. Therefore, option D is an incorrect answer. The <code>-R</code> switch allows you to view file information recursively through a directory tree, and thus option E is also a wrong choice.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      39,
      49,
      50,
      52,
      41
    ],
    "source": "316328_c03",
    "choice_e": "<code>-R</code>"
  },
  {
    "id": 200,
    "question": "You have just created an empty directory called <code>MyDir</code>. Which command most likely did you use?",
    "choice_a": "<code>mkdir -v MyDir</code>",
    "choice_b": "<code>touch MyDir</code>",
    "choice_c": "<code>cp -R TheDir MyDir</code>",
    "choice_d": "<code>mv -r TheDir MyDir</code>",
    "correct_answer": "A",
    "explanation": "The <code>mkdir -v</code> command creates a directory and lets you know whether it was successful, so option A is the correct answer. The <code>touch</code> command creates blank and empty files, so option B is incorrect. The <code>cp -R</code> command will recursively copy an entire directory full of files to another directory. Since you do not know if the directory <code>TheDir</code> is empty or not, you most likely did not use this command. Option C is a wrong answer. The <code>mv -r</code> command will rename a directory to a new directory name. Again, you do not know if the directory <code>TheDir</code> is empty or not, so you most likely did not use this command, and thus, option D is also a wrong answer. Option E is an incorrect answer because the <code>rmdir</code> command deletes empty directions.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      40,
      41,
      43,
      42,
      50
    ],
    "source": "316328_c03",
    "choice_e": "<code>rmdir MyDir</code>"
  },
  {
    "id": 201,
    "question": "You have a file that is over 10 GB in size, and it needs to be backed up to a locally attached drive. What is the best utility to use in this situation?",
    "choice_a": "<code>readlink -f</code>",
    "choice_b": "<code>mv</code>",
    "choice_c": "<code>cp</code>",
    "choice_d": "<code>scp</code>",
    "correct_answer": "E",
    "explanation": "The <code>rsync</code> utility allows you to perform fast local copies, so for a big file it is the best utility to use in this case. Therefore, option E is the correct answer. The <code>readlink -f</code> command finds the file being pointed to via a series of soft links, so option A is an incorrect answer. The <code>mv</code> command will rename a file instead of creating a backup copy, so option B is incorrect. The <code>cp</code> command does create a file copy. However, it is not as fast as the <code>rsync</code> utility and therefore is not the best choice. Option C is a wrong answer. The <code>scp</code> command also does create a file copy. However, it also is not as fast as the <code>rsync</code> utility and therefore is not the best choice. Option D is also a wrong answer.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      42,
      41,
      48,
      50,
      39
    ],
    "source": "316328_c03",
    "choice_e": "<code>rsync</code>"
  },
  {
    "id": 202,
    "question": "A long-time server administrator, Zoe, has left the company, and now you are in charge of her system. Her old user account directory tree, <code>/home/Zoe/</code>, has been backed up. Which command is the best one to use to quickly remove her files but still indicate that you are removing the correct directory, but without forcing you to confirm every file deletion?",
    "choice_a": "<code>cp -R /home/Zoe/ /dev/null/</code>",
    "choice_b": "<code>mv -R /home/zoe/ /dev/null/</code>",
    "choice_c": "<code>rm -Rf /home/Zoe/</code>",
    "choice_d": "<code>rm -ri /home/Zoe/</code>",
    "correct_answer": "E",
    "explanation": "The <code>rm -rI</code> command will recursively delete the files in the <code>/home/Zoe</code> directory tree, and it will ask before it starts, so you know you are deleting the correct tree. Therefore, option E is the best answer. Option A is incorrect because the <code>cp</code> command simply copies files. It does not remove them. Option B is incorrect because not only is part of the directory name using the wrong case, but there is no verification the correct directory is being moved to the black hole device, <code>/dev/null/</code>. The <code>rm -Rf</code> command would work, but it is not the best command to use because it does not ask before it starts, so you do not know if you are deleting the correct tree. In fact, the <code>-f</code> option suppresses error messages, so option C is wrong. Option D would also work, but it is not the best answer because it employs the <code>-i</code> option. If Zoe has years of files in her home directory, you may be sitting there for a long time deleting files due to the fact that you must confirm each file before it is deleted. Therefore, option D is an incorrect answer.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      43,
      41,
      42,
      40,
      39
    ],
    "source": "316328_c03",
    "choice_e": "<code>rm -rI /home/Zoe</code>"
  },
  {
    "id": 203,
    "question": "There is a large directory structure that needs to be renamed. What <code>mv</code> command options should you consider employing? (Choose all that apply.)",
    "choice_a": "<code>-f</code>",
    "choice_b": "<code>-i</code>",
    "choice_c": "<code>-n</code>",
    "choice_d": "<code>-r</code>",
    "correct_answer": [
      "B",
      "C",
      "E"
    ],
    "explanation": "When renaming a directory, you only need to employ the <code>mv</code> command. However, it is wise to use the <code>-i</code> option, so if the new directory name already exists, the utility will stop and ask permission prior to proceeding. Even better is to use the <code>-n</code> option; that way, if the new name you select is already being used, the <code>mv</code> command does not allow you to overwrite it. Also, the <code>-v</code> option is worthwhile, so the <code>mv</code> command operates in verbose mode, telling you want is going on. Therefore, options B, C, and E are all correct choices. The <code>-f</code> option is not a wise choice because it forces the directory\u2019s renaming, even if a directory already exists that has that name. Therefore, option A is a wrong answer. Also, there is no <code>-r</code> switch, because renaming a directory using the <code>mv</code> command does not require any recursive action. Thus, option D is an incorrect choice.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      41,
      43,
      338,
      40,
      50
    ],
    "source": "316328_c03",
    "choice_e": "<code>-v</code>"
  },
  {
    "id": 204,
    "question": "You are trying to decide whether to use a hard link or a symbolic link for a data file. The file is 5 GB, has mission-critical data, and is accessed via the command line by three other people. What should you do?",
    "choice_a": "Create a hard link so that the file can reside on a different filesystem for data protection.",
    "choice_b": "Create three hard links and provide the links to the three other people for data protection.",
    "choice_c": "Create three symbolic links and protect the links from the three other people for data protection.",
    "choice_d": "Create a symbolic link so the file can reside on a different filesystem.",
    "correct_answer": "B",
    "explanation": "Option B is the correct answer because the hard links will prevent the three other command-line interface users from accidently deleting the data. If they delete their link\u2019s name, they will not delete the data. Option A is an incorrect choice because hard linked files must reside on the same filesystem together. Option C is also an incorrect choice because if you do not provide the symbolic links to the other three data users, they will have to access the data file directly and could delete it. While creating symbolic links will protect the data by letting it reside on a different filesystem, if it is mission-critical data, the filesystem employed should be rigorous enough to protect the data, and therefore your only threat would be human. Thus, option D is an incorrect answer. Symbolic linked files do not share an inode number. Therefore, option E is an incorrect choice.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      46,
      44,
      45,
      43,
      50
    ],
    "source": "316328_c03",
    "choice_e": "Create a symbolic link so that the links can share an inode number."
  },
  {
    "id": 205,
    "question": "A short text-based control file is no longer working properly with the program that reads it. You suspect the file was accidentally corrupted by a control code update you performed recently, even though the file\u2019s control codes are all correct. Which command should you use next on the file in your problem investigation?",
    "choice_a": "<code>cat -v</code>",
    "choice_b": "<code>cat -z</code>",
    "choice_c": "<code>cat -n</code>",
    "choice_d": "<code>cat -s</code>",
    "correct_answer": "A",
    "explanation": "The <code>cat -v</code> command will show any nonprinting characters that may have gotten embedded in the control file causing it to be corrupted, and therefore option A is the correct answer. The <code>-z</code> option only lets you see end-of-line characters if they are NUL, and thus, option B is a wrong choice. The <code>-n</code> option only numbers the text lines in output, so option C is also a wrong answer. The <code>cat -s</code> command will display multiple blank lines in the file as one blank line. This will not help in the investigation, so option D is an incorrect answer. The <code>-E</code> option displays a <code>$</code> whenever a newline linefeed is encountered, and though possibly helpful, it is not the best option to use in this case. Therefore, option E is a wrong answer.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      50,
      51,
      47,
      54,
      338
    ],
    "source": "316328_c03",
    "choice_e": "<code>cat -E</code>"
  },
  {
    "id": 206,
    "question": "You have two short text files that have maximum record lengths of 15 characters. You want to review these files side by side. Which of the following commands would be the best to use?",
    "choice_a": "<code>pr -m</code>",
    "choice_b": "<code>pr -tl 20</code>",
    "choice_c": "<code>cat</code>",
    "choice_d": "<code>pr -mtl 20</code>",
    "correct_answer": "D",
    "explanation": "Option D is the correct answer because the best command to use is the <code>pr -mtl 20</code> command. This will display the files side by side, remove any file headers or trailers, and set the page length to 20 lines so the files do not scroll off your screen. Of course, you may need to adjust the line length depending on your screen\u2019s resolution. Option A is incorrect because, while it will display the files side by side, the display may scroll off your screen. Option B is also incorrect, because the command will not display your files side by side. Option C is a wrong choice because the <code>cat</code> command will not display the files side by side. Option E\u2019s command may work for you, but it is not the best choice because file headers or trailers will not be removed. Therefore, option E is an incorrect answer.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      48,
      50,
      51,
      55,
      41
    ],
    "source": "316328_c03",
    "choice_e": "<code>pr -ml 20</code>"
  },
  {
    "id": 207,
    "question": "You have a lengthy file named, <code>FileA.txt</code>. What will the <code>head -15 FileA.txt</code> command do?",
    "choice_a": "Display all but the last 15 lines of the file.",
    "choice_b": "Display all but the first 15 lines of the file.",
    "choice_c": "Display the first 15 lines of the file.",
    "choice_d": "Display the last 15 lines of the file.",
    "correct_answer": "C",
    "explanation": "The <code>head</code> command can use either the <code>-n 15</code> switch or the <code>-15</code> switch to display a file\u2019s first 15 lines. Therefore, option C is the correct answer. To display all but the last 15 lines of the file, you would need to employ the <code>-n -15</code> switch, so option A is incorrect. To display all but the first 15 lines, you need to use the <code>tail</code> command instead of the <code>head</code> command, so option B is a wrong answer. Also, you need to use <code>tail</code> to display the last 15 lines of the file, so option D is also an incorrect answer. Option E is a wrong choice because the command will not generate an error message in this case.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      47,
      48,
      54,
      50,
      39
    ],
    "source": "316328_c03",
    "choice_e": "Generate an error message."
  },
  {
    "id": 208,
    "question": "You have issued the command <code>grep Hal</code> on a text file you generated using information from a failed login attempts file. It returns nothing, but you just performed a test case, by purposely failing to log into the Hal account, prior to generating the text file. Which of the following is the best choice as your next step?",
    "choice_a": "Employ the <code>tail</code> command to peruse the text file.",
    "choice_b": "Employ the <code>cat</code> command to view the text file.",
    "choice_c": "Delete the text file and regenerated it using information from the failed login attempts file.",
    "choice_d": "Issue the <code>grep -d skip Hal</code> command on the text file.",
    "correct_answer": "E",
    "explanation": "It is possible that the account name Hal is listed in the generated text file as <code>hal</code>. Therefore, your best next step is to employ the <code>-i</code> option on the <code>grep</code> command. This will quickly search the text file for the word <code>Hal</code>, while ignoring case. Option E is the correct answer. Option A is a wrong choice because the <code>tail</code> command will not allow you to search the file. Option B is also an incorrect answer, because the <code>cat</code> command will just display the entire text file to the screen and is not an efficient method for finding a few text lines. While you may end up having to regenerate the text file, prior to doing so, you should check for <code>Hal</code>, ignoring case. If you find the records, then you have saved yourself some time. Thus, option C is also a wrong choice. Finally, the <code>-d skip</code> option on the <code>grep</code> command allows the search to skip any directory files. This option is useless in this situation, and therefore option D is an incorrect answer.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      54,
      47,
      49,
      152,
      55
    ],
    "source": "316328_c03",
    "choice_e": "Issue the <code>grep -i Hal</code> command on the text file."
  },
  {
    "id": 209,
    "question": "You are trying to peruse a rather large text file. A coworker suggests you use a pager. Which of the following best describes what your coworker is recommending?",
    "choice_a": "Use a utility that allows you to view the first few lines of the file.",
    "choice_b": "Use a utility that allows you to view one text page at time.",
    "choice_c": "Use a utility that allows you to search through the file.",
    "choice_d": "Use a utility that allows you to filter out text in the file.",
    "correct_answer": "B",
    "explanation": "A pager utility allows you to view one text page at a time and move through the text at your own pace. Therefore, option B is the correct answer. A utility that only allows you to view the first few lines of a file would not be useful in this case, and these utilities are not called pagers. Therefore, option A is a wrong answer. While the <code>less</code> utility is a pager and will allow you to search through the text file, the coworker mentioned pagers, which includes the <code>more</code> utility. With the <code>more</code> utility you cannot search through text, so option C is an incorrect choice. You do not need to filter out text in the file, and filter utilities are not called pagers, so option D is a wrong answer. A utility that only allows you to view the last few lines of a file would not be useful in this case, and these utilities are not called pagers. Therefore, option E is an incorrect choice.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      48,
      49,
      47,
      52,
      51
    ],
    "source": "316328_c03",
    "choice_e": "Use a utility that allows you to view the last few lines of the file."
  },
  {
    "id": 210,
    "question": "Which of the following does not describe the <code>less</code> utility?",
    "choice_a": "It does not read the entire file prior to displaying the file\u2019s first page.",
    "choice_b": "You can use the up and down arrow keys to move through the file.",
    "choice_c": "You press the spacebar to move forward a page.",
    "choice_d": "You can use the Esc+V key combination to move backward a page.",
    "correct_answer": "E",
    "explanation": "You need to use the q key to exit from the <code>less</code> pager utility; therefore, only option E does not describe <code>less</code> and is the correct answer. Option A is a wrong answer because <code>less</code> does not read the entire file prior to displaying the file\u2019s first page. You can also employ the up and down arrow keys to traverse the file as well as the spacebar to move forward a page and the Esc+V key combination to move backward a page, so options B, C, and D are incorrect answers.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      48,
      47,
      39,
      52,
      51
    ],
    "source": "316328_c03",
    "choice_e": "You can press the X key to exit from the utility."
  },
  {
    "id": 211,
    "question": "Which <code>diff</code> option is the best option to allow you to quickly determine if two text files are different from one another?",
    "choice_a": "<code>-e</code>",
    "choice_b": "<code>-q</code>",
    "choice_c": "<code>-s</code>",
    "choice_d": "<code>-W</code>",
    "correct_answer": "B",
    "explanation": "The <code>-q</code> (or <code>--brief</code>) option used with the diff command will allow you to quickly determine if two text files are different from one another. Thus, option B is the correct answer. The <code>-e</code> switch allows you to create an <code>ed</code> script to use later on, so option A is an incorrect choice. The <code>-s</code> option does allow you to see if the files are the same and shows a simple message stating this fact. However, it is focused on file differences, so it is not the best switch to use. Therefore, option C is also a wrong answer. The <code>diff</code> command\u2019s <code>-W</code> option allows you to set a display width, and thus, option D is an incorrect choice. The <code>-y</code> switch displays the two files in two columns, so option E is also a wrong selection.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      51,
      47,
      49,
      54,
      53
    ],
    "source": "316328_c03",
    "choice_e": "<code>-y</code>"
  },
  {
    "id": 212,
    "question": "You are working on a Linux server at the command line, and you try to issue a <code>diff</code> command and receive a response stating that the command was not found. What is the next best step to take in order to start the troubleshooting process?",
    "choice_a": "Hit your up arrow key and press Enter.",
    "choice_b": "Log out, log back in, and retry the command.",
    "choice_c": "Enter the <code>which diff</code> command.",
    "choice_d": "Enter the <code>whereis diff</code> command.",
    "correct_answer": "C",
    "explanation": "Option C is the correct answer because the <code>which</code> command will allow you to quickly see the location of the program you provide as an argument. If you see no response, you can go on to the next troubleshooting step of determining if the program is not installed. Option A is not correct because these actions will simply recall the original <code>diff</code> command and try it again. Logging out and then back in again may reset some variables you accidently created, but it is not a good first step in this troubleshooting process. Therefore, option B is a wrong answer. Entering the <code>whereis diff</code> command will provide additional information concerning the <code>diff</code> command, such as program location and source code file locations as well as manual page locations. This additional information is not needed, so option D is an incorrect choice. Rebooting a server just because a command does not work is not a good first troubleshooting step. Therefore, option E is also a wrong answer.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      52,
      55,
      334,
      339,
      53
    ],
    "source": "316328_c03",
    "choice_e": "Reboot the server and retry the command."
  },
  {
    "id": 213,
    "question": "You are trying to find a file on your Linux server whose name is <code>conf</code>. Employing the <code>locate conf</code> command for your search shows many directories that contain the letters <code>conf</code>. What is the best description for why this is happening?",
    "choice_a": "The <code>locate</code> utility searches for only for directory names.",
    "choice_b": "You did not employ the <code>-d skip</code> switch.",
    "choice_c": "It is most likely because the <code>locate</code> database is corrupted.",
    "choice_d": "You did not employ the appropriate regular expression.",
    "correct_answer": "E",
    "explanation": "By default, the <code>locate</code> command uses file globbing, which adds wildcards to the pattern you enter. Thus, <code>conf</code> is turned into <code>*conf*</code>. Therefore, option E best explains the results and is the correct answer. The <code>locate</code> command will search for both file and directory names for specified patterns unless options are provided to modify this behavior. Therefore, option A is an incorrect answer. The <code>locate</code> command does not use the <code>-d skip</code> switch (the <code>grep</code> command does use it though), and thus, option B is a wrong answer. Because the command operated normally, there is not a problem with the <code>locate</code> database, so option C is an incorrect choice. Also, a regular expression switch was not used in the <code>locate</code> command, so option D is also a wrong choice.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      52,
      55,
      54,
      53,
      50
    ],
    "source": "316328_c03",
    "choice_e": "It is due to file globbing on the pattern name."
  },
  {
    "id": 214,
    "question": "You downloaded a large important file, <code>fortytwo.db</code>, from your company\u2019s local website to your Linux server but got interrupted by an emergency. Now you cannot remember where you stored the file. What is the best first step to fixing this problem?",
    "choice_a": "Issue the <code>sudo updatedb</code> command.",
    "choice_b": "Issue the <code>locate -b fortytwo.db</code> command.",
    "choice_c": "Issue the <code>locate -b 'fortytwo.db'</code> command.",
    "choice_d": "Download the file from the company\u2019s local website again.",
    "correct_answer": "A",
    "explanation": "The <code>locate</code> utility searches the <code>mlocate.db</code> database, which is typically only updated one time per day via a <code>cron</code> job. Therefore, for this newly created file, the first thing you should do is update the <code>mlocate.db</code> via the <code>updatedb</code> command, using super user privileges. Thus, option A is the correct answer. After you have updated the database, any of the commands in option B, C, or E should work fairly well, with option B\u2019s command being the best choice. However, for the first step, options B, C, and E are wrong answers. Downloading the file again is tedious and time-consuming and can possibly consume disk space unnecessarily. Therefore, option D is an incorrect choice.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      52,
      55,
      54,
      48,
      153
    ],
    "source": "316328_c03",
    "choice_e": "Issue the <code>locate fortytwo.db</code> command."
  },
  {
    "id": 215,
    "question": "You want to search for a particular file, <code>main.conf</code>, using the <code>find</code> utility. This file most likely is located somewhere in the <code>/etc/</code> directory tree. Which of the following commands is the best one to use in this situation?",
    "choice_a": "<code>find -r /etc -name main.conf</code>",
    "choice_b": "<code>find / -name main.conf</code>",
    "choice_c": "<code>find /etc -maxdepth -name main.conf</code>",
    "choice_d": "<code>find /etc -name main.conf</code>",
    "correct_answer": "D",
    "explanation": "When using the <code>locate</code> command, the <code><i>path</i></code> argument is listed first, which is a starting point directory. The <code>find</code> utility will search through that directory and all its subdirectories (recursively) for the file or files you seek. Also, the <code>-name</code> switch allows you to search for a file by name, so option D is the correct answer. Option A is incorrect because there is no <code>-r</code> switch, and no need for one. Option B is not the best command to use in this case because the starting directory is <code>/</code>, which is the root of the virtual directory structure. It is much better to start at the <code>/etc</code> directory, since the file is most likely located somewhere in that directory tree. Using the <code>-maxdepth</code> switch may hamper the search because it sets the subdirectory level to stop the search. Therefore, option C is a wrong answer. Option E is an incorrect choice, because the <code><i>path</i></code> and file name are flip-flopped and the <code>-name</code> switch is missing.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      53,
      52,
      54,
      41,
      40
    ],
    "source": "316328_c03",
    "choice_e": "<code>find main.conf /etc</code>"
  },
  {
    "id": 216,
    "question": "Yesterday a coworker, Michael, was fired for nefarious behavior. His account and home directory were immediately deleted. You need to audit the server to see if he left any files out in the virtual directory system. Which of the following commands is the best one to use in this situation?",
    "choice_a": "<code>find / -name Michael</code>",
    "choice_b": "<code>find / -user Michael</code>",
    "choice_c": "<code>find / -mmin 1440</code>",
    "choice_d": "<code>find ~ -user Michael</code>",
    "correct_answer": "E",
    "explanation": "The <code>find / -nouser</code> command will search through the entire virtual directory structure looking for any files that do not have a username associated with them. Since Michael\u2019s account and home directory were deleted, any files he owned out in the virtual directory structure will not have a username associated with them, only a user ID (UID). Thus, option E is the best answer. Option A is incorrect because the <code>-name</code> switch is for file names, not usernames. Option B is also an incorrect answer, because the <code>-user</code> switch is used to search for files owned by a particular account. Since Michael\u2019s account was deleted, his username would no longer be associated with any files. Option C is a wrong answer because you do not know when his files may have experienced data changes, as indicated by the <code>-mmin</code> switch, and thus this is a bad method for trying to identify them. Option D is an incorrect choice because the <code>find</code> command is starting the search process in the user\u2019s home directory instead of the root (<code>/</code>) of the virtual directory structure.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      53,
      142,
      143,
      139,
      335
    ],
    "source": "316328_c03",
    "choice_e": "<code>find / -nouser</code>"
  },
  {
    "id": 217,
    "question": "You need to figure out what configuration file(s) hold a host name directive. Which of the following commands is the best one to use?",
    "choice_a": "<code>which</code>",
    "choice_b": "<code>whereis</code>",
    "choice_c": "<code>grep</code>",
    "choice_d": "<code>locate</code>",
    "correct_answer": "C",
    "explanation": "The <code>grep</code> utility will allow you to search file contents quickly and effectively. Therefore, option C is the correct answer. The <code>which</code> utility can help you locate a program\u2019s location by its name, but it does not search its contents, so option A is an incorrect choice. The <code>whereis</code> command will search for a file\u2019s program location, source code files, and man pages, but it cannot search a file\u2019s contents, so option B is also a wrong choice. The <code>locate</code> utility will search for a file\u2019s location, using its name, but cannot search a file\u2019s contents, so option D is an incorrect answer. The <code>find</code> command can find files using a file\u2019s metadata, but it does not search inside a file, so option E is a wrong choice.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      54,
      47,
      52,
      53,
      55
    ],
    "source": "316328_c03",
    "choice_e": "<code>find</code>"
  },
  {
    "id": 218,
    "question": "The <code>cat -E MyFile.tx</code>t command is entered, and at the end of every line displayed is a <code>$</code>. What does this indicate?",
    "choice_a": "The text file has been corrupted somehow.",
    "choice_b": "The text file records end in the ASCII character NUL.",
    "choice_c": "The text file records end in the ASCII character LF.",
    "choice_d": "The text file records end in the ASCII character $.",
    "correct_answer": "C",
    "explanation": "A text file record is considered to be a single file line that ends in a newline linefeed that is the ASCII character LF. You can see if your text file uses this end-of-line character via the <code>cat -E</code> command. Therefore, option C is the correct answer. The text file may have been corrupted, but this command does not indicate it, so option A is an incorrect choice. The text file records end in the ASCII character LF and not NUL or $. Therefore, options B and D are incorrect. The text file records may very well contain a <code>$</code> at their end, but you cannot tell via the situation description, so option E is a wrong answer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      59,
      57,
      61,
      58,
      56
    ],
    "source": "316328_c04",
    "choice_e": "The text file records contain a <code>$</code> at their end."
  },
  {
    "id": 219,
    "question": "The <code>cut</code> utility often needs delimiters to process text records. Which of the following best describes a delimiter?",
    "choice_a": "One or more characters that designate the beginning of a line in a record",
    "choice_b": "One or more characters that designate the end of a line in a record",
    "choice_c": "One or more characters that designate the end of a text file to a command-line text processing utility",
    "choice_d": "A single space or a colon (:) that creates a boundary between different data items in a record",
    "correct_answer": "E",
    "explanation": "To properly use some of the <code>cut</code> command options, fields must exist within each text file record. These fields are data that is separated by a delimiter, which is one or more characters that create a boundary between different data items within a record. Therefore, option E best describes a delimiter and is the correct answer. Option A is made up and is a wrong answer. Option B describes an end-of-line character, such as the ASCII LF. Option C is made up and is a wrong answer. While a single space and a colon can be used as a delimiter, option D is not the best answer and is therefore a wrong choice.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      56,
      58,
      71,
      59,
      60
    ],
    "source": "316328_c04",
    "choice_e": "One or more characters that create a boundary between different data items in a record"
  },
  {
    "id": 220,
    "question": "Which of the following utilities change text within a file? (Choose all that apply.)",
    "choice_a": "<code>cut</code>",
    "choice_b": "<code>sort</code>",
    "choice_c": "<code>vim</code>",
    "choice_d": "<code>nano</code>",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Recall that many utilities that process text do not change the text within a file unless redirection is employed to do so. The only utilities in this list that will allow you to modify text include the text editors <code>vim</code> and <code>nano</code>. Therefore, options C and D are the correct answers. The <code>cut</code>, <code>sort</code>, and <code>sed</code> utilities gather the data from a designated text file(s), modify it according to the options used, and display the modified text to standard output. The text in the file is not modified. Therefore, options A, B, and E are incorrect choices.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      72,
      67,
      70,
      68,
      73
    ],
    "source": "316328_c04",
    "choice_e": "<code>sed</code>"
  },
  {
    "id": 221,
    "question": "You have a text file, <code>monitor.txt</code>, which contains information concerning the monitors used within the data center. Each record ends with the ASCII LF character and fields are delimitated by a comma (,). A text record has the monitor ID, manufacture, serial number, and location. To display each data center monitor\u2019s monitor ID, serial number, and location, use which <code>cut</code> command?",
    "choice_a": "<code>cut -d \",\" -f 1,3,4 monitor.txt</code>",
    "choice_b": "<code>cut -z -d \",\" -f 1,3,4 monitor.txt</code>",
    "choice_c": "<code>cut -f \",\" -d 1,3,4 monitor.txt</code>",
    "choice_d": "<code>cut monitor.txt -d \",\" -f 1,3,4</code>",
    "correct_answer": "A",
    "explanation": "The <code>cut</code> command gathers data from the text file, listed as its last argument, and displays it according to the options used. To define field delimiters as a comma and display each data center monitor\u2019s monitor ID, serial number, and location, the options to use are <code>-d \",\" -f 1,3,4</code>. Also, since the text file\u2019s records end with an ASCII LF character, no special options, such as the <code>-z</code> option, are needed to process these records. Therefore, option A is the correct choice. Option B uses the unneeded <code>-z</code> option and is therefore a wrong answer. Option C is an incorrect choice because it reverses the <code>-f</code> and <code>-d</code> options. Options D and E are wrong answers because they put the filename before the command switches.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      56,
      57,
      63,
      58,
      60
    ],
    "source": "316328_c04",
    "choice_e": "<code>cut monitor.txt -f \",\" -d 1,3,4</code>"
  },
  {
    "id": 222,
    "question": "The <code>grep</code> utility can employ regular expressions in its <code><i>PATTERN</i></code>. Which of the following best describes a regular expression?",
    "choice_a": "A series of characters you define for a utility, which uses the characters to match the same characters in text files",
    "choice_b": "ASCII characters, such as LF and NUL, that a utility uses to filter text",
    "choice_c": "Wildcard characters, such as <code>*</code> and <code>?</code>, that a utility uses to filter text",
    "choice_d": "A pattern template you define for a utility, which uses the pattern to filter text",
    "correct_answer": "D",
    "explanation": "Option D is the best answer because a regular expression is a pattern template you define for a utility, such as <code>grep</code>, which uses the pattern to filter text. While you may use a series of characters in a <code>grep <i>PATTERN</i></code>, they are not called regular expressions, so option A is a wrong answer. Option B is describing end-of-line characters, and not regular expression characters, so it also is an incorrect answer. While the <code>?</code> is used in basic regular expressions, the <code>*</code> is not (however, <code>.*</code> is used). Therefore, option C is a wrong choice. Quotation marks may be employed around a <code><i>PATTERN</i></code>, but they are not considered regular expression characters, and therefore option E is an incorrect answer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      57,
      56,
      16,
      67,
      1
    ],
    "source": "316328_c04",
    "choice_e": "Quotation marks (single or double) used around characters to prevent unexpected results"
  },
  {
    "id": 223,
    "question": "You are a system administrator on a Red Hat Linux server. You need to view records in the <code>/var/log/messages</code> file that start with the date May 30 and end with the IPv4 address 192.168.10.42. Which of the following is the best <code>grep</code> command to use?",
    "choice_a": "<code>grep \"May 30?192.168.10.42\" /var/log/messages</code>",
    "choice_b": "<code>grep \"May 30.*192.168.10.42\" /var/log/messages</code>",
    "choice_c": "<code>grep -i \"May 30.*192.168.10.42\" /var/log/messages</code>",
    "choice_d": "<code>grep -i \"May 30?192.168.10.42\" /var/log/messages</code>",
    "correct_answer": "B",
    "explanation": "Option B is the best command because this <code>grep</code> command employs the correct syntax. It uses the quotation marks around the <code><i>pattern</i></code> to avoid unexpected results and uses the <code>.*</code> regular expression characters to indicate that anything can be between May 30 and the IPv4 address. No additional switches are necessary. Option A is not the best <code>grep</code> command because it uses the wrong regular expression of <code>?</code>, which allows only one character to exist between May 30 and the IPv4 address. Options C and D are not the best <code>grep</code> commands because they employ the use of the <code>-i</code> switch to ignore case, which is not needed in this case. The <code>grep</code> command in option E is an incorrect choice, because it uses the <code>-v</code> switch, which will display text records that do not match the <code><i>PATTERN</i></code>.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      57,
      63,
      59,
      56,
      58
    ],
    "source": "316328_c04",
    "choice_e": "<code>grep -v \"May 30.*192.168.10.42\" /var/log/messages</code>"
  },
  {
    "id": 224,
    "question": "Which of the following is a BRE pattern that could be used with the <code>grep</code> command? (Choose all that apply.)",
    "choice_a": "<code>Sp?ce</code>",
    "choice_b": "<code>\"Space, the .*frontier\"</code>",
    "choice_c": "<code>^Space</code>",
    "choice_d": "(<code>lasting | final)</code>",
    "correct_answer": [
      "A",
      "B",
      "C",
      "E"
    ],
    "explanation": "A BRE is a basic regular expression that describes certain patterns you can use with the <code>grep</code> command. An ERE is an extended regular expression and requires the use of <code>grep -e</code> or the <code>egrep</code> command. Options A, B, C, and E are all BRE patterns that can be used with the <code>grep</code> command, so they are correct choices. The only ERE is in option D, and therefore, it is an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      57,
      66,
      16,
      58,
      67
    ],
    "source": "316328_c04",
    "choice_e": "<code>frontier$</code>"
  },
  {
    "id": 225,
    "question": "You need to search through a large text file and find any record that contains either <code>Luke</code> or <code>Laura</code> at the record\u2019s beginning. Also, the phrase <code>Father is</code> must be located somewhere in the record\u2019s middle. Which of the following is an ERE pattern that could be used with the <code>egrep</code> command to find this record?",
    "choice_a": "<code>\"Luke$|Laura$.*Father is\"</code>",
    "choice_b": "<code>\"^Luke|^Laura.Father is\"</code>",
    "choice_c": "<code>\"(^Luke|^Laura).Father is\"</code>",
    "choice_d": "<code>\"(Luke$|Laura$).* Father is$\"</code>",
    "correct_answer": "E",
    "explanation": "To meet the search requirements, option E is the ERE to use with the <code>egrep</code> command. Therefore, option E is the correct answer. Option A will return either a record that ends with <code>Luke</code> or a record that ends with <code>Laura</code>. Thus, option A is the wrong answer. Option B is an incorrect choice because it will return either a record that begins with <code>Luke</code> or a record that begins with <code>Laura</code> and has one character between <code>Laura</code> and the <code>Father is</code> phrase. Option C has the <code>Luke</code> and <code>Laura</code> portion of the ERE correct, but it only allows one character between the names and the <code>Father is</code> phrase, which will not meet the search requirements. Thus, option C is a wrong choice. Option D will try to return either a record that ends with <code>Luke</code> or a record that ends with <code>Laura</code> and contains the <code>Father is</code> phrase, so the <code>egrep</code> command will display nothing. Thus, option D is an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      57,
      56,
      58,
      59,
      60
    ],
    "source": "316328_c04",
    "choice_e": "<code>\"(^Luke|^Laura).*Father is.*\"</code>"
  },
  {
    "id": 226,
    "question": "A file <code>data.txt</code> needs to be sorted numerically and its output saved to a new file <code>newdata.txt</code>. Which of the following commands can accomplish this task? (Choose all that apply.)",
    "choice_a": "<code>sort -n -o newdata.txt data.txt</code>",
    "choice_b": "<code>sort -n data.txt > newdata.txt</code>",
    "choice_c": "<code>sort -n -o data.txt newdata.txt</code>",
    "choice_d": "<code>sort -o newdata.txt data.txt</code>",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "To sort the <code>data.txt</code> file numerically and save its output the new file, <code>newdata.txt</code>, you can either use the <code>-o</code> switch to save the file or employ standard output redirection via the <code>></code> symbol. In both cases, however, you need to use the <code>-n</code> switch to properly enact a numerical sort. Therefore, both options A and B are correct. Option C is a wrong answer because the command has the <code>newdata.txt</code> and <code>data.txt</code> flipped in the command\u2019s syntax. Options D and E do not employ the <code>-n</code> switch, so they are incorrect answers as well.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      58,
      61,
      66,
      62,
      63
    ],
    "source": "316328_c04",
    "choice_e": "<code>sort data.txt > newdata.txt</code>"
  },
  {
    "id": 227,
    "question": "Which of the following commands can display the <code>data.txt</code> and <code>datatoo.txt</code> files\u2019 content one after the other to STDOUT? (Choose all that apply.)",
    "choice_a": "<code>ls data.txt datatoo.txt</code>",
    "choice_b": "<code>sort -n data.txt > datatoo.txt</code>",
    "choice_c": "<code>cat -n data.txt datatoo.txt</code>",
    "choice_d": "<code>ls -l data.txt datatoo.txt</code>",
    "correct_answer": [
      "C",
      "E"
    ],
    "explanation": "The commands in both options C and E will display the <code>data.txt</code> and <code>datatoo.txt</code> files\u2019 content one after the other to STDOUT. The <code>cat -n</code> command will also append line numbers to it, but it will still concatenate the files\u2019 content to standard output. Therefore, options C and E are correct. Option A will just display the files\u2019 names to STDOUT, so it is a wrong answer. Option B will numerically sort the <code>data.txt</code>, wipe out the <code>datatoo.txt</code> file\u2019s contents, and replace it with the numerically sorted contents from the <code>data.txt</code> file. Therefore, option B is an incorrect answer. Option D will show the two files\u2019 metadata to STDOUT instead of their contents, so it is also a wrong choice.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      59,
      61,
      63,
      60,
      56
    ],
    "source": "316328_c04",
    "choice_e": "<code>sort data.txt datatoo.txt</code>"
  },
  {
    "id": 228,
    "question": "A text file, <code>StarGateAttacks.txt</code>, needs to be specially formatted for review. Which of the following commands is the best command to accomplish this task quickly?",
    "choice_a": "<code>printf</code>",
    "choice_b": "<code>wc</code>",
    "choice_c": "<code>pr</code>",
    "choice_d": "<code>paste</code>",
    "correct_answer": "C",
    "explanation": "The <code>pr</code> command\u2019s primary purpose in life is to specially format a text file for printing, and it can accomplish the required task fairly quickly. Therefore, option C is the best choice. While the <code>pr</code> utility can handle formatting entire text files, the <code>printf</code> command is geared toward formatting the output of a single text line. Although you could write a shell script to read and format each text file\u2019s line via the <code>printf</code> command, it would not be the quickest method to employ. Therefore, option A is a wrong answer. Option B\u2019s <code>wc</code> command will perform counts on a text file and does not format text file contents, so it is also an incorrect answer. The <code>paste</code> command will \u201csloppily\u201d put together two or more text files side by side. Thus, option D is a wrong answer. Option E is an incorrect choice because the <code>nano</code> text editor would force you to manually format the text file, which is not the desired action.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      59,
      60,
      58,
      63,
      70
    ],
    "source": "316328_c04",
    "choice_e": "<code>nano</code>"
  },
  {
    "id": 229,
    "question": "You need to format the string <code>42.777</code> into the correct two-digit floating number. Which of the following <code>printf</code> command <code><i>FORMAT</i></code> settings is the correct one to use?",
    "choice_a": "<code>\"%s\\n\"</code>",
    "choice_b": "<code>\"%.2s\\n\"</code>",
    "choice_c": "<code>\"%d\\n\"</code>",
    "choice_d": "<code>\"%.2c\\n\"</code>",
    "correct_answer": "E",
    "explanation": "The <code>printf <i>FORMAT</i>\"%.2f\\n\"</code> will produce the desired result of <code>42.78</code>, and therefore option E is the correct answer. The <code><i>FORMAT</i></code> in option A will simply output <code>42.777</code>, so it is an incorrect choice. The <code><i>FORMAT</i></code> in option B will output <code>42</code> and therefore is a wrong answer. The <code>printf <i>FORMAT</i></code> setting in option C will produce an error, and therefore, it is an incorrect choice. Option D\u2019s <code>printf <i>FORMAT</i>\"%.2c\\n\"</code> will display <code>42</code> and thus is also an incorrect answer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      59,
      66,
      61,
      67,
      16
    ],
    "source": "316328_c04",
    "choice_e": "<code>\"%.2f\\n\"</code>"
  },
  {
    "id": 230,
    "question": "A Unicode-encoded text file, <code>MyUCode.txt</code>, needs to be perused. Before you decide what utility to use in order view the file\u2019s contents, you employ the <code>wc</code> command on it. This utility displays <code>2020 6786 11328</code> to STDOUT. What of the following is true? (Choose all that apply.)",
    "choice_a": "The file has 2,020 lines in it.",
    "choice_b": "The file has 2,020 characters in it.",
    "choice_c": "The file has 6,786 words in it.",
    "choice_d": "The file has 11,328 characters in it.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "The first item output by the <code>wc</code> utility is the number of lines within a designated text file. Therefore, option A is correct. Option C is also correct, because the second item output by the <code>wc</code> utility is the number of words within a designated text file. Option B is a wrong answer because the file contains 2,020 lines and not characters. Option D is an incorrect choice because you do not know if the Unicode subset of ASCII is used for the text file\u2019s encoding or not. You should always assume the last number is the number of bytes within the file. Use the <code>-m</code> or <code>--chars</code> switch on the <code>wc</code> command to get a character count. Therefore, the file could have 11,328 bytes in it instead of characters. Option E is also a wrong choice because the file has 2,020 lines in it.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      60,
      61,
      59,
      56,
      58
    ],
    "source": "316328_c04",
    "choice_e": "The file has 11,328 lines in it."
  },
  {
    "id": 231,
    "question": "Which of the following best defines a file descriptor?",
    "choice_a": "A letter that represents the file\u2019s type",
    "choice_b": "A number that represents a process\u2019s open files",
    "choice_c": "Another term for the file\u2019s name",
    "choice_d": "A six-character name that represents standard output",
    "correct_answer": "B",
    "explanation": "A file descriptor is a number that represents a process\u2019s open files. Therefore, option B is the correct answer. A file type code is a letter that represents the file\u2019s type, displayed as the first item in the <code>ls -l</code> output line. Therefore, option A is a wrong answer. Option C is also wrong, because it is a made-up answer. Option D is incorrect because it describes only STDOUT, which has a file descriptor number of 1 and is only one of several file descriptors. A file indicator code is a symbol that indicates the file\u2019s classification, and it is generated by the <code>ls -F</code> command. Therefore, option E is also a wrong choice.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      61,
      66,
      59,
      16,
      72
    ],
    "source": "316328_c04",
    "choice_e": "A symbol that indicates the file\u2019s classification"
  },
  {
    "id": 232,
    "question": "By default, STDOUT goes to what item?",
    "choice_a": "<code>/dev/tty <i>n</i></code>, where <code><i>n</i></code> is a number.",
    "choice_b": "<code>/dev/null</code>",
    "choice_c": "<code>></code>",
    "choice_d": "<code>/dev/tty</code>",
    "correct_answer": "D",
    "explanation": "By default, STDOUT goes to your current terminal, which is represented by the <code>/dev/tty</code> file. Therefore, option D is the correct answer. The <code>/dev/tty <i>n</i></code> file, such as <code>/dev/tty2</code>, may be your current terminal at a particular point in time, but <code>/dev/tty</code> always represents your current terminal, so option A is a wrong answer. Option C is incorrect because it is the symbol used at the command line to redirect STDOUT away from its default behavior. The <code>pwd</code> command displays your present working directory, so option E is a wrong choice.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      61,
      66,
      16,
      63,
      1
    ],
    "source": "316328_c04",
    "choice_e": "<code>pwd</code>"
  },
  {
    "id": 233,
    "question": "Which of the following commands will display the file <code>SpaceOpera.txt</code> to output as well as save a copy of it to the file <code>SciFi.txt</code>?",
    "choice_a": "<code>cat SpaceOpera.txt | tee SciFi.txt</code>",
    "choice_b": "<code>cat SpaceOpera.txt > SciFi.txt</code>",
    "choice_c": "<code>cat SpaceOpera.txt 2> SciFi.txt</code>",
    "choice_d": "<code>cp SpaceOpera.txt SciFi.txt</code>",
    "correct_answer": "A",
    "explanation": "The command in option A will display the <code>SpaceOpera.txt</code> file to output as well as save a copy of it to the <code>SciFi.txt</code> file. Therefore, option A is the correct answer. Option B is a wrong answer because it will only put a copy of <code>SpaceOpera.txt</code> into the <code>SciFi.txt</code> file. Option C is an incorrect choice because this will display the <code>SpaceOpera.txt</code> file to output and put any error messages into the <code>SciFi.txt</code> file. The <code>cp</code> command will only copy one text file to another. It will not display the original file to output, so option D is a wrong answer. Option E is a wrong choice because it will put a copy of <code>SpaceOpera.txt</code> into the <code>SciFi.txt</code> file and include any error messages that are generated.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      61,
      66,
      62,
      59,
      60
    ],
    "source": "316328_c04",
    "choice_e": "<code>cat SpaceOpera.txt &> SciFi.txt</code>"
  },
  {
    "id": 234,
    "question": "Which of the following commands will put any generated error messages into the black hole?",
    "choice_a": "<code>sort SpaceOpera.txt 2> BlackHole</code>",
    "choice_b": "<code>sort SpaceOpera.txt &> BlackHole</code>",
    "choice_c": "<code>sort SpaceOpera.txt > BlackHole</code>",
    "choice_d": "<code>sort SpaceOpera.txt 2> /dev/null</code>",
    "correct_answer": "D",
    "explanation": "The <code>/dev/null</code> file is also called the black hole, because anything you put into it cannot be retrieved. If you do not wish to see any error messages while issuing a command, you can redirect STDERR into it. Thus, option D is the correct answer. Options A through C are wrong answers because they perform redirection to a file called <code>BlackHole</code> instead of <code>/dev/null</code>. Option E is also incorrect, because it redirects STDOUT to the <code>/dev/null</code> file, and any error messages will be displayed.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      62,
      66,
      61,
      63,
      59
    ],
    "source": "316328_c04",
    "choice_e": "<code>sort SpaceOpera.txt > /dev/null</code>"
  },
  {
    "id": 235,
    "question": "Which of the following commands will determine how many records in the file <code>Problems.txt</code> contain the word <code>error</code>?",
    "choice_a": "<code>grep error Problems.txt | wc -b</code>",
    "choice_b": "<code>grep error Problems.txt | wc -w</code>",
    "choice_c": "<code>grep error Problems.txt | wc -l</code>",
    "choice_d": "<code>grep Problems.txt error | wc -w</code>",
    "correct_answer": "C",
    "explanation": "To find records within the <code>Problems.txt</code> file that contain the word <code>error</code> at least one time, the <code>grep</code> command is employed. The correct syntax is <code>grep error Problems.txt</code>. To count the records, the <code>grep</code> command\u2019s STDOUT is piped as STDIN into the <code>wc</code> utility. The correct syntax to count the records is <code>wc -l</code>. Therefore, option C is the correct answer. The command in option A is incorrect because its <code>wc</code> command is counting the number of bytes within each input record. Option B is a wrong answer, because its <code>wc</code> command is counting the number of words within each input record. The command in option D has two problems. First, its <code>grep</code> command syntax has the item for which to search and the file to search backward. Also, its <code>wc</code> command is counting the number of words within each input record. Therefore, option D is a wrong choice. Option E is an incorrect answer because its <code>grep</code> command syntax has the item for which to search and the file to search backward.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      63,
      57,
      60,
      61,
      62
    ],
    "source": "316328_c04",
    "choice_e": "<code>grep Problems.txt error | wc -l</code>"
  },
  {
    "id": 236,
    "question": "You want to find any file named <code>42.tmp</code>, which exists somewhere in your current directory\u2019s tree structure and display its contents to STDOUT. Which of the following will allow you to build a command to do this? (Choose all that apply.)",
    "choice_a": "<code>xargs (find . -name 42.tmp) cat</code>",
    "choice_b": "<code>cat `find . -name 42.tmp`</code>",
    "choice_c": "<code>cat $(find . -name 42.tmp)</code>",
    "choice_d": "<code>cat {find . -name 42.tmp}</code>",
    "correct_answer": [
      "B",
      "C",
      "E"
    ],
    "explanation": "The <code>xargs</code> command, <code>$()</code> method, backticks (<code>`</code>), and brace expansion all allow you to build a command-line command on the fly. In this case, only options B, C, and E are using the correct command syntax to find any file named <code>42.tmp</code>, which exists somewhere in your current directory\u2019s tree structure and display its contents to STDOUT. Therefore, options B, C, and E are correct answers. Option A is using the wrong syntax for the <code>xargs</code> command, and this command will generate an error message. Therefore, option A is a wrong answer. Option D is using the wrong syntax for brace expansion, and thus, it is an incorrect choice as well.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      64,
      63,
      66,
      163,
      56
    ],
    "source": "316328_c04",
    "choice_e": "<code>find . -name 42.tmp | xargs cat</code>"
  },
  {
    "id": 237,
    "question": "You want to edit the file <code>SpaceOpera.txt</code> and decide to use the <code>vim</code> editor to complete this task. Which of the following are <code>vim</code> modes you might employ? (Choose all that apply.)",
    "choice_a": "Insert",
    "choice_b": "Change",
    "choice_c": "Command",
    "choice_d": "Ex",
    "correct_answer": [
      "A",
      "C",
      "D",
      "E"
    ],
    "explanation": "The three modes of the <code>vim</code> editor are command (also called normal mode), insert (also called edit or entry mode), and Ex (sometimes called colon commands) mode. Therefore, options A, C, D, and E are correct answers. The only incorrect choice for this question is option B.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      68,
      72,
      69,
      73,
      67
    ],
    "source": "316328_c04",
    "choice_e": "Edit"
  },
  {
    "id": 238,
    "question": "What program does the workstation firmware start at boot time?",
    "choice_a": "A bootloader",
    "choice_b": "The <code>fsck</code> program",
    "choice_c": "The Windows OS",
    "choice_d": "The <code>mount</code> command",
    "correct_answer": "A",
    "explanation": "The workstation firmware looks for the bootloader program to load an operating system. The <code>fsck</code> program (option B) is used to check and repair damage to hard drives, so it isn\u2019t useful until after the Linux system has started. The Windows operating system only starts after a Windows bootloader program can run, so option C is incorrect. The <code>mount</code> program is a Linux tool for attaching a partition to the virtual directory, which isn\u2019t available until after the Linux system starts, so option D is also incorrect. The <code>mkinitrd</code> program is used to create an <code>initrd</code> RAM disk used for booting, but it isn\u2019t run when the workstation starts up, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      74,
      76,
      77,
      81,
      80
    ],
    "source": "316328_c05",
    "choice_e": "The <code>mkinitrd</code> program"
  },
  {
    "id": 239,
    "question": "Where does the firmware first look for a Linux bootloader program?",
    "choice_a": "The <code>/boot/grub</code> folder",
    "choice_b": "The Master Boot Record (MBR)",
    "choice_c": "The <code>/var/log</code> folder",
    "choice_d": "A boot partition",
    "correct_answer": "B",
    "explanation": "The workstation firmware looks at the first sector of the first hard drive to load the bootloader program. This is called the Master Boot Record, so option A is correct. The bootloader program itself can use the chainloader feature to look for another bootloader in a boot partition, but the firmware can\u2019t do that, so option D is incorrect. Option A specifies the configuration folder used to store the GRUB configuration file and the kernel image file, but the actual GRUB bootloader program can\u2019t be stored there. Option C specifies the common log file folder, but that doesn\u2019t contain the GRUB bootloader program. Option E also specifies a common Linux configuration file directory, but it\u2019s not used to store the GRUB bootloader program that the firmware can access.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      76,
      74,
      79,
      77,
      81
    ],
    "source": "316328_c05",
    "choice_e": "The <code>/etc</code> folder"
  },
  {
    "id": 240,
    "question": "Which command allows us to examine the most recent boot messages?",
    "choice_a": "<code>fsck</code>",
    "choice_b": "<code>mkinitramfs</code>",
    "choice_c": "<code>mount</code>",
    "choice_d": "<code>dmesg</code>",
    "correct_answer": "D",
    "explanation": "The kernel ring buffer, which you can view by typing <code>dmesg</code>, contains messages from the boot messages from the kernel; thus, option D is correct. The <code>fsck</code> program (option A) fixes corrupted partitions, and the <code>mount</code> program (option C) is used to attach partitions to the virtual directory, so neither of those is correct. Option B, the <code>init</code> program, is used to start programs from the kernel, not display boot messages, so it also is incorrect. Option E, the <code>mkinitrd</code> program, is used to create a new <code>initrd</code> RAM disk and is not related to the boot messages, so it too is incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      75,
      74,
      83,
      1,
      212
    ],
    "source": "316328_c05",
    "choice_e": "<code>mkinitrd</code>"
  },
  {
    "id": 241,
    "question": "What folder do most Linux distributions use to store boot logs?",
    "choice_a": "<code>/etc</code>",
    "choice_b": "<code>/var/messages</code>",
    "choice_c": "<code>/var/log</code>",
    "choice_d": "<code>/boot</code>",
    "correct_answer": "C",
    "explanation": "Most Linux distributions store boot log files in the <code>/var/log</code> folder. The <code>/etc</code> folder is most often used for storing system and application configuration files, not boot logs, so option A is incorrect. Some Unix systems use the <code>/var/messages</code> folder for storing log files, but Linux has not adopted this standard, so option B is also incorrect. The <code>/boot</code> folder contains the GRUB configuration files along with the image files necessary to boot the system, but it\u2019s not where Linux stores boot logs, and is thus incorrect. The <code>/proc</code> folder is unique in that the Linux kernel dynamically stores information about the system there, but it doesn\u2019t store boot log information there.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      75,
      74,
      213,
      1,
      167
    ],
    "source": "316328_c05",
    "choice_e": "<code>/proc</code>"
  },
  {
    "id": 242,
    "question": "Where does the workstation BIOS attempt to find a bootloader program? (Choose all that apply.)",
    "choice_a": "An internal hard drive",
    "choice_b": "An external hard drive",
    "choice_c": "A DVD drive",
    "choice_d": "A USB memory stick",
    "correct_answer": [
      "A",
      "B",
      "C",
      "D",
      "E"
    ],
    "explanation": "The BIOS firmware can look in multiple locations for a bootloader program. Most commonly it looks at the internal hard drive installed on the system, but if none is found, it can search other places. Most workstations allow you to boot from an external hard drive or from a DVD drive. Modern workstations now also provide the option to boot from a USB memory stick inserted into a USB port on the workstation. Finally, many workstations provide the PXE boot option, which allows the workstation to boot remotely from a network server.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      76,
      77,
      78,
      80,
      81
    ],
    "source": "316328_c05",
    "choice_e": "A network server"
  },
  {
    "id": 243,
    "question": "Where is the Master Boot Record located? (Choose all that apply.)",
    "choice_a": "The first sector of the first hard drive on the system",
    "choice_b": "The boot partition of any hard drive on the system",
    "choice_c": "The last sector of the first hard drive on the system",
    "choice_d": "Any sector on any hard drive on the system",
    "correct_answer": "A",
    "explanation": "The Master Boot Record (MBR) is only located in one place: on the first sector of the first hard drive on the workstation, so option A is the only correct answer. The boot partition in any hard drive may contain a bootloader, but it is not the Master Boot Record, which is run first by the firmware, thus option B is incorrect. The other locations are not valid locations for the Master Boot Record.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      76,
      78,
      79,
      158,
      74
    ],
    "source": "316328_c05",
    "choice_e": "The first sector of the second hard drive on the system"
  },
  {
    "id": 244,
    "question": "The EFI System Partition (ESP) is stored in the _______ directory on Linux systems.",
    "choice_a": "<code>/boot</code>",
    "choice_b": "<code>/etc</code>",
    "choice_c": "<code>/var</code>",
    "choice_d": "<code>/boot/efi</code>",
    "correct_answer": "D",
    "explanation": "The ESP is stored in the <code>/boot/efi</code> directory on Linux systems. The UEFI firmware always looks for the <code>/boot/efi</code> directory for bootloader programs, so option D is correct. The <code>/etc</code> directory is used to store application and system configuration files, not bootloader programs, so option B is incorrect. The <code>/var</code> folder is used to store variable files such as log files, not bootable files, so option C is incorrect. Option E, the <code>/boot/grub</code> file, is used in GRUB Legacy and GRUB2 to store the bootloader configuration files, as well as the kernel image files. However, it is not used to store the bootloader files themselves, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      77,
      74,
      80,
      78,
      81
    ],
    "source": "316328_c05",
    "choice_e": "<code>/boot/grub</code>"
  },
  {
    "id": 245,
    "question": "What file extension does UEFI bootloader files use?",
    "choice_a": "<code>.cfg</code>",
    "choice_b": "<code>.uefi</code>",
    "choice_c": "<code>.lst</code>",
    "choice_d": "<code>.conf</code>",
    "correct_answer": "E",
    "explanation": "The UEFI specification doesn\u2019t require a specific extension for UEFI bootloader files, but it has become somewhat common in Linux to use the <code>.efi</code> file extension to identify them; thus, option E is correct. Options A and D specify file extensions used to identify GRUB2 (option A) and GRUB Legacy (option D) configuration files, not UEFI bootloader files, so they are both incorrect. Option C specifies the <code>.lst</code> file extension, which is also used for GRUB Legacy configuration files, so it too is incorrect. The <code>.uefi</code> file extension is not used in Linux, so option B is incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      77,
      81,
      78,
      80,
      79
    ],
    "source": "316328_c05",
    "choice_e": "<code>.efi</code>"
  },
  {
    "id": 246,
    "question": "Which was the first bootloader program used in Linux?",
    "choice_a": "GRUB Legacy",
    "choice_b": "LILO",
    "choice_c": "GRUB2",
    "choice_d": "SYSLINUX",
    "correct_answer": "B",
    "explanation": "The Linux Loader (LILO) bootloader program was the first bootloader used in Linux, so option B is correct. The GRUB Legacy bootloader, despite its name, wasn\u2019t the first bootloader, but the second bootloader commonly used in Linux. The GRUB2 bootloader was a later improvement over the GRUB Legacy bootloader, so options A and C are incorrect. Option D, the SYSLINUX bootloader, provided features for use with Microsoft FAT partitions, so that you could boot Linux from a floppy drive or USB memory stick, but it was a later creation and not the first Linux bootloader. Option E, ISOLINUX, is also a later bootloader that allows us to boot Linux from a CD or DVD drive.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      81,
      74,
      76,
      79,
      78
    ],
    "source": "316328_c05",
    "choice_e": "ISOLINUX"
  },
  {
    "id": 247,
    "question": "Where are the GRUB Legacy configuration files stored?",
    "choice_a": "<code>/boot/grub</code>",
    "choice_b": "<code>/boot/efi</code>",
    "choice_c": "<code>/etc</code>",
    "choice_d": "<code>/var</code>",
    "correct_answer": "A",
    "explanation": "The GRUB Legacy configuration files are stored in the <code>/boot/grub</code> directory, so option A is correct. Option B, the <code>/boot/efi</code> directory, is used to store UEFI bootloader programs, not GRUB configuration files, so it is incorrect. Option C, the <code>/etc</code> directory, stores many application and system configuration files, but not the GRUB Legacy configuration files. The <code>/var</code> directory stores variable files such as log files, but not configuration files, so option D is incorrect. Likewise, Linux uses the <code>/proc</code> directory to provide dynamic kernel runtime data, and not configuration files.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      78,
      79,
      80,
      77,
      162
    ],
    "source": "316328_c05",
    "choice_e": "<code>/proc</code>"
  },
  {
    "id": 248,
    "question": "Where are GRUB2 configuration files stored? (Choose all that apply.)",
    "choice_a": "<code>/proc</code>",
    "choice_b": "<code>/etc/grub.d</code>",
    "choice_c": "<code>/boot/grub</code>",
    "choice_d": "<code>/boot/efi</code>",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "The GRUB2 bootloader stores configuration files in both the <code>/boot/grub</code> directory and the <code>/etc/grub.d</code> directory, so options B and C are correct. Linux uses the <code>/proc</code> directory to provide dynamic kernel runtime data, and not configuration files, so option A is incorrect. Option D, <code>/boot/efi</code>, stores UEFI bootloader program files, not GRUB2 configuration files, so it is also incorrect. Option E, <code>/var</code>, is used to store variable files, such as log files, and not configuration files, so it is incorrect.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      80,
      81,
      77,
      74,
      84
    ],
    "source": "316328_c05",
    "choice_e": "<code>/var</code>"
  },
  {
    "id": 249,
    "question": "You must run the ______ command to generate the GRUB2 <code>grub.cfg</code> configuration file.",
    "choice_a": "<code>mkinitrd</code>",
    "choice_b": "<code>mkinitramfs</code>",
    "choice_c": "<code>grub-mkconfig</code>",
    "choice_d": "<code>grub-install</code>",
    "correct_answer": "C",
    "explanation": "The <code>grub-mkconfig</code> command combines the configurations defined in the <code>/etc/default/grub</code> file and all of the files in the <code>/etc/grub.d</code> folder into a single <code>grub.cfg</code> configuration file. The <code>mkinitrd</code> command (option A) is used to create a new <code>initrd</code> RAM disk image file, so it is incorrect. Likewise, the <code>mkinitramfs</code> command (option B) is also used to create <code>initrd</code> image files on Debian systems, so it too is incorrect. The <code>grub-install</code> program is used by the GRUB Legacy bootloader to install the bootloader in the MBR or a boot partition, but it isn\u2019t used to generate the GRUB2 configuration files and is thus incorrect. Option E is the <code>fsck</code> program, which checks and repairs hard drive partitions, and is an incorrect answer for this question.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      80,
      81,
      79,
      84,
      86
    ],
    "source": "316328_c05",
    "choice_e": "<code>fsck</code>"
  },
  {
    "id": 250,
    "question": "What command must you run to save changes to a GRUB Legacy boot menu?",
    "choice_a": "<code>mkinitrd</code>",
    "choice_b": "<code>mkinitramfs</code>",
    "choice_c": "<code>grub-mkconfig</code>",
    "choice_d": "<code>grub-install</code>",
    "correct_answer": "D",
    "explanation": "The <code>grub-install</code> command installs any configuration changes into the GRUB MBR, so option D is correct. The <code>mkinitrd</code> command creates a new <code>initrd</code> RAM disk image file, so option A is incorrect. Likewise, the <code>mkinitramfs</code> command (option B) is also used to create <code>initrd</code> image files on Debian systems, so it too is incorrect. The <code>grub-mkconfig</code> command is used in GRUB2 systems to create an updated configuration file but not in GRUB Legacy systems, so option C is incorrect. The <code>fsck</code> program checks and repairs hard drive partitions, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      79,
      78,
      76,
      80,
      81
    ],
    "source": "316328_c05",
    "choice_e": "<code>fsck</code>"
  },
  {
    "id": 251,
    "question": "The ____ firmware method has replaced BIOS on most modern IBM-compatible computers.",
    "choice_a": "FTP",
    "choice_b": "UEFI",
    "choice_c": "PXE",
    "choice_d": "NFS",
    "correct_answer": "B",
    "explanation": "The UEFI firmware method has replaced the BIOS in most IBM-compatible computers, so option B is correct. FTP, PXE, NFS, and HTTPS are not firmware methods, but methods for loading the Linux bootloader, so options A, C, D, and E are all incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      77,
      76,
      74,
      81,
      80
    ],
    "source": "316328_c05",
    "choice_e": "HTTPS"
  },
  {
    "id": 252,
    "question": "What memory area does Linux use to store boot messages?",
    "choice_a": "BIOS",
    "choice_b": "The GRUB bootloader",
    "choice_c": "The MBR",
    "choice_d": "The <code>initrd</code> RAM disk",
    "correct_answer": "E",
    "explanation": "The kernel ring buffer is an area in memory reserved for storing output messages as the Linux system boots, so option E is correct. Option A, BIOS, is firmware on the workstation, not an area in memory, so it is incorrect. The GRUB bootloader, option B, is a program that starts the Linux system and is not in memory, so it is also incorrect. The MBR is a location on the hard drive to store the Linux bootloader, so option C is incorrect. The <code>initrd</code> RAM disk is an area in memory that stores modules required for the boot process, but it doesn\u2019t store the boot messages as the system starts, so option D is incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      75,
      74,
      346,
      76,
      212
    ],
    "source": "316328_c05",
    "choice_e": "The kernel ring buffer"
  },
  {
    "id": 253,
    "question": "What command parameter would you add to the end of the GRUB2 <code>linux</code> command to force a Linux system to start in single-user mode?",
    "choice_a": "<code>single</code>",
    "choice_b": "<code>fsck</code>",
    "choice_c": "<code>mkinitrd</code>",
    "choice_d": "<code>mkinitramfs</code>",
    "correct_answer": "A",
    "explanation": "The <code>single</code> command parameter instructs the Linux system to start in single-user mode after booting, so option A is correct. The <code>fsck</code> command checks and repairs hard drive partitions, so option B is incorrect. Both the <code>mkinitrd</code> and <code>mkinitramfs</code> commands create <code>initrd</code> RAM disk files, so options C and D are incorrect. The <code>dmesg</code> command displays the boot messages from the kernel ring buffer, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      86,
      84,
      74,
      83,
      85
    ],
    "source": "316328_c05",
    "choice_e": "<code>dmesg</code>"
  },
  {
    "id": 254,
    "question": "What is the term commonly used for when the Linux system halts due to a system error?",
    "choice_a": "Kernel panic",
    "choice_b": "Kernel ring buffer",
    "choice_c": "<code>initrd</code> RAM disk",
    "choice_d": "Bootloader",
    "correct_answer": "A",
    "explanation": "A kernel panic occurs when a Linux system halts unexpectedly due to a system error, so option A is the correct term. The kernel ring buffer stores boot messages at boot time, so option B is incorrect. The <code>initrd</code> RAM disk is an area in memory that stores module files required to boot the system, so option C is incorrect. The bootloader and firmware are part of the Linux boot process and don\u2019t refer to when the system halts, so options D and E are both incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      83,
      75,
      74,
      78,
      84
    ],
    "source": "316328_c05",
    "choice_e": "Firmware"
  },
  {
    "id": 255,
    "question": "The ________ command generates the GRUB2 configuration used for booting.",
    "choice_a": "<code>mkinitrd</code>",
    "choice_b": "<code>grub-mkconfig</code>",
    "choice_c": "<code>grub-install</code>",
    "choice_d": "<code>mkinitramfs</code>",
    "correct_answer": "B",
    "explanation": "The <code>grub-mkconfig</code> command processes GRUB2 directives stored in the <code>/etc/grub.d</code> folder to create the <code>/etc/grub2.cfg</code> configuration file, so option B is correct. The <code>mkinitrd</code> and <code>mkinitramfs</code> commands are used to create an <code>initrd</code> RAM disk to store module files, so options A and D are incorrect. The <code>grub-install</code> command is used in GRUB Legacy to install the GRUB configuration file in the correct location, but it isn\u2019t used in GRUB2, so option C is incorrect. The <code>dmesg</code> command displays the system boot messages and isn\u2019t part of the GRUB2 bootloader, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      80,
      81,
      79,
      86,
      84
    ],
    "source": "316328_c05",
    "choice_e": "<code>dmesg</code>"
  },
  {
    "id": 256,
    "question": "What program allows you to fix corrupted hard drive partitions?",
    "choice_a": "<code>mount</code>",
    "choice_b": "<code>umount</code>",
    "choice_c": "<code>fsck</code>",
    "choice_d": "<code>dmesg</code>",
    "correct_answer": "C",
    "explanation": "The <code>fsck</code> program can perform a filesystem check and repair multiple types of filesystems on partitions. You should use it on any partition that can\u2019t be mounted due to errors. The <code>mount</code> program (option A) is used to append a partition to a virtual directory, but it can\u2019t correct a partition that contains errors (and will usually refuse to mount them). The <code>umount</code> command (option B) is also incorrect. It is used to remove a mounted partition from the virtual directory. Option D (the <code>dmesg</code> command) displays boot messages, and option E (the <code>mkinitrd</code> command) creates an <code>initrd</code> RAM disk, so both are incorrect.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      85,
      167,
      164,
      170,
      160
    ],
    "source": "316328_c05",
    "choice_e": "<code>mkinitrd</code>"
  },
  {
    "id": 257,
    "question": "Which command allows you to append a partition to the virtual directory on a running Linux system?",
    "choice_a": "<code>mount</code>",
    "choice_b": "<code>umount</code>",
    "choice_c": "<code>fsck</code>",
    "choice_d": "<code>dmesg</code>",
    "correct_answer": "A",
    "explanation": "The <code>mount</code> command allows you to specify both the partition and the location in the virtual directory where to append the partition files and folders. The files and folders contained in the partition then appear at that location in the virtual directory. The <code>umount</code> command (option B) is used to remove a mounted partition. Option C, the <code>fsck</code> command, is used to fix a hard drive that is corrupted and can\u2019t be mounted, but it doesn\u2019t actually mount the drive itself. The <code>dmesg</code> command in option D is used to view boot messages for the system, which may tell you where a hard drive is appended to the virtual directory but doesn\u2019t actually do the appending. Option E, the <code>kninitramfs</code> command, creates an <code>initrd</code> RAM disk, and doesn\u2019t directly handle mounting hard drives to the virtual directory.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      167,
      162,
      342,
      158,
      166
    ],
    "source": "316328_c05",
    "choice_e": "<code>mkinitramfs</code>"
  },
  {
    "id": 258,
    "question": "The <code>init</code> program may be located in which of the following directories? (Choose all that apply.)",
    "choice_a": "<code>/etc/rc.d/</code>",
    "choice_b": "<code>/etc/</code>",
    "choice_c": "<code>/sbin/</code>",
    "choice_d": "<code>/usr/lib/systemd/</code>",
    "correct_answer": [
      "B",
      "C",
      "E"
    ],
    "explanation": "The <code>init</code> program may exist in the <code>/etc/</code>, <code>/sbin/</code>, or <code>/bin/</code> directory, depending on your distribution and its version, so therefore options B, C, and E are correct. The <code>/etc/rc.d/</code> directory is used in SysVint systems and not a location for the <code>init</code> program, so option A is a wrong answer. The <code>/etc/lib/systemd/</code> directory is the location of the systemd program, and thus option D is also an incorrect choice.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      87,
      52,
      90,
      88,
      89
    ],
    "source": "316328_c06",
    "choice_e": "<code>/bin/</code>"
  },
  {
    "id": 259,
    "question": "Which of the following is true concerning systemd service units? (Choose all that apply.)",
    "choice_a": "Services can be started at system boot time.",
    "choice_b": "Services can be started in parallel.",
    "choice_c": "A service can be started based on a timer.",
    "choice_d": "A service can be started after all other services are started.",
    "correct_answer": [
      "A",
      "B",
      "C",
      "D",
      "E"
    ],
    "explanation": "This is a tricky question, because all of these statements are true concerning systemd service units. It makes you realize that systemd managed systems are very flexible.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      89,
      88,
      95,
      92,
      91
    ],
    "source": "316328_c06",
    "choice_e": "A service can be prevented from starting at system boot time."
  },
  {
    "id": 260,
    "question": "Which of the following is not a systemd target unit?",
    "choice_a": "<code>runlevel7.target</code>",
    "choice_b": "<code>emergency.target</code>",
    "choice_c": "<code>graphical.target</code>",
    "choice_d": "<code>multi-user.target</code>",
    "correct_answer": "A",
    "explanation": "There is no <code>runlevel7.target</code>. The legitimate systemd targets, which provide backward SysV init compatibility, go from <code>runlevel0.target</code> through <code>runlevel6.target</code>. Therefore, option A is the correct answer. The <code>emergency.target</code> is a special systemd target unit used to enter emergency mode. When your system goes into emergency mode, the system only mounts the root filesystem and mounts it as read-only. Therefore, option B is a systemd target unit and not a correct answer. The <code>graphical.target</code> is a legitimate systemd target, which provides multiple users access to the system via local terminals and/or through the network and offers a GUI. Thus, option C is an incorrect choice. The <code>multi-user.target</code> is also a legitimate systemd target, just like the <code>graphical.target</code>, except it does not offer a GUI. Therefore, option D is also a wrong answer. The <code>rescue.target</code> is like <code>emergency.target</code>, but it mounts the root filesystem for reading and writing. Therefore, option E is an incorrect choice.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      91,
      93,
      88,
      97,
      96
    ],
    "source": "316328_c06",
    "choice_e": "<code>rescue.target</code>"
  },
  {
    "id": 261,
    "question": "You need to modify a systemd service unit configuration. Where should the modified file be located?",
    "choice_a": "<code>/etc/system/systemd/</code>",
    "choice_b": "<code>/usr/lib/system/systemd/</code>",
    "choice_c": "<code>/etc/systemd/system/</code>",
    "choice_d": "<code>/usr/lib/systemd/system/</code>",
    "correct_answer": "C",
    "explanation": "Any modified systemd service unit configuration file should be stored in the <code>/etc/systemd/system/</code> directory. This will prevent any package upgrades from overwriting it and keep the directory precedence from using the unmodified service unit copy, which may reside in the <code>/usr/lib/systemd/system/</code> directory. Therefore, option C is the correct answer. The directories in options A and B are made up, and therefore those options are wrong answers. The <code>/usr/lib/systemd/system/</code> directory should only store unmodified unit files, which are provided by default, and thus option D is an incorrect answer. The <code>/run/system/systemd/</code> directory is made up, and therefore option E is also an incorrect choice.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      90,
      89,
      88,
      92,
      95
    ],
    "source": "316328_c06",
    "choice_e": "<code>/run/system/systemd/</code>"
  },
  {
    "id": 262,
    "question": "On your server, you need Service-B to start immediately before Service-A. Within the systemd Service-A unit configuration file, what directive should you check and potentially modify?",
    "choice_a": "<code>Conflicts</code>",
    "choice_b": "<code>Wants</code>",
    "choice_c": "<code>Requires</code>",
    "choice_d": "<code>Before</code>",
    "correct_answer": "E",
    "explanation": "For starting Service-B immediately before starting Service-A, the Service-A unit configuration file will need to employ the <code>After</code> directive, set it similar to something like <code>After=Service-B.unit</code>. Therefore, option E is the correct answer. The <code>Conflicts</code> directive sets the unit to not start with the designated units. If any of the designated units start, this unit is not started. Therefore, option A is a wrong answer. The <code>Wants</code> directive sets the unit to start together with the designated units. If any of the designated units do not start, this unit is still started. Therefore, option B is also an incorrect answer. The <code>Requires</code> directive sets the unit to start together with the designated units. If any of the designated units do not start, this unit is not started. Thus, option C is a wrong choice. The <code>Before</code> directive sets this unit to start before the designated units. While this should be set in Service-B\u2019s unit configuration file, it does not apply, in this case, to Service-A\u2019s configuration file. Therefore, option D is also an incorrect answer.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      89,
      88,
      92,
      91,
      94
    ],
    "source": "316328_c06",
    "choice_e": "<code>After</code>"
  },
  {
    "id": 263,
    "question": "For setting environment parameters within a unit configuration file, which directives should you potentially employ? (Choose all that apply.)",
    "choice_a": "<code>Type</code>",
    "choice_b": "<code>Environment</code>",
    "choice_c": "<code>EnvironmentParam</code>",
    "choice_d": "<code>EnvironmentFile</code>",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Linux systems use environment variables to store information about the shell session and working environment. If you need to ensure that a particular environment variable is set properly for your service, you need to employ the <code>Environment</code> directive and/or the <code>EnvironmentFile</code> directive for setting environment parameters. Therefore, options B and D are correct answers. The <code>Type</code> directive sets the unit startup type, which can be, for example, <code>forking</code>. Thus, option A is a wrong answer. The <code>EnvironmentParam</code> is a made-up directive, and therefore option C is an incorrect choice. The <code>PATH</code> is an environment variable, which you may modify for your unit\u2019s environmental parameters. However, it is not a directive, and therefore, option E is also an incorrect answer.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      89,
      340,
      150,
      131,
      90
    ],
    "source": "316328_c06",
    "choice_e": "<code>PATH</code>"
  },
  {
    "id": 264,
    "question": "You attempt to jump to a systemd target using the <code>systemctl isolate</code> command, but it will not work. You decide to look at the target unit file. What might you see there that is causing this problem?",
    "choice_a": "<code>static</code>",
    "choice_b": "<code>AllowIsolate=yes</code>",
    "choice_c": "<code>Type=oneshot</code>",
    "choice_d": "<code>AllowIsolate=no</code>",
    "correct_answer": "D",
    "explanation": "If a target unit file has the <code>AllowIsolate=no</code> setting, the target cannot be used with the <code>systemctl isolate</code> command. Therefore, option D is the correct answer. Option A\u2019s <code>static</code> is an enablement state displayed for a unit file via the <code>systemctl --list-unit-files</code> command. Thus, option A is a wrong answer. The <code>AllowIsolate=yes</code> directive permits the target to be used with the <code>systemctl isolate</code> command. Therefore, option B is also an incorrect choice. The <code>Type=oneshot</code> is a service unit directive, and you would not find it in a target unit file. Thus, option C is a wrong answer. Option E\u2019s <code>disabled</code> is also an enablement state, like <code>static</code>. Therefore, option E is a wrong choice as well.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      96,
      91,
      89,
      90,
      95
    ],
    "source": "316328_c06",
    "choice_e": "<code>disabled</code>"
  },
  {
    "id": 265,
    "question": "You have modified an OpenSSH service\u2019s configuration file, <code>/etc/ssh/ssh_config</code>. The service is already running. What is the best command to use with <code>systemctl</code> to make this modified file take immediate effect?",
    "choice_a": "<code>reload</code>",
    "choice_b": "<code>daemon-reload</code>",
    "choice_c": "<code>restart</code>",
    "choice_d": "<code>mask</code>",
    "correct_answer": "A",
    "explanation": "The best command to make the modified file take immediate effect for the openSSH service is <code>systemctl reload</code>. This command will load the service configuration file of the running designated service without stopping the service. Therefore, option A is the best answer. A <code>daemon-reload</code> will load the unit configuration file and not the service configuration file. Thus, option B is a wrong answer. The <code>restart</code> command will stop and immediately restart the service. While this will load the modified service configuration file, it will also disrupt the service for current service users. Therefore, option C is not the best answer and a wrong one. The <code>mask</code> command prevents a particular service from starting. Thus, option D is a wrong choice. The <code>unmask</code> command undoes the mask command\u2019s effects, and thus option E is also an incorrect answer.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      92,
      88,
      89,
      90,
      87
    ],
    "source": "316328_c06",
    "choice_e": "<code>unmask</code>"
  },
  {
    "id": 266,
    "question": "Your system uses systemd and has a service currently set to not start at system boot. You want to change this behavior and have it start. What <code>systemctl</code> command should you employ for this service?",
    "choice_a": "<code>restart</code>",
    "choice_b": "<code>start</code>",
    "choice_c": "<code>isolate</code>",
    "choice_d": "<code>disable</code>",
    "correct_answer": "E",
    "explanation": "To set a particular service unit to start at boot time, you need to use the <code>systemctl enable</code> command followed by the service unit name. Therefore, option E is the correct answer. The <code>restart</code> command will stop and immediately restart the service but does not control whether or not a service unit is started at system boot. Thus, option A is a wrong answer. The <code>start</code> command will start the service but does not control whether or not a service unit is started at system boot. Therefore, option B is also a wrong choice. The <code>isolate</code> command is used with systemd target units, not service units, and thus option C is an incorrect choice. Option D\u2019s <code>disable</code> command will set a particular service unit to <i>not</i> start at boot time (disable it from starting), and therefore option D is also an incorrect answer.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      92,
      95,
      88,
      91,
      90
    ],
    "source": "316328_c06",
    "choice_e": "<code>enable</code>"
  },
  {
    "id": 267,
    "question": "You need to change the system\u2019s default target. What <code>systemctl</code> command should you use to accomplish this task?",
    "choice_a": "<code>get-default</code>",
    "choice_b": "<code>set-default</code>",
    "choice_c": "<code>isolate</code>",
    "choice_d": "<code>is-enabled</code>",
    "correct_answer": "B",
    "explanation": "To change the system\u2019s default target, you need to employ the <code>systemctl set-default</code> command, passing the target name as an argument and using super user privileges. Therefore, option B is the correct answer. The <code>get-default</code> command will show you the system\u2019s current default target. Thus, option A is a wrong answer. The <code>isolate</code> command is used to jump to new targets and not set default targets. Thus, option C is an incorrect choice. The <code>is-enabled</code> command displays <code>enabled</code> for any service that is configured to start at system boot and <code>disabled</code> for any service that is not configured to start at system boot. It only deals with services, and therefore option D is a wrong choice. The <code>is-active</code> command also only deals with services, and therefore option E is also an incorrect answer.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      91,
      92,
      96,
      95,
      94
    ],
    "source": "316328_c06",
    "choice_e": "<code>is-active</code>"
  },
  {
    "id": 268,
    "question": "Your systemd system is taking a long time to boot and you need to reduce the boot time. Which <code>systemd-analyze</code> command is the best to start narrowing down which units need to be investigated first?",
    "choice_a": "<code>time</code>",
    "choice_b": "<code>dump</code>",
    "choice_c": "<code>failure</code>",
    "choice_d": "<code>blame</code>",
    "correct_answer": "D",
    "explanation": "The <code>blame</code> command displays the amount of time each running unit took to initialize, and the units and their times are listed starting from the slowest to the fastest. That way, you can start investigating the units at the list\u2019s top. Therefore, option D is the correct answer. The <code>time</code> command displays the amount of time system initialization spent for the kernel, and the initial RAM filesystem, as well as the time it took for normal system user space to initialize. However, it does not help you determine which unit configurations may be to blame for the slow boot. Therefore, option A is a wrong answer. The <code>dump</code> command displays data concerning all the units and not in a format to easily track down what unit takes the most time to initialize at boot. Therefore, option B is an incorrect choice. Option C\u2019s <code>failure</code> is a service state, indicating that the service has failed. Thus, option C is a wrong answer as well. The <code>verify</code> command is handy in that it scans unit files and displays warning messages if any errors are found. However, it does not provide configuration information that can assist you in uncovering the reason a system is slow to boot. Therefore, option E is an incorrect choice.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      94,
      88,
      89,
      95,
      87
    ],
    "source": "316328_c06",
    "choice_e": "<code>verify</code>"
  },
  {
    "id": 269,
    "question": "Your older Debian-based Linux distribution system uses SysV init. It soon is going to be upgraded to a Debian-based distro that uses systemd. To start some analysis, you enter the <code>runlevel</code> command. Which of the following are results you may see? (Choose all that apply.)",
    "choice_a": "<code>N 5</code>",
    "choice_b": "<code>3 5</code>",
    "choice_c": "<code>N 2</code>",
    "choice_d": "<code>2 3</code>",
    "correct_answer": [
      "C",
      "E"
    ],
    "explanation": "Debian-based Linux distributions that use SysV init only use runlevels from 0 through 2. The <code>runlevel</code> command shows the previous runlevel or <code>N</code> for newly booted. Therefore, the only options that this <code>runlevel</code> command would show on an older Debian-based Linux distribution system, which uses SysV init, are options C and E. Therefore, those options are correct. Option A is incorrect, because it shows <code>5</code> as the current runlevel, and Debian-based distros don\u2019t use that runlevel. Option B is also incorrect, because it shows <code>5</code> as the current runlevel. Option D is incorrect because it shows <code>3</code> as the current runlevel and the Debian-based distros do not use that runlevel either.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      97,
      87,
      101,
      98,
      100
    ],
    "source": "316328_c06",
    "choice_e": "<code>1 2</code>"
  },
  {
    "id": 270,
    "question": "You\u2019ve recently become the system administrator for an older Linux server, which still uses SysV init. You determine that its default runlevel is 3. What file did you find that information in?",
    "choice_a": "<code>/etc/inittab</code>",
    "choice_b": "<code>/etc/rc.d</code>",
    "choice_c": "<code>/etc/init.d/rc</code>",
    "choice_d": "<code>/etc/rc.d/rc</code>",
    "correct_answer": "A",
    "explanation": "For SysV init systems, the default runlevel is stored in the <code>/etc/inittab</code> file within the <code>initdefault</code> record. Therefore, option A is the correct answer. The <code>/etc/rc.d</code> is a directory and not a file. Thus, option B is a wrong answer. The <code>rc</code> file is a script that can reside in either the <code>/etc/init.d/</code> or the <code>/etc/rc.d/</code> directory. It runs the scripts that start the various system services when jumping runlevels or booting the system. However, this script does not contain any information concerning the default runlevel. Therefore, options C and D are incorrect choices. The <code>/etc/rc.local</code> file allows you to issue certain commands or run any scripts as soon as system initialization is completed. However, this script also does not contain any information concerning the default runlevel. Thus, option E is an incorrect answer.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      97,
      98,
      100,
      101,
      87
    ],
    "source": "316328_c06",
    "choice_e": "<code>/etc/rc.local</code>"
  },
  {
    "id": 271,
    "question": "Which directory on an old SysV init system stores the service startup scripts?",
    "choice_a": "<code>/usr/lib/systemd/system/</code>",
    "choice_b": "<code>/etc/rc.d/rc <i>n</i>.d/</code>",
    "choice_c": "<code>/etc/init.d/</code>",
    "choice_d": "<code>/etc/systemd/system/</code>",
    "correct_answer": "C",
    "explanation": "The directory that stores the service startup scripts for an old (and a new) SysV init system is the <code>/etc/init.d/</code> directory. Therefore, option C is the correct answer. The <code>/etc/rc.d/rc <i>n</i>.d/</code> directories are used on a SysV init system, but they contain symbolic links to the scripts within the /<code>etc/init.d/</code> directory. Thus, option B is an incorrect answer. Options A, D, and E are all systemd directories. Therefore, they are incorrect choices.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      98,
      99,
      100,
      87,
      97
    ],
    "source": "316328_c06",
    "choice_e": "<code>/run/systemd/system/</code>"
  },
  {
    "id": 272,
    "question": "You are managing a SysV init system and need to perform some emergency maintenance at runlevel 1. To do this, you need to jump runlevels. What command could you employ? (Choose all that apply.)",
    "choice_a": "<code>telinit S</code>",
    "choice_b": "<code>telinit 1</code>",
    "choice_c": "<code>init one</code>",
    "choice_d": "<code>init s</code>",
    "correct_answer": [
      "A",
      "B",
      "D",
      "E"
    ],
    "explanation": "Runlevel 1 is also called single user mode. You can employ either the <code>init</code> or <code>telinit</code> command to jump to that runlevel and pass them one of the three following arguments: <code>1</code>, <code>s</code>, or <code>S</code>. Therefore, options A, B, D, and E are correct answers. You cannot use the <code>one</code> argument to reach runlevel 1, and therefore option C is the only wrong choice.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      101,
      97,
      100,
      99,
      87
    ],
    "source": "316328_c06",
    "choice_e": "<code>init 1</code>"
  },
  {
    "id": 273,
    "question": "A customer has complained that a service on your SysV init system is not working. Which of the following commands is the best command to use to check the service?",
    "choice_a": "<code>service start</code>",
    "choice_b": "<code>service status</code>",
    "choice_c": "<code>service \u2013\u2013status-all</code>",
    "choice_d": "<code>service stop</code>",
    "correct_answer": "B",
    "explanation": "The best command to use is the <code>service status</code> command, passing the service name to it as an argument. This will display the service\u2019s current status and allow you to start the troubleshooting process quickly. Therefore, option B is the correct answer. The <code>service start</code> command will start the designated service, but you do not know whether or not this service was stopped. Thus it is not the best command to use, and option A is an incorrect choice. The <code>service --status-all</code> command is not the best command to use because it shows the status of all the various services. Thus, option C is a wrong answer. The <code>service stop</code> command will stop the designated service and provide a <code>FAILED</code> status if it was already stopped. However, this is not the best way to check a service\u2019s status on a SysV init system. Thus it is not the best command to use, and option D is an incorrect choice. The <code>service reload</code> command will load the designated service\u2019s configuration file and provide a <code>FAILED</code> status if the service is stopped. Yet again, this is not the proper way to check a service\u2019s status. Therefore, option E is also an incorrect answer.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      99,
      87,
      97,
      100,
      21
    ],
    "source": "316328_c06",
    "choice_e": "<code>service reload</code>"
  },
  {
    "id": 274,
    "question": "You need to enable the DHCP service on your Red Hat\u2013based SysV init system for runlevels 3 and 5. Which of the following commands should you use?",
    "choice_a": "<code>service enable dhcp 3,5</code>",
    "choice_b": "<code>chkconfig \u2013\u2013levels 3,5 dhcp on</code>",
    "choice_c": "<code>chkconfig \u2013\u2013levels 35 on dhcp</code>",
    "choice_d": "<code>chkconfig \u2013\u2013levels 35 dhcp on</code>",
    "correct_answer": "D",
    "explanation": "To enable the DHCP service on your Red Hat\u2013based SysV init system for runlevels 3 and 5, the correct command to use is the <code>chkconfig --levels 35 dhcp on</code> command. Therefore, option D is the correct answer. Options A and E are incorrect, because you cannot use the <code>service</code> command to enable SysV init services. Option B is a wrong answer because you cannot use a delimiter, such as a comma, to separate the runlevel list. Option C is an incorrect choice because this command has its service name and the <code>on</code> argument flip-flopped.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      100,
      97,
      98,
      99,
      101
    ],
    "source": "316328_c06",
    "choice_e": "<code>service enable dhcp 35</code>"
  },
  {
    "id": 275,
    "question": "You need to enable the DHCP service on your Debian-based SysV init system for the default runlevels. Which of the following commands should you use?",
    "choice_a": "<code>update-rc.d dhcp default</code>",
    "choice_b": "<code>chkconfig \u2013\u2013default dhcp on</code>",
    "choice_c": "<code>update-rc.d default dhcp</code>",
    "choice_d": "<code>update-rc.d defaults dhcp</code>",
    "correct_answer": "E",
    "explanation": "To enable the DHCP service on your Debian-based SysV init system for default runlevels, the correct command to use is the <code>update-rc.d dhcp defaults</code> command. Therefore, option E is the correct answer. Option A is incorrect because the last command argument should be <code>defaults</code> and not <code>default</code>. Option B is a wrong answer because you cannot use the <code>chckconfig</code> command on a Debian-based distribution. Option C is an incorrect choice because this command has the service name and the <code>default</code> argument flip-flopped. Also, it is using the wrong argument. The argument should be <code>defaults</code>. The command used in option D is incorrect because this command has the service name and the <code>defaults</code> argument flip-flopped. Therefore, option D is a wrong choice as well.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      100,
      98,
      97,
      87,
      95
    ],
    "source": "316328_c06",
    "choice_e": "<code>update-rc.d dhcp defaults</code>"
  },
  {
    "id": 276,
    "question": "Which of the following would be the appropriate base name for a mount unit file that mounts a filesystem at the <code>/var/log/</code> mount point?",
    "choice_a": "<code>/var/log.mount</code>",
    "choice_b": "<code>/var/log.unit</code>",
    "choice_c": "<code>var-log.mount</code>",
    "choice_d": "<code>var-log.unit</code>",
    "correct_answer": "C",
    "explanation": "The mount unit file names are created by having the absolute directory reference\u2019s preceding forward slash (/) removed, subsequent forward slashes are converted to dashes (-), and trailing forward slashes are removed. Mount unit filenames also have a <code>.mount</code> extension. Therefore, the mount unit file for the <code>/var/log/</code> mount point would be <code>var-log.mount</code>. Thus, option C is the correct answer. The <code>/var/log.mount</code> unit filename is incorrect because the forward slashes were not removed or replaced. Therefore, option A is a wrong answer. The <code>/var/log.unit</code> base name is incorrect because the forward slashes were not removed or replaced. Also, the wrong file extension is used. Thus, option B is an incorrect answer. The <code>var-log.unit</code> base name is incorrect because the wrong file extension is used. Therefore, option D is a wrong choice. The <code>var/log.mount</code> unit filename is incorrect because the middle forward slash was not replaced by a dash. Thus, option E is an incorrect choice.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      103,
      88,
      90,
      89,
      91
    ],
    "source": "316328_c06",
    "choice_e": "<code>var/log.mount</code>"
  },
  {
    "id": 277,
    "question": "You are managing a systemd system and need to create an automount unit file. Which of the following directives should you review to possibly include in this file\u2019s <code>[Automount]</code> section? (Choose all that apply.)",
    "choice_a": "<code>Where</code>",
    "choice_b": "<code>Options</code>",
    "choice_c": "<code>DirectoryMode</code>",
    "choice_d": "<code>TimeOutIdleSec</code>",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "For systemd automount unit files, the only directives that can be included in the <code>[Automount]</code> file section are <code>Where</code>, <code>DirectoryMode</code>, and <code>TimeOutIdleSec</code>. Thus, options A, C, and D are correct answers. The <code>Options</code> and <code>What</code> directives are ones you would see in a mount unit file\u2019s <code>[Mount]</code> section. Therefore, options B and E are incorrect choices.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      103,
      88,
      90,
      94,
      95
    ],
    "source": "316328_c06",
    "choice_e": "<code>What</code>"
  },
  {
    "id": 278,
    "question": "Which two commands can be used to set the IP address, subnet mask, and default router information on an interface using the command line?",
    "choice_a": "<code>netstat</code>",
    "choice_b": "<code>ping</code>",
    "choice_c": "<code>nmtui</code>",
    "choice_d": "<code>ip</code>",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "The <code>nmtui</code> command provides an interactive text menu for selecting a network interface and setting the network parameters, and the <code>ip</code> command provides a command-line tool for setting network parameters, so both options C and D are correct. The <code>netstat</code> command displays information about network connections but doesn\u2019t set the network parameters, so option A is incorrect. The <code>ping</code> command can send ICMP packets to a remote host but doesn\u2019t set the local network parameters, so option B is incorrect. The <code>route</code> command sets the routing network parameters but not the IP address or subnet mask, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      105,
      104,
      114,
      106,
      16
    ],
    "source": "316328_c07",
    "choice_e": "<code>route</code>"
  },
  {
    "id": 279,
    "question": "Which tool does newer versions of Ubuntu use to set network address information?",
    "choice_a": "<code>netstat</code>",
    "choice_b": "Netplan",
    "choice_c": "<code>iwconfig</code>",
    "choice_d": "<code>route</code>",
    "correct_answer": "B",
    "explanation": "Starting with version 17.04, Ubuntu has switched to using the Netplan tool to set network address information, so option B is the correct answer. The <code>netstat</code> command doesn\u2019t set network information, but instead displays active network connections, so option A is incorrect. The <code>iwconfig</code> command sets wireless network parameters but not network address information, so option C is incorrect. The <code>route</code> command sets default router information but not network address information, so option D is incorrect. The <code>ifconfig</code> command does set network address information, but it isn\u2019t used by the newer versions of Ubuntu, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      105,
      104,
      106,
      13,
      114
    ],
    "source": "316328_c07",
    "choice_e": "<code>ifconfig</code>"
  },
  {
    "id": 280,
    "question": "Which command displays the duplex settings for an Ethernet card?",
    "choice_a": "<code>ethtool</code>",
    "choice_b": "<code>netstat</code>",
    "choice_c": "<code>iwconfig</code>",
    "choice_d": "<code>iwlist</code>",
    "correct_answer": "A",
    "explanation": "The <code>ethtool</code> command displays features and parameters for network cards, so option A is the correct answer. The <code>netstat</code> command displays network statistics and connections, so option B is incorrect. The <code>iwconfig</code> and <code>iwlist</code> commands are used to set wireless network parameters and not Ethernet card settings, so options C and D are incorrect. The <code>route</code> command sets or displays routing information and not Ethernet card settings, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      105,
      104,
      114,
      106,
      341
    ],
    "source": "316328_c07",
    "choice_e": "<code>route</code>"
  },
  {
    "id": 281,
    "question": "Which command displays what processes are using which ports on a Linux systems?",
    "choice_a": "<code>iwconfig</code>",
    "choice_b": "<code>ip</code>",
    "choice_c": "<code>ping</code>",
    "choice_d": "<code>nmtui</code>",
    "correct_answer": "E",
    "explanation": "The <code>ss</code> command displays a list of the open ports on a Linux system, along with the processes associated with each port, so option E is correct. The <code>iwconfig</code> command sets wireless network information, not open ports, so option A is incorrect. The <code>ip</code> command displays or sets network information on a network interface, but doesn\u2019t display open ports, so option B is incorrect. The <code>ping</code> command sends ICMP messages to a remote host, but doesn\u2019t display any open ports, so option C is incorrect. The <code>nmtui</code> command allows you to configure network parameters for a network interface, but doesn\u2019t display the open ports on the system, so option D is incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      114,
      105,
      129,
      106,
      104
    ],
    "source": "316328_c07",
    "choice_e": "<code>ss</code>"
  },
  {
    "id": 282,
    "question": "If your Linux server doesn\u2019t have a graphical desktop installed, what two tools could you use to configure network settings on a wired network card from the command line?",
    "choice_a": "<code>nmcli</code>",
    "choice_b": "<code>iwconfig</code>",
    "choice_c": "<code>ip</code>",
    "choice_d": "<code>netstat</code>",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "The <code>nmcli</code> and the <code>ip</code> commands both allow you to set and change network settings from the command line, so options A and C are both correct. The <code>iwconfig</code> command only sets wireless network information, so option B is incorrect. The <code>netstat</code> command displays open ports and doesn\u2019t change any network settings, so option D is incorrect. The <code>ping</code> command sends ICMP packets to remote hosts for testing; it also doesn\u2019t set any network settings, so option E is also incorrect.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      105,
      104,
      114,
      106,
      16
    ],
    "source": "316328_c07",
    "choice_e": "<code>ping</code>"
  },
  {
    "id": 283,
    "question": "What network setting defines the network device that routes packets intended for hosts on remote networks?",
    "choice_a": "Default router",
    "choice_b": "Netmask",
    "choice_c": "Hostname",
    "choice_d": "IP address",
    "correct_answer": "A",
    "explanation": "The default router is used to send packets from the local network to remote networks, so to communicate with a remote host you need to define the default router address, making option A correct. The netmask only defines the local network, it doesn\u2019t define what to do with packets for remote hosts, so option B is incorrect. The hostname and IP address only define features of the local host, so options C and D are incorrect, while the DNS server defines how to retrieve the IP address of a host based on its domain name, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      104,
      106,
      114,
      446,
      341
    ],
    "source": "316328_c07",
    "choice_e": "DNS server"
  },
  {
    "id": 284,
    "question": "What device setting defines a host that maps a host name to an IP address?",
    "choice_a": "Default router",
    "choice_b": "Netmask",
    "choice_c": "Hostname",
    "choice_d": "IP address",
    "correct_answer": "E",
    "explanation": "The DNS server maps the hostname to an IP address, so you must have a DNS server defined in your network configuration to be able to use hostnames in your applications. Thus, option E is correct. The default router only defines how to send packets to remote hosts; it doesn\u2019t map the hostname to the IP address, so option A is incorrect. The netmask value defines the local network, but not how to map hostnames to IP addresses, so option B is incorrect. The hostname and IP address define features of the local host, so options C and D are incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      104,
      114,
      16,
      8,
      1
    ],
    "source": "316328_c07",
    "choice_e": "DNS server"
  },
  {
    "id": 285,
    "question": "What is used to automatically assign an IP address to a client?",
    "choice_a": "Default router",
    "choice_b": "DHCP",
    "choice_c": "ARP table",
    "choice_d": "Netmask",
    "correct_answer": "B",
    "explanation": "The Dynamic Host Configuration Protocol (DHCP) is used to assign dynamic IP addresses to client workstations on a network, so option B is correct. The default router can\u2019t assign addresses to devices, so option B is incorrect. The ARP table maps the hardware address of the network card to IP addresses but doesn\u2019t assign the IP addresses, so option C is incorrect. The netmask value determines the network address, but not the IP address of the host, so option D is incorrect. The <code>ifconfig</code> command can set the static IP address of the host but doesn\u2019t automatically assign the IP address, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      104,
      114,
      84,
      1,
      16
    ],
    "source": "316328_c07",
    "choice_e": "<code>ifconfig</code>"
  },
  {
    "id": 286,
    "question": "What type of address is used so local applications can use network protocols to communicate with each other?",
    "choice_a": "Dynamic address",
    "choice_b": "Loopback address",
    "choice_c": "Static address",
    "choice_d": "Hostname",
    "correct_answer": "B",
    "explanation": "The loopback address is a special address assigned to the loopback interface that allows local applications to communicate with each other, making option B the correct answer. Dynamic and static IP addresses are assigned to network interfaces, which interact with remote systems, not local applications, so options A and C are incorrect. The hostname identifies the local host for remote connections, not for local applications, so option D is incorrect. The MAC address identifies the network card hardware address but isn\u2019t used by local applications, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      104,
      105,
      106,
      122,
      126
    ],
    "source": "316328_c07",
    "choice_e": "MAC address"
  },
  {
    "id": 287,
    "question": "Which command would you use to find the mail server for a domain?",
    "choice_a": "<code>dig</code>",
    "choice_b": "<code>netstat</code>",
    "choice_c": "<code>ping6</code>",
    "choice_d": "<code>host</code>",
    "correct_answer": "A",
    "explanation": "The <code>dig</code> command can display individual host records for a domain, which you can use to find the MX mail host for the domain, so option A is correct. The <code>host</code> command only displays host IP address information; it can\u2019t determine the server type from the DNS records, so option D is incorrect. The <code>netstat</code> and <code>ss</code> commands display active network connections, but not the remote host types, so options B and E are both incorrect. The <code>ping6</code> command sends IPv6 ICMP packets to test remote hosts but can\u2019t tell if the remote host is a mail server, so option C is incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      114,
      104,
      63,
      58,
      16
    ],
    "source": "316328_c07",
    "choice_e": "<code>ss</code>"
  },
  {
    "id": 288,
    "question": "What command would you use to find out what application was using a specific TCP port on the system?",
    "choice_a": "<code>ip</code>",
    "choice_b": "<code>ss</code>",
    "choice_c": "<code>host</code>",
    "choice_d": "<code>dig</code>",
    "correct_answer": "B",
    "explanation": "The <code>ss</code> command can display both open ports, and the applications that own them, so option B is correct. The <code>ip</code> and <code>ifconfig</code> commands just display or set network settings, so options A and E are incorrect. The <code>host</code> and <code>dig</code> commands only display hostname information, so options C and D are also incorrect.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      111,
      112,
      310,
      109,
      107
    ],
    "source": "316328_c07",
    "choice_e": "<code>ifconfig</code>"
  },
  {
    "id": 289,
    "question": "Which network tool allows you to test the bandwidth of your network?",
    "choice_a": "<code>nmap</code>",
    "choice_b": "<code>nc</code>",
    "choice_c": "<code>iperf3</code>",
    "choice_d": "<code>ifconfig</code>",
    "correct_answer": "C",
    "explanation": "The <code>ipef3</code> tool allows you to set up a server and client and push data through the network to test the network bandwidth, so option C is correct. The <code>nmap</code> tool is used to find servers on the network and scan for open network ports but not test the bandwidth, so option A is incorrect. The <code>nc</code> tool allows you to set up a server and client to transfer data, but it doesn\u2019t test the network bandwidth for the connection, so option B is incorrect. The <code>ifconfig</code> and <code>iwlist</code> commands are part of the net-tools package for configuring network settings on a system; they don\u2019t test network bandwidth, so both options D and E are incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      105,
      104,
      106,
      114,
      173
    ],
    "source": "316328_c07",
    "choice_e": "<code>iwlist</code>"
  },
  {
    "id": 290,
    "question": "What network tool allows you to find rogue servers on your network?",
    "choice_a": "<code>nmap</code>",
    "choice_b": "<code>nc</code>",
    "choice_c": "<code>iperf3</code>",
    "choice_d": "<code>ifconfig</code>",
    "correct_answer": "A",
    "explanation": "The <code>nmap</code> tool scans the network looking for servers with open network ports, allowing you to document all of the servers on your network, so option A is correct. The <code>nc</code> tool allows you to set up a server and client for testing the network but doesn\u2019t scan the network looking for other servers, so option B is incorrect. The <code>iperf3</code> tool allows you to set up a server and client for testing the network bandwidth but doesn\u2019t scan the network looking for other servers, so option C is incorrect. The <code>ifconfig</code> and <code>iwlist</code> commands are part of the net-tools package used to configure network settings on the system; they don\u2019t scan the network, so options D and E are incorrect.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      114,
      105,
      104,
      106,
      446
    ],
    "source": "316328_c07",
    "choice_e": "<code>iwlist</code>"
  },
  {
    "id": 291,
    "question": "Which file contains a list of DNS servers the Linux system can use to resolve hostnames?",
    "choice_a": "<code>/etc/dhcpd.conf</code>",
    "choice_b": "<code>/etc/resolv.conf</code>",
    "choice_c": "<code>/etc/nsswitch.conf</code>",
    "choice_d": "<code>/etc/network/interfaces</code>",
    "correct_answer": "B",
    "explanation": "The DNS servers are listed in the <code>/etc/resolv.conf</code> configuration file using the <code>nameserver</code> setting, so option B is correct. The <code>/etc/dhcpd.conf</code> file defines configuration settings for a DHCP server, so option A is incorrect. The <code>/etc/nsswitch.conf</code> file defines the order in which the system searches for a hostname, not the list of DNS servers used, so option C is incorrect. The <code>/etc/network/interfaces</code> file defines the network interfaces for a Debian-based system, not the list of DNS servers, so option D is also incorrect. The <code>/etc/sysctl.conf</code> file defines kernel network parameters and not a list of DNS servers, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      104,
      114,
      106,
      72,
      67
    ],
    "source": "316328_c07",
    "choice_e": "<code>/etc/sysctl.conf</code>"
  },
  {
    "id": 292,
    "question": "Which <code>ifconfig</code> format correctly assigns an IP address and netmask to the eth0 interface?",
    "choice_a": "<code>ifconfig eth0 up 192.168.1.50 netmask 255.255.255.0</code>",
    "choice_b": "<code>ifconfig eth0 255.255.255.0 192.168.1.50</code>",
    "choice_c": "<code>ifconfig up 192.168.1.50 netmask 255.255.255.0</code>",
    "choice_d": "<code>ifconfig up</code>",
    "correct_answer": "A",
    "explanation": "The <code>ifconfig</code> command must specify the network interface, the IP address, then the <code>netmask</code> option before the netmask address. You can use the <code>up</code> or <code>down</code> option to place the network card in an active or inactive state by default, but it\u2019s not required. Option A is the only option that uses the correct values in the correct order. Option C is close but fails to specify the network interface. Option B is not in the correct format, and options D and E fail to list the necessary configuration settings.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      105,
      104,
      106,
      114,
      84
    ],
    "source": "316328_c07",
    "choice_e": "<code>ifconfig down</code>"
  },
  {
    "id": 293,
    "question": "What command displays all of the available wireless networks in your area?",
    "choice_a": "<code>iwlist</code>",
    "choice_b": "<code>iwconfig</code>",
    "choice_c": "<code>ifconfig</code>",
    "choice_d": "<code>ip</code>",
    "correct_answer": "A",
    "explanation": "The <code>iwlist</code> command displays the available wireless network access points detected by the wireless network card, so option A is correct. The <code>iwconfig</code> command configures the network card to connect to a specific access point but doesn\u2019t list all of the detected access points, making option B incorrect. Option C specifies the <code>ifconfig</code> command, which is used to assign an IP address to a wireless network card but doesn\u2019t list the access points. The <code>ip</code> command specified in option D likewise can be used to set the IP address of the card but doesn\u2019t list the access points. Option E, the <code>arp</code> command, maps hardware addresses to IP addresses so you can find duplicate IP addresses on your network, but it doesn\u2019t list the wireless access points.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      105,
      104,
      347,
      16,
      1
    ],
    "source": "316328_c07",
    "choice_e": "<code>arp</code>"
  },
  {
    "id": 294,
    "question": "What option sets the wireless access point name in the <code>iwconfig</code> command?",
    "choice_a": "<code>key</code>",
    "choice_b": "<code>netmask</code>",
    "choice_c": "<code>address</code>",
    "choice_d": "<code>essid</code>",
    "correct_answer": "D",
    "explanation": "The SSID value defines the access point name, and it is set using the <code>essid</code> option in the <code>iwconfig</code> command, making option D the correct answer. The <code>key</code> specifies the encryption key required to connect to the access point but not the access point name, making option A incorrect. The <code>netmask</code> and <code>address</code> values aren\u2019t set by the <code>iwconfig</code> command, so options B and C are incorrect. The <code>channel</code> defines the radio frequency the access point uses, not the access point name, so option E is also incorrect.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      127,
      126,
      128,
      129,
      166
    ],
    "source": "316328_c07",
    "choice_e": "<code>channel</code>"
  },
  {
    "id": 295,
    "question": "What command can you use to both display and set the IP address, netmask, and default router values?",
    "choice_a": "<code>ifconfig</code>",
    "choice_b": "<code>iwconfig</code>",
    "choice_c": "<code>router</code>",
    "choice_d": "<code>ifup</code>",
    "correct_answer": "E",
    "explanation": "The <code>ip</code> command allows you to both display and set the IP address, netmask, and default router values for a network interface, so option E is correct. The <code>ifconfig</code> command can set the IP address and netmask values but not the default router. The <code>iwconfig</code> command is used to set the wireless access point settings, and the router command is used to set the default router but not the IP address or netmask values. The <code>ifup</code> command only activates the network interface; it can\u2019t set the address values.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      105,
      104,
      114,
      15,
      72
    ],
    "source": "316328_c07",
    "choice_e": "<code>ip</code>"
  },
  {
    "id": 296,
    "question": "What tool allows you to send ICMP messages to a remote host to test network connectivity?",
    "choice_a": "<code>netstat</code>",
    "choice_b": "<code>ifconfig</code>",
    "choice_c": "<code>ping</code>",
    "choice_d": "<code>iwconfig</code>",
    "correct_answer": "C",
    "explanation": "The <code>ping</code> command sends ICMP packets to a specified remote host and waits for a response, making option C the correct answer. The <code>netstat</code> command displays statistics about the network interface, so it\u2019s incorrect. The <code>ifconfig</code> command displays or sets network information but doesn\u2019t send ICMP packets, making option B incorrect. The <code>iwconfig</code> command displays or sets wireless network information but doesn\u2019t handle ICMP packets, making option D incorrect. The <code>ss</code> command displays information about open connections and ports on the system, so option E is also incorrect.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      104,
      105,
      106,
      114,
      122
    ],
    "source": "316328_c07",
    "choice_e": "<code>ss</code>"
  },
  {
    "id": 297,
    "question": "You have a network application that fails to connect to a remote server. What command-line tool should you use to watch the network packets that leave your system to ensure they use the correct network port?",
    "choice_a": "<code>nc</code>",
    "choice_b": "<code>tcpdump</code>",
    "choice_c": "<code>ping</code>",
    "choice_d": "<code>traceroute</code>",
    "correct_answer": "B",
    "explanation": "The <code>tcpdump</code> command displays network packets that traverse the system network interface, so you can use that for monitoring application packets on the network, making option B the correct answer. The <code>nc</code> command allows you to manually send packets on the network but doesn\u2019t allow you to monitor application packets, so option A is incorrect. The <code>ping</code> and <code>traceroute</code> commands only send ICMP packets to remote servers; they don\u2019t monitor packets, so options C and D are incorrect. The <code>mtr</code> command can display the connectivity status to a remote server but doesn\u2019t allow you to view application packets going to the server, so option E is incorrect.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      307,
      112,
      109,
      111,
      368
    ],
    "source": "316328_c07",
    "choice_e": "<code>mtr</code>"
  },
  {
    "id": 298,
    "question": "Which of the following best describes a desktop environment?",
    "choice_a": "A set of programs that allow a user to interact with the system via icons, windows, and various other visual elements",
    "choice_b": "A screen where you choose a username and enter a password to gain system access",
    "choice_c": "A series of components that work together to provide the graphical setting for the user interface",
    "choice_d": "A program that allows you to perform file maintenance activities graphically",
    "correct_answer": "C",
    "explanation": "A desktop environment is a series of components that work together to provide the graphical setting for the user interface. Therefore, option C is the correct answer. A graphical user interface (GUI) is a set of programs that allow a user to interact with the system via icons, windows, and various other visual elements. Thus, option A is a wrong answer. A display manager operates the screen where you choose a username and enter a password to gain system access. Therefore, option B is an incorrect choice. A file manager is the program that allows you to perform file maintenance activities graphically. Thus, option D is also a wrong choice. A window manager is a set of programs that determine how the windows are presented on the desktop. Therefore, option E is also an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      115,
      116,
      118,
      119,
      121
    ],
    "source": "316328_c08",
    "choice_e": "A set of programs that determine how the windows are presented on the desktop"
  },
  {
    "id": 299,
    "question": "Which of the following are GUI components? (Choose all that apply.)",
    "choice_a": "Favorites bar",
    "choice_b": "File manager",
    "choice_c": "Icons",
    "choice_d": "Command line",
    "correct_answer": [
      "A",
      "B",
      "C",
      "E"
    ],
    "explanation": "A favorites bar, file manager, icons, and a system tray are all part of a graphical UI. Therefore, options A, B, C, and E are correct choices. A command line is a location to enter text-based commands, and while you can reach it from the GUI using a terminal emulator, it is not considered to be part of the graphical UI. Therefore, option D is the only incorrect choice.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      115,
      119,
      348,
      437,
      105
    ],
    "source": "316328_c08",
    "choice_e": "System tray"
  },
  {
    "id": 300,
    "question": "Which of the following is not used by default within GNOME Shell?",
    "choice_a": "SDDM",
    "choice_b": "Files",
    "choice_c": "Mutter",
    "choice_d": "GDM",
    "correct_answer": "A",
    "explanation": "SDDM (Simple Desktop Display Manager) is the default display manager for the KDE Plasma desktop environment. Therefore, option A is the correct answer. Files, also called GNOME files, is the file manager within the GNOME Shell desktop environment. Therefore, option B is a wrong answer. Mutter is the GNOME shell window manager, and thus, option C is an incorrect answer. GDM stands for the GNOME Display Manager. Therefore, option D is a wrong choice. Dock is another name for the GNOME Shell Dash, which is the favorites bar within GNOME Shell. Thus, option E is also an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      115,
      116,
      119,
      118,
      117
    ],
    "source": "316328_c08",
    "choice_e": "Dock"
  },
  {
    "id": 301,
    "question": "Which of the following is the KDE Plasma files manager?",
    "choice_a": "Nautilus",
    "choice_b": "Plasmoid",
    "choice_c": "Dolphin",
    "choice_d": "Kwin",
    "correct_answer": "C",
    "explanation": "The KDE Plasma\u2019s file manager is named Dolphin. Therefore, option C is the correct answer. Nautilus is the file manager on the Unity desktop environment, and therefore, option A is a wrong answer. Plasmoid is another name for a KDE Plasma widget. Thus, option B is an incorrect answer. Kwin is the KDE Plasma\u2019s window manager, and therefore option D is a wrong choice. Nemo is the default file manager on the Cinnamon desktop environment. Thus, option E is an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      116,
      115,
      119,
      348,
      121
    ],
    "source": "316328_c08",
    "choice_e": "Nemo"
  },
  {
    "id": 302,
    "question": "Which desktop manager should you use on an old desktop computer with an old CPU and little memory?",
    "choice_a": "Xfce",
    "choice_b": "GNOME3",
    "choice_c": "KDE Plasma",
    "choice_d": "GNOME2",
    "correct_answer": "A",
    "explanation": "The Xfce desktop manager was specifically designed for systems with older CPUs and little memory, so option A is correct. The GOME2, GNOME3, and KDE Plasma desktop managers both require higher CPU and memory requirements, so options B, C, and E are incorrect. Wayland is a low-level display server and not a desktop manager, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      118,
      115,
      116,
      6,
      119
    ],
    "source": "316328_c08",
    "choice_e": "Wayland"
  },
  {
    "id": 303,
    "question": "Which of the following describes the sound keys accessibility setting?",
    "choice_a": "Sounds are made when the Caps Lock or Num Lock key is turned on or off.",
    "choice_b": "A program that reads the GUI aloud, such as Orca.",
    "choice_c": "A cursor blink rate modification to make it easier to locate the cursor on the screen.",
    "choice_d": "Output to a refreshable braille display that is provided by the Orca screen reader.",
    "correct_answer": "A",
    "explanation": "The sound keys accessibility setting provides beeps whenever the Caps Lock or Num Lock key is turned on or off. Therefore, option A is the correct answer. A program that reads the GUI aloud, such as Orca, is a screen reader. Thus, option B is a wrong answer. The cursor blinking setting modifies the cursor blink rate to make it easier to locate the cursor on the screen. Therefore, option C is also an incorrect answer. Output to a refreshable braille display is provided by the Orca screen reader, which is a screen reader. Thus, option D is a wrong choice. Zoom settings allow the screen or a screen portion to be amplified to different magnification levels. Therefore, option E is also an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      117,
      115,
      119,
      348,
      121
    ],
    "source": "316328_c08",
    "choice_e": "The screen or a screen portion is amplified to different magnification levels."
  },
  {
    "id": 304,
    "question": "A blind coworker who is programming on the Linux server is suddenly having odd problems with his braille display device. You determine that you need to restart the braille service. Assuming the appropriate systemd unit file is available, which command would you use?",
    "choice_a": "<code>systemctl restart braille</code>",
    "choice_b": "<code>systemctl reload braille</code>",
    "choice_c": "<code>systemctl restart brailled</code>",
    "choice_d": "<code>systemctl restart brltty</code>",
    "correct_answer": "D",
    "explanation": "The braille display device would be using the <code>brltty</code> service. The proper <code>systemctl</code> command to restart the services is in option D. Options A, B, and C all use incorrect names for the braille service and are wrong answers. The command in option E would reload any modified <code>brltty</code> configuration files but not restart the service. Therefore, option E is also an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      117,
      74,
      115,
      119,
      16
    ],
    "source": "316328_c08",
    "choice_e": "<code>systemctl reload brltty</code>"
  },
  {
    "id": 305,
    "question": "Which of the following best describes the slow keys accessibility setting?",
    "choice_a": "A keyboard option that modifies how long a key must be pressed down to acknowledge the key",
    "choice_b": "A keyboard option that sets keyboard modifier keys, such as Ctrl and Shift, to maintain their pressed status until a subsequent key is pressed",
    "choice_c": "A keyboard option that modifies how long a key must be pressed down as well as defines a delay to acknowledge the key repeat",
    "choice_d": "A keyboard option that sets a primary key to be pressed along with a mouse click to emulate secondary mouse clicks",
    "correct_answer": "A",
    "explanation": "Slow keys are a keyboard option that modifies how long a key must be pressed down to acknowledge the key. Therefore, option A is the correct answer. Sticky keys are a keyboard option that sets keyboard modifier keys, such as Ctrl and Shift, to maintain their pressed status until a subsequent key is pressed. Thus, option B is a wrong answer. Repeat keys are a keyboard option that modifies how long a key must be pressed down as well as defines a delay to acknowledge the key repeat. Therefore, option C is also a wrong choice. Simulated secondary click is actually a mouse option, and it sets a primary key to be pressed along with a mouse click to emulate secondary mouse clicks. Thus, option D is an incorrect answer. A screen keyboard is a keyboard option that displays a visual keyboard on the UI that can be manipulated by a mouse or other pointing device to emulate key strokes. Therefore, option E is also an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      117,
      115,
      116,
      118,
      120
    ],
    "source": "316328_c08",
    "choice_e": "A keyboard option that displays a visual keyboard on the UI that can be manipulated by a mouse or other pointing device to emulate keystrokes"
  },
  {
    "id": 306,
    "question": "Which of the following communicates with the Linux operating system to transmit the UI wants and needs?",
    "choice_a": "Window manager",
    "choice_b": "Display manager",
    "choice_c": "Desktop environment",
    "choice_d": "Windows server",
    "correct_answer": "E",
    "explanation": "The display server uses a communication protocol to transmit the desires of the UI to the operating system, and vice versa. Therefore, option E is the correct answer. A windows manager is a program that communicates with the display server on behalf of the UI. Thus, option A is a wrong answer. A display manager controls the desktop environment\u2019s login screen, where you choose a username and enter a password to gain system access. Therefore, option B is also a wrong choice. A desktop environment is a user environment which provides a predetermined look and feel to a GUI, but it does not transmit the desires of the UI to the operating system, so option C is a wrong answer. A windows server is another name for a window manager, and thus, option D is also an incorrect answer.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      119,
      115,
      120,
      121,
      348
    ],
    "source": "316328_c08",
    "choice_e": "Display server"
  },
  {
    "id": 307,
    "question": "Which of the following is true of a compositor? (Choose all that apply.)",
    "choice_a": "A compositor arranges various display elements within a window to create a screen image.",
    "choice_b": "Wayland is a compositor.",
    "choice_c": "Mutter contains a compositor.",
    "choice_d": "Kwin contains a compositor.",
    "correct_answer": [
      "A",
      "C",
      "D",
      "E"
    ],
    "explanation": "A compositor arranges various display elements within a window to create a screen image. Therefore, option A is a correct answer. Both Mutter and Kwin, even though their primary duty is as a window manager, also contain compositors. Thus, options C and D are correct answers too. Weston is a compositor for the Wayland display server, so option E is also a correct choice. Wayland is a display server and not a compositor. Thus, option B is the only wrong answer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      119,
      120,
      121,
      115,
      348
    ],
    "source": "316328_c08",
    "choice_e": "Weston is a compositor."
  },
  {
    "id": 308,
    "question": "Which of the following are true concerning Wayland? (Choose all that apply.)",
    "choice_a": "Currently X11 is more secure than Wayland.",
    "choice_b": "Wayland uses the <code>$WAYLAND_DISPLAY</code> environment variable.",
    "choice_c": "Wayland\u2019s only compositor is Weston.",
    "choice_d": "XWayland supports legacy X11 programs.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Wayland does use the <code>$WAYLAND_DISPLAY</code> environment variable, so option B is a correct answer. Also, XWayland supports legacy X11 programs. Therefore, option D is an additional correct answer. Wayland is a replacement for the X11 display server, and it is designed to be more secure. Thus, option A is a wrong answer. Wayland\u2019s compositor is swappable and there are several other compositors besides Weston available for use with Wayland. Therefore, option C is wrong choice. In order to disable Wayland in GNOME Shell, you edit the <code>/etc/gdm3/custom.conf</code> file and set <code>WaylandEnable</code> to <code>false</code>. Thus, option E is also an incorrect answer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      120,
      119,
      348,
      116,
      121
    ],
    "source": "316328_c08",
    "choice_e": "Set <code>WaylandDisable</code> to <code>true</code> to disable Wayland in GNOME Shell."
  },
  {
    "id": 309,
    "question": "Which of the following commands will help you determine whether your display server is Wayland or X11?",
    "choice_a": "<code>$WAYLAND_DISPLAY</code>",
    "choice_b": "<code>echo $AccessX</code>",
    "choice_c": "<code>loginctl</code>",
    "choice_d": "<code>echo $X11</code>",
    "correct_answer": "C",
    "explanation": "The <code>loginctl</code> command will help you determine your current GUI session number. You can then employ again the <code>loginctl</code> command along with your session number to determine if your GUI session is Wayland or X11. Thus, option C is the correct answer. While you can issue the command <code>echo $WAYLAND_DISPLAY</code> to help determine if your GUI session is Wayland or X11, <code>$WAYLAND_DISPLAY</code> by itself does nothing. Therefore, option A is a wrong answer. AccessX is a program that originally provided many universal access settings. There is no environment variable used by Wayland or X11 called <code>$AccessX</code>, and thus, option B is an incorrect answer. The <code>$X11</code> environment variable is made up, so option D is a wrong choice. The <code>runlevel</code> command allows you to determine your system\u2019s current run level and is not used in determining display servers. Therefore, option E is also an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      120,
      348,
      119,
      121,
      115
    ],
    "source": "316328_c08",
    "choice_e": "<code>runlevel</code>"
  },
  {
    "id": 310,
    "question": "You use the command <code>gnome-shell --replace</code> at the command line and receive an error message from the utility. What does this indicate?",
    "choice_a": "The X11 display server is hung. You need to reboot the server.",
    "choice_b": "The <code>--replace</code> option should be swapped for the <code>-R</code> option.",
    "choice_c": "Your display server is Wayland.",
    "choice_d": "XWayland is currently being used.",
    "correct_answer": "C",
    "explanation": "When your display server is Wayland, some commands, such as <code>gnome-shell --replace</code>, do not work in your GUI session. Therefore, option C is the correct answer. The scenario does not indicate that the X11 display server is hung. So please don\u2019t reboot your server and know that option A is a wrong answer. The error message does not indicate that the <code>-R</code> option should be used instead. Thus, option B is an incorrect answer. If XWayland was being used, you would not receive an error message. Therefore, option D is also a wrong choice. If Wayland was disabled for the session, the command would not generate an error message. Thus, option E is an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      120,
      119,
      348,
      121,
      115
    ],
    "source": "316328_c08",
    "choice_e": "Wayland has been disabled for this session."
  },
  {
    "id": 311,
    "question": "Which of the following is true concerning X11? (Choose all that apply.)",
    "choice_a": "XFree86 is the dominant X server.",
    "choice_b": "X.Org foundation develops an X server.",
    "choice_c": "The X server is being replaced by Wayland.",
    "choice_d": "X11 means a user can have 11 sessions.",
    "correct_answer": [
      "B",
      "C",
      "E"
    ],
    "explanation": "The X.Org foundation does develop an X server, called X11. The X server is being replaced by Wayland. X is short for X Window System, which is a display server. So options B, C, and E are correct. XFree86 was the dominant server implementing X until 2004. Now the dominant server is the X.Org foundation\u2019s X11 server, so option A is a wrong answer. The X.Org server implements the X Window System version 11, and that is why it is sometimes called X11. It is not due to the number of graphical sessions a particular user can have. Therefore, option D is also an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      348,
      121,
      119,
      120,
      115
    ],
    "source": "316328_c08",
    "choice_e": "X is short for X Window System."
  },
  {
    "id": 312,
    "question": "Your system is running an X display server and a user\u2019s graphical user interface is not acting properly. Which of the following commands can you use first to diagnose potential problems? (Choose all that apply.)",
    "choice_a": "<code>xwininfo</code>",
    "choice_b": "<code>Xorg -configure</code>",
    "choice_c": "<code>xcpyinfo</code>",
    "choice_d": "<code>xdpyinfo</code>",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "The <code>xwininfo</code> and <code>xdpyinfo</code> commands provide information about the X server, including the different screen types available, the default communication parameter values, and protocol extension information as well as individual window information. These two utilities would be the best ones to start diagnosing the problem. Therefore, options A and D are correct answers. The <code>Xorg -configure</code> creates a new X11 configuration file for your perusal, which may be useful later on in the troubleshooting process. However, this is not the best command to start diagnosis. Therefore, option B is a wrong answer. The <code>xcpyinfo</code> command is made up. Therefore, option C is also an incorrect answer. The <code>loginctl</code> command can help you determine whether or not the user is using X11 or Wayland, but since you already know that the X display server is running, issuing this command will not help. Thus, option E is an incorrect answer as well.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      121,
      348,
      119,
      115,
      347
    ],
    "source": "316328_c08",
    "choice_e": "<code>loginctl</code>"
  },
  {
    "id": 313,
    "question": "Which of the following are remote desktops? (Choose all that apply.)",
    "choice_a": "SPICE",
    "choice_b": "NX",
    "choice_c": "Xrdp",
    "choice_d": "VNC",
    "correct_answer": [
      "A",
      "B",
      "C",
      "D"
    ],
    "explanation": "SPICE (sometimes written as Spice), NX, Xrdp, and VNC are all remote desktops. Therefore, options A, B, C, and D are correct answers. Caja is the file manager in the MATE desktop environment and not a remote desktop. Thus, option E is the only incorrect answer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      125,
      123,
      122,
      124,
      118
    ],
    "source": "316328_c08",
    "choice_e": "Caja"
  },
  {
    "id": 314,
    "question": "Which of the following are remote desktops typically used with virtual machines? (Choose all that apply.)",
    "choice_a": "SPICE",
    "choice_b": "NX",
    "choice_c": "Xrdp",
    "choice_d": "VNC",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "SPICE and VNC are the remote desktops, which are typically used with virtual machines. By default, VNC is used with KVM virtual machines. However, you can replace VNC with SPICE. Thus, options A and D are the correct answers. NX and Xrdp are not typically used with virtual machines, and thus, options B, C, and E are not correct answers.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      125,
      122,
      437,
      123,
      124
    ],
    "source": "316328_c08",
    "choice_e": "All of the above"
  },
  {
    "id": 315,
    "question": "Which of the following protocols does Xrdp employ?",
    "choice_a": "Remote Frame Buffer protocol",
    "choice_b": "Wayland protocol",
    "choice_c": "NX technology protocol",
    "choice_d": "Simple protocol for ICEs",
    "correct_answer": "E",
    "explanation": "The Xrdp remote desktop software uses the Remote Desktop Protocol (RDP). Thus, option E is the correct answer. The Remote Frame Buffer (RFB) protocol is used by VNC. Thus, option A is a wrong answer. The Wayland protocol is used by the Wayland display server. Therefore, option B is also a wrong choice. Option C is also an incorrect answer, because the NX technology protocol is used by the NX remote desktop. The Simple protocol for ICEs, or Simple Protocol for Independent Computing Environments (SPICE), is used by the Spice remote desktop. Thus, option D is also an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      123,
      122,
      125,
      124,
      120
    ],
    "source": "316328_c08",
    "choice_e": "Remote Desktop Protocol"
  },
  {
    "id": 316,
    "question": "You want to employ SSH port forwarding and use its local mode. Which <code>ssh</code> command switches should you employ? (Choose all that apply.)",
    "choice_a": "<code>-N</code>",
    "choice_b": "<code>-X</code>",
    "choice_c": "<code>-f</code>",
    "choice_d": "<code>-R</code>",
    "correct_answer": [
      "A",
      "C",
      "E"
    ],
    "explanation": "You need to indicate to the openSSH server that no terminal is required because you are only establishing a tunnel. Therefore, the <code>-N</code> switch is needed. The <code>-f</code> switch will send the openSSH tunnel into the background, freeing up your command-line interface so you can type in remote desktop commands. The local mode of the <code>ssh</code> command requires that you use the <code>-L</code> switch to specify the local system as well as the local and remote ports to be used. Therefore, options A, C, and E are correct. The <code>-X</code> switch is not used in SSH port forwarding, so option B is a wrong answer. The <code>-R</code> switch is used for remote mode SSH port forwarding. Therefore, option D is also an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      127,
      129,
      126,
      128,
      122
    ],
    "source": "316328_c08",
    "choice_e": "<code>-L</code>"
  },
  {
    "id": 317,
    "question": "You (username Samantha) are logged into a laptop (IP address 192.168.0.42) running a Linux GNOME Classic desktop environment at your company desk in Building A. A problem has occurred on a rack-mounted Linux system (IP address 192.168.0.7) in Building C. You need to securely access a GUI application on the remote system that uses X11. What command should you use?",
    "choice_a": "<code>ssh -Y Samantha@192.168.0.7</code>",
    "choice_b": "<code>ssh -X Samantha@192.168.0.7</code>",
    "choice_c": "<code>ssh -Y Samantha@192.168.0.42</code>",
    "choice_d": "<code>ssh -X Samantha@192.168.0.42</code>",
    "correct_answer": "B",
    "explanation": "You need to employ X11 forwarding. To properly and securely access the remote Linux system and run an X11-based application, the command in option B is the best choice. Thus, option B is the right answer. The command in option A uses the trusted X11 via the <code>-Y</code> switch, which is not secure. Therefore, option A is a wrong answer. The command in option C also uses the <code>-Y</code> switch, so option C is also an incorrect answer. The command in option D uses the correct command switch but sends the connection to the laptop instead of the rack-mounted Linux server. Thus, option D is a wrong answer. The option E command is using the <code>-L</code> switch, which is for local SSH port forwarding, and it uses the wrong syntax for that switch and attempts to send the connection to the laptop. Thus, option E is an incorrect answer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      128,
      121,
      348,
      129,
      127
    ],
    "source": "316328_c08",
    "choice_e": "<code>ssh -L Samantha@192.168.0.42</code>"
  },
  {
    "id": 318,
    "question": "Which character set uses 7 bits to store characters?",
    "choice_a": "UTF-8",
    "choice_b": "UTF-16",
    "choice_c": "ASCII",
    "choice_d": "Unicode",
    "correct_answer": "C",
    "explanation": "The ASCII character set uses a seven-bit code to store English language characters, so option C is correct. The UTF-8 character set uses 1 byte (8 bits) to store characters, so option A is incorrect. The UTF-16 character set uses 2 bytes (16 bits) to store characters, so option B is incorrect. The Unicode character set uses 3 bytes (24 bits) to store characters, so option D is incorrect, while the UTF-32 character set uses 4 bytes (32 bits) to store characters, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      130,
      131,
      132,
      139,
      143
    ],
    "source": "316328_c09",
    "choice_e": "UTF-32"
  },
  {
    "id": 319,
    "question": "What two character sets use a transformation code to store characters?",
    "choice_a": "UTF-8",
    "choice_b": "UTF-16",
    "choice_c": "ASCII",
    "choice_d": "Unicode",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "The UTF-8 and UTF-16 character sets use a transformation process to reduce the Unicode character set into 1-byte (UTF-8) or 2-byte (UTF-16) values, so options A and B are correct. The ASCII character set doesn\u2019t transform any characters, so option C is incorrect. The Unicode character set also doesn\u2019t transform characters, so option D is incorrect. The locale is a Linux command and not a character set, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      130,
      131,
      132,
      139,
      50
    ],
    "source": "316328_c09",
    "choice_e": "locale"
  },
  {
    "id": 320,
    "question": "Which character set uses a 3-byte code, and can represent characters from most languages used in the world?",
    "choice_a": "ASCII",
    "choice_b": "LC_ALL",
    "choice_c": "UTF-8",
    "choice_d": "UTF-16",
    "correct_answer": "E",
    "explanation": "The Unicode character set uses 3 bytes to store characters, which provides enough space to represent all of the characters in the known world languages, so option E is correct. The ASCII character set only supports English language characters, so option A is incorrect. The <code>LC_ALL</code> environment variable defines a character set to use for the Linux system, but isn\u2019t a character set in itself, so option B is incorrect. Both the UTF-8 and UTF-16 character sets are a subset of the Unicode character set, so they can\u2019t represent all of the language characters in use in the world, so options C and D are incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      130,
      131,
      132,
      137,
      139
    ],
    "source": "316328_c09",
    "choice_e": "Unicode"
  },
  {
    "id": 321,
    "question": "What Linux command displays all of the localization environment variables and their values?",
    "choice_a": "<code>date</code>",
    "choice_b": "<code>time</code>",
    "choice_c": "<code>hwclock</code>",
    "choice_d": "<code>LANG</code>",
    "correct_answer": "E",
    "explanation": "The <code>locale</code> command displays all of the <code>LC_</code> environment variables and their values, so option E is correct. The <code>date</code> command only displays the time and date, not the localization information, so option A is incorrect. The <code>time</code> command displays the amount of time an application uses on the system, not the localization information, so option B is incorrect. The <code>hwclock</code> command displays the hardware clock time, not the localization information, so option C is incorrect. The <code>LANG</code> environment variable allows you to set all of the <code>LC_</code> environment variables in one place, but it doesn\u2019t display all of their settings, so option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      131,
      132,
      150,
      133,
      134
    ],
    "source": "316328_c09",
    "choice_e": "<code>locale</code>"
  },
  {
    "id": 322,
    "question": "What two environment variables control all of the localization settings?",
    "choice_a": "<code>LC_MONETARY</code>",
    "choice_b": "<code>LC_NUMERIC</code>",
    "choice_c": "<code>LANG</code>",
    "choice_d": "<code>LC_CTYPE</code>",
    "correct_answer": [
      "C",
      "E"
    ],
    "explanation": "The <code>LANG</code> and <code>LC_ALL</code> environment variables control all of the localization environment variable settings, so options C and E are correct. The <code>LC_MONETARY</code>, <code>LC_NUMBERIC</code>, and <code>LC_CTYPE</code> environment variables each control a single category of localization environment variables, but not all of the localization environment variables, so options A, B, and D are all incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      132,
      131,
      150,
      340,
      130
    ],
    "source": "316328_c09",
    "choice_e": "<code>LC_ALL</code>"
  },
  {
    "id": 323,
    "question": "___________ is the ability to adapt a Linux system to a specific language.",
    "choice_a": "Locale",
    "choice_b": "Localization",
    "choice_c": "Character set",
    "choice_d": "Unicode",
    "correct_answer": "B",
    "explanation": "Localization is the process of adapting a Linux system\u2019s character set to use a local language, so option B is correct. The <code>locale</code> command allows you to view the character sets, but doesn\u2019t adapt the Linux system to the locale environment, so option A is incorrect. The character set is used to specify language characters, but it doesn\u2019t adapt the Linux system to a specific language, so option C is incorrect. Unicode and ASCII are two types of character sets, and don\u2019t adapt the Linux system to a specific language, so options D and E are incorrect.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      130,
      132,
      131,
      133,
      88
    ],
    "source": "316328_c09",
    "choice_e": "ASCII"
  },
  {
    "id": 324,
    "question": "What Systemd utility allows you to change the localization on your Linux system?",
    "choice_a": "<code>timedatectl</code>",
    "choice_b": "<code>time</code>",
    "choice_c": "<code>date</code>",
    "choice_d": "<code>localectl</code>",
    "correct_answer": "D",
    "explanation": "The <code>localectl</code> command is part of the Systemd package, and allows you to display and change the localization settings for your Linux system, so option D is correct. The <code>timedatectl</code> command is also part of the Systemd package, but only applies to time and date changes and not the localization changes, so option A is incorrect. The <code>time</code>, <code>date</code>, and <code>locale</code> programs are legacy programs and not part of the Systemd package, so options B, C, and E are incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      132,
      131,
      130,
      133,
      87
    ],
    "source": "316328_c09",
    "choice_e": "<code>locale</code>"
  },
  {
    "id": 325,
    "question": "Which Linux command changes the value of a localization environment variable?",
    "choice_a": "<code>time</code>",
    "choice_b": "<code>export</code>",
    "choice_c": "<code>locale</code>",
    "choice_d": "<code>date</code>",
    "correct_answer": "B",
    "explanation": "The <code>export</code> command sets the value associated with an environment variable, so option B is correct. The <code>time</code> command displays the amount of time an application used on the system, not the values of an environment variable, so option A is incorrect. The <code>locale</code> command displays the values of the localization environment variables, but doesn\u2019t allow you to change them, so option C is incorrect. The <code>date</code> command displays and sets the time and date values, but not the localization environment variables, so option D is incorrect. The <code>hwclock</code> command displays and sets the hardware clock, but not the localization environment variables, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      340,
      132,
      131,
      150,
      89
    ],
    "source": "316328_c09",
    "choice_e": "<code>hwclock</code>"
  },
  {
    "id": 326,
    "question": "Which <code>LC_</code> environment variable determines how Linux displays dollar and cents values?",
    "choice_a": "<code>LC_NUMERIC</code>",
    "choice_b": "<code>LC_MONETARY</code>",
    "choice_c": "<code>LC_CTYPE</code>",
    "choice_d": "<code>LC_TIME</code>",
    "correct_answer": "B",
    "explanation": "The <code>LC_MONETARY</code> environment variable determines the character set used for displaying monetary values, so option B is correct. The <code>LC_NUMERIC</code> environment variable determines how Linux displays numeric values, so option A is incorrect. The <code>LC_CTYPE</code> environment variable determines the default character set used by programs, but not necessarily only for monetary values, so option C is incorrect. The <code>LC_TIME</code> environment variable determines how time the Linux system displays time, not monetary values, so option D is incorrect. The <code>LC_COLLATE</code> environment variable determines who Linux sorts alpha characters, not how it displays monetary values, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      131,
      132,
      130,
      150,
      89
    ],
    "source": "316328_c09",
    "choice_e": "<code>LC_COLLATE</code>"
  },
  {
    "id": 327,
    "question": "A __________ determines the time relative to the UTC time in a specific location.",
    "choice_a": "time zone",
    "choice_b": "localization",
    "choice_c": "character set",
    "choice_d": "locale",
    "correct_answer": "A",
    "explanation": "Each time zone determines the offset from UTC that applies to a specific location, so option A is correct. The localization determines the character set used to display language characters, but not the time, so option B is incorrect. The character set determines how to display the language characters, but not the time, so option C is incorrect. The locale determines how Linux displays the time, but not the actual time setting, so option D is incorrect. The hardware clock is the time the physical workstation or server is set to in BIOS or UEFI, it doesn\u2019t necessarily represent the time relative to UTC, it can actually even be stored as a UTC value, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      133,
      132,
      130,
      131,
      134
    ],
    "source": "316328_c09",
    "choice_e": "hardware clock"
  },
  {
    "id": 328,
    "question": "Which Linux commands allow you to retrieve the time from the physical workstation or server? (Choose two.)",
    "choice_a": "<code>date</code>",
    "choice_b": "<code>hwclock</code>",
    "choice_c": "<code>time</code>",
    "choice_d": "<code>locale</code>",
    "correct_answer": [
      "B",
      "E"
    ],
    "explanation": "Both the <code>hwclock</code> and <code>timedatectl</code> commands retrieve the time and date from the physical workstation or server, so options B and E are correct. The <code>date</code> command displays the system time and date, not the time and date set on the physical hardware, so option A is incorrect. The <code>time</code> command displays the amount of time a program uses on the system, not the physical hardware time and date on the workstation or server, so option C is incorrect. The <code>locale</code> command displays the localization environment variables and their values, not the hardware time and date, so option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      134,
      135,
      133,
      136,
      132
    ],
    "source": "316328_c09",
    "choice_e": "<code>timedatectl</code>"
  },
  {
    "id": 329,
    "question": "What file does Red Hat-based systems use to define the time zone for the Linux system?",
    "choice_a": "<code>/etc/localtime</code>",
    "choice_b": "<code>/etc/timezone</code>",
    "choice_c": "<code>/usr/share/zoneinfo</code>",
    "choice_d": "<code>/usr/share/timezone</code>",
    "correct_answer": "A",
    "explanation": "Red Hat\u2013based systems use the <code>/etc/localtime</code> file to store the appropriate time zone file for the location where the system is running, so option A is correct. The <code>/etc/timezone</code> file is normally used by Debian-based systems, so option B is incorrect. The <code>/usr/share/zoneinfo</code> folder stores time zone files that you must copy to the <code>/etc/localtime</code> file, so option C is incorrect. The <code>/usr/share/timezone</code> and <code>/usr/share/localtime</code> folders are incorrect folder names, so options D and E and incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      133,
      134,
      135,
      206,
      41
    ],
    "source": "316328_c09",
    "choice_e": "<code>/usr/share/localtime</code>"
  },
  {
    "id": 330,
    "question": "Which folder contains template files for each time zone that Linux supports?",
    "choice_a": "<code>/etc/localtime</code>",
    "choice_b": "<code>/usr/share/zoneinfo</code>",
    "choice_c": "<code>/etc/timezone</code>",
    "choice_d": "<code>$HOME</code>",
    "correct_answer": "B",
    "explanation": "The <code>/usr/share/zoneinfo</code> folder contains template files for each of the time zones supported in Linux, so option B is correct. The <code>/etc/localtime</code> and <code>/etc/timezone</code> files are the locations where you copy or link the appropriate time zone file to, but neither of them are the template folder, so options A and C are incorrect. The <code>$HOME</code> folder contains the user environment settings, and user files, but not the time zone template files, so option D is incorrect. The <code>/usr/share/timezone</code> folder is an incorrect folder name, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      133,
      134,
      135,
      29,
      138
    ],
    "source": "316328_c09",
    "choice_e": "<code>/usr/share/timezone</code>"
  },
  {
    "id": 331,
    "question": "Which command displays the current date, system time, hardware time, and time zone?",
    "choice_a": "<code>date</code>",
    "choice_b": "<code>timedatectl</code>",
    "choice_c": "<code>time</code>",
    "choice_d": "<code>hwclock</code>",
    "correct_answer": "B",
    "explanation": "The <code>timedatectl</code> command from the Systemd package displays the current date, the Linux system time, the hardware clock time, and the time zone, so option B is correct. The <code>date</code> command displays the current system time, date, and time zone, but not the hardware time, so option A is incorrect. The <code>time</code> command displays the amount of time an application uses on the CPU, not the current date and time, so option C is incorrect. The <code>hwclock</code> command displays the current hardware time, but not the system time, date, or time zone, so option D is incorrect. The <code>localectl</code> command displays the localization settings for the system, but not the time, date, hardware time, or time zone, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      134,
      133,
      135,
      136,
      88
    ],
    "source": "316328_c09",
    "choice_e": "<code>localectl</code>"
  },
  {
    "id": 332,
    "question": "Which command do you use to display the current time and date using a specific output format?",
    "choice_a": "<code>date</code>",
    "choice_b": "<code>time</code>",
    "choice_c": "<code>timedatectl</code>",
    "choice_d": "<code>localectl</code>",
    "correct_answer": "A",
    "explanation": "The <code>date</code> command allows you to specify a format for displaying the time and date, so option A is correct. The <code>time</code> command displays the amount of CPU time an application consumes, not the current time and date, so option B is incorrect. The <code>timedatectl</code> command displays the current time and date, but doesn\u2019t allow you to format the output, so option C is incorrect. The <code>localectl</code> command displays the localization settings for the system, but not the current time and date, so option D is incorrect. The <code>hwclock</code> command displays the current hardware time, but doesn\u2019t allow you to specify the format, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      134,
      136,
      414,
      410,
      411
    ],
    "source": "316328_c09",
    "choice_e": "<code>hwclock</code>"
  },
  {
    "id": 333,
    "question": "Which commands allows you to set the Linux system time to the workstation BIOS clock time? (Choose two.)",
    "choice_a": "<code>hwclock</code>",
    "choice_b": "<code>date</code>",
    "choice_c": "<code>time</code>",
    "choice_d": "<code>timedatectl</code>",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "The <code>hwclock</code> and <code>timedatectl</code> commands allow you to synchronize the Linux system time to the workstation BIOS time, so options A and D are correct. The <code>date</code> command allows you to change the date and time, but it doesn\u2019t allow you to synchronize it with the workstation BIOS time, so option B is incorrect. The <code>time</code> command allows you to display the amount of CPU time an application consumes, but it doesn\u2019t allow you to synchronize the system time with the workstation BIOS time, so option C is incorrect. The <code>localectl</code> command is used for localization, not setting the time, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      134,
      135,
      133,
      136,
      132
    ],
    "source": "316328_c09",
    "choice_e": "<code>localectl</code>"
  },
  {
    "id": 334,
    "question": "What network time package do Red Hat\u2013based Linux systems utilize to synchronize the system time with a network time server?",
    "choice_a": "<code>ntpd</code>",
    "choice_b": "<code>chrony</code>",
    "choice_c": "<code>localectl</code>",
    "choice_d": "<code>timedatectl</code>",
    "correct_answer": "B",
    "explanation": "Red Hat\u2013based Linux systems utilize the <code>chrony</code> software package for connecting to network time servers. The <code>ntpd</code> package is a legacy software package and not often used, so option A is incorrect. The <code>localectl</code> command isn\u2019t used for setting time, so option C is incorrect. While you can set the local time using the <code>timedatectl</code> command, you can\u2019t use it to set the time using a network time server, so option D is incorrect. Although Red Hat\u2013based systems utilize the Systemd utilities, they don\u2019t use the <code>timesyncd</code> program for network time, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      135,
      29,
      134,
      133,
      206
    ],
    "source": "316328_c09",
    "choice_e": "<code>timesyncd</code>"
  },
  {
    "id": 335,
    "question": "Which environment variable can programmers use to temporarily change the time zone setting for just their environment?",
    "choice_a": "<code>LANG</code>",
    "choice_b": "<code>LC_MONETARY</code>",
    "choice_c": "<code>LC_NUMBERIC</code>",
    "choice_d": "<code>LC_ALL</code>",
    "correct_answer": "E",
    "explanation": "The <code>TZ</code> environment variable overrides the default system time zone for session applications, so option E is correct. The <code>LANG</code> and <code>LC_ALL</code> environment variables set the entire system time zone, not just the programming environment, so options A and D are incorrect. The <code>LC_MONETARY</code> and <code>LC_NUMERIC</code> environment variables set the localization for money values and numeric values, and they don\u2019t change the time zone setting, so options B and C are incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      131,
      150,
      340,
      133,
      89
    ],
    "source": "316328_c09",
    "choice_e": "<code>TZ</code>"
  },
  {
    "id": 336,
    "question": "Which character set has replaced ASCII as the default character set used in US Linux installations?",
    "choice_a": "Unicode",
    "choice_b": "UTF-16",
    "choice_c": "UTF-8",
    "choice_d": "UTF-32",
    "correct_answer": "C",
    "explanation": "The UTF-8 character set duplicates the ASCII character set, and is the default used in most US Linux installations, so option C is correct. The Unicode, UTF-16, and UTF-32 character set use more than one byte to represent characters, so they are not often used for English language characters, so options A, B, and D are incorrect. The <code>locale</code> command displays the localization environment variables and their values, it is not a character set code, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      130,
      131,
      132,
      150,
      340
    ],
    "source": "316328_c09",
    "choice_e": "<code>locale</code>"
  },
  {
    "id": 337,
    "question": "Which command lists all of the localizations installed on your Linux system?",
    "choice_a": "<code>timecatectl</code>",
    "choice_b": "<code>localectl</code>",
    "choice_c": "<code>locale</code>",
    "choice_d": "<code>LANG</code>",
    "correct_answer": "B",
    "explanation": "The <code>localectl</code> command uses the list-locales to display all of the localizations installed on the Linux system, so option B is correct. The <code>timedatectl</code> command displays the local time and date, but doesn\u2019t provide information on which localization files are installed, so option A is incorrect. The <code>locale</code> command displays the localization environment variable settings, but doesn\u2019t list which localizations are installed, so option C is incorrect. The <code>LANG</code> and <code>LC_ALL</code> environment variables set the current localization, but can\u2019t display which ones are installed on the system, so options D and E are incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      132,
      131,
      130,
      133,
      134
    ],
    "source": "316328_c09",
    "choice_e": "<code>LC_ALL</code>"
  },
  {
    "id": 338,
    "question": "Which of the following are fields within a <code>/etc/passwd</code> file record? (Choose all that apply.)",
    "choice_a": "User account\u2019s username",
    "choice_b": "Password",
    "choice_c": "Password change date",
    "choice_d": "Special flag",
    "correct_answer": [
      "A",
      "B",
      "E"
    ],
    "explanation": "The user account\u2019s username, password (though it typically only contains an <code>x</code>), and UID are all legitimate fields within a <code>/etc/passwd</code> file record. Therefore, options A, B, and E are correct answers. The password change date and special flag are fields within the <code>/etc/shadow</code> file. Thus, options C and D are incorrect choices.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      139,
      137,
      145,
      141,
      152
    ],
    "source": "316328_c10",
    "choice_e": "UID"
  },
  {
    "id": 339,
    "question": "Which of the following are fields within a <code>/etc/shadow</code> file record? (Choose all that apply.)",
    "choice_a": "Password expiration date",
    "choice_b": "Account expiration date",
    "choice_c": "Password",
    "choice_d": "Comment",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "The password expiration date, account expiration date, and password are all legitimate fields within a <code>/etc/shadow</code> file record. Therefore, options A, B, and C are correct answers. The comment and default shell are fields within the <code>/etc/passwd</code> file. Thus, options D and E are incorrect choices.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      139,
      143,
      141,
      330,
      149
    ],
    "source": "316328_c10",
    "choice_e": "Default shell"
  },
  {
    "id": 340,
    "question": "Which field contains the same data for both a <code>/etc/passwd</code> and <code>/etc/shadow</code> file record?",
    "choice_a": "Password",
    "choice_b": "Account expiration date",
    "choice_c": "UID",
    "choice_d": "GID",
    "correct_answer": "E",
    "explanation": "The user account\u2019s username is the only field within a <code>/etc/passwd</code> and <code>/etc/shadow</code> record that contains the same data. Therefore, option E is the correct answer. While both files have a password field, they do not contain the same data. The password can only exist in one of the two files, preferably the <code>/etc/shadow</code> file. Thus, option A is a wrong answer. The account expiration date only exists in the <code>/etc/shadow</code> file, so option B is also a wrong choice. The UID and GID fields only exist in the <code>/etc/passwd</code> file, so options C and D are also incorrect answers.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      139,
      143,
      138,
      137,
      141
    ],
    "source": "316328_c10",
    "choice_e": "User account\u2019s username"
  },
  {
    "id": 341,
    "question": "Which of the following commands will allow you to view the <code>NUhura</code> account\u2019s record data in the <code>/etc/passwd</code> file? (Choose all that apply.)",
    "choice_a": "<code>getent NUhura passwd</code>",
    "choice_b": "<code>cat /etc/passwd</code>",
    "choice_c": "<code>passwd NUhura</code>",
    "choice_d": "<code>grep NUhura /etc/passwd</code>",
    "correct_answer": [
      "B",
      "D",
      "E"
    ],
    "explanation": "Though not very efficient, the <code>cat /etc/passwd</code> command would allow you to view the <code>NUhura</code> account\u2019s record within the <code>/etc/passwd</code> file. The <code>grep NUhura /etc/passwd</code> and <code>getent passwd NUhura</code> commands also would allow you to see the <code>NUhura</code> record. So options B, D, and E are correct choices. The <code>getent</code> command in option A has got the username and file name flip-flopped, so it is an incorrect choice. Also, the <code>passwd NUhura</code> attempts to change the account\u2019s password instead of display its file record, so option C is also an incorrect answer.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      139,
      143,
      54,
      39,
      152
    ],
    "source": "316328_c10",
    "choice_e": "<code>getent passwd NUhura</code>"
  },
  {
    "id": 342,
    "question": "You use the <code>useradd -D</code> command to view account creation configuration directives. What file does this command pull its displayed information from?",
    "choice_a": "The <code>/etc/passwd</code> file",
    "choice_b": "The <code>/etc/shadow</code> file",
    "choice_c": "The <code>/etc/group</code> file",
    "choice_d": "The <code>/etc/login.defs</code> file",
    "correct_answer": "E",
    "explanation": "The <code>useradd -D</code> command allows you to view the account creation configuration directives within the <code>/etc/default/useradd</code> file. Therefore, option E is the correct answer. The <code>/etc/passwd</code>, <code>/etc/shadow</code>, and <code>/etc/group</code> files do not contain account creation configuration directives, so options A, B, and C are wrong answers. While the <code>/etc/login.defs</code> file does contain account creation configuration directives, you cannot display it via the <code>useradd -D</code> command. Therefore, option D is also an incorrect choice.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      144,
      138,
      137,
      140,
      142
    ],
    "source": "316328_c10",
    "choice_e": "The <code>/etc/default/useradd</code> file"
  },
  {
    "id": 343,
    "question": "You create an account using the appropriate utility, except for some reason the account\u2019s home directory was not created. Which of the following most likely caused this to occur?",
    "choice_a": "The <code>HOME</code> directive is set to <code>no</code>.",
    "choice_b": "You did not employ super user privileges.",
    "choice_c": "The <code>CREATE_HOME</code> directive is not set.",
    "choice_d": "The <code>INACTIVE</code> directive is set to <code>-1</code>.",
    "correct_answer": "C",
    "explanation": "If the <code>CREATE_HOME</code> directive is not set or it is set to <code>no</code>, then when a user account is created, no home directory will be created by default. Most likely this caused the problem, so option C is the correct answer. The <code>HOME</code> directive determines what base directory name is used when creating home directories for new accounts, so option A is a wrong answer. If you did not employ super user privileges, you would not have been able to even create the account, so option B is a wrong choice. The <code>INACTIVE</code> directive pertains to when an account will be considered inactive, so option D is also an incorrect answer. The <code>EXPIRE</code> directive is involved with account expiration and not home directory creation. Therefore, option E is also an incorrect choice.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      144,
      140,
      137,
      141
    ],
    "source": "316328_c10",
    "choice_e": "The <code>EXPIRE</code> date is set and it is before today."
  },
  {
    "id": 344,
    "question": "Your boss has asked you to remove <code>KSingh</code>\u2019s account and all his home directory files from the system immediately. Which command should you use?",
    "choice_a": "<code>usermod -r KSingh</code>",
    "choice_b": "<code>rm -r /home/KSingh</code>",
    "choice_c": "<code>userdel Ksingh</code>",
    "choice_d": "<code>userdel -r KSingh</code>",
    "correct_answer": "D",
    "explanation": "To immediately remove the <code>KSingh</code> account and all his home directory files, using super user privileges, you would use the <code>userdel -r KSingh</code> command. Therefore, option D is the correct answer. There is no <code>-r</code> option for the <code>usermod</code> command, so option A is a wrong answer. The <code>rm -r /home/KSingh</code> command would only remove the account\u2019s home directory files and not delete the user account. Therefore, option B is an incorrect answer. The <code>userdel</code> command without any options would only delete the account and not remove any of its home directory files, so option C is a wrong choice. The <code>-d</code> option on the <code>usermod</code> command is for changing an account\u2019s home directory. Therefore, option E is also an incorrect choice.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      142,
      139,
      43,
      137,
      140
    ],
    "source": "316328_c10",
    "choice_e": "<code>usermod -d KSingh</code>"
  },
  {
    "id": 345,
    "question": "Which of the following will allow you to change an account\u2019s <code>/etc/shadow</code> file record data? (Choose all that apply.)",
    "choice_a": "The <code>passwd</code> command",
    "choice_b": "The <code>usermod</code> command",
    "choice_c": "The <code>userdel</code> command",
    "choice_d": "The <code>getent</code> command",
    "correct_answer": [
      "A",
      "B",
      "C",
      "E"
    ],
    "explanation": "The <code>passwd</code>, <code>usermod</code>, <code>userdel</code>, and <code>chage</code> commands can all manipulate (or remove) an account\u2019s <code>/etc/shadow</code> file record data in some way. Therefore, options A, B, C, and E are all correct. While the <code>getent</code> command will allow you to display selected records from the <code>/etc/shadow</code> file, it will not allow you to manipulate data records within the file. Therefore, option D is the only incorrect choice.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      139,
      147,
      152,
      143,
      334
    ],
    "source": "316328_c10",
    "choice_e": "The <code>chage</code> command"
  },
  {
    "id": 346,
    "question": "Which of the following commands will allow you to switch temporarily from your account\u2019s default group to another group with whom you have membership?",
    "choice_a": "The <code>usermod</code> command",
    "choice_b": "The <code>newgrp</code> command",
    "choice_c": "The <code>groups</code> command",
    "choice_d": "The <code>groupadd</code> command",
    "correct_answer": "B",
    "explanation": "The <code>newgrp</code> command will let you switch temporarily from your account\u2019s default group to another group with whom you have membership. Therefore, option B is the correct answer. The <code>usermod</code> command could make that switch, but it is not best for temporary situations, so it is an incorrect choice. The <code>groups</code> command allows you to display group information, but not change groups, so it also is a wrong answer. The <code>groupadd</code> and <code>groupmod</code> commands deal with group management, but not temporarily switching an account\u2019s default group. Therefore, options D and E are also incorrect choices.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      145,
      147,
      146,
      149,
      408
    ],
    "source": "316328_c10",
    "choice_e": "The <code>groupmod</code> command"
  },
  {
    "id": 347,
    "question": "Which of the following commands is the best one to add <code>JKirk</code> as a member to a new group called the <code>NCC-1701</code> group and not remove any of the account\u2019s previous group memberships?",
    "choice_a": "<code>usermod -g NCC-1701 JKirk</code>",
    "choice_b": "<code>usermod -G NCC-1701 JKirk</code>",
    "choice_c": "<code>usermod -aG NCC-1701 JKirk</code>",
    "choice_d": "<code>groupadd NCC-1701</code>",
    "correct_answer": "C",
    "explanation": "The <code>usermod -aG NCC-1701 JKirk</code> command would add <code>JKirk</code> to the <code>NCC-1701</code> group as a member and not remove any of the account\u2019s previous group memberships. Therefore, option C is the correct answer. The <code>usermod -g NCC-1701 JKirk</code> command would change the <code>JKirk</code> account\u2019s primary group membership, so option A is a wrong answer. The command in option B would add the <code>JKirk</code> account as a member to the <code>NCC-1701</code> group, but it would remove any of the account\u2019s previous group memberships. Thus, option B is an incorrect answer. The <code>groupadd NCC-1701</code> command would only add the <code>NCC-1701</code> group. Therefore, option D is a wrong answer as well. The <code>groupmod</code> command is for modifying groups, and so the command in option E would have undesirable results. Thus, option E is an incorrect choice.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      147,
      146,
      145,
      144,
      148
    ],
    "source": "316328_c10",
    "choice_e": "<code>groupmod NCC-1701 JKirk</code>"
  },
  {
    "id": 348,
    "question": "Which of the following could be used to view the members of the <code>NCC-1701</code> group? (Choose all that apply.)",
    "choice_a": "<code>groups NCC-1701</code>",
    "choice_b": "<code>getent group NCC-1701</code>",
    "choice_c": "<code>getent groups NCC-1701</code>",
    "choice_d": "<code>grep NCC-1701 /etc/group</code>",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "The <code>getent group NCC-1701</code> and <code>grep NCC-1701 /etc/group</code> commands would both allow you to see the various <code>NCC-1701</code> group members. Therefore, options B and D are correct answers. The <code>groups</code> command is for viewing an account\u2019s various group memberships. Therefore, option A is a wrong answer. It is always tempting to add an s to the <code>/etc/group</code> filename, because of the <code>groups</code> command. However, it is the <code>group</code> file and <i>not</i> the <code>groups</code> file. Thus, options C and E are incorrect choices.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      145,
      143,
      149,
      146,
      54
    ],
    "source": "316328_c10",
    "choice_e": "<code>grep NCC-1701 /etc/groups</code>"
  },
  {
    "id": 349,
    "question": "User environment files typically come from where?",
    "choice_a": "<code>/etc/skel/</code>",
    "choice_b": "<code>/home/<i>userid</i></code>",
    "choice_c": "<code>$HOME</code>",
    "choice_d": "<code>~</code>",
    "correct_answer": "A",
    "explanation": "The skeleton directory, <code>/etc/skel/</code>, typically contains the user environment files that are copied to the account\u2019s home directory when it is created. Therefore, option A is the correct answer. Options B, C, and D all contain references to home (or potential home) directories. That is where the user environment files end up, but not where they come from. Thus options B, C, and D are wrong answers. The <code>/etc/</code> directory is where the global environment files reside. Therefore, option E is also an incorrect choice.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      140,
      150,
      340,
      144
    ],
    "source": "316328_c10",
    "choice_e": "<code>/etc/</code>"
  },
  {
    "id": 350,
    "question": "A user has logged into the tty3 terminal. Which of the following user environment files is executed first if found in the user\u2019s home directory?",
    "choice_a": "The <code>.bash_login</code> file",
    "choice_b": "The <code>.bashrc</code> file",
    "choice_c": "The <code>.profile</code> file",
    "choice_d": "The <code>.bash.bashrc</code> file",
    "correct_answer": "E",
    "explanation": "The <code>.bash_profile</code> user environment file is run first if it is found in the user account\u2019s home directory. Therefore, option E is the right answer. The <code>.bash_login</code> and <code>.profile</code> user environment files would be ignored if they existed alongside the <code>.bash_profile</code> file within the user\u2019s home directory. Thus, options A and C are wrong answers. The <code>.bashrc</code> file is typically called to execute from one of the other user environment files for an interactive login session. Thus, option B is also an incorrect answer. The <code>.bash.bashrc</code> file, though similar in name to a global environment file, does not exist. Therefore, option D is an incorrect choice.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      150,
      340,
      138,
      339,
      132
    ],
    "source": "316328_c10",
    "choice_e": "The <code>.bash_profile</code> file"
  },
  {
    "id": 351,
    "question": "Which of the following files and directories may be involved in setting up the environment for all system users? (Choose all that apply.)",
    "choice_a": "<code>/etc/bash_profile/</code>",
    "choice_b": "<code>/etc/profile</code>",
    "choice_c": "<code>/etc/profile.d/</code>",
    "choice_d": "<code>/etc/bashrc</code>",
    "correct_answer": [
      "B",
      "C",
      "D",
      "E"
    ],
    "explanation": "Depending on the Linux distribution currently in use, the files (and directory) in options B, C, D, and E may be involved in setting up the global environment. The directory in option A, while similar to a user environment file name, is made up. Therefore, option A is the only incorrect choice.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      150,
      340,
      138,
      131,
      89
    ],
    "source": "316328_c10",
    "choice_e": "<code>/etc/bash.bashrc</code>"
  },
  {
    "id": 352,
    "question": "Which of the following commands displays information about the account issuing the command? (Choose all that apply.)",
    "choice_a": "<code>whoami</code>",
    "choice_b": "<code>who am i</code>",
    "choice_c": "<code>cat $HOME/.bashrc</code>",
    "choice_d": "<code>cat $HOME/.profile</code>",
    "correct_answer": [
      "A",
      "B",
      "E"
    ],
    "explanation": "The <code>whoami</code>, <code>who am i</code>, and <code>id</code> commands will all display information about the current account that is issuing the commands. Therefore, options A, B, and E are correct answers. While the <code>cat</code> commands may display user environment files in the account\u2019s home directory, they do not display information concerning the account. Thus, options C and D are incorrect choices.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      151,
      143,
      139,
      140,
      144
    ],
    "source": "316328_c10",
    "choice_e": "<code>id</code>"
  },
  {
    "id": 353,
    "question": "Which of the following commands will display CPU load data along with information concerning users who are currently logged into the system?",
    "choice_a": "The <code>who</code> command",
    "choice_b": "The <code>id</code> command",
    "choice_c": "The <code>whoami</code> command",
    "choice_d": "The <code>w</code> command",
    "correct_answer": "D",
    "explanation": "The <code>w</code> command displays CPU load information for the last 1, 5, and 15 minutes as well as data about users who are currently accessing the system. Therefore, option D is the correct answer. The <code>who</code> command will display information concerning users who are currently logged into the system, but not CPU load data. Thus, option A is a wrong answer. The <code>id</code> command displays user account information, not CPU load data or active user info. Therefore, option B is also a wrong choice. The <code>whoami</code> command only displays the username of the current user issuing the command. Thus, option C is an incorrect answer. The <code>last</code> command displays past and present system access information for user accounts, but nothing concerning CPU load data. Thus, option E is an incorrect choice.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      151,
      323,
      324,
      152,
      322
    ],
    "source": "316328_c10",
    "choice_e": "The <code>last</code> command"
  },
  {
    "id": 354,
    "question": "The <code>last</code> command, by default, pulls its data from what file?",
    "choice_a": "The <code>/var/run/utmp</code> file",
    "choice_b": "The <code>/var/log/wtmp</code> file",
    "choice_c": "The <code>/var/log/wtmp.1</code> file",
    "choice_d": "The <code>/etc/shadow</code> file",
    "correct_answer": "B",
    "explanation": "The <code>last</code> command by default pulls its data from the <code>/var/log/wtmp</code> file. Therefore, option B is the correct answer. The <code>w</code> command uses data from the <code>/var/run/utmp</code> file, so option A is a wrong choice. The <code>last</code> command can pull information from an older saved <code>wtmp</code> file, such as <code>/var/log/wtmp.1</code>, but it does not do so by default. Thus, option C is a wrong choice. The <code>/etc/shadow</code> and <code>/etc/passwd</code> files do not contain any data that can be used with the <code>last</code> command. Therefore, options D and E are incorrect answers.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      47,
      48,
      53,
      139,
      143
    ],
    "source": "316328_c10",
    "choice_e": "The <code>/etc/passwd</code> file"
  },
  {
    "id": 355,
    "question": "Which of the following are options used in the <code>/etc/fstab</code> file to designate a filesystem as one that uses quotas? (Choose all that apply.)",
    "choice_a": "<code>usrquota</code>",
    "choice_b": "<code>quotaon</code>",
    "choice_c": "<code>grpquota</code>",
    "choice_d": "<code>quotacheck</code>",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "The <code>usrquota</code> and <code>grpquota</code> are <code>/etc/fstab</code> settings used to enable user and group quotas for a filesystem. Therefore, options A and C are correct answers. Options B and D contain commands that are used with managing filesystem quotas. Thus, options B and D are wrong answers. The <code>aquota.user</code> is a file that is created when the <code>quotacheck -cu</code> command is employed. Therefore, option E is an incorrect choice.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      153,
      155,
      337,
      103,
      338
    ],
    "source": "316328_c10",
    "choice_e": "<code>aquota.user</code>"
  },
  {
    "id": 356,
    "question": "A problem has occurred concerning group quotas on three filesystems. You need to quickly remove all filesystems\u2019 quota limits to temporarily resolve this issue. What is the best command to employ?",
    "choice_a": "<code>vi /etc/fstab</code>",
    "choice_b": "<code>quotaoff -a</code>",
    "choice_c": "<code>quotacheck -cg</code>",
    "choice_d": "<code>quotacheck -cu</code>",
    "correct_answer": "B",
    "explanation": "To quickly remove quota limits on all filesystems, you would use the <code>quotaoff -a</code> command. Therefore, option B is the correct answer. Editing the <code>/etc/fstab</code> would take too long because you would have to remove the quota options and then unmount and remount all the filesystems. Thus, option A is a wrong answer. The <code>quotacheck</code> utility creates either the <code>aquota.group</code> file, if the <code>-cg</code> options are used, or the <code>aquota.user</code> file, if the <code>-cu</code> switches are used, or both files if <code>-cug</code> is employed. However, it does nothing for quickly turning off filesystems\u2019 quotas. Thus, options C and D are incorrect answers. The <code>umount</code> command will not turn off filesystems\u2019 quotas, and therefore option E is also an incorrect choice.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      155,
      153,
      154,
      337,
      410
    ],
    "source": "316328_c10",
    "choice_e": "<code>umount</code>"
  },
  {
    "id": 357,
    "question": "You need to edit quota grace periods. Which of the following commands should you use?",
    "choice_a": "<code>edquota -u</code>",
    "choice_b": "<code>edquota -g</code>",
    "choice_c": "<code>edquota -t</code>",
    "choice_d": "<code>edquota -G</code>",
    "correct_answer": "C",
    "explanation": "The <code>edquota -t</code> command will edit quota grace periods. Therefore, option C is the right answer. The <code>edquota -u</code> command edits a designated user\u2019s quota limits. Thus, option A is a wrong answer. The <code>edquota -g</code> command edits a designated group\u2019s quota limits. Therefore, option B is also an incorrect answer. The <code>edquota -G</code> command and <code>edquota --grace</code> command are made up. Thus, both options D and E are incorrect choices.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      154,
      155,
      153,
      337,
      147
    ],
    "source": "316328_c10",
    "choice_e": "<code>edquota --grace</code>"
  },
  {
    "id": 358,
    "question": "Which type of storage device uses integrated circuits to store data with no moving parts?",
    "choice_a": "SSD",
    "choice_b": "SATA",
    "choice_c": "SCSI",
    "choice_d": "HDD",
    "correct_answer": "A",
    "explanation": "The solid-state drive (SSD) storage device uses an integrated circuit to store data, so option A is correct. SATA, SCSI, and PATA are drive connection types and not storage device types, so options B, C, and E are all incorrect. The hard disk drive (HDD) storage devices use disk platters and a read/write head to store data, not an integrated circuit, so option D is incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      156,
      157,
      342,
      346,
      158
    ],
    "source": "316328_c11",
    "choice_e": "PATA"
  },
  {
    "id": 359,
    "question": "What raw device file would Linux create for the second SCSI drive connected to the system?",
    "choice_a": "<code>/dev/hdb</code>",
    "choice_b": "<code>/dev/sdb</code>",
    "choice_c": "<code>/dev/sdb1</code>",
    "choice_d": "<code>/dev/hdb1</code>",
    "correct_answer": "B",
    "explanation": "Linux creates files named <code>sd <i>x</i></code> in the <code>/dev</code> folder for SCSI devices. For the second SCSI device, Linux would create the file <code>/dev/sdb</code>, so option B is correct. The <code>/dev/hdb</code> file would represent the second HDD drive connected to the system, so option A is incorrect, and <code>/dev/sda</code> would represent the first SCSI device connected to the system, so option E is incorrect. Options C and D both represent partitions and not entire drives, so they are both incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      157,
      159,
      342,
      158,
      160
    ],
    "source": "316328_c11",
    "choice_e": "<code>/dev/sda</code>"
  },
  {
    "id": 360,
    "question": "What program runs in the background to automatically detect and mount new storage devices?",
    "choice_a": "<code>mkfs</code>",
    "choice_b": "<code>fsck</code>",
    "choice_c": "<code>umount</code>",
    "choice_d": "<code>mount</code>",
    "correct_answer": "E",
    "explanation": "The <code>udev</code> program runs in the background on Linux systems and detects and mounts storage devices as they\u2019re connected to the system, so option E is correct. The <code>mkfs</code> program creates a filesystem on partitions; it doesn\u2019t mount them, so option A is incorrect. The <code>fsck</code> program repairs filesystems but doesn\u2019t mount them, so option B is incorrect. The <code>umount</code> program unmounts filesystems, not mounts them, so option C is incorrect. The <code>mount</code> program manually mounts filesystems but doesn\u2019t run in background or automatically detect them, so option D is incorrect.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      159,
      350,
      167,
      342,
      346
    ],
    "source": "316328_c11",
    "choice_e": "<code>udev</code>"
  },
  {
    "id": 361,
    "question": "What folder does the <code>udev</code> program use to create a permanent link to a storage device based on its serial number?",
    "choice_a": "<code>/dev/disk/by-path</code>",
    "choice_b": "<code>/dev/sdb</code>",
    "choice_c": "<code>/dev/disk/by-id</code>",
    "choice_d": "<code>/dev/disk/by-uuid</code>",
    "correct_answer": "C",
    "explanation": "The <code>udev</code> program creates files in the <code>/dev/disk/by-id</code> folder that are linked to the raw device files for storage devices. These files are identified by manufacturer information, including the serial number assigned to the device, so option C is correct. The <code>/dev/disk/by-path</code> folder links files based on the drive\u2019s connection to the system, so option A is incorrect. The <code>/dev/sdb</code> file represents the raw device file assigned to the device, not a permanent link file, so option B is incorrect. The <code>/dev/disk/by-uuid</code> folder contains permanent link files based on the device UUID value, not the serial number, so option D is incorrect. The <code>/dev/mapper</code> folder contains files for virtual drives for LVM and multipath systems, not permanent links to raw device files, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      159,
      350,
      342,
      346,
      162
    ],
    "source": "316328_c11",
    "choice_e": "<code>/dev/mapper</code>"
  },
  {
    "id": 362,
    "question": "Which partitioning tool provides a graphical interface?",
    "choice_a": "<code>gdisk</code>",
    "choice_b": "<code>gparted</code>",
    "choice_c": "<code>fdisk</code>",
    "choice_d": "<code>parted</code>",
    "correct_answer": "B",
    "explanation": "The GNU <code>gparted</code> program provides a graphical window for managing device partitions, so option B is correct. The <code>gdisk</code>, <code>fdisk</code>, and <code>parted</code> programs are all command-line partitioning tools, so options A, C, and D are all incorrect. The <code>fsck</code> program is a tool to repair filesystems, not to create or modify partitions, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      161,
      160,
      158,
      348,
      119
    ],
    "source": "316328_c11",
    "choice_e": "<code>fsck</code>"
  },
  {
    "id": 363,
    "question": "Linux uses ___________ to add the filesystem on a new storage device to the virtual directory for users to access.",
    "choice_a": "Mount points",
    "choice_b": "Drive letters",
    "choice_c": "<code>/dev</code> files",
    "choice_d": "<code>/proc</code> folder",
    "correct_answer": "A",
    "explanation": "Linux uses mount points to insert a filesystem on a storage device to the virtual directory, so option A is correct. Unlike Windows, Linux doesn\u2019t assign drive letters to storage devices, so option B is incorrect. The <code>/dev</code> files are used as raw devices for storage devices; they don\u2019t access the filesystem, so option C is incorrect. The <code>/proc</code> and <code>/sys</code> folders are used by the kernel to display and change storage device information, not to add the filesystem to the virtual directory, so options D and E are incorrect.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      162,
      167,
      342,
      164,
      165
    ],
    "source": "316328_c11",
    "choice_e": "<code>/sys</code> folder"
  },
  {
    "id": 364,
    "question": "What filesystem is the latest version of the first Linux filesystem?",
    "choice_a": "reiserFS",
    "choice_b": "btrfs",
    "choice_c": "ext3",
    "choice_d": "ext4",
    "correct_answer": "D",
    "explanation": "The ext filesystem was the original filesystem used in Linux, and ext4 is the latest version of it, so option D is correct and option C is incorrect. The reiserFS and btrfs filesystems are specialty filesystems created separately from the ext filesystem, so options A and B are also incorrect. The nfs filesystem was created to allow sharing files and folders across networks and wasn\u2019t the original Linux filesystem, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      164,
      169,
      166,
      212,
      1
    ],
    "source": "316328_c11",
    "choice_e": "nfs"
  },
  {
    "id": 365,
    "question": "What tool do you use to create a new filesystem on a partition?",
    "choice_a": "<code>fdisk</code>",
    "choice_b": "<code>mkfs</code>",
    "choice_c": "<code>fsck</code>",
    "choice_d": "<code>gdisk</code>",
    "correct_answer": "B",
    "explanation": "The <code>mkfs</code> program allows you to create a new filesystem on a partition, so option B is correct. The <code>fdisk</code>, <code>gdisk</code>, and <code>parted</code> programs are used to create or modify partitions but not to work with the filesystem installed on them, so options A, D, and E are all incorrect. The <code>fsck</code> program repairs filesystems but can\u2019t create them, so option C is incorrect.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      166,
      164,
      161,
      167,
      169
    ],
    "source": "316328_c11",
    "choice_e": "<code>parted</code>"
  },
  {
    "id": 366,
    "question": "What tool do you use to manually add a filesystem to the virtual directory?",
    "choice_a": "<code>fsck</code>",
    "choice_b": "<code>mount</code>",
    "choice_c": "<code>umount</code>",
    "choice_d": "<code>fdisk</code>",
    "correct_answer": "B",
    "explanation": "The <code>mount</code> program allows you to insert the filesystem on a partition into the virtual directory, so option B is correct. The <code>fsck</code> program repairs filesystems but doesn\u2019t insert them into the virtual directory, so option A is incorrect. The <code>umount</code> program removes filesystems from the virtual directory, as opposed to inserting them, so option C is incorrect. The <code>fdisk</code> program partitions devices but doesn\u2019t create filesystems or insert them into the virtual directory, so option D is incorrect. The <code>mkfs</code> program creates filesystems but doesn\u2019t insert them into the virtual directory, so option E is also incorrect.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      167,
      162,
      166,
      164,
      165
    ],
    "source": "316328_c11",
    "choice_e": "<code>mkfs</code>"
  },
  {
    "id": 367,
    "question": "The ___________ program is a handy tool for repairing corrupted filesystems.",
    "choice_a": "<code>fsck</code>",
    "choice_b": "<code>mount</code>",
    "choice_c": "<code>umount</code>",
    "choice_d": "<code>fdisk</code>",
    "correct_answer": "A",
    "explanation": "The <code>fsck</code> program repairs corrupt filesystems, so option A is correct. The <code>mount</code> program inserts filesystems into the virtual directory, but it can\u2019t repair them, so option B is incorrect. The <code>umount</code> program removes filesystems from the virtual directory but can\u2019t repair them, so option C is also incorrect. The <code>fdisk</code> program creates and modifies partitions but doesn\u2019t work with filesystems, so option D is incorrect. The <code>mkfs</code> program creates filesystems but doesn\u2019t repair them, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      85,
      169,
      170,
      167,
      166
    ],
    "source": "316328_c11",
    "choice_e": "<code>mkfs</code>"
  },
  {
    "id": 368,
    "question": "Time and space to generate archives is not an issue, and your system\u2019s environment is not a high I/O one. You want to create full backups for your system only once per week and need to restore data as quickly as possible. Which backup type plan should you use?",
    "choice_a": "Full archive daily",
    "choice_b": "Incremental archive daily",
    "choice_c": "Differential archive daily",
    "choice_d": "Full archive weekly; incremental daily",
    "correct_answer": "E",
    "explanation": "Scheduling a full archive weekly and implementing a differential backup daily (which backs up all the data that is new or modified since the last full archive) will meet the requirements. Therefore, option E is the correct answer. Since you only want to create a full backup one time per week, option A is a wrong answer. Doing an incremental every day without a periodic full archive would result in a long time period to restore data. So option B does not match the requirements and is an incorrect choice. Doing a differential archive daily also does not fully match the requirements, because you are not conducting a full archive weekly. Thus, option C is a wrong answer. Option D is not as time efficient for a data restore as option E, because you would have to apply each incremental to restore data instead of one differential archive. Therefore, option D is also an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      177,
      176,
      193,
      188,
      191
    ],
    "source": "316328_c12",
    "choice_e": "Full archive weekly; differential daily"
  },
  {
    "id": 369,
    "question": "The system admin took an archive file and applied a compression utility to it. The resulting file extension is <code>.gz</code>. Which compression utility was used?",
    "choice_a": "The <code>xz</code> utility",
    "choice_b": "The <code>gzip</code> utility",
    "choice_c": "The <code>bzip2</code> utility",
    "choice_d": "The <code>zip</code> utility",
    "correct_answer": "B",
    "explanation": "The <code>gzip</code> utility compresses data files and gives them the <code>.gz</code> file extension. Therefore, option B is the correct answer. The <code>xz</code>, <code>bzip2</code>, and <code>zip</code> compression utilities compress a data file and give it a different file extension, so options A, C, and D are wrong answers. The <code>dd</code> utility is not a compression program. Therefore, option E is also a wrong choice.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      181,
      186,
      182,
      183,
      184
    ],
    "source": "316328_c12",
    "choice_e": "The <code>dd</code> utility"
  },
  {
    "id": 370,
    "question": "You need to quickly create a special archive. This archive will be a single compressed file, which contains any <code>.snar</code> files across the virtual directory structure. Which archive utility should you use?",
    "choice_a": "The <code>tar</code> utility",
    "choice_b": "The <code>dd</code> utility",
    "choice_c": "The <code>rsync</code> utility",
    "choice_d": "The <code>cpio</code> utility",
    "correct_answer": "D",
    "explanation": "To quickly create an archive of disparate files around the virtual directory structure, the best utility to use is the <code>cpio</code> program. This is because you can employ the <code>find</code> command to locate the files and then pipe the results into the <code>cpio</code> utility. Therefore, option D is the correct answer. While the <code>tar</code> utility uses <code>.snar</code> files, it is not the most efficient program to use in this scenario, and thus, option A is a wrong answer. The <code>dd</code> utility is used for entire disks or partitions, and therefore, option B is an incorrect answer. The <code>rsync</code> and <code>zip</code> programs are not the most efficient utilities to use in this scenario, so options C and E are also incorrect choices.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      191,
      187,
      63,
      162,
      193
    ],
    "source": "316328_c12",
    "choice_e": "The <code>zip</code> utility"
  },
  {
    "id": 371,
    "question": "An administrator needs to create a full backup using the <code>tar</code> utility, compress it as much as possible, and view the files as they are being copied into the archive. What <code>tar</code> options should the admin employ?",
    "choice_a": "<code>-xzvf</code>",
    "choice_b": "<code>-xJvf</code>",
    "choice_c": "<code>-czvf</code>",
    "choice_d": "<code>-cJf</code>",
    "correct_answer": "E",
    "explanation": "The <code>tar</code> options <code>-cJvf</code> will create a tarball using the highest compression utility, <code>xz</code>, and allow the administrator to view the files via the verbose option while they are being copied into the compressed archive. Thus, option E is the correct answer. The switches in options A and B perform extracts (<code>-x</code>) and do not create, so they are wrong answers. The only thing wrong with option C is that it employs <code>gzip</code> compression via the <code>-z</code> switch, so it is an incorrect choice. Option D leaves out the verbose switch, so it too is an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      188,
      182,
      184,
      185,
      193
    ],
    "source": "316328_c12",
    "choice_e": "<code>-cJvf</code>"
  },
  {
    "id": 372,
    "question": "You need to create a low-level backup of all the data on the <code>/dev/sdc</code> drive and want to use the <code>/dev/sde</code> drive to store it on. Which <code>dd</code> command should you use?",
    "choice_a": "<code>dd of=/dev/sde if=/dev/sdc</code>",
    "choice_b": "<code>dd of=/dev/sdc if=/dev/sde</code>",
    "choice_c": "<code>dd of=/dev/sde if=/dev/sdc count=5</code>",
    "choice_d": "<code>dd if=/dev/sde of=/dev/sdc count=5</code>",
    "correct_answer": "A",
    "explanation": "The <code>dd</code> command in option A will accomplish the job correctly. Therefore, it is the correct answer. The <code>dd</code> commands in options B through D have the input and output files flip-flopped, so they would destroy the data on the <code>/dev/sdc</code> drive. Therefore, options B, C, and D are wrong answers. The <code>dd</code> command in option E would wipe the <code>/dev/sdc</code> drive using zeros. Therefore, option E is also an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      184,
      197,
      66,
      156,
      157
    ],
    "source": "316328_c12",
    "choice_e": "<code>dd if=/dev/zero of=/dev/sdc</code>"
  },
  {
    "id": 373,
    "question": "You need to create a backup of a user directory tree. You want to ensure that all the file metadata is retained. Employing super user privileges, which of the following should you use with the <code>rsync</code> utility?",
    "choice_a": "The <code>-r</code> option",
    "choice_b": "The <code>-z</code> option",
    "choice_c": "The <code>-a</code> option",
    "choice_d": "The <code>-e</code> option",
    "correct_answer": "C",
    "explanation": "The <code>-a</code> switch allows you to recursively back up a directory tree and preserves all the file metadata. It is equivalent to using the <code>-rlptgoD</code> switches. Therefore, option C is the correct answer. The <code>-r</code> switch only allows recursive operations but does not preserve metadata, such as file ownership. Therefore, option A is a wrong answer. The <code>-z</code> switch employs compression and nothing else, so option B is a wrong choice. The <code>-e</code> and <code>--rsh</code> switches are used to designate a remote program to use when sending files to a remote system. Thus, options D and E are also incorrect choices.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      190,
      184,
      185,
      198,
      199
    ],
    "source": "316328_c12",
    "choice_e": "The <code>--rsh</code> option"
  },
  {
    "id": 374,
    "question": "You decide to compress the archive you are creating with the <code>rsync</code> utility and employ the <code>-z</code> option. Which compression method are you using?",
    "choice_a": "<code>compress</code>",
    "choice_b": "<code>gzip</code>",
    "choice_c": "<code>bzip2</code>",
    "choice_d": "<code>xz</code>",
    "correct_answer": "E",
    "explanation": "When you use the <code>-z</code> switch in conjunction with the <code>rsync</code> utility, you are employing compression from the <code>zlib</code> library. Therefore, option E is correct. And thus, options A, B, C, and D are incorrect choices.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      190,
      181,
      186,
      188,
      194
    ],
    "source": "316328_c12",
    "choice_e": "<code>zlib</code>"
  },
  {
    "id": 375,
    "question": "Which of the following is true concerning the <code>scp</code> utility? (Choose all that apply.)",
    "choice_a": "Well suited for quickly transferring files between two systems on a network",
    "choice_b": "Is faster than the <code>sftp</code> utility",
    "choice_c": "An interactive utility useful for quickly transferring large files",
    "choice_d": "Can be interrupted during file transfers with no ill effects",
    "correct_answer": [
      "A",
      "B",
      "E"
    ],
    "explanation": "Options A, B, and E are all true statements regarding the <code>scp</code> utility and therefore are correct answers. The <code>scp</code> program is not an interactive utility, and thus, option C is a wrong answer. Also, the <code>scp</code> utility cannot be interrupted without ill effects (you have to start all over), so option D is also an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      196,
      191,
      129,
      127,
      59
    ],
    "source": "316328_c12",
    "choice_e": "Uses OpenSSH for file transfers"
  },
  {
    "id": 376,
    "question": "You are transferring files for a local backup using the <code>sftp</code> utility to a remote system and the process gets interrupted. What <code>sftp</code> utility command should you use next?",
    "choice_a": "The <code>progress</code> command",
    "choice_b": "The <code>get</code> command",
    "choice_c": "The <code>reget</code> command",
    "choice_d": "The <code>put</code> command",
    "correct_answer": "E",
    "explanation": "The <code>reput</code> command will resume your interrupted operation of uploading a local backup to a remote system. Therefore, option E is the correct answer. The <code>progress</code> command toggles on and off the progress display, so option A is a wrong answer. The <code>get</code> command and the <code>reget</code> command involve downloading a file from a remote system to a local system. Thus, options B and C are wrong choices. Though the <code>put</code> command was probably used prior to the operation\u2019s start, it will not resume an upload, so option D is also an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      196,
      191,
      190,
      177,
      197
    ],
    "source": "316328_c12",
    "choice_e": "The <code>reput</code> command"
  },
  {
    "id": 377,
    "question": "You have completed a full archive and sent it to a remote system using the <code>sftp</code> utility. You employ the <code>md5sum</code> program on both the local archive and its remote copy. The numbers don\u2019t match. What most likely is the cause of this?",
    "choice_a": "The local archive was corrupted when it was created.",
    "choice_b": "The archive was corrupted when it was transferred.",
    "choice_c": "You used incorrect commands within the <code>sftp</code> utility.",
    "choice_d": "The numbers only match if corruption occurred.",
    "correct_answer": "B",
    "explanation": "In this scenario, the most likely cause is that the archive got corrupted when it was transferred to the remote system. Therefore, option B is correct. If the local archive was corrupted when it was created, transferring would either corrupt it more or leave it the same. Therefore, option A is a wrong answer. Using incorrect commands within the <code>sftp</code> utility or wrong switches on the <code>md5sum</code> program will not typically cause corruption. Therefore, options C and E are wrong choices. The numbers only match if corruption has not occurred, and thus, option D is also an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      184,
      192,
      194,
      190,
      197
    ],
    "source": "316328_c12",
    "choice_e": "You used incorrect utility switches on <code>md5sum</code>."
  },
  {
    "id": 378,
    "question": "Which two programs should you use to download tarballs from an application\u2019s website? (Choose two.)",
    "choice_a": "wget",
    "choice_b": "cURL",
    "choice_c": "<code>dpkg</code>",
    "choice_d": "<code>rpm</code>",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "When developers distribute their applications as source code tarballs using the <code>tar</code> and <code>gzip</code> utilities, you often need to download the file from a website. The wget and cURL programs allow you to download files from the command line, so options A and B are correct. The <code>dpkg</code> tool is used for installing <code>.deb</code> package files, not tarballs, so option C is incorrect. The <code>rpm</code> and yum tools are used for installing <code>.rpm</code> package files, so options D and E are incorrect.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      200,
      201,
      204,
      205,
      206
    ],
    "source": "316328_c13",
    "choice_e": "yum"
  },
  {
    "id": 379,
    "question": "Fred received an application in source code format. What script should he run to create the executable application program?",
    "choice_a": "<code>dpkg</code>",
    "choice_b": "<code>rpm</code>",
    "choice_c": "<code>yum</code>",
    "choice_d": "<code>make</code>",
    "correct_answer": "D",
    "explanation": "The <code>make</code> script runs the necessary compiler steps to compile all of the source code and library files necessary to build the application executable file, so option D is correct. The <code>dpkg</code> tool installs <code>.deb</code> package files, not source code files, so option A is incorrect. The <code>rpm</code> and <code>yum</code> tools are used to install <code>.rpm</code> package files, so options B and C are incorrect. The <code>wget</code> program is used to download source code bundles, but not build them, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      201,
      206,
      205,
      200,
      203
    ],
    "source": "316328_c13",
    "choice_e": "<code>wget</code>"
  },
  {
    "id": 380,
    "question": "Sherri is trying to compile an application from source code. Before she can create the application executable file, what script should she run to create the <code>make</code> script?",
    "choice_a": "<code>make</code>",
    "choice_b": "<code>make install</code>",
    "choice_c": "<code>configure</code>",
    "choice_d": "<code>gcc</code>",
    "correct_answer": "C",
    "explanation": "The <code>configure</code> tool assesses your Linux system to ensure that any dependencies are met and that the proper compiler tools are installed and then builds the <code>make</code> script, so option C is correct. The <code>make</code> script along with the <code>install</code> option runs the <code>make</code> script but doesn\u2019t create it, so options A and B are incorrect. The <code>gcc</code> program compiles the source code and library files but doesn\u2019t create the <code>make</code> script, so option D is incorrect. The <code>dpkg</code> installs <code>.deb</code> package files but doesn\u2019t create a <code>make</code> script, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      201,
      202,
      203,
      200,
      208
    ],
    "source": "316328_c13",
    "choice_e": "<code>dpkg</code>"
  },
  {
    "id": 381,
    "question": "What is the most common compiler used for open source Linux applications?",
    "choice_a": "<code>gcc</code>",
    "choice_b": "<code>make</code>",
    "choice_c": "<code>configure</code>",
    "choice_d": "<code>dpkg</code>",
    "correct_answer": "A",
    "explanation": "The GNU Compiler Collection (<code>gcc</code>) is the most popular compiler used in Linux, so option A is correct. The <code>make</code> utility runs make scripts to help build applications using <code>gcc</code>, but it doesn\u2019t compile the source code directly, so option B is incorrect. The <code>configure</code> utility helps build the <code>make</code> script based on the location of the compiler program, but doesn\u2019t compile the source code, so option C is incorrect. The <code>dpkg</code> and <code>rpm</code> programs are package tools for installing <code>.deb</code> and <code>.rpm</code> package files, respectively, and aren\u2019t used to compile source code files, so options D and E are both incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      201,
      204,
      205,
      206,
      211
    ],
    "source": "316328_c13",
    "choice_e": "<code>rpm</code>"
  },
  {
    "id": 382,
    "question": "Harry has finished writing his application source code but needs to package it for distribution. What tool should he use so that it can be extracted in any Linux distribution?",
    "choice_a": "<code>dpkg</code>",
    "choice_b": "<code>rpm</code>",
    "choice_c": "<code>yum</code>",
    "choice_d": "<code>apt-get</code>",
    "correct_answer": "E",
    "explanation": "The tape archive, <code>tar</code>, application is often used for bundling source code projects into a single distributable file, so option E is correct. The <code>dpkg</code>, <code>rpm</code>, <code>yum</code>, and <code>apt-get</code> programs all work with package management files, not for archiving source code files, so options A, B, C, and D are all incorrect.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      201,
      203,
      204,
      205,
      206
    ],
    "source": "316328_c13",
    "choice_e": "<code>tar</code>"
  },
  {
    "id": 383,
    "question": "What <code>tar</code> command-line options are commonly used together to extract and decompress files from a tarball file?",
    "choice_a": "<code>-Uvh</code>",
    "choice_b": "<code>-zxvf</code>",
    "choice_c": "<code>-xvf</code>",
    "choice_d": "<code>-zcvf</code>",
    "correct_answer": "B",
    "explanation": "The <code>-zxvf</code> command-line options for the <code>tar</code> program are commonly used to decompress and extract files from a tarball file, so option B is correct. The <code>-Uvh</code> option group is commonly used for the <code>rpm</code> program to install packages, but it\u2019s not valid for the <code>tar</code> program, so option A is incorrect. The <code>-xvf</code> command-line option combination extracts files from a tarball but doesn\u2019t decompress them, so option C is incorrect. The <code>-zcvf</code> option group will create a new tarball and compress it, not extract and decompress the files, so option D is incorrect. The <code>-cvf</code> option group creates a new tarball file, but it doesn\u2019t extract files from an existing file, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      54,
      147,
      146,
      143,
      148
    ],
    "source": "316328_c13",
    "choice_e": "<code>-cvf</code>"
  },
  {
    "id": 384,
    "question": "What filename extension does the Rocky Linux distribution use for packages?",
    "choice_a": "<code>.deb</code>",
    "choice_b": "<code>.rpm</code>",
    "choice_c": "<code>.tgz</code>",
    "choice_d": "<code>.tar</code>",
    "correct_answer": "B",
    "explanation": "The Rocky Linux distribution uses the Red Hat package management system, which uses <code>.rpm</code> files, so option B is correct. The <code>.deb</code> filename extension is used to identify Debian-based package management files, so option A is incorrect. The <code>.tgz</code> filename extension is used to identify compressed tar archive files, so option C is incorrect. The <code>.tar</code> filename extension is used to identify tar archive files, so option D is incorrect, and the <code>.gz</code> filename extension is used to identify files compressed with the <code>gzip</code> utility, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      206,
      211,
      204,
      205,
      207
    ],
    "source": "316328_c13",
    "choice_e": "<code>.gz</code>"
  },
  {
    "id": 385,
    "question": "Sally needs to install a new package on her Ubuntu Linux system. The package was distributed as a <code>.deb</code> file. What tool should she use?",
    "choice_a": "<code>rpm</code>",
    "choice_b": "<code>yum</code>",
    "choice_c": "<code>dnf</code>",
    "choice_d": "<code>dpkg</code>",
    "correct_answer": "D",
    "explanation": "The <code>dpkg</code> program is used to install <code>.deb</code> package files on Debian-based systems, so option D is correct. The <code>rpm</code>, <code>yum</code>, and <code>dnf</code> programs are all tools used for Red Hat\u2013based package management systems, not Debian-based systems, so options A, B, and C are all incorrect. The <code>tar</code> program is used for creating and extracting tarball archive files, not <code>.deb</code> files, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      205,
      206,
      204,
      211,
      207
    ],
    "source": "316328_c13",
    "choice_e": "<code>tar</code>"
  },
  {
    "id": 386,
    "question": "What tools do you use to install packages from a Red Hat\u2013based repository? (Choose two.)",
    "choice_a": "<code>dpkg</code>",
    "choice_b": "<code>tar</code>",
    "choice_c": "<code>yum</code>",
    "choice_d": "<code>apt-get</code>",
    "correct_answer": [
      "C",
      "E"
    ],
    "explanation": "The <code>yum</code> and <code>dnf</code> programs are used to install <code>.rpm</code> packages from Red Hat\u2013based repositories, so options C and E are correct. The <code>dpkg</code> and <code>apt-get</code> programs are used for installing <code>.deb</code> files on Debian-based package management systems, so options A and D are incorrect. The <code>tar</code> program is used for creating and extracting archive files, so option B is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      206,
      211,
      207,
      205,
      204
    ],
    "source": "316328_c13",
    "choice_e": "<code>dnf</code>"
  },
  {
    "id": 387,
    "question": "What application container format do Red Hat\u2013based Linux distributions utilize for installing applications?",
    "choice_a": "flatpak",
    "choice_b": "<code>rpm</code>",
    "choice_c": "<code>dpkg</code>",
    "choice_d": "snap",
    "correct_answer": "A",
    "explanation": "Red Hat\u2013based Linux distributions use the flatpak application container format to install containers, making option A correct. The snap application container format is used in Ubuntu, but not Red Hat, so option D is incorrect. The <code>rpm</code> and <code>dpkg</code> formats are used in package management, not application containers, so options B and C are incorrect. The <code>gcc</code> program is used for compiling source code into executable programs, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      210,
      208,
      211,
      206,
      433
    ],
    "source": "316328_c13",
    "choice_e": "<code>gcc</code>"
  },
  {
    "id": 388,
    "question": "Which of the following is true concerning a kernel module? (Choose all that apply.)",
    "choice_a": "It is a self-contained driver library file.",
    "choice_b": "It is compiled into the Linux kernel.",
    "choice_c": "It allows the addition of functionality when required.",
    "choice_d": "It can be loaded when needed.",
    "correct_answer": [
      "A",
      "C",
      "D",
      "E"
    ],
    "explanation": "A kernel module is a self-contained driver library file, which is not precompiled into the Linux kernel. It can be loaded and unloaded as needed, which provides additional functionality when required. These kernel modules keep the Linux kernel lighter and more agile. Therefore, options A, C, D, and E are all correct answers. The only incorrect answer is option B, and it is wrong because kernel modules are not compiled into the kernel.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      212,
      213,
      216,
      218,
      215
    ],
    "source": "316328_c14",
    "choice_e": "It keeps the Linux kernel lighter and more agile."
  },
  {
    "id": 389,
    "question": "Where are module files stored? (Choose all that apply.)",
    "choice_a": "A <code>/lib/modules/kernel/</code> subdirectory",
    "choice_b": "A <code>/lib/modules/<i>KernelVersion</i>/</code> subdirectory",
    "choice_c": "A <code>/usr/lib/modules/kernel/</code> subdirectory",
    "choice_d": "A <code>/usr/lib/modules/<i>KernelVersion</i>/</code> subdirectory",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Kernel modules files, depending on the distribution, can be stored in a subdirectory of <code>/lib/modules/<i>KernelVersion</i>/</code> or <code>/usr/lib/modules/<i>KernelVersion</i>/</code>. If the <code>/usr/lib/modules/<i>KernelVersion</i>/</code> directory is used, it typically is hard-linked to the <code>/lib/modules/KernelVersion/</code> directory. Therefore, options B and D are correct answers. The other directory names are made up. Thus, options A, C, and E are incorrect choices.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      213,
      216,
      215,
      212,
      162
    ],
    "source": "316328_c14",
    "choice_e": "A <code>/lib/kernel/modules</code> subdirectory"
  },
  {
    "id": 390,
    "question": "Where can a module\u2019s configuration information be stored? (Choose all that apply.)",
    "choice_a": "The <code>/etc/modules.conf</code> file",
    "choice_b": "The <code>/etc/modprobe.d/*.conf</code> files",
    "choice_c": "The <code>/etc/modules.d/*.conf</code> files",
    "choice_d": "The <code>/lib/modprobe.d/*.conf</code> files",
    "correct_answer": [
      "A",
      "B",
      "D",
      "E"
    ],
    "explanation": "Older Linux distributions store module configuration information in a single configuration file, <code>/etc/modules.conf</code>. On more modern distributions, configuration information is stored in <code>*.conf</code> files within the <code>/etc/modprobe.d/</code>, <code>/lib/modprobe.d/</code>, <code>/usr/lib/modprobe.d/</code>, and <code>run/modprobe.d/</code> directories. Therefore, options A, B, D, and E are all correct answers. The <code>/etc/modules.d/</code> directory is made up, and thus option C is an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      213,
      215,
      212,
      162,
      167
    ],
    "source": "316328_c14",
    "choice_e": "The <code>/usr/lib/modprobe.d/*.conf</code> files"
  },
  {
    "id": 391,
    "question": "You need to determine the dependencies of the unloaded <code>xyz</code> module. Which is the best utility to employ to accomplish this task?",
    "choice_a": "<code>dmesg</code>",
    "choice_b": "<code>insmod</code>",
    "choice_c": "<code>lsmod</code>",
    "choice_d": "<code>modprobe</code>",
    "correct_answer": "E",
    "explanation": "The <code>modinfo</code> utility will allow you to view detailed information concerning a module passed as a command argument. This detailed information includes any dependencies. Therefore, option E is the correct answer. The <code>dmesg</code> command is helpful for viewing any kernel messages concerning module failures but does not display module dependency information. Thus, option A is a wrong answer. The <code>insmod</code> utility is used for loading modules dynamically, and therefore, option B is a wrong choice. The <code>lsmod</code> command displays currently loaded modules. While it does show other modules that are currently using the module, because it does not list dependencies nor show information for unloaded modules, it is not the best choice. Thus, option C is also an incorrect answer. The <code>modprobe</code> utility is used for loading and unloading kernel modules, and therefore, it is not the best choice either. Thus, option D is an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      213,
      216,
      218,
      212,
      75
    ],
    "source": "316328_c14",
    "choice_e": "<code>modinfo</code>"
  },
  {
    "id": 392,
    "question": "You need to install the <code>xyz</code> module, including all its needed dependencies. Which of the following utilities should you use?",
    "choice_a": "<code>insmod</code>",
    "choice_b": "<code>modinfo</code>",
    "choice_c": "<code>modprobe</code>",
    "choice_d": "<code>lsmod</code>",
    "correct_answer": "C",
    "explanation": "The <code>modprobe</code> utility will dynamically load the <code>xyz</code> utility, if you pass it as an argument to the command, and also load any of its needed dependencies. Therefore, option C is the correct answer. The <code>insmod</code> utility is used for loading modules dynamically. However, it will not load any of the module\u2019s dependencies, and therefore, option A is an incorrect choice. The <code>modinfo</code> utility allows you to view detailed information concerning a module passed as a command argument, but it does not load modules. Therefore, option B is a wrong answer. The <code>lsmod</code> command displays currently loaded modules, and thus option D is an incorrect answer. The <code>depmod</code> command is used for scanning through the system in order to update the <code>modules.dep</code> file. Therefore, option E is also an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      216,
      218,
      212,
      213,
      350
    ],
    "source": "316328_c14",
    "choice_e": "<code>depmod</code>"
  },
  {
    "id": 393,
    "question": "When you install a USB device on a Linux system, it appears that the device is not being detected. Which of the following is the best command to troubleshoot this particular situation?",
    "choice_a": "<code>lsmod</code>",
    "choice_b": "<code>modinfo</code>",
    "choice_c": "<code>dmesg</code>",
    "choice_d": "<code>depmod</code>",
    "correct_answer": "D",
    "explanation": "The Linux system typically will automatically detect new hardware and load any needed modules. The <code>depmod</code> command will scan through the system looking for any hardware that was not automatically detected. It determines any needed modules, reviews the modules\u2019 dependencies, and updates the appropriate file. Therefore, option D is the correct answer. The <code>lsmod</code> command displays currently loaded modules, and thus option A is an incorrect answer. The <code>modinfo</code> utility allows you to view detailed information concerning a module passed as a command argument. However, if you don\u2019t know the device\u2019s associated module, this utility is of little use. Therefore, option B is a wrong choice. The <code>dmesg</code> command is helpful for viewing any kernel messages concerning module failures, so if it is a module failure issue, you can view it using this command. However, since the device was not detected, it is not the best command to start the troubleshooting process. Therefore, option C is a wrong answer. The <code>insmod</code> utility is used for loading modules dynamically, and therefore, option E is an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      350,
      344,
      212,
      216,
      75
    ],
    "source": "316328_c14",
    "choice_e": "<code>insmod</code>"
  },
  {
    "id": 394,
    "question": "The <code>modprobe</code> utility uses the _____ file to determine any module dependencies.",
    "choice_a": "<code>modules.dep</code>",
    "choice_b": "<code>/lib/modules</code>",
    "choice_c": "<code>/usr/lib/modules</code>",
    "choice_d": "<code>/etc/modprobe.d</code>",
    "correct_answer": "A",
    "explanation": "The <code>modprobe</code> utility uses the <code>modules.dep</code> file to determine any module dependencies. Therefore, option A is the correct answer. The other options contain directories involved in the kernel module management, and thus options B, C, D, and E are wrong choices.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      216,
      213,
      218,
      344,
      350
    ],
    "source": "316328_c14",
    "choice_e": "<code>/lib/modprobe.d</code>"
  },
  {
    "id": 395,
    "question": "You need to insert the <code>abc</code> module into the Linux kernel. This module does not have any dependencies. What is the best utility to use?",
    "choice_a": "<code>lsmod</code>",
    "choice_b": "<code>modinfo</code>",
    "choice_c": "<code>dmesg</code>",
    "choice_d": "<code>depmod</code>",
    "correct_answer": "E",
    "explanation": "The <code>insmod</code> utility will allow you to quickly insert a module, whose name is passed as an argument to the command, into the Linux kernel. Therefore, option E is the correct answer. The <code>lsmod</code> command displays currently loaded modules, and thus option A is an incorrect answer. The <code>modinfo</code> utility allows you to view detailed information concerning a module passed as a command argument, but it does not load modules. Therefore, option B is a wrong answer. The <code>dmesg</code> utility displays the kernel\u2019s ring buffer but does not allow you to insert modules into it. Thus, option C is also a wrong choice. The <code>depmod</code> command is used for scanning through the system in order to update the <code>modules.dep</code> file. Therefore, option D is also an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      216,
      218,
      212,
      213,
      215
    ],
    "source": "316328_c14",
    "choice_e": "<code>insmod</code>"
  },
  {
    "id": 396,
    "question": "You need to unload the <code>abc</code> module from the Linux kernel. This module does not have any dependencies. What is the best utility to use?",
    "choice_a": "<code>insmod</code>",
    "choice_b": "<code>unload</code>",
    "choice_c": "<code>rmmod</code>",
    "choice_d": "<code>modprobe</code>",
    "correct_answer": "C",
    "explanation": "The <code>rmmod</code> command will quickly unload a module, but none of its dependencies, from the Linux kernel. Since the <code>abc</code> module does not have any dependencies, option C is the best answer. The <code>insmod</code> utility is used for loading (inserting) a module and not unloading one. Therefore, option A is a wrong answer. The <code>unload</code> command is made up, and thus option B is also an incorrect answer. The <code>modprobe</code> command used without any switches is for loading (inserting) modules, not unloading them. Thus, option D is a wrong choice. The <code>rm -f</code> command is used in removing files, not unloading modules. Therefore, option E is an incorrect answer.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      218,
      216,
      212,
      213,
      215
    ],
    "source": "316328_c14",
    "choice_e": "<code>rm -f</code>"
  },
  {
    "id": 397,
    "question": "You need to remove the <code>xyz</code> module and all of its dependencies. Which is the best command to employ?",
    "choice_a": "<code>dmesg</code>",
    "choice_b": "<code>modprobe -r</code>",
    "choice_c": "<code>lsmod</code>",
    "choice_d": "<code>paste</code>",
    "correct_answer": "B",
    "explanation": "The <code>modprobe -r</code> command will remove the module whose name is passed to it as an argument and any of its dependent modules. Therefore, option B is the best answer. The <code>dmesg</code> command is helpful for viewing kernel messages related to module failures but not for unloading modules. Thus, option A is a wrong answer. The <code>lsmod</code> utility shows brief module information for loaded modules but is not involved in the unlinking process. Therefore, option C is also an incorrect answer. The <code>paste</code> command allows you to sloppily put together two files side by side to STDOUT. However, it is not involved with kernel modules, so option D is also a wrong choice. The <code>groupdel</code> utility is used for removing user groups, and it also is not used with kernel modules. Therefore, option E is an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      218,
      216,
      213,
      212,
      75
    ],
    "source": "316328_c14",
    "choice_e": "<code>groupdel</code>"
  },
  {
    "id": 398,
    "question": "What permissions can be applied to a file or directory? (Choose three.)",
    "choice_a": "Read",
    "choice_b": "Write",
    "choice_c": "Delete",
    "choice_d": "Modify",
    "correct_answer": [
      "A",
      "B",
      "E"
    ],
    "explanation": "The basic Linux security permissions that you can set are read, write, and execute access, so options A, B, and E are correct. To delete a file a user must have write access because there is no delete access permission, so option C is incorrect. To modify a file a user must also have write access because there is no specific modify access permissions, so option D is incorrect.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      220,
      221,
      222,
      219,
      235
    ],
    "source": "316328_c15",
    "choice_e": "Execute"
  },
  {
    "id": 399,
    "question": "What user categories can be assigned permissions in Linux? (Choose three.)",
    "choice_a": "Root",
    "choice_b": "Owner",
    "choice_c": "Group",
    "choice_d": "Others",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "The three categories Linux uses for assigning permissions are the owner, the group, and all others on the system; thus answers B, C, and D are correct. The root user account already has full permissions on all files and folders, so it\u2019s not specified as a separate category, so option A is incorrect. Linux doesn\u2019t use a department category because departments must be defined as groups, so option E is also incorrect.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      219,
      220,
      223,
      229,
      230
    ],
    "source": "316328_c15",
    "choice_e": "Department"
  },
  {
    "id": 400,
    "question": "Sam needs to allow standard users to run an application with root privileges. What special permissions bit should she apply to the application file?",
    "choice_a": "The sticky bit",
    "choice_b": "The SUID bit",
    "choice_c": "The GUID bit",
    "choice_d": "Execute",
    "correct_answer": "B",
    "explanation": "The set user ID bit (SUID) allows all users to run applications as the root user account, so option B is correct. The sticky bit prevents users from deleting files for which they have group permissions but don\u2019t own. It doesn\u2019t allow users to run the file with root privileges, so option A is incorrect. The GUID bit directs Linux to set all files in a directory with the directory\u2019s group assignment and not that of the user account creating the file. However, it doesn\u2019t allow users to run files as the root user account, so option C is incorrect. The execute and write bits set those permissions for the standard category of users, groups, or others. They don\u2019t allow users to run files as the root user account, so both options D and E are incorrect.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      221,
      220,
      219,
      222,
      235
    ],
    "source": "316328_c15",
    "choice_e": "Write"
  },
  {
    "id": 401,
    "question": "What are the equivalent symbolic mode permissions for the octal mode value of 644?",
    "choice_a": "<code>rwxrw-r--</code>",
    "choice_b": "<code>-w--w--w-</code>",
    "choice_c": "<code>-w-r--r--</code>",
    "choice_d": "<code>rwxrw-rw-</code>",
    "correct_answer": "E",
    "explanation": "The octal mode permission 644 represents read/write for the owner and read only for the group and other categories. In symbolic mode that would be <code>rw-r--r--</code>, so option E is correct. Option A, <code>rwxrw-r--</code>, would be octal mode 764, so it is incorrect. Option B, <code>-w--w--w-</code>, would be octal mode 222, so it is incorrect. Option C, <code>-w-r--r--</code>, would be octal mode 244, so it is also incorrect. Option D, <code>rwxrw-rw-</code>, would be octal mode 766, so it too is incorrect.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      220,
      219,
      221,
      236,
      223
    ],
    "source": "316328_c15",
    "choice_e": "<code>rw-r--r\u2014</code>"
  },
  {
    "id": 402,
    "question": "Fred was assigned the task of creating a new group on the company Linux server and now needs to assign permissions for that group to files and directories. What Linux utility should he use to change the group assigned to the files and directories? (Choose all that apply.)",
    "choice_a": "<code>chgrp</code>",
    "choice_b": "<code>chown</code>",
    "choice_c": "<code>chmod</code>",
    "choice_d": "<code>chage</code>",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "The <code>chgrp</code> command is used to change the group assigned to a file or directory; however, you can also specify a new group with the <code>chown</code> command to change the owner and the group at the same time, so both options A and B are correct. The <code>chmod</code> command changes the permissions assigned to a file or directory but not the group, so option C is incorrect. The <code>chage</code> command is used to control the password of user accounts, not the group assigned to a file or directory, so option D is incorrect. The <code>ulimit</code> command is used to restrict the system resources a user account can use, not to set the group assignment of a file or directory, so option E is incorrect.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      219,
      220,
      236,
      221,
      223
    ],
    "source": "316328_c15",
    "choice_e": "<code>ulimit</code>"
  },
  {
    "id": 403,
    "question": "Sally needs to view the ACL permissions assigned to a file on her Linux server. What command should she use?",
    "choice_a": "<code>ls -Z</code>",
    "choice_b": "<code>ls -l</code>",
    "choice_c": "<code>getfacl</code>",
    "choice_d": "<code>chmod</code>",
    "correct_answer": "C",
    "explanation": "The <code>getfacl</code> command retrieves all of the ACL permissions assigned to a file or directory, so option C is correct. The <code>-Z</code> option added to the <code>ls</code> command displays SELinux context settings, not ACL permissions, so option A is incorrect. The <code>-l</code> option of the <code>ls</code> command displays the standard Linux file permissions, not the ACL permissions, so option B is incorrect. The <code>chmod</code> command allows you to change the standard permissions assigned to a file or directory, not display the ACL permissions, so option D is incorrect. The <code>setfacl</code> command allows you to change the ACL permissions for a file or directory, but not view them, so option E is incorrect.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      223,
      220,
      221,
      235,
      225
    ],
    "source": "316328_c15",
    "choice_e": "<code>setfacl</code>"
  },
  {
    "id": 404,
    "question": "What SELinux mode tracks policy violations but doesn\u2019t enforce them?",
    "choice_a": "Disabled",
    "choice_b": "Enforcing",
    "choice_c": "Targeted",
    "choice_d": "Permissive",
    "correct_answer": "D",
    "explanation": "The permissive mode in SELinux logs policy violations but doesn\u2019t prevent the action from happening, so option D is correct. The disabled mode allows all actions to happen but doesn\u2019t log them, so option A is incorrect. The enforcing mode logs policy violations and enforces them, so option B is incorrect. Options C and E, targeted and MLS, are not SELinux modes but rather define what types of daemons to monitor; they are both incorrect.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      225,
      226,
      367,
      228,
      231
    ],
    "source": "316328_c15",
    "choice_e": "MLS"
  },
  {
    "id": 405,
    "question": "Ted is tasked with documenting the SELinux security context assigned to a group of files in a directory. What command should he use?",
    "choice_a": "<code>getsebool</code>",
    "choice_b": "<code>setsebool</code>",
    "choice_c": "<code>ls -Z</code>",
    "choice_d": "<code>getenforce</code>",
    "correct_answer": "C",
    "explanation": "The <code>-Z</code> option of the <code>ls</code> command displays the SELinux security context assigned to a file or directory, so option C is correct. The <code>getsebool</code> command displays the current setting for a policy rule, not the security context of files, so option A is incorrect. The <code>setsebool</code> command enables or disables a policy rule, and it doesn\u2019t display the security context of a file, so option B is incorrect. The <code>getenforce</code> command displays the current SELinux mode, not the security context of files, so option D is incorrect. The <code>-l</code> option of the <code>ls</code> command displays the standard permissions assigned to a file, not the SELinux security context of the file, so option E is incorrect.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      225,
      226,
      367,
      228,
      220
    ],
    "source": "316328_c15",
    "choice_e": "<code>ls -l</code>"
  },
  {
    "id": 406,
    "question": "Mary is required to log into her Linux system as a standard user but needs to run an application with administrator privileges. What commands can she use to do that? (Choose all that apply.)",
    "choice_a": "<code>su</code>",
    "choice_b": "<code>wheel</code>",
    "choice_c": "<code>visudo</code>",
    "choice_d": "<code>sudo</code>",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "The <code>su</code> command allows you to run an application as another user, including the root user account, and the <code>sudo</code> command allows you to run an application as the root user account, so options A and D are both correct. Both <code>wheel</code> and <code>adm</code> are user groups that provide administrator privileges, but they aren\u2019t commands that run applications themselves, so options B and E are both incorrect. The <code>visudo</code> command opens an editor to edit the sudoers file so you can edit it, but it can\u2019t run other applications, so option C is incorrect.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      230,
      232,
      229,
      231,
      227
    ],
    "source": "316328_c15",
    "choice_e": "<code>adm</code>"
  },
  {
    "id": 407,
    "question": "What user groups are commonly used to assign privileges for group members to run applications as the administrator? (Choose two.)",
    "choice_a": "<code>lp</code>",
    "choice_b": "<code>adm</code>",
    "choice_c": "<code>wheel</code>",
    "choice_d": "<code>sudo</code>",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Red Hat\u2013based distributions use the <code>wheel</code> group and Debian-based distributions use the <code>sudo</code> group to allow members to gain administrator privileges on the system to run applications, so options C and D are correct. The <code>lp</code> group is used to grant access to system printers, not run applications with administrator privileges, so option A is incorrect. The <code>adm</code> group is commonly used in Debian-based systems to grant access to log files, but not run applications with administrator privileges, so option B is incorrect. Option E, <code>su</code>, is a command-line command for running commands as another user, not a user group, so it is incorrect.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      232,
      229,
      219,
      233,
      228
    ],
    "source": "316328_c15",
    "choice_e": "<code>su</code>"
  },
  {
    "id": 408,
    "question": "For an application to use PAM, it needs to be compiled with which PAM library?",
    "choice_a": "<code>ldd</code>",
    "choice_b": "<code>pam_nologin.so</code>",
    "choice_c": "<code>pam_unix.so</code>",
    "choice_d": "<code>libpam</code>",
    "correct_answer": "D",
    "explanation": "For an application to use PAM, it must be compiled with the <code>libpam</code> (also called <code>libpam.so</code>) library. Thus, option D is the correct answer. Option A lists the <code>ldd</code> command, which allows you to view modules compiled with various applications. Therefore, option A is a wrong answer. Options B, C, and E are all PAM modules, but none are the PAM library module needed to make an application PAM-aware. Therefore, options B, C, and E are incorrect choices.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      237,
      238,
      243,
      239,
      240
    ],
    "source": "316328_c16",
    "choice_e": "<code>pam_cracklib</code>"
  },
  {
    "id": 409,
    "question": "Which of the following are PAM control flags? (Choose all that apply.)",
    "choice_a": "<code>requisite</code>",
    "choice_b": "<code>required</code>",
    "choice_c": "<code>allowed</code>",
    "choice_d": "<code>sufficient</code>",
    "correct_answer": [
      "A",
      "B",
      "D",
      "E"
    ],
    "explanation": "<code>requisite</code>, <code>required</code>, <code>sufficient</code>, and <code>optional</code> are all PAM control flags you may find in a PAM <code>/etc/pam.d/</code> configuration file. Therefore, options A, B, D, and E are correct. Option C, <code>allowed</code>, is made up and thus an incorrect choice.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      238,
      237,
      239,
      240,
      242
    ],
    "source": "316328_c16",
    "choice_e": "<code>optional</code>"
  },
  {
    "id": 410,
    "question": "Which of the following will display failed login attempts? (Choose all that apply.)",
    "choice_a": "<code>tally2</code>",
    "choice_b": "<code>pam_tally2</code>",
    "choice_c": "<code>pam_tally2.so</code>",
    "choice_d": "<code>pam_faillock</code>",
    "correct_answer": [
      "B",
      "E"
    ],
    "explanation": "The <code>pam_tally2</code> and <code>faillock</code> commands display failed login attempts, and therefore options B and E are correct answers. The <code>tally2</code> command does not exist, and thus option A is a wrong answer. The <code>pam_tally2.so</code> module is involved with locking out accounts due to failed login attempts, but it does not display failed logins. Therefore, option C is a wrong choice. The <code>pam_faillock</code> is made up, and thus, option D is also an incorrect choice.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      240,
      238,
      243,
      242,
      287
    ],
    "source": "316328_c16",
    "choice_e": "<code>faillock</code>"
  },
  {
    "id": 411,
    "question": "Leigh encrypts a message with Luke\u2019s public key and then sends the message to Luke. After receiving the message, Luke decrypts the message with his private key. What does this describe? (Choose all that apply.)",
    "choice_a": "Symmetric key encryption",
    "choice_b": "Asymmetric key encryption",
    "choice_c": "Public/private key encryption",
    "choice_d": "Secret key encryption",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Asymmetric, or public/private, key encryption involves a message sender encrypting a message with the receiver\u2019s public key. When the receiver obtains the encrypted message, it is then decrypted using the receiver\u2019s private key. Therefore, options B and C are correct answers. Symmetric key encryption is also called secret or private key encryption. It involves the sender and receiver using the same secret key to encrypt and decrypt a message. Therefore, options A, D, and E are incorrect choices.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      244,
      248,
      247,
      245,
      299
    ],
    "source": "316328_c16",
    "choice_e": "Private key encryption"
  },
  {
    "id": 412,
    "question": "Which of the following best describes a digital signature?",
    "choice_a": "Plaintext that has been turned into ciphertext",
    "choice_b": "Ciphertext that has been turned into plaintext",
    "choice_c": "A framework that proves authenticity and validation of keys as well as the people or devices that use them",
    "choice_d": "A digital certificate that is not signed by a CA but by an end user",
    "correct_answer": "E",
    "explanation": "Option E best describes a digital signature and is therefore the correct answer. Option A describes encryption and is thus a wrong answer. Option B describes decryption and is also an incorrect choice. PKI is described in option C, and thus option C is a wrong answer. Option D describes a self-signed digital certificate, and therefore it is an incorrect choice as well.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      245,
      247,
      244,
      248,
      252
    ],
    "source": "316328_c16",
    "choice_e": "An original plaintext hash, which is encrypted with a private key and sent along with the cipher text"
  },
  {
    "id": 413,
    "question": "The OpenSSH application keeps track of any previously connected hosts and their public keys in what file?",
    "choice_a": "<code>~/.ssh/known_hosts</code>",
    "choice_b": "<code>~/.ssh/authorized_keys</code>",
    "choice_c": "<code>/etc/ssh/known_hosts</code>",
    "choice_d": "<code>/etc/ssh/authorized_keys</code>",
    "correct_answer": "A",
    "explanation": "The OpenSSH application keeps track of any previously connected hosts and their public keys in each user\u2019s <code>~/.ssh/known_hosts</code> file. Therefore, option A is the correct answer. The <code>~/.ssh/authorized_keys</code> file is used on an SSH server to keep track of authorized public keys used for password-less authentication. Therefore, option B is a wrong answer. Options C and D are made up and therefore incorrect choices. Option E is an RSA public key that could be created by the <code>ssh-keygen</code> utility, so it is a wrong choice as well.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      249,
      252,
      253,
      251,
      248
    ],
    "source": "316328_c16",
    "choice_e": "<code>/etc/ssh/ssh_host_rsa_key.pub</code>"
  },
  {
    "id": 414,
    "question": "Which of the following are OpenSSH configuration files? (Choose all that apply.)",
    "choice_a": "<code>~./ssh/config</code>",
    "choice_b": "<code>/etc/ssh/ssh_config</code>",
    "choice_c": "<code>/etc/ssh/sshd_config</code>",
    "choice_d": "<code>/etc/sshd/ssh_config</code>",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "The <code>~./ssh/config</code>, <code>/etc/ssh/ssh_config</code>, and <code>/etc/ssh/sshd_config</code> files are all OpenSSH configuration files. Therefore, options A, B, and C are correct choices. The files listed in options D and E are made up and therefore incorrect answers.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      251,
      255,
      249,
      248,
      238
    ],
    "source": "316328_c16",
    "choice_e": "<code>/etc/sshd/sshd_config</code>"
  },
  {
    "id": 415,
    "question": "Which of the following files may be involved in authenticating with SSH keys?",
    "choice_a": "<code>/etc/ssh/ssh_host_rsa_key</code>",
    "choice_b": "<code>/etc/ssh/ssh_host_rsa_key.pub</code>",
    "choice_c": "<code>~/.ssh/id_rsa_key</code>",
    "choice_d": "<code>~/.ssh/id_rsa_key.pub</code>",
    "correct_answer": "E",
    "explanation": "The only correct answer is option E. These identity keys are created with the file names of <code>id_ <i>type</i></code> for the private key and <code>id_ <i>type</i>.pub</code> for the public key. The key in option E is a private key using the RSA algorithm. Option A\u2019s key is an RSA private key used in establishing a password authenticated SSH connection, so it is a wrong answer. The key listed in option B is a public version of option A\u2019s key, so it too is a wrong choice. The keys listed in options C and D are made up, and thus they are wrong choices as well.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      252,
      253,
      248,
      249,
      251
    ],
    "source": "316328_c16",
    "choice_e": "<code>~/.ssh/id_rsa</code>"
  },
  {
    "id": 416,
    "question": "Which of the following is true concerning TCP Wrappers? (Choose all that apply.)",
    "choice_a": "The <code>/etc/hosts.allow</code> file is consulted first.",
    "choice_b": "The <code>/etc/hosts.allow</code> file should contain <code>ALL: ALL</code> to provide the best security.",
    "choice_c": "If an application is compiled with the <code>libwrap</code> library, it can employ TCP Wrappers.",
    "choice_d": "IP addresses of remote systems can be listed individually or as entire subnets.",
    "correct_answer": [
      "A",
      "C",
      "D",
      "E"
    ],
    "explanation": "Options A, C, D, and E are all true statements concerning TCP Wrappers and therefore are correct choices. You would never want to place <code>ALL: ALL</code> in the <code>/etc/hosts.allow</code> file because it would block everyone from accessing the service. Instead, you would want to place this record in the <code>/etc/hosts.deny</code> file to provide the best security because it is checked last. Therefore, option B is a wrong choice.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      296,
      255,
      289,
      237,
      243
    ],
    "source": "316328_c16",
    "choice_e": "TCP Wrappers are considered to be deprecated by many distributions and firewalls should be used instead."
  },
  {
    "id": 417,
    "question": "Which PAM library allows you to limit the number of login attempts to help guard against brute-force attacks?",
    "choice_a": "<code>pam_pwhistory.so</code>",
    "choice_b": "<code>pam_pwquality.so</code>",
    "choice_c": "<code>pam_tally2.so</code>",
    "choice_d": "<code>pam_unix.so</code>",
    "correct_answer": "C",
    "explanation": "The <code>pam_tally2.so</code> library allows you to set the number of login attempts before locking out the user account, helping to prevent brute-force attacks. This makes option C correct. The <code>pam_pwhistory.so</code> library prevents you from reusing passwords but doesn\u2019t limit the number of login attempts, making option A incorrect. The <code>pam_pwquality.so</code> library requires that you use mixed-case and special characters in your password, but it doesn\u2019t limit the number of login attempts, making option B incorrect. The <code>pam_unix.so</code> library uses the shadow password file but doesn\u2019t limit the number of login attempts, making option D incorrect. The <code>pam_cracklib.so</code> library is a legacy PAM library that only enforced strong passwords\u2014it didn\u2019t limit the number of login attempts, making option E incorrect.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      240,
      238,
      239,
      237,
      281
    ],
    "source": "316328_c16",
    "choice_e": "<code>pam_cracklib.so</code>"
  },
  {
    "id": 418,
    "question": "What protocol became a de facto standard in Linux for tracking system event messages?",
    "choice_a": "SMTP",
    "choice_b": "FTP",
    "choice_c": "NTP",
    "choice_d": "syslog",
    "correct_answer": "D",
    "explanation": "The syslog protocol created by the Sendmail project has become the de facto standard for logging system event messages in Linux, so option D is correct. SMTP is a mail protocol, and FTP is a file transfer protocol, so both options A and B are incorrect. NTP is a network time protocol, so option C is incorrect. Option E, <code>journalctl</code>, is a tool used to read <code>systemd-journald</code> journal files, not a protocol for logging event messages, so it is also incorrect.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      295,
      287,
      268,
      296,
      272
    ],
    "source": "316328_c17",
    "choice_e": "<code>journalctl</code>"
  },
  {
    "id": 419,
    "question": "Nancy wants to write a <code>rsyslogd</code> rule that separates event messages coming from the system job scheduler to a separate log file. Which syslog facility keyword should she use?",
    "choice_a": "<code>cron</code>",
    "choice_b": "<code>user</code>",
    "choice_c": "<code>kern</code>",
    "choice_d": "<code>console</code>",
    "correct_answer": "A",
    "explanation": "The <code>cron</code> application schedules jobs on Linux systems, so the <code>cron</code> facility keyword represents event messages received from the job scheduler, so option A is correct. The <code>user</code> keyword represents events received from users, so option B is incorrect. The <code>kern</code> keyword represents events received from the kernel, so option C is incorrect. The <code>console</code> keyword represents events received from a console on the system, so option D is incorrect. The <code>local0</code> keyword is not defined in the standard and is normally defined within the system, but it doesn\u2019t normally receive events from the job scheduler, so option E is incorrect.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      257,
      256,
      266,
      259,
      258
    ],
    "source": "316328_c17",
    "choice_e": "<code>local0</code>"
  },
  {
    "id": 420,
    "question": "What syslog severity level has the highest priority ranking in <code>rsyslogd</code>?",
    "choice_a": "<code>crit</code>",
    "choice_b": "<code>alert</code>",
    "choice_c": "<code>emerg</code>",
    "choice_d": "<code>notice</code>",
    "correct_answer": "C",
    "explanation": "The <code>emerg</code> severity level has a priority of 0, the highest level in syslog, so option C is correct. The <code>crit</code> severity level is at level 2, so it\u2019s not the highest level and therefore option A is incorrect. The <code>alert</code> keyword is assigned level 1, but it\u2019s not the highest level, so option B is incorrect. The <code>notice</code> keyword is assigned level 5 and is not the highest level, so option D is incorrect. The <code>err</code> keyword is assigned level 3 and is not the highest level, so option E is incorrect.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      268,
      277,
      292,
      297,
      270
    ],
    "source": "316328_c17",
    "choice_e": "<code>err</code>"
  },
  {
    "id": 421,
    "question": "What syslog severity level represents normal but significant condition messages?",
    "choice_a": "<code>crit</code>",
    "choice_b": "<code>notice</code>",
    "choice_c": "<code>info</code>",
    "choice_d": "<code>alert</code>",
    "correct_answer": "B",
    "explanation": "The <code>notice</code> severity level represents system event messages that are significant but normal, so option B is correct. The <code>crit</code> and <code>alert</code> keywords represent event messages that are critical or require special attention, so options A and D are incorrect. The <code>info</code> keyword represents event messages that are only informational but not significant, so option C is incorrect. The <code>local0</code> keyword is not defined in the syslog protocol but by the local system, so option E is incorrect.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      287,
      295,
      268,
      238,
      270
    ],
    "source": "316328_c17",
    "choice_e": "<code>local0</code>"
  },
  {
    "id": 422,
    "question": "What syslog application is known for its rocket-fast speed?",
    "choice_a": "<code>syslogd</code>",
    "choice_b": "<code>syslog-ng</code>",
    "choice_c": "<code>systemd-journald</code>",
    "choice_d": "<code>klogd</code>",
    "correct_answer": "E",
    "explanation": "The <code>rsyslogd</code> application was designed to be a faster version of the <code>syslogd</code> application, so option E is correct. The <code>syslogd</code> application is the original syslog application and was not known for its speed, so option A is incorrect. The <code>syslog-ng</code> application was designed to be more versatile than <code>syslogd</code>, but not faster, so option B is incorrect. The <code>systemd-journald</code> application is known for faster queries in reading journal entries but wasn\u2019t designed to be faster in handling event messages, so option C is incorrect. The <code>klogd</code> application is part of the original sysklogd application and is also not fast, so option D is incorrect.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      295,
      287,
      367,
      237,
      243
    ],
    "source": "316328_c17",
    "choice_e": "<code>rsyslogd</code>"
  },
  {
    "id": 423,
    "question": "What configuration file does the <code>rsyslogd</code> application use by default?",
    "choice_a": "<code>rsyslog.conf</code>",
    "choice_b": "<code>journald.conf</code>",
    "choice_c": "<code>syslogd.conf</code>",
    "choice_d": "<code>rsyslog.d</code>",
    "correct_answer": "A",
    "explanation": "The <code>rsyslogd</code> application uses the <code>rsyslog.conf</code> configuration file by default, so option A is correct. Option D, <code>rsyslog.d</code>, is commonly used as a folder for storing additional <code>rsyslogd</code> configuration files, but it isn\u2019t the default configuration filename, so it is incorrect. Options B and C are configuration files for other logging applications, not <code>rsyslogd</code>, so they are incorrect. Option E is not a valid logging application configuration filename.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      251,
      238,
      225,
      255,
      277
    ],
    "source": "316328_c17",
    "choice_e": "<code>syslog.d</code>"
  },
  {
    "id": 424,
    "question": "James needs to log all kernel messages that have a severity level of warning or higher to a separate log file. What facility and priority setting should he use?",
    "choice_a": "<code>kern.=warn</code>",
    "choice_b": "<code>kern.*</code>",
    "choice_c": "<code>*.info</code>",
    "choice_d": "<code>kern.warn</code>",
    "correct_answer": "D",
    "explanation": "The <code>rsyslogd</code> application priorities log event messages with the defined severity or higher, so option D would log all kernel event messages at the <code>warn</code>, <code>alert</code>, or <code>emerg</code> severities and therefore it is correct. The option A facility and priority setting would only log kernel messages with a severity of warning, so it is incorrect. Option B would log all kernel event messages, not just warnings or higher, so it is incorrect. Option C would log all facility type event messages but include the information or higher-level severity, so it is incorrect. Option E would log kernel event messages but only at the alert or emerg severity levels, not the warning level, so it is incorrect.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      257,
      256,
      259,
      266,
      258
    ],
    "source": "316328_c17",
    "choice_e": "<code>kern.alert</code>"
  },
  {
    "id": 425,
    "question": "Barbara wants to ensure that the journal log files will be saved after the next reboot of her Linux system. What <code>systemd-journald</code> configuration setting should she use?",
    "choice_a": "<code>Storage=auto</code>",
    "choice_b": "<code>Storage=persistent</code>",
    "choice_c": "<code>ForwardToSyslog=on</code>",
    "choice_d": "<code>Storage=volatile</code>",
    "correct_answer": "B",
    "explanation": "The <code>Storage</code> setting controls how <code>systemd-journald</code> manages the journal file. Setting the value to <code>persistent</code> ensures that the journal file will remain in the <code>/var/log/journal</code> directory, so option B is correct. Setting the value to <code>auto</code> only ensures that the journal file will be persistent if the <code>/var/log/journal</code> directory exists, so option A is incorrect. Setting the value to <code>volatile</code> ensures that the file does not persist, so option D is incorrect. Options C and E refer to settings that control whether or not event messages are passed to the <code>rsyslogd</code> application, so they are both incorrect.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      279,
      234,
      235,
      251,
      227
    ],
    "source": "316328_c17",
    "choice_e": "<code>ForardToSyslog=off</code>"
  },
  {
    "id": 426,
    "question": "Katie wants to display the most recent entries in the journal log on her Linux system. What <code>journalctl</code> option should she use?",
    "choice_a": "<code>-a</code>",
    "choice_b": "<code>-l</code>",
    "choice_c": "<code>-r</code>",
    "choice_d": "<code>-e</code>",
    "correct_answer": "C",
    "explanation": "The <code>-r</code> option displays the journal entries in reverse order, so the most recent entry will appear first. Thus, option C is correct. The <code>-a</code> option displays all of the data fields, but in the normal order, so option A is incorrect. The <code>-l</code> option displays all printable data fields, but in the normal order, so option B is incorrect. The <code>-e</code> option jumps to the end of the journal file but displays the remaining entries in normal order instead of reverse order, so option D is incorrect. The <code>-n</code> option displays a specified number of entries, but in normal order, so option E is incorrect.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      287,
      229,
      237,
      243,
      231
    ],
    "source": "316328_c17",
    "choice_e": "<code>-n</code>"
  },
  {
    "id": 427,
    "question": "Tony is trying to troubleshoot errors produced by an application on his Linux system but has to dig through lots of entries in the journal log file to find them. What <code>journalctl</code> match option would help him by only displaying journal entries related to the specific application?",
    "choice_a": "<code>OBJECT_PID</code>",
    "choice_b": "<code>Kernel</code>",
    "choice_c": "<code>_TRANSPORT</code>",
    "choice_d": "<code>_UID</code>",
    "correct_answer": "A",
    "explanation": "The <code>journalctl</code> application allows you to filter event messages related to a specific application by the application process ID (PID) using the <code>OBJECT_PID</code> match, so option A is correct. The <code>Kernel</code> match retrieves event messages generated by the system kernel and not applications, so option B is incorrect. The <code>_TRANSPORT</code> option filters event messages based on how they were received and not by application, so option C is incorrect. Option D, <code>_UID</code>, filters event messages based on the user ID value, not the application, so it is incorrect. Option E, <code>_UDEV</code>, filters events by device ID and not by application, so it too is incorrect.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      262,
      266,
      258,
      261,
      257
    ],
    "source": "316328_c17",
    "choice_e": "<code>_UDEV</code>"
  },
  {
    "id": 428,
    "question": "What SNMP feature allows a server to forward error messages to a remote collection server?",
    "choice_a": "Webhooks",
    "choice_b": "Traps",
    "choice_c": "API",
    "choice_d": "MIB",
    "correct_answer": "B",
    "explanation": "SNMP uses traps to capture server events and send them to a remote monitoring server, so option B is correct. Webhooks allow a remote program to connect and query the server using an application programming interface (API), often using the JSON file format, but they don\u2019t send error messages themselves, so options A, C, and E are all incorrect. The management information base (MIB) defines event codes in SNMP to monitor, but it doesn\u2019t forward them to remote servers, so option D is incorrect.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      264,
      256,
      257,
      259,
      261
    ],
    "source": "316328_c17",
    "choice_e": "JSON"
  },
  {
    "id": 429,
    "question": "Which of the following is true concerning firewalls on Linux that were covered in this chapter? (Choose all that apply.)",
    "choice_a": "They use ACLs for allowing packets.",
    "choice_b": "They detect malicious behavior.",
    "choice_c": "They inspect network packet control information.",
    "choice_d": "They use iptables embedded in the Linux kernel.",
    "correct_answer": [
      "A",
      "C",
      "E"
    ],
    "explanation": "The Linux firewall applications covered in this chapter use access control lists (ACLs) to identify which network packets are allowed in or out of the system. Therefore, option A is a correct answer. They identify the network packets by inspecting their control information along with other network data. Thus, option C is also a correct choice. In addition, the Linux firewall applications use configuration files to maintain persistency, which allows the firewall configuration to survive system reboots and/or the firewall application being started or reloaded. Therefore, option E is also a correct answer. These firewalls cannot detect malicious behavior. They only follow predefined rules. Therefore, option B is a wrong answer. In addition, they use netfilter embedded in the Linux kernel, and not <code>iptables</code> (which is instead a firewall service), so option D is also an incorrect choice.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      267,
      270,
      273,
      275,
      369
    ],
    "source": "316328_c18",
    "choice_e": "They employ configuration files for persistency."
  },
  {
    "id": 430,
    "question": "Which of the following options best describes packet filtering?",
    "choice_a": "Identifying network packets via their control information, and allowing them into the system",
    "choice_b": "Identifying network packets via their control information, and determining what to do based upon ACL rules",
    "choice_c": "Identifying network packets via their payload, and determining what to do based upon ACL rules",
    "choice_d": "Identifying network packets by their source address, and determining what to do based upon ACL rules",
    "correct_answer": "B",
    "explanation": "Option B best describes packet filtering. Option A describes how packets are identified, but only allows them into the system, and therefore is not the best answer. A packet\u2019s payload refers to the data it is carrying. In packet filtering, packets are identified by their control information, such as their source IP address. Therefore, option C is not the correct answer either. Network packets can be identified by much more than just their source address, and thus, option D is also a wrong answer. Option E is also a wrong answer because it focuses on the packet\u2019s payload and not its control information.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      267,
      270,
      269,
      274,
      282
    ],
    "source": "316328_c18",
    "choice_e": "Identifying network packets by their payload, and determining what to do based upon their source address"
  },
  {
    "id": 431,
    "question": "Which of the following are benefits of a stateful firewall over a stateless firewall? (Choose all that apply.)",
    "choice_a": "It operates faster.",
    "choice_b": "It is not as vulnerable to DDoS attacks.",
    "choice_c": "It determines if packets are fragmented.",
    "choice_d": "It operates faster for established connections.",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "A stateful firewall uses a memory table to track an established connection\u2019s packets, making it faster for those connections. In addition, it can tell if packets are fragmented and thus protects the system from attacks that spread among multiple packets. Therefore options C and D are the correct answers. Stateless firewalls operate faster overall, and they are not as vulnerable to DDoS attacks. Thus, options A and B are wrong answers. While stateful firewalls are vulnerable to DDoS attacks, it is not a benefit. Therefore, option E is also an incorrect choice.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      269,
      270,
      273,
      267,
      281
    ],
    "source": "316328_c18",
    "choice_e": "It is vulnerable to DDoS attacks."
  },
  {
    "id": 432,
    "question": "The firewalld service uses _____\u200a, which is a predefined rule set.",
    "choice_a": "<code>netfilter</code>",
    "choice_b": "<code>firewall-cmd</code>",
    "choice_c": "Services",
    "choice_d": "<code>reject</code>",
    "correct_answer": "E",
    "explanation": "With <code>firewalld</code>, network traffic is grouped into a zone, which is a predefined rule set, also called a trust level. Therefore, option E is the correct answer. While <code>firewalld</code> does employ the <code>netfilter</code> as well as the <code>firewall-cmd</code> command, those items are not predefined rule sets, so options A and B are wrong answers. A service is a predefined configuration set for a particular service, such as DNS. Therefore, option C is an incorrect answer as well. Option D is an incorrect choice because the zone that rejects packets is called <code>block</code>.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      271,
      272,
      277,
      270,
      273
    ],
    "source": "316328_c18",
    "choice_e": "Zones"
  },
  {
    "id": 433,
    "question": "Peter Quill, a Linux system administrator, has been testing a new <code>firewalld</code> configuration. The test was successful. What should Mr. Quill do next?",
    "choice_a": "Using super user privileges, issue the <code>reboot</code> command.",
    "choice_b": "Using super user privileges, issue the <code>firewall-cmd --panic-on</code> command.",
    "choice_c": "Nothing. If the test was successful, the runtime environment is the permanent environment.",
    "choice_d": "Issue the <code>firewall-cmd --runtime-to-permanent</code> command using super user privileges.",
    "correct_answer": "D",
    "explanation": "The <code>firewalld</code>\u2019s runtime environment is the active firewall, but if the configuration is not saved as the permanent environment, it is not persistent. Therefore, after his successful tests, Mr. Quill should issue the <code>firewall-cmd --runtime-to-permanent</code> command to save the runtime environment to the permanent environment. Thus, option D is the correct answer. Rebooting the system would lose the tested runtime environment, so option A is a wrong answer. The <code>--panic-on</code> option blocks all incoming traffic, so option B is also an incorrect answer. The runtime environment is different than the permanent environment in this situation, so option C is a wrong choice. While the <code>--permanent</code> option will allow you to modify the runtime and permanent environment at the same time, Mr. Quill did not do this, so option E is also an incorrect answer.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      277,
      273,
      270,
      279,
      238
    ],
    "source": "316328_c18",
    "choice_e": "Issue another <code>firewall-cmd</code> command, but add the <code>--permanent</code> option to it."
  },
  {
    "id": 434,
    "question": "Peter Quill is a Linux system administrator of a system using the <code>iptables</code> service. Mr. Quill wants to add a rule to block only incoming <code>ping</code> packets and not send a rejection message to the source. What command should he employ?",
    "choice_a": "<code>sudo iptables -P INPUT DROP</code>",
    "choice_b": "<code>sudo iptables -A INPUT -p icmp -j REJECT</code>",
    "choice_c": "<code>sudo iptables -A INPUT -p icmp -j DROP</code>",
    "choice_d": "<code>sudo iptables -D INPUT -p icmp -j DROP</code>",
    "correct_answer": "C",
    "explanation": "To achieve the desired result, Mr. Quill will need to modify the <code>iptablesINPUT</code> chain for the protocol <code>ping</code> uses, which is ICMP. Also, the target will need to be set to <code>DROP</code>, in order to not send any rejection message. Therefore, option C is the correct <code>iptables</code> command to use. The command in option A will set the policy to <code>DROP</code> for all incoming packets that do not have a rule in the <code>INPUT</code> chain, but that does not target <code>ping</code> packets. Therefore, option A is a wrong answer. The command in option B will send a rejection message, which is not desired, so it is also an incorrect answer. The command in option D is attempting to delete a rule, not add one. Therefore, option D is a wrong choice. The command in option E is modifying the <code>OUTPUT</code> chain instead of the <code>INPUT</code> chain, which will affect outbound network packets. Thus, option E is an incorrect choice.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      273,
      267,
      270,
      282,
      280
    ],
    "source": "316328_c18",
    "choice_e": "<code>sudo iptables -A OUTPUT -p icmp -j REJECT</code>"
  },
  {
    "id": 435,
    "question": "Which of the following commands will allow you to view the various rules in a <code>ufw</code> firewall with their associated numbers?",
    "choice_a": "<code>sudo ufw show numeric</code>",
    "choice_b": "<code>sudo ufw status</code>",
    "choice_c": "<code>sudo ufw status verbose</code>",
    "choice_d": "<code>sudo ufw status numbered</code>",
    "correct_answer": "D",
    "explanation": "The <code>sudo ufw status numbered</code> command will display the <code>ufw</code> firewall\u2019s ACL rules with their associated numbers. Therefore, option D is the correct answer. Option A is made up, and thus it is a wrong answer. Both options B and C will show any rules, but they will not include their numbers, so those options are incorrect answers. The UFW command in option E enables the firewall but does not display ACL rules, so it is an incorrect choice as well.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      276,
      267,
      369,
      230,
      278
    ],
    "source": "316328_c18",
    "choice_e": "<code>sudo ufw enable</code>"
  },
  {
    "id": 436,
    "question": "Which of the following is an example of <code>ufw</code> simple syntax for blocking all incoming and outgoing OpenSSH connections without providing a blocking message?",
    "choice_a": "<code>sudo ufw deny 22/tcp</code>",
    "choice_b": "<code>sudo ufw drop 22/tcp</code>",
    "choice_c": "<code>sudo ufw reject 22/tcp</code>",
    "choice_d": "<code>sudo ufw accept 22/tcp</code>",
    "correct_answer": "A",
    "explanation": "While all these options use simple syntax, the <code>ufw</code> command in option A will block all incoming and outgoing OpenSSH connections and not send a blocking (rejection) message. Thus, option A is the correct answer. There is no <code>drop</code> argument in the <code>ufw</code> command, so option B is a wrong answer. The command in option C would send a rejection message. Thus, it is a wrong choice. The command in option D will allow OpenSSH connections, and therefore it is an incorrect answer. There is no <code>block</code> argument in the <code>ufw</code> command, so option E is also an incorrect choice.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      270,
      277,
      298,
      297,
      279
    ],
    "source": "316328_c18",
    "choice_e": "<code>sudo ufw block 22/tcp</code>"
  },
  {
    "id": 437,
    "question": "Which of the following are true concerning both <code>DenyHosts</code> and <code>Fail2ban</code>? (Choose all that apply.)",
    "choice_a": "It is an intrusion detection system (IDS),",
    "choice_b": "It modifies the <code>/etc/hosts.deny</code> file.",
    "choice_c": "It only handles OpenSSH traffic.",
    "choice_d": "Its configuration file is named <code>jail.conf</code>.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Options A and B are true statements concerning both <code>DenyHosts</code> and <code>Fail2ban</code>. <code>DenyHosts</code> only works with OpenSSH traffic, while <code>Fail2ban</code> can handle many different types of traffic. So option C is a wrong answer. <code>Fail2ban</code>\u2019s configuration file is named <code>/etc/fail2ban/jail.conf</code>, but not <code>DenyHosts</code>. Therefore, option D is an incorrect answer as well. <code>DenyHosts</code> can only work with TCP Wrappers, whereas <code>Fail2ban</code> can work with <code>iptables</code>, TCP Wrappers, <code>firewalld</code>, and so on. Thus, option E is an incorrect choice.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      281,
      296,
      255,
      272,
      282
    ],
    "source": "316328_c18",
    "choice_e": "It can work with TCP Wrappers, <code>iptables</code>, and <code>firewalld</code>."
  },
  {
    "id": 438,
    "question": "Virginia Potts is administering a Linux system with a firewall. She has already set up an IPset and named it <code>BlockThem</code>. A new attack has begun to occur from the 72.32.138.96 address. Along with super user privileges, what command should Ms. Potts issue to add this IPv4 address to the IPset?",
    "choice_a": "<code>ipset create BlockThem hash:net</code>",
    "choice_b": "<code>ipset -n BlockThem hash:net</code>",
    "choice_c": "<code>ipset save -f /etc/ipset.conf</code>",
    "choice_d": "<code>ipset -A BlockThem 72.32.138.0/24</code>",
    "correct_answer": "E",
    "explanation": "The command in option E will properly add the new IP address to the <code>BlockThem</code> IPset. Thus, it is the correct answer. The commands in options A and B create the IPset and do not add new addresses to it. Therefore, those options are wrong answers. The command in option C will save the current IPset configuration to the IPset configuration file. While this is something Ms. Potts should do after the new address is added, it is not the currently needed command. Thus, option C is a wrong answer. The command in option D adds an entire subnet of addresses to the IPset and not a single IP address. Thus it is an incorrect answer as well.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      282,
      273,
      270,
      230,
      249
    ],
    "source": "316328_c18",
    "choice_e": "<code>ipset add BlockThem 72.32.138.96</code>"
  },
  {
    "id": 439,
    "question": "Which authentication method issues tickets to users and helps with implementing the single sign-on feature in a network of servers?",
    "choice_a": "LDAP",
    "choice_b": "Kerberos",
    "choice_c": "RADIUS",
    "choice_d": "TACACS+",
    "correct_answer": "B",
    "explanation": "The Kerberos authentication method uses a ticket-granting system to assign a ticket to the user account after a successful authentication. Any server on the network that uses Kerberos can then authenticate the user account using that ticket. Thus, option B is correct. The LDAP, RADIUS, and TACACS+ authentication methods don\u2019t use tickets for user authentication, so options A, C, and D are all incorrect. The biometrics authentication method uses user physical features to authenticate user accounts but doesn\u2019t issue a ticket to allow single sign-on, so option E is incorrect.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      283,
      285,
      237,
      241,
      238
    ],
    "source": "316328_c19",
    "choice_e": "Biometrics"
  },
  {
    "id": 440,
    "question": "Mary wants to implement two-factor authentication using fingerprint readers for her users to authenticate with the Linux system. Which method of authentication should she look into implementing?",
    "choice_a": "LDAP",
    "choice_b": "Tokens",
    "choice_c": "Biometrics",
    "choice_d": "PKI",
    "correct_answer": "C",
    "explanation": "Biometrics uses physical features of users to authenticate them on the Linux system, so option C is correct. LDAP and Kerberos are only single-factor authentication methods, so options A and E are incorrect. Tokens and PKI are both two-factor authentication methods but use digital tokens instead of physical features for authentication, so options B and D are incorrect.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      286,
      245,
      237,
      238,
      240
    ],
    "source": "316328_c19",
    "choice_e": "Kerberos"
  },
  {
    "id": 441,
    "question": "Jaime is interested in using a distributed database method for authorizing users to access resources located on multiple network servers. Which authentication method would be best for her to use?",
    "choice_a": "LDAP",
    "choice_b": "Kerberos",
    "choice_c": "Tokens",
    "choice_d": "RADIUS",
    "correct_answer": "A",
    "explanation": "The LDAP authentication method allows administrators to create a distributed database that not only authenticates user accounts but tracks user authorization of network resources, so option A is correct. The Kerberos and RADIUS authentication methods don\u2019t use a distributed database, nor can they authorize users to access network resources, so options B and D are incorrect. Tokens and PKI are two-factor authentication methods that don\u2019t use distributed databases, nor do they authorize users to access network resources, so options C and E are incorrect.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      284,
      241,
      283,
      285,
      237
    ],
    "source": "316328_c19",
    "choice_e": "PKI"
  },
  {
    "id": 442,
    "question": "Fred wants to block users from logging in directly with the root user account from any console or terminal session. What is the best way he can do that?",
    "choice_a": "Implement biometric authentication.",
    "choice_b": "Implement tokens.",
    "choice_c": "Use Kerberos authentication.",
    "choice_d": "Remove root user entry from the <code>/etc/passwd</code> file.",
    "correct_answer": "E",
    "explanation": "When you specify the <code>nologin</code> utility as the default shell for a user account, users will receive a message upon successful login that they aren\u2019t allowed to access the system, so option E is correct. Biometrics, tokens, and Kerberos are all authentication methods that won\u2019t prevent the root user account from logging in, so options A, B, and C are all incorrect. Removing the root user account from the <code>/etc/passwd</code> file removes the root user account from the system, which will break applications that require the root user account to run, so option D is incorrect.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      289,
      231,
      232,
      242,
      286
    ],
    "source": "316328_c19",
    "choice_e": "Set the default login shell for the root user to <code>/usr/sbin/nologin</code>."
  },
  {
    "id": 443,
    "question": "Which directory should you place on a separate partition to separate user data from system data?",
    "choice_a": "<code>/usr</code>",
    "choice_b": "<code>/home</code>",
    "choice_c": "<code>/etc</code>",
    "choice_d": "<code>/sbin</code>",
    "correct_answer": "B",
    "explanation": "All user data is normally stored under the <code>/home</code> directory structure on Linux systems, so placing the <code>/home</code> directory on a separate disk partition would separate user data from system data, making option B correct. The <code>/usr</code>, <code>/etc</code>, <code>/sbin</code>, and <code>/bin</code> directories all contain system data and not user data, so options A, C, D, and E are all incorrect.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      351,
      317,
      313,
      320,
      257
    ],
    "source": "316328_c19",
    "choice_e": "<code>/bin</code>"
  },
  {
    "id": 444,
    "question": "Sally is concerned about an application that allows guests to connect to her Linux system and access a database. What can she do to limit the application to a specific directory structure on the Linux server so it can\u2019t access system data?",
    "choice_a": "Block the application network port.",
    "choice_b": "Move the application port to a private port number.",
    "choice_c": "Place the application in an encrypted partition.",
    "choice_d": "Run the application with <code>chroot</code>.",
    "correct_answer": "D",
    "explanation": "The <code>chroot</code> program restricts an application to a specific area within the virtual filesystem structure, so option D is correct. Blocking the application network port would prevent guests from connecting to the application, so option A is incorrect. Moving the application to a private port number wouldn\u2019t restrict access to directories, so option B is incorrect. Placing the application in an encrypted partition or on a separate partition wouldn\u2019t prevent the application from accessing data outside of the application, so options C and E are incorrect.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      293,
      228,
      227,
      290,
      235
    ],
    "source": "316328_c19",
    "choice_e": "Place the application in a separate partition."
  },
  {
    "id": 445,
    "question": "Ted wants to provide encryption at the disk level so users don\u2019t need to encrypt individual files as they store them. What Linux feature should he use?",
    "choice_a": "LUKS",
    "choice_b": "<code>chroot</code>",
    "choice_c": "<code>auditd</code>",
    "choice_d": "PKI",
    "correct_answer": "A",
    "explanation": "The Linux Unified Key Setup (LUKS) feature provides disk-level encryption so that all files stored in a partition are automatically encrypted when written and decrypted when read, so option A is correct. The <code>chroot</code> utility restricts an application to a specific location in the virtual filesystem but doesn\u2019t encrypt files, so option B is incorrect. The <code>auditd</code> utility creates detailed logs of system activity such as user file access but doesn\u2019t encrypt files or disks, so option D is incorrect. Both PKI and Kerberos are authentication methods and not disk encryption methods, so both options D and E are incorrect.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      291,
      300,
      247,
      244,
      290
    ],
    "source": "316328_c19",
    "choice_e": "Kerberos"
  },
  {
    "id": 446,
    "question": "Ned notices in the logs that a user account schedules a job every day at noon that uses all of the system resources. How can he prevent that user account from doing that?",
    "choice_a": "Use <code>chroot</code> for the user account.",
    "choice_b": "Use <code>nologin</code> as the user\u2019s default shell.",
    "choice_c": "Add the user account to the <code>/etc/cron.deny</code> file.",
    "choice_d": "Add the user account to the <code>/etc/hosts.deny</code> file.",
    "correct_answer": "C",
    "explanation": "The <code>/etc/cron.deny</code> file is a list of user accounts prevented from scheduling jobs, so adding the user to that file would stop them from scheduling the job, making option C correct. The <code>chroot</code> program restricts applications to a specific location in the virtual filesystem, it doesn\u2019t block users from scheduling jobs, so option A is incorrect. The <code>nologin</code> program prevents user accounts from logging into the system, which is an extreme solution to the problem, so option B isn\u2019t a good solution. The <code>/etc/hosts.deny</code> file blocks hosts from accessing the system and not users from scheduling jobs, so option D is incorrect. The <code>/etc/motd</code> file displays a message to all users as they log into the system, but it won\u2019t block them from scheduling jobs, so option E is incorrect.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      294,
      234,
      231,
      296,
      287
    ],
    "source": "316328_c19",
    "choice_e": "Create a <code>/etc/motd</code> message telling users to not schedule large jobs."
  },
  {
    "id": 447,
    "question": "Tom sees an attacker continually attempt to break into a user account on his Linux system from a specific IP address. What can he do to quickly mitigate this issue?",
    "choice_a": "Place the application in a chroot jail.",
    "choice_b": "Add the <code>nologin</code> shell to the user account.",
    "choice_c": "Implement two-factor authentication.",
    "choice_d": "Add the attacker\u2019s IP address to the <code>/etc/hosts.deny</code> file.",
    "correct_answer": "D",
    "explanation": "The fastest way to deter an attacker is to place their IP address in the <code>/etc/hosts.deny</code> file, preventing them from accessing the system, so option D is correct. Placing applications into a chroot jail prevents the application from accessing files outside of the jail filesystem but doesn\u2019t prevent the attacker from continuing to access a user account, so option A is incorrect. Adding the <code>nologin</code> shell to the user account will prevent the attacker from accessing the user account but will also block the valid user from accessing the account, so option B is incorrect. Implementing two-factor authentication will help stop the attacker but isn\u2019t a quick solution, so option C is incorrect. Adding the user account to the <code>/etc/cron.deny</code> file prevents the user account from scheduling jobs but won\u2019t stop the attacker from trying to log in as the user account, so option E is incorrect.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      296,
      231,
      240,
      286,
      242
    ],
    "source": "316328_c19",
    "choice_e": "Add the user account to the <code>/etc/cron.deny</code> file."
  },
  {
    "id": 448,
    "question": "Despite his warnings, Fred continues to see users transfer files to his Linux server using unsecure FTP. How can he stop this?",
    "choice_a": "Place a message in the <code>/etc/motd</code> file telling users to stop.",
    "choice_b": "Move the FTP application to a different network port.",
    "choice_c": "Place the user accounts in the <code>/etc/hosts.deny</code> file.",
    "choice_d": "Place the user accounts in the <code>/etc/cron.deny</code> file.",
    "correct_answer": "E",
    "explanation": "While it may seem extreme, removing the FTP client and server application software prevents accidental usage of the unsecure protocol, so option E is correct. Placing a message in the <code>/etc/motd</code> file to display when users log in won\u2019t prevent them from using the FTP service, so option A is incorrect. Moving the FTP application to a different network port may temporarily solve the problem, but once users find the alternative ports, they can continue using FTP, so option B is incorrect. The <code>/etc/hosts.deny</code> file contains IP addresses or hostnames of remote hosts to block, not user accounts, so option C is incorrect. The <code>/etc/cron.deny</code> file blocks users from scheduling jobs, not accessing network applications, so option D is incorrect.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      297,
      296,
      298,
      249,
      299
    ],
    "source": "316328_c19",
    "choice_e": "Remove the FTP client and server software packages from the server."
  },
  {
    "id": 449,
    "question": "Which of the following is true concerning network sockets? (Choose all that apply.)",
    "choice_a": "Numbers are used to identify which service is transmitting data.",
    "choice_b": "A network socket is a single endpoint of a network connection\u2019s two endpoints.",
    "choice_c": "A network socket uses a combination of an IP address and a port number.",
    "choice_d": "Network sockets are the endpoints between processes on a local system.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "A network socket is a single endpoint of a network connection\u2019s two endpoints. That single endpoint is on the local system, bound to a particular port, and uses a combination of an IP address and a port number. Therefore, options B and C are correct answers. Ports use numbers to identify which service of application is transmitting data, and thus option A is a wrong answer. Unix sockets are endpoints between processes on a local system and provide better interprocess communication than localhost. Therefore, options D and E are incorrect choices.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      304,
      107,
      111,
      305,
      309
    ],
    "source": "316328_c20",
    "choice_e": "A network socket provides better IPC than localhost."
  },
  {
    "id": 450,
    "question": "The system administrator, Preston, has noticed that the IPv4 network seems sluggish. He decides to run some tests to check for high latency. Which of the following utilities should he use? (Choose all that apply.)",
    "choice_a": "<code>iperf</code>",
    "choice_b": "<code>ping</code>",
    "choice_c": "<code>ip neigh</code>",
    "choice_d": "<code>dig</code>",
    "correct_answer": [
      "A",
      "B",
      "E"
    ],
    "explanation": "The <code>iperf</code>, <code>ping</code>, and <code>traceroute</code> utilities will help test the network for high latency (slowness) in order to determine the cause. Thus, options A, B, and E are correct answers. The <code>ip neigh</code> command is used to check the routing tables and is often employed in situations where a duplicate or incorrect MAC address is causing problems on a local network segment. Therefore, option C is a wrong answer. The <code>dig</code> utility checks name server resolutions, not high latency. Thus, option D is also an incorrect choice.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      109,
      305,
      306,
      301,
      302
    ],
    "source": "316328_c20",
    "choice_e": "<code>traceroute</code>"
  },
  {
    "id": 451,
    "question": "Mr. Scott has formulated a problem cause theory that routers are saturated with traffic and dropping TCP packets from their queues. Which of the following tools should he employ to test this theory? (Choose all that apply.)",
    "choice_a": "<code>mtr</code>",
    "choice_b": "<code>ifconfig</code>",
    "choice_c": "<code>ethtool -s</code>",
    "choice_d": "<code>tracepath</code>",
    "correct_answer": [
      "A",
      "D",
      "E"
    ],
    "explanation": "The <code>mtr</code>, <code>tracepath</code>, and <code>traceroute</code> utilities all allow Mr. Scott to view router packets traveling through certain network segments and isolate which routers may be dropping packets. Therefore, options A, D, and E are correct answers. The <code>ifconfig</code> tool is for viewing and configuring network adapters. Therefore, option B is a wrong answer. The <code>ethtool -s</code> command will show adapter statistics but not router information, and therefore option C is also an incorrect choice.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      109,
      306,
      302,
      307,
      111
    ],
    "source": "316328_c20",
    "choice_e": "<code>traceroute</code>"
  },
  {
    "id": 452,
    "question": "The network engineer, Keenser, believes the choices of name servers in the system\u2019s <code>/etc/resolv.conf</code> file are inefficient. Which of the following tools can he employ to test new server choices?",
    "choice_a": "<code>dnsmasq</code>",
    "choice_b": "<code>whois</code>",
    "choice_c": "<code>nmap</code>",
    "choice_d": "<code>nslookup</code>",
    "correct_answer": "D",
    "explanation": "The <code>nslookup</code> utility can be used along with the <code>time</code> command to test new name servers to see if they are more efficient (faster). Thus, option D is the correct answer. Option A\u2019s <code>dnsmasq</code> is caching-only name server software, so it is a wrong answer. The <code>whois</code> utility performs queries of Whois servers, not name servers. Thus, option B is an incorrect answer. The <code>nmap</code> utility is used for network mapping and analysis (or pen testing), and therefore, option C is a wrong choice. The <code>ipset list</code> command displays the various IPsets on a system but is not involved with name resolution. Thus, option E is an incorrect choice.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      110,
      303,
      109,
      307,
      305
    ],
    "source": "316328_c20",
    "choice_e": "<code>ipset list</code>"
  },
  {
    "id": 453,
    "question": "Mera, a Linux system admin, believes a new application on her system is producing too much I/O for a particular partition, causing the system\u2019s processor to appear sluggish. Which tool should she use to test her problem cause theory?",
    "choice_a": "<code>iostat</code>",
    "choice_b": "<code>ioping</code>",
    "choice_c": "<code>du</code>",
    "choice_d": "<code>df</code>",
    "correct_answer": "A",
    "explanation": "The <code>iostat</code> command displays I/O wait, which is a performance statistic showing the amount of time a processor must wait on disk I/O. Therefore, option A is the correct answer. The <code>iopin</code>g utility is more for testing new disks on performance items such as disk I/O latency, seek rates, sequential speeds, and so on. Therefore, option B is a wrong answer. The <code>du</code> and <code>df</code> commands are useful for situations where disk space is an issue but do not provide I/O wait statistics. Therefore, options C and D are incorrect answers. The <code>iotop</code> utility is helpful in locating an application or process causing high I/O but not CPU latency due to high I/O. Thus, option E is also an incorrect answer.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      312,
      356,
      313,
      318,
      311
    ],
    "source": "316328_c20",
    "choice_e": "<code>iotop</code>"
  },
  {
    "id": 454,
    "question": "From analysis, Arthur believes the system\u2019s I/O throughput will improve by changing the I/O scheduler. On his system is a real-time application, which uses a database located on a solid-state drive. Which I/O scheduler should Arthur choose?",
    "choice_a": "<code>scheduler</code>",
    "choice_b": "<code>deadline</code>",
    "choice_c": "<code>queue</code>",
    "choice_d": "<code>cfq</code>",
    "correct_answer": "B",
    "explanation": "The <code>deadline</code> I/O scheduler is good for situations where increased database I/O and overall reduced I/O latency are needed, and/or an SSD is employed, and/or a real-time application is in use. Therefore, option B is the correct answer. Option A is the I/O scheduler configuration file\u2019s name, and therefore it is a wrong answer. Option C is one of the subdirectories in the directory that contains the I/O scheduler configuration file, such as <code>/sys/block/sdc/queue/</code>. Thus, option C is also an incorrect answer. The <code>cfq</code> scheduler is best for situations where more balance I/O handling is needed and/or the system has a multiprocessor. Therefore, option D is a wrong answer. The <code>noop</code> I/O scheduler is good for situations where an SSD is employed but less CPU usage is needed. Therefore, option E is an incorrect choice.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      312,
      313,
      315,
      316,
      319
    ],
    "source": "316328_c20",
    "choice_e": "<code>noop</code>"
  },
  {
    "id": 455,
    "question": "Using the <code>uptime</code> command, you will see CPU load averages in what increments? (Choose all that apply.)",
    "choice_a": "1 minute",
    "choice_b": "5 minutes",
    "choice_c": "10 minutes",
    "choice_d": "15 minutes",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "The <code>uptime</code> command displays CPU load averages in 1-, 5-, and 15-minute increments. Thus, options A, B, and D are correct answers. Options C and E are incorrect choices.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      318,
      315,
      301,
      265,
      266
    ],
    "source": "316328_c20",
    "choice_e": "20 minutes"
  },
  {
    "id": 456,
    "question": "Mary wants to view her system\u2019s processor performance over time. Which is the best utility for her to employ?",
    "choice_a": "<code>uptime</code>",
    "choice_b": "<code>sysstat</code>",
    "choice_c": "<code>sar</code>",
    "choice_d": "<code>cat /proc/cpuinfo</code>",
    "correct_answer": "C",
    "explanation": "The <code>sar</code> utility is the best one for viewing a system\u2019s processor performance over time. It uses data stored by the <code>sadc</code> program in the <code>/var/log/sa/</code> directory, which contains up to a month\u2019s worth of data. Therefore, option C is the correct answer. The <code>uptime</code> utility is handy to view processor performance, but <code><i>sar</i></code> is a better one for viewing it over time. Thus, option A is a wrong answer. The <code>sysstat</code> is a package that provides the <code>sar</code> utility, and therefore, option B is an incorrect answer. The <code>/proc/cpuinfo</code> file contains detailed processor information, but it is not the best for viewing CPU performance. Thus, option D is also a wrong choice. The <code>sysctl</code> utility is used to view or tweak kernel parameters. Therefore, option E is an incorrect choice.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      312,
      315,
      319,
      316,
      262
    ],
    "source": "316328_c20",
    "choice_e": "<code>sysctl</code>"
  },
  {
    "id": 457,
    "question": "Gertie needs to determine a swap space element\u2019s type, name, and priority. Which command should she use?",
    "choice_a": "<code>vmstat</code>",
    "choice_b": "<code>free</code>",
    "choice_c": "<code>fstab</code>",
    "choice_d": "<code>swapoff</code>",
    "correct_answer": "E",
    "explanation": "The <code>swapon -s</code> command will allow Gertie to view a swap space element\u2019s type, name, and priority. Therefore, option E is the correct answer. The <code>vmstat</code> utility provides a lot of memory statistics, including disk I/O specific to swapping as well as total blocks in and blocks out to the device. However, it does not provide the information Gertie needs, so option A is a wrong answer. The <code>free</code> command shows memory items such as free memory, used memory, and buffer/cache usage. Thus, option B is an incorrect answer. <code>fstab</code> is not a command, but a file. This file is where swap partitions/files must have records in order for the swap space to remain persistent through reboots. Therefore, option C is a wrong choice. The <code>swapoff</code> utility disengages a partition/file from swap space, and thus, option D is an incorrect choice.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      317,
      318,
      319,
      316,
      312
    ],
    "source": "316328_c20",
    "choice_e": "<code>swapon -s</code>"
  },
  {
    "id": 458,
    "question": "Elliot is administering a Linux system that has multiple swap spaces. One is on a logical volume, but it needs more space to accommodate additional RAM that is to be installed in the near future. What is the best way for Elliot to add swap space?",
    "choice_a": "Add a partition and format it with <code>mkswap</code> command.",
    "choice_b": "Add a file and format it with <code>mkswap</code> command.",
    "choice_c": "Add a partition via the <code>swapon</code> utility.",
    "choice_d": "Add a file via the <code>swapon</code> utility.",
    "correct_answer": "E",
    "explanation": "In this scenario, since multiple swap spaces already exist, and the one swap partition or file is on a logical volume, Elliot should add more swap space by using LVM tools to increase the logical volume. Thus, option E is the correct answer. While you will need to employ <code>mkswap</code> and <code>swapon</code> on the logical volume after it is extended, options A, B, C, and D are using those utilities on files or partitions, instead of logical volumes. Therefore, those options are incorrect choices.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      317,
      311,
      319,
      318,
      351
    ],
    "source": "316328_c20",
    "choice_e": "Use LVM tools to increase the logical volume."
  },
  {
    "id": 459,
    "question": "What are the three types of option styles available for the <code>ps</code> command?",
    "choice_a": "BSD style",
    "choice_b": "Linux style",
    "choice_c": "Unix style",
    "choice_d": "GNU style",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "The GNU <code>ps</code> command in Linux supports parameters that were supported by the legacy BSD and Unix <code>ps</code> command, along with new options created by GNU, so options A, C, and D are correct. There are no Linux-style options used by the <code>ps</code> command, so option B is incorrect. The <code>ps</code> command doesn\u2019t support numeric options, so option E is also incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      321,
      322,
      327,
      326,
      324
    ],
    "source": "316328_c21",
    "choice_e": "Numeric style"
  },
  {
    "id": 460,
    "question": "How do you identify the legacy Unix-style options for the <code>ps</code> command?",
    "choice_a": "Use a double dash in front of the option.",
    "choice_b": "Use a single dash in front of the option.",
    "choice_c": "Do not place a dash in front of the option.",
    "choice_d": "Unix-style options are numerical.",
    "correct_answer": "B",
    "explanation": "The Unix style command-line options for the GNU <code>ps</code> command are identified by placing a single dash in front of the option, so option B is correct. The newer GNU options are identified by using a double dash, so option A is incorrect. The legacy BSD style options are identified by not placing anything in front of the option letter, so option C is incorrect. Unix-style options still use letters, not decimal nor hexadecimal numbers, so options D and E are both incorrect.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      321,
      322,
      323,
      327,
      328
    ],
    "source": "316328_c21",
    "choice_e": "Unix-style options use hexadecimal numbers."
  },
  {
    "id": 461,
    "question": "By default, if you specify no command-line options, what does the <code>ps</code> command display?",
    "choice_a": "All processes running on the terminal",
    "choice_b": "All active processes",
    "choice_c": "All sleeping processes",
    "choice_d": "All processes run by the current shell",
    "correct_answer": "D",
    "explanation": "With no command-line options, the GNU <code>ps</code> command displays only processes run by the current shell, so option D is correct. To display all processes running on a specific terminal, you need to add the <code>-t</code> option, so option A is incorrect. To display all active processes, you must add the <code>-A</code> option, so option B is incorrect. To display the sleeping processes, you need to use the <code>-ef</code> option, so C is incorrect. To display all processes run by the current user account, you need to add the <code>-x</code> option, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      321,
      322,
      323,
      408,
      404
    ],
    "source": "316328_c21",
    "choice_e": "All processes run by the current user"
  },
  {
    "id": 462,
    "question": "Charles noticed that his Linux system is running slow and needs to find out what application is causing the problem. What tool should he use to show the current CPU utilization of all the processes running on his system?",
    "choice_a": "<code>top</code>",
    "choice_b": "<code>ps</code>",
    "choice_c": "<code>lsof</code>",
    "choice_d": "<code>pkill</code>",
    "correct_answer": "A",
    "explanation": "The <code>top</code> command displays the currently running processes on the system and updates every 3 seconds, so option A is correct. The <code>ps</code> command displays currently running processes but doesn\u2019t update in real time, so option B is incorrect. The <code>lsof</code> command displays files currently opened by processes but not the processes themselves, so option C is incorrect. The <code>pkill</code> and <code>kill</code> commands are used to stop running processes, not display them, so options D and E are both incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      323,
      324,
      321,
      328,
      326
    ],
    "source": "316328_c21",
    "choice_e": "<code>kill</code>"
  },
  {
    "id": 463,
    "question": "What <code>top</code> command displays cumulative CPU time instead of relative CPU time?",
    "choice_a": "<code>l</code>",
    "choice_b": "<code>F</code>",
    "choice_c": "<code>r</code>",
    "choice_d": "<code>y</code>",
    "correct_answer": "E",
    "explanation": "The <code>S</code> command displays the processes based on the cumulative CPU time for each process, so option E is correct. The <code>l</code> command displays the processes based on the load average, so option A is incorrect. The <code>F</code> command allows you to select the field used to sort the display, so option B is incorrect. The <code>r</code> command reverses the sort order of the display, so option C is incorrect. The <code>y</code> command highlights running tasks, so option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      323,
      324,
      136,
      321,
      322
    ],
    "source": "316328_c21",
    "choice_e": "<code>S</code>"
  },
  {
    "id": 464,
    "question": "Shelly thinks that one of the applications on her Linux system is taking up too much physical memory and may have a problem. What column of data from the <code>top</code> display should she focus on?",
    "choice_a": "<code>VIRT</code>",
    "choice_b": "<code>RES</code>",
    "choice_c": "<code>SHR</code>",
    "choice_d": "<code>S</code>",
    "correct_answer": "B",
    "explanation": "The <code>RES</code> column in the <code>top</code> output displays the amount of physical memory used by the applications, so option B is correct. The <code>VIRT</code> column displays the amount of virtual memory, not physical memory, so option A is incorrect. The <code>SHR</code> column displays the amount of shared memory used, so option C is incorrect. The <code>S</code> column displays the status of the application process, so option D is incorrect. The <code>%MEM</code> column displays the percentage of physical memory the application is using, but not the amount of physical memory, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      324,
      323,
      328,
      321,
      322
    ],
    "source": "316328_c21",
    "choice_e": "<code>%MEM</code>"
  },
  {
    "id": 465,
    "question": "Jessica has an application that crunches lots of numbers and uses a lot of system resources. She wants to run the application with a lower priority so it doesn\u2019t interfere with other applications on the system. What tool should she use to start the application program?",
    "choice_a": "<code>renice</code>",
    "choice_b": "<code>pkill</code>",
    "choice_c": "<code>nice</code>",
    "choice_d": "<code>kill</code>",
    "correct_answer": "C",
    "explanation": "The <code>nice</code> command allows you to specify the priority level for an application, so option B is correct. The <code>renice</code> command allows you to change the priority level of an application that\u2019s already running, but not one that hasn\u2019t started yet, so option A is incorrect. The <code>pkill</code> and <code>kill</code> commands are used to stop running processes, not change their priority levels, so options B and D are incorrect. The <code>pgrep</code> command displays the application processes matching a search term; it doesn\u2019t change the priority level of the processes, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      325,
      321,
      322,
      323,
      326
    ],
    "source": "316328_c21",
    "choice_e": "<code>pgrep</code>"
  },
  {
    "id": 466,
    "question": "Jimmy noticed his Linux system was running slow. He ran the <code>top</code> command and found out that a data-intensive application was consuming most of the CPU time. He doesn\u2019t want to kill the application but wants to give it a lower priority so it doesn\u2019t take up too much CPU time. What tool should he use to change the priority of the running application?",
    "choice_a": "<code>renice</code>",
    "choice_b": "<code>pkill</code>",
    "choice_c": "<code>nice</code>",
    "choice_d": "<code>kill</code>",
    "correct_answer": "A",
    "explanation": "The <code>renice</code> command allows you to change the priority level assigned to an application that\u2019s already running on the system, so option A is correct. The <code>pkill</code> and <code>kill</code> commands allow you to stop an application but not change the priority level, so options B and D are both incorrect. The <code>nice</code> command lets you start an application with a specified priority level but not change the priority level of an application that\u2019s already running, so option C is incorrect. The <code>pgrep</code> command allows you to search for a running application based on a search term, but not change the priority level of it, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      325,
      323,
      326,
      321,
      322
    ],
    "source": "316328_c21",
    "choice_e": "<code>pgrep</code>"
  },
  {
    "id": 467,
    "question": "Hank needs to stop an application from running on his Linux system. He knows the name of the application file, but not the process ID assigned to it. What tool can he use to stop the application?",
    "choice_a": "<code>renice</code>",
    "choice_b": "<code>pkill</code>",
    "choice_c": "<code>nice</code>",
    "choice_d": "<code>kill</code>",
    "correct_answer": "B",
    "explanation": "The <code>pkill</code> command allows you to send a <code>HUP</code> signal to a running process based on a search term for the process name, so option B is correct. The <code>renice</code> command allows you to change the priority level of an application that\u2019s already running but not stop it, so option A is incorrect. The <code>nice</code> command allows you to start an application at a specified priority level but not stop an application that\u2019s already running, so option C is incorrect. The <code>kill</code> command allows you to stop an application that\u2019s running, but you need to use the process ID number and not the name, so option D is incorrect. The <code>pgrep</code> command allows you to search for running applications based on their name but not stop them, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      327,
      326,
      325,
      321,
      408
    ],
    "source": "316328_c21",
    "choice_e": "<code>pgrep</code>"
  },
  {
    "id": 468,
    "question": "Frankie used the <code>ps</code> command to find the process ID of an application that he needs to stop. What command-line tool should he use to stop the application based on its process ID?",
    "choice_a": "<code>renice</code>",
    "choice_b": "<code>pkill</code>",
    "choice_c": "<code>nice</code>",
    "choice_d": "<code>kill</code>",
    "correct_answer": "D",
    "explanation": "The <code>kill</code> command allows you to stop an application that\u2019s already running by specifying its process ID, so option D is correct. The <code>renice</code> command allows you to change the priority level of an application but not stop it, so option A is incorrect. The <code>pkill</code> command allows you to stop an application, but by specifying its process name and not its process ID, so option B is incorrect. The <code>nice</code> command allows you to start an application using a specified priority level but not stop an application, so option C is incorrect. The <code>pgrep</code> command allows you to display running applications based on a search term for the application name but not stop them, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      326,
      321,
      327,
      325,
      328
    ],
    "source": "316328_c21",
    "choice_e": "<code>pgrep</code>"
  },
  {
    "id": 469,
    "question": "Lamar, a contractor, claims he cannot log into his account locally. He was able to do so yesterday. No one else seems to be having problems accessing the system. What should you check first?",
    "choice_a": "Check if GUI services are running by using the <code>systemctl</code> command.",
    "choice_b": "Look at the OpenSSH server configuration files.",
    "choice_c": "Determine if his account is expired by using the <code>chage</code> command.",
    "choice_d": "See if the account is locked by using the <code>faillock</code> utility.",
    "correct_answer": "C",
    "explanation": "Since Lamar is a contractor, his account should have an expiration date set. Thus, the first thing to check for his particular local access problem is whether or not the account has expired. Option C is the correct answer. GUI services may not be running, but this is not the first thing to check (and no one except Lamar is having problems). Thus, option A is an incorrect choice. Lamar is not employing a utility such as OpenSSH, so option B is a wrong answer. The account might be locked, but this is not the first thing to check, so option D is an incorrect answer. SELinux policy violations also may be a problem, but you don\u2019t know if the system is running SELinux or AppArmor. Therefore, option E is also an incorrect choice.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      330,
      329,
      141,
      142,
      143
    ],
    "source": "316328_c22",
    "choice_e": "Check for policy violations in the SELinux log files."
  },
  {
    "id": 470,
    "question": "Irene normally logs into the system locally using the tty4 terminal but cannot today. She tries her authentication at the tty3 terminal and logs in successfully. What should you check first?",
    "choice_a": "Determine if <code>getty</code> services are running by using the <code>systemctl</code> command.",
    "choice_b": "Review access rules in the <code>/etc/security/access.conf</code> file.",
    "choice_c": "See if the account is locked by using the <code>passwd -S</code> command.",
    "choice_d": "Use the <code>last</code> command to see when she last logged in.",
    "correct_answer": "E",
    "explanation": "Since Irene normally logs into the system by using the tty4 terminal and is having trouble today but can log in using the tty3 terminal, the first thing to check is whether or not the tty4 device file is corrupted. Therefore, option E is the correct answer. If <code>getty</code> services were not running, Irene could not log into the tty3 terminal, so option A is a wrong answer. Option B is not the first item to check, so it is an incorrect answer. The account is not locked because Irene can log in by using the tty3 terminal. Thus, option C is an incorrect answer. Using the <code>last</code> command is not helpful in this scenario, unless you think Irene is confused, so option D is an incorrect choice as well.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      331,
      333,
      334,
      152,
      88
    ],
    "source": "316328_c22",
    "choice_e": "Check if the tty4 device file is corrupted by using the <code>ls -l</code> command."
  },
  {
    "id": 471,
    "question": "Vincent is attempting to remotely log into the system using OpenSSH without success. He asks you what he can do to help troubleshoot this problem. What should you recommend first?",
    "choice_a": "Check the <code>/etc/ssh/sshd_config</code> configuration file.",
    "choice_b": "Add the <code>-vvv</code> option to Vincent\u2019s <code>ssh</code> command.",
    "choice_c": "Add the <code>-X</code> option to Vincent\u2019s <code>ssh</code> command.",
    "choice_d": "Confirm Vincent\u2019s public key is stored in the <code>~/.ssh/authorized_keys</code> file.",
    "correct_answer": "B",
    "explanation": "To enlist Vincent\u2019s help, have him add the <code>-vvv</code> option to his <code>ssh</code> command. This will provide a great deal of information that will assist you as you track down the problem. Therefore, option B is the correct answer. The <code>/etc/ssh/sshd_config</code> configuration file is on the server side, and Vincent cannot reach the system, so option A is the wrong answer. The <code>-X</code> option will only help if your system is forwarding X11 GUI servers over the network, so option C is an incorrect answer. If Vincent is using token-based authentication via <code>ssh</code>, then this will need to be checked, but it\u2019s not the first item to address. Thus, option D is a wrong choice. The <code>config</code> file may need to be checked, but it\u2019s not the first item to address, so option E is an incorrect choice as well.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      128,
      129,
      127,
      114,
      16
    ],
    "source": "316328_c22",
    "choice_e": "Check the <code>~/.ssh/config</code> configuration file."
  },
  {
    "id": 472,
    "question": "Anton is struggling to determine why a particular user cannot log into a Rocky Linux system, where SELinux is disabled and <code>auditd</code> is not used. Which of the following are the best log files to check? (Choose two.)",
    "choice_a": "<code>/var/log/audit/audit.log</code>",
    "choice_b": "<code>/var/log/messages</code>",
    "choice_c": "<code>/var/log/auth</code>",
    "choice_d": "<code>/var/log/secure</code>",
    "correct_answer": [
      "D",
      "E"
    ],
    "explanation": "The best log files for Anton to check in this situation are <code>/var/log/secure</code> and <code>/var/log/lastlog</code> by using the <code>lastlog</code> command. Therefore, options D and E are the correct answers. Since <code>auditd</code> is not employed, the file in option A is not available and is a wrong answer. Since SELinux is not used, the file in option B is also an incorrect answer. This system, Rocky Linux, is a Red Hat\u2013based system and not Debian, so the <code>/var/log/auth</code> file is not available. Thus option C is also an incorrect choice.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      152,
      54,
      47,
      334,
      39
    ],
    "source": "316328_c22",
    "choice_e": "<code>/var/log/lastlog</code>"
  },
  {
    "id": 473,
    "question": "Tarissa needs to run a shell script, which has the permissions of <code>rwxr--r--</code>, is owned by <code>root</code>, and belongs to the <code>wheel</code> group. Tarissa\u2019s user account is <code>T2T1000</code>, and she is a member of the <code>admin</code> group. What can be done to allow her to run this script? (Choose all that apply.)",
    "choice_a": "Add Tarissa to the <code>wheel</code> group.",
    "choice_b": "Create a new account for Tarissa named <code>wheel</code>.",
    "choice_c": "Add <code>w</code> to the script file\u2019s group permissions.",
    "choice_d": "Add <code>x</code> to the script file\u2019s group permissions.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "From the choices listed, to allow Tarissa to run the script, add her to the <code>wheel</code> group and add execute (<code>x</code>) to the shell script file\u2019s permissions. Thus, options A and D are the correct answers. Option B will do nothing for this situation and is a wrong answer. Adding write (<code>w</code>) to the group permissions will not allow her (or the <code>wheel</code> group members) to execute the file. Thus, option C is a wrong choice. Actions need to take place, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      147,
      334,
      335,
      146,
      339
    ],
    "source": "316328_c22",
    "choice_e": "Nothing. Tarissa can run the script now."
  },
  {
    "id": 474,
    "question": "Miles needs to change his present working directory to the <code>/home/miles</code> directory. He does not own the directory, nor is he a member of its group. Assuming needed parent directory permissions are set, what needs to take place for this to successfully occur?",
    "choice_a": "Nothing. The <code>/home/miles</code> directory is Miles\u2019s home directory, so he can access it by default.",
    "choice_b": "The execute (<code>x</code>) permission needs to be added.",
    "choice_c": "The write (<code>w</code>) permission needs to be added.",
    "choice_d": "The read (<code>r</code>) permission needs to be added.",
    "correct_answer": "B",
    "explanation": "For Miles to change his present working directory to <code>/home/miles</code>, the permission settings must have the execute (<code>x</code>) permission. Therefore, option B is the correct answer. You do not know Miles\u2019s home directory configuration, so you cannot assume it is <code>/home/miles</code>. Thus, option A is the wrong answer. The write (<code>w</code>) and read (<code>r</code>) permissions don\u2019t allow a user to change their present working directory to this directory. Therefore, options C and D are incorrect answers. The dash (<code>-</code>) in a file permission listing is not a permission but instead shows the absence of a permission. Thus, option E is also an incorrect choice.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      335,
      334,
      53,
      147,
      40
    ],
    "source": "316328_c22",
    "choice_e": "The dash (<code>-</code>) permission needs to be added."
  },
  {
    "id": 475,
    "question": "Sarah, a system administrator, attempts to create a file and receives an error message indicating the file cannot be created. Which of the following might be the problem? (Choose all that apply.)",
    "choice_a": "The filesystem on which she is attempting to create the file has quotas set, and she is past her quota and grace period.",
    "choice_b": "The filesystem on which she is attempting to create the file has run out of space.",
    "choice_c": "The file that she is attempting to create has the immutable bit set and therefore cannot be created.",
    "choice_d": "The action is triggering either a SELinux or an AppArmor policy violation.",
    "correct_answer": [
      "A",
      "B",
      "D",
      "E"
    ],
    "explanation": "Options A, B, D, and E contain potential causes of Sarah\u2019s file creation problem and are therefore correct answers. A file with an immutable bit cannot be deleted, and thus option C is the only incorrect choice.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      162,
      164,
      166,
      61,
      62
    ],
    "source": "316328_c22",
    "choice_e": "The filesystem is experiencing inode exhaustion and therefore cannot accommodate any new files."
  },
  {
    "id": 476,
    "question": "A user cannot delete one of her files but is able to delete other files in her directory. John, a system admin, is attempting to troubleshoot this issue. What command should he use first on the file?",
    "choice_a": "<code>chown</code>",
    "choice_b": "<code>chattr</code>",
    "choice_c": "<code>chmod</code>",
    "choice_d": "<code>umask</code>",
    "correct_answer": "E",
    "explanation": "The <code>lsattr</code> command used on the file will display whether or not the immutable bit is set. If this bit is set, the user cannot delete the file until it is removed. Therefore, option E is the correct answer. The <code>chown</code> command changes a file\u2019s ownership, and thus option A is the wrong answer. The <code>chattr</code> command can add or remove certain file attributes, such as the immutable bit, but is not helpful at this point, so option B is an incorrect answer. The <code>chmod</code> utility changes file permissions (modes), but it does not help in this situation, so option C is a wrong choice. The <code>umask</code> command displays or sets what permissions are removed from default permissions when a file or directory is created. This is not helpful here, so option D is an incorrect choice.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      338,
      334,
      39,
      50,
      43
    ],
    "source": "316328_c22",
    "choice_e": "<code>lsattr</code>"
  },
  {
    "id": 477,
    "question": "Melissa wants to set her default editor to the <code>vim</code> editor and wants this to stay set when she enters a subshell. What should she do?",
    "choice_a": "Put <code>EDITOR='vim'</code> in the <code>/etc/profile</code> file.",
    "choice_b": "Put <code>export EDITOR='vim'</code> in the <code>/etc/profile</code> file.",
    "choice_c": "Put <code>EDITOR='vim'</code> in her <code>~/.profile</code> file.",
    "choice_d": "Put <code>export EDITOR='vim'</code> in her <code>~/.profile</code> file.",
    "correct_answer": "D",
    "explanation": "When the <code>export EDITOR='vim'</code> line is put in her <code>~/.profile</code> file, the default editor will be set to the <code>vim</code> editor for Melissa. It will also stay set when she enters a subshell. Thus, option D is the correct answer. If option A or B was completed, then everyone on the system would have the <code>vim</code> editor as their default editor. Therefore, options A and B are incorrect answers. Option C would set the <code>vim</code> editor as Melissa\u2019s default editor, but it would not be set when she entered a subshell due to the missing <code>export</code> command. Thus, option C is also an incorrect answer. The <code>. bash.bashrc</code> file does not reside in the user\u2019s local directory (it is located in the <code>/etc</code> directory) and is also not a hidden file, so option E is an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      72,
      69,
      438,
      162,
      167
    ],
    "source": "316328_c22",
    "choice_e": "Put <code>export EDITOR='vim'</code> in her <code>~/. bash.bashrc</code> file."
  },
  {
    "id": 478,
    "question": "Mark Watney, a system administrator, has his account, <code>MW2015</code>, modified by a new system admin intern. When Mark logs into the system and tries to group a list of commands by using braces, it no longer works. No one else is having this problem. He suspects his account\u2019s default shell has been changed from <code>/bin/bash</code> to <code>/bin/tcsh</code>. Which of the following will help determine if his suspicion is correct? (Choose all that apply.)",
    "choice_a": "<code>cat /etc/profile</code>",
    "choice_b": "<code>echo $SHELL</code>",
    "choice_c": "<code>sudo grep tcsh$ /etc/passwd</code>",
    "choice_d": "<code>sudo getent shadow MW2015</code>",
    "correct_answer": [
      "B",
      "C",
      "E"
    ],
    "explanation": "The <code>echo $SHELL</code> command will show Mark his current shell. Though it could be a modified environment variable, this will help to determine if his default shell has been changed. Thus, option B is a correct answer. The <code>sudo grep tcsh$ /etc/passwd</code> command will display any <code>/etc/passwd</code> file records that have <code>/bin/tcsh</code> as their default shell, including Mark\u2019s. Thus, option C is a correct answer too. The <code>sudo getent passwd MW2015</code> command will show Mark\u2019s account\u2019s password file setting, including its default shell. Therefore, option E is also a correct answer. The option A command will display the settings in the profile environment configuration file, but since Mark is the only one experiencing the problem, the <code>SHELL</code> environment variable is not set via this method. Thus, option A is a wrong answer. The command in option D will show the shadow file records and not the password file records. Therefore, option D is an incorrect choice.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      143,
      339,
      139,
      150,
      340
    ],
    "source": "316328_c22",
    "choice_e": "<code>sudo getent passwd MW2015</code>"
  },
  {
    "id": 479,
    "question": "What type of hardware interface uses interrupts, I/O ports, and DMA channels to communicate with the PC motherboard?",
    "choice_a": "USB",
    "choice_b": "GPIO",
    "choice_c": "PCI",
    "choice_d": "Monitors",
    "correct_answer": "C",
    "explanation": "PCI boards use interrupts, I/O ports, and DMA channels to send and receive data with the PC motherboard, so option C is correct. USB devices transmit data using a serial bus connected to the motherboard and don\u2019t use DMA channels, so option A is incorrect. The GPIO interface uses memory-mapped specialty IC chips and not interrupts and I/O ports, so option B is incorrect. Monitors and printers are hardware devices and not hardware interfaces, so options D and E are incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      341,
      343,
      347,
      342,
      344
    ],
    "source": "316328_c23",
    "choice_e": "Printers"
  },
  {
    "id": 480,
    "question": "What filesystem does the Linux system use to track ports used to communicate with PCI boards?",
    "choice_a": "<code>/proc/ioports</code>",
    "choice_b": "<code>/proc/interrupts</code>",
    "choice_c": "<code>/sys</code>",
    "choice_d": "<code>/dev</code>",
    "correct_answer": "C",
    "explanation": "PCI boards use interrupts, I/O ports, and DMA channels to send and receive data with the PC motherboard, so option C is correct. USB devices transmit data using a serial bus connected to the motherboard and don\u2019t use DMA channels, so option A is incorrect. The GPIO interface uses memory-mapped specialty IC chips and not interrupts and I/O ports, so option B is incorrect. Monitors and printers are hardware devices and not hardware interfaces, so options D and E are incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      343,
      341,
      342,
      347,
      350
    ],
    "source": "316328_c23",
    "choice_e": "<code>/proc/dma</code>"
  },
  {
    "id": 481,
    "question": "Where does Linux create files to send data to and receive data from directly with devices?",
    "choice_a": "<code>/sys</code>",
    "choice_b": "<code>/proc</code>",
    "choice_c": "<code>/etc</code>",
    "choice_d": "<code>/dev</code>",
    "correct_answer": "D",
    "explanation": "The kernel creates files in the <code>/dev</code> directory for each device on the Linux system. These files are used to send data to the device and read data from the device. Thus, option D is correct. The <code>/sys</code> and <code>/proc</code> directories are used by the kernel to display system information, not transfer data, so options A and B are incorrect. The <code>/etc</code> directory is used for configuration files, not for transferring data, so option C is incorrect. The <code>/dev/mapper</code> directory is used by virtual systems such as LVM and LUKS to create virtual files that indirectly interface with devices through another application, not directly, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      342,
      350,
      344,
      346,
      347
    ],
    "source": "316328_c23",
    "choice_e": "<code>/dev/mapper</code>"
  },
  {
    "id": 482,
    "question": "Katie Jane created a new LVM volume on her Linux system. Where in the virtual directory should she look to find the virtual file related to the new volume?",
    "choice_a": "<code>/dev</code>",
    "choice_b": "<code>/dev/mapper</code>",
    "choice_c": "<code>/proc</code>",
    "choice_d": "<code>/sys</code>",
    "correct_answer": "B",
    "explanation": "The kernel uses the <code>/dev/mapper</code> directory to create virtual files that interface with applications that manipulate data on a virtual LVM volume before being sent to a physical hard drive device, so option B is correct. The <code>/dev</code> directory contains the physical device files, not virtual files, so option A is incorrect. The kernel uses the <code>/proc</code> and <code>/sys</code> directories to display kernel and system information, not virtual files for LVM volumes, so options C and D are incorrect. The <code>/etc</code> directory contains configuration files for applications, not LVM volumes, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      342,
      171,
      350,
      166,
      162
    ],
    "source": "316328_c23",
    "choice_e": "<code>/etc</code>"
  },
  {
    "id": 483,
    "question": "Joel installed a new PCI card in his Linux system but is now getting a conflict with another device on the system. What command can he use to display the interrupts, I/O ports, and DMA channels in use by all of the existing devices?",
    "choice_a": "<code>lsdev</code>",
    "choice_b": "<code>lsblk</code>",
    "choice_c": "<code>lspci</code>",
    "choice_d": "<code>lsusb</code>",
    "correct_answer": "A",
    "explanation": "The <code>lsdev</code> command displays all of the hardware information about all of the devices connected to the system, so option A is correct. The <code>lsblk</code> only displays information on block devices, so option B is incorrect. The <code>lspci</code> command only displays information about PCI devices, so option C is incorrect. The <code>lsusb</code> command only displays information about USB devices, so option D is incorrect. The <code>dmesg</code> command displays messages from the kernel ring buffer, not information about the current devices, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      346,
      343,
      347,
      342,
      350
    ],
    "source": "316328_c23",
    "choice_e": "<code>dmesg</code>"
  },
  {
    "id": 484,
    "question": "Which Linux command displays the contents of the kernel ring buffer?",
    "choice_a": "<code>lsdev</code>",
    "choice_b": "<code>lsblk</code>",
    "choice_c": "<code>lspci</code>",
    "choice_d": "<code>lsusb</code>",
    "correct_answer": "E",
    "explanation": "The <code>dmesg</code> command displays the kernel event messages contained in the kernel ring buffer, so option E is correct. The <code>lsdev</code> command displays hardware information about devices, but not messages from the kernel, so option A is incorrect. The <code>lsblk</code> command only displays information about block devices, not kernel event messages, so option B is incorrect. The <code>lspci</code> command only displays information about PCI devices, not kernel event messages, so option C is incorrect. The <code>lsusb</code> command only displays information about USB devices, not kernel event messages, so option D is incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      75,
      346,
      74,
      83,
      212
    ],
    "source": "316328_c23",
    "choice_e": "<code>dmesg</code>"
  },
  {
    "id": 485,
    "question": "Which software packages implement the X Windows graphical system in Linux? (Choose two.)",
    "choice_a": "X.org",
    "choice_b": "CUPS",
    "choice_c": "Wayland",
    "choice_d": "X11",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "The X.org and Wayland software packages implement the X Windows graphical system for Linux, so options A and C are correct. The CUPS software package implements Postscript printing for Linux, not X Windows graphical systems, so option B is incorrect. X11 is an X Windows standard but not a software package, so option D is incorrect. The <code>udev</code> program is used to detect hot-pluggable devices, not implement the X Windows graphical system, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      348,
      120,
      119,
      121,
      349
    ],
    "source": "316328_c23",
    "choice_e": "<code>udev</code>"
  },
  {
    "id": 486,
    "question": "Sophia needs to connect her Linux system to a new network printer on the office network. What software package does she need to ensure is installed so she can configure the new network printer?",
    "choice_a": "X.org",
    "choice_b": "CUPS",
    "choice_c": "Wayland",
    "choice_d": "X11",
    "correct_answer": "B",
    "explanation": "The CUPS software package provides an interface to convert Postscript documents and send them to common printers, so option B is correct. The X.org and Wayland software packages are used to implement the X Windows graphical system in Linux, not interface with printers, so options A and C are incorrect. X11 is a standard for X Windows, not a software package for printers, so option D is incorrect. The <code>udev</code> program detects hot-pluggable devices but doesn\u2019t interact directly with the printers, so option E is incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      349,
      350,
      348,
      120,
      121
    ],
    "source": "316328_c23",
    "choice_e": "<code>udev</code>"
  },
  {
    "id": 487,
    "question": "Which program runs in the background monitoring the kernel ring buffer messages for new devices?",
    "choice_a": "X.org",
    "choice_b": "CUPS",
    "choice_c": "Wayland",
    "choice_d": "X11",
    "correct_answer": "E",
    "explanation": "The <code>udev</code> program runs in the background and monitors the kernel ring buffer for event messages from new devices, so option E is correct. The X.org and Wayland software packages implement the X Windows graphical system but don\u2019t listen for new devices, so options A and C are incorrect. The CUPS package interfaces with printers on the Linux system and doesn\u2019t listen for new devices, so option B is incorrect. X11 is a standard for X Windows and not a software package that listens for new devices, so option D is incorrect.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      350,
      75,
      346,
      212,
      216
    ],
    "source": "316328_c23",
    "choice_e": "<code>udev</code>"
  },
  {
    "id": 488,
    "question": "Which program allows you to reload the defined rules for detecting and installing new devices?",
    "choice_a": "<code>udevadm</code>",
    "choice_b": "<code>udev</code>",
    "choice_c": "<code>lsusb</code>",
    "choice_d": "<code>lspci</code>",
    "correct_answer": "A",
    "explanation": "The <code>udevadm</code> program allows you to send control messages to the <code>udev</code> application running in background, signaling it to reload the rules defined in the <code>/etc/udev/rules.d</code> directory, so option A is correct. The <code>udev</code> application can\u2019t direct itself to reload the rules, so option B is incorrect. The <code>lsusb</code>, <code>lspci</code>, and <code>lsdev</code> programs are used for displaying hardware information for the system, not for directing the <code>udev</code> program to reload defined rules, so options C, D, and E are all incorrect.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      350,
      341,
      347,
      75,
      1
    ],
    "source": "316328_c23",
    "choice_e": "<code>lsdev</code>"
  },
  {
    "id": 489,
    "question": "Peter\u2019s system has a memory-intensive application running on it continually. To help improve performance, he has replaced the old hard drives with solid-state drives instead of increasing RAM. Which of the following is most likely true about this situation?",
    "choice_a": "The SSD for application data will enter into a degraded mode.",
    "choice_b": "The SSD for swap will become degraded storage.",
    "choice_c": "The SSD will need a namespace in its device filename.",
    "choice_d": "The SSD will end up a missing volume.",
    "correct_answer": "B",
    "explanation": "Due to this application that is memory intensive and experiencing performance issues, the system\u2019s swap space is most likely receiving high I/O from RAM. SSDs have a finite number of program/erase (PE) cycles, and continually writing and removing data from them, such as occurs in swap, will cause them to become degraded storage faster than normal. Thus, option B is the correct answer. Degraded mode refers to the mode a RAID enters when one or more of its member disks have failed. Since it is not stated whether or not the application data is stored on a RAID array, option A is a wrong answer. Only NVMe SSDs need to have a namespace in their device filenames. Since it is not stated whether or not these SSDs are NVMe disks, option C is also an incorrect answer. A missing volume occurs when a disk that is part of a logical volume fails or is accidentally removed. Since it is not stated whether or not these SSDs are involved with a logical volume, option D is a wrong choice. Resource exhaustion occurs when a system\u2019s finite resources are committed and unavailable to others. For disks, this includes running out of inode numbers or disk space. While it is possible that at some point in time the SSDs will experience resource exhaustion, there is not enough information provide to declare that they will. Therefore, option E is also an incorrect choice.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      352,
      318,
      317,
      312,
      313
    ],
    "source": "316328_c24",
    "choice_e": "The SSD will experience resource exhaustion."
  },
  {
    "id": 490,
    "question": "Mary adds the first SCSI disk to a Linux system that currently has only IDE drives. The system is not recognizing the new disk. Which of the following commands should she employ to troubleshoot the problem? (Choose all that apply.)",
    "choice_a": "<code>ls /sys/bus/scsi/drivers</code>",
    "choice_b": "<code>pvscan /dev/vg00/lvol0</code>",
    "choice_c": "<code>lsmod | grep <i>module-name</i></code>",
    "choice_d": "<code>hdparm -B 127 <i>device-filename</i></code>",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Since this is this system\u2019s first SCSI disk and it is not being recognized, it is possible that the appropriate modules (drivers) are not loaded. Thus, Mary should check to see if the drivers are on the system using the command in option A and check if they are currently loaded into the kernel using the command in option C. The <code>pvscan</code> utility is used for physical volumes being used for a logical volume\u2019s volume group. Therefore, option B is a wrong answer. The <code>hdparm</code> and <code>smartctl</code> commands in options D and E are employed for checking and resetting power management configurations on a SATA device. Thus, they are incorrect choices.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      214,
      355,
      217,
      371,
      351
    ],
    "source": "316328_c24",
    "choice_e": "<code>smartctl -a</code>"
  },
  {
    "id": 491,
    "question": "The system administrator, Norman, runs a Python program and receives an <code>IO Error: [Error 13] Permission denied</code> message. What information should he gather (or know) to start troubleshooting this issue? (Choose all that apply.)",
    "choice_a": "The disk type, where the program resides",
    "choice_b": "His user account name",
    "choice_c": "The program action that raised the error",
    "choice_d": "Filename and directory location of the program\u2019s I/O files",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "For Norman to begin the process of troubleshooting this application permission issue, he\u2019ll need to either know or determine the information listed in options B, C, and D. The disk type, where the program resides, does not assist in this troubleshooting process, so option A is a wrong answer. The program\u2019s name is also not helpful here, so option E is an incorrect choice.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      357,
      360,
      358,
      359,
      366
    ],
    "source": "316328_c24",
    "choice_e": "The program\u2019s name"
  },
  {
    "id": 492,
    "question": "Harry has modified an application to create a file in a directory and then write data to it. The program creates the file with no problems but cannot write data to it and receives a permission error. Which of the following is most likely the issue?",
    "choice_a": "Directory ownership",
    "choice_b": "File ownership",
    "choice_c": "File group membership",
    "choice_d": "Permission inheritance",
    "correct_answer": "D",
    "explanation": "Because the application can create the file in a particular directory with no problem but cannot write to the file, it is most likely a permission inheritance issue via default directory ACLs. Therefore, option D is the correct answer. If the directory ownership and their permissions were a problem, the application could not create a file in that directory. Therefore, option A is a wrong answer. File ownership and group membership would have to be manually changed by the application in order to cause this issue. Therefore, options B and C are incorrect answers. Executable privileges are involved with being able to run a program file or change a process\u2019s present working directory, and thus, option E is an incorrect choice.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      335,
      334,
      338,
      145,
      53
    ],
    "source": "316328_c24",
    "choice_e": "Executable privileges"
  },
  {
    "id": 493,
    "question": "Ben updates his Ubuntu system\u2019s packages using the <code>sudo apt-get upgrade</code> command, and now the Apache Web service is not working properly. What command should he run?",
    "choice_a": "<code>sudo apt-get clean</code>",
    "choice_b": "<code>sudo zypper clean -a</code>",
    "choice_c": "<code>sudo ldd /usr/sbin/apache2</code>",
    "choice_d": "<code>sudo rpm -aV</code>",
    "correct_answer": "E",
    "explanation": "The upgrade may have broken the Apache package via breaking a dependency. The <code>sudo apt-get check</code> command will check for such a thing. Thus, option E is the correct answer. The commands in options A and B will clean up the repository database and any temporary download files but not help to troubleshoot this issue. Therefore, options A and B are wrong answers. The command in option C shows library files used by the Apache service, but it does not help troubleshoot the problem and is therefore an incorrect answer. Option D\u2019s command checks for broken dependencies, but on a Red Hat\u2013based system, and thus it is an incorrect choice.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      205,
      204,
      211,
      206,
      92
    ],
    "source": "316328_c24",
    "choice_e": "<code>sudo apt-get check</code>"
  },
  {
    "id": 494,
    "question": "Peter writes a new C++ application to use for managing his older Linux server. The new app contains no programming or logic errors. However, when he tries to compile it, it does not work. Which of the following is most likely the issue?",
    "choice_a": "An incorrect application permission",
    "choice_b": "An incorrect file permission",
    "choice_c": "A missing or outdated GCC",
    "choice_d": "A missing or outdated device",
    "correct_answer": "C",
    "explanation": "If Peter cannot compile a flawlessly written C++ application, then the problem must lie with the compiler, GCC. Thus, option C is the correct answer. Application and file permissions would not cause this particular issue, so options A and B are wrong answers. A missing or outdated device would not be the problem for this situation, so option D is also an incorrect answer. Since Peter wrote this application, instead of trying to obtain one from a package repository, option E is an incorrect choice as well.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      201,
      38,
      334,
      53,
      87
    ],
    "source": "316328_c24",
    "choice_e": "A repository problem"
  },
  {
    "id": 495,
    "question": "Mary confirms via the <code>sealert</code> utility that her application cannot access the file <code>flash.txt</code>. What command should she use next?",
    "choice_a": "<code>ls -l flash.txt</code>",
    "choice_b": "<code>ls -Z flash.txt</code>",
    "choice_c": "<code>ls -l <i>flash.txt-directory</i></code>",
    "choice_d": "<code>setroubleshoot</code>",
    "correct_answer": "B",
    "explanation": "The <code>sealert</code> utility is used to check the audit log file for SELinux context violations. Therefore, the issue here revolves around SELinux. The <code>ls -Z</code> command will allow Mary to view the <code>flash.txt</code> file\u2019s SELinux context to determine if it needs to have it changed. Thus, option B is the correct answer. The option A command will not show the file\u2019s SELinux context and is therefore a wrong answer. While the <code>flash.txt</code> directory might have a context problem, the <code>ls -l</code> command will not show it, and thus option C is a wrong choice as well. Option D\u2019s <code>setroubleshoot</code> is a package and not a command, so it is a wrong answer. Option E\u2019s <code>restorecon</code> will fix SELinux labels, which may be used in the repair process but not in troubleshooting, so it is an incorrect choice.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      366,
      357,
      358,
      359,
      360
    ],
    "source": "316328_c24",
    "choice_e": "<code>restorecon</code>"
  },
  {
    "id": 496,
    "question": "A clock-in/out application, which uses an NTP server on the local network, is throwing an error concerning reaching the server. There are currently no network problems. Which of the following are steps in the troubleshooting process for this issue? (Choose all that apply.)",
    "choice_a": "Check the firewall ACLs on the NTP server.",
    "choice_b": "Check the firewall ACLs on the application server.",
    "choice_c": "Use the <code>firewall-cmd --get-default-zone</code> command.",
    "choice_d": "Check the <code>/etc/services</code> file for NTP ports and transport protocols.",
    "correct_answer": [
      "A",
      "B",
      "D",
      "E"
    ],
    "explanation": "For troubleshooting this issue, the firewall ACLs on both the NTP server and the application server must be checked. Either side could be dropping or rejecting packets, so options A and B are correct answers. If you do not have the NTP ports and transport protocols memorized, the <code>/etc/services</code> file needs checking. That information is critical for reviewing server- and client-side firewall ACLs. Thus, option D is a correct answer too. It is a good idea to view the firewall log entries because they may point to the exact cause of the problem or provide valuable information. Therefore, option E is a right choice. The <code>firewall-cmd</code> command is specific only to those systems that employ the <code>firewalld</code> firewall. Therefore, option C is the only incorrect choice.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      268,
      267,
      270,
      273,
      277
    ],
    "source": "316328_c24",
    "choice_e": "View firewall log entries."
  },
  {
    "id": 497,
    "question": "Your system administrator team member Norman tells you the device located at the communications port is not working. What command should you issue to start the troubleshooting process?",
    "choice_a": "<code>dmesg | grep -i COM</code>",
    "choice_b": "<code>dmesg | grep -i ttys</code>",
    "choice_c": "<code>sudo setserial -a /dev/COM1</code>",
    "choice_d": "<code>sudo setserial -a /dev/ttyS0</code>",
    "correct_answer": "B",
    "explanation": "The communications port is a serial port, represented by the <code>/dev/ttyS#</code> device files. To find the right number (#), use the <code>dmesg</code> command to start the troubleshooting process. Thus, option B is the correct answer. Since a serial port is not represented by files named <code>/dev/COM#</code>, both options A and C are wrong answers. The <code>setserial</code> command is used after you determined the appropriate filename for the serial device, so it is not the first step and option D is an incorrect answer. The <code>cat /proc/interrupts</code> command is performed after you find the correct IRQ via the <code>setserial</code> command, so option E is an incorrect choice as well.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      376,
      214,
      351,
      375,
      355
    ],
    "source": "316328_c24",
    "choice_e": "<code>cat /proc/interrupts</code>"
  },
  {
    "id": 498,
    "question": "Harry\u2019s newly installed USB printer is not working. The system employs CUPS. Which of the following are steps that may be included in the troubleshooting process? (Choose all that apply.)",
    "choice_a": "Issue the <code>less /etc/printcap</code> command.",
    "choice_b": "Use the <code>lpinfo -m</code> command to view available USB ports.",
    "choice_c": "Put a watch on the appropriate log file and plug in the USB cable.",
    "choice_d": "Use the <code>dmesg</code> and <code>grep</code> utilities to find printer information.",
    "correct_answer": [
      "C",
      "D",
      "E"
    ],
    "explanation": "The activities in options C, D, and E are all steps that may be included in troubleshooting this USB printer issue. A CUPS system uses the <code>/etc/cups/printers.conf</code> file instead of the <code>/etc/printcap</code> file, so option A is a wrong answer. The <code>lpinfo -m</code> command allows you to view available printer drivers, not USB ports, so option B is an incorrect choice as well.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      373,
      375,
      214,
      262,
      259
    ],
    "source": "316328_c24",
    "choice_e": "Use the <code>lsusb -v</code> command to see if the device is on the USB bus."
  },
  {
    "id": 499,
    "question": "What character or characters make up the shebang used in Linux to define the shell used for a shell script?",
    "choice_a": "<code>>></code>",
    "choice_b": "<code>#!</code>",
    "choice_c": "<code>|</code>",
    "choice_d": "<code>></code>",
    "correct_answer": "B",
    "explanation": "The <code>#!</code> character combination defines the shebang, which tells the Linux shell what shell to use to run the shell script code, so option B is correct. The <code>>></code> character combination appends the output of a command to a file, so option A is incorrect. The <code>|</code> character pipes the output of a command to another command, so option C is incorrect. The <code>></code> character redirects the output of a command to a new file or overwrites an existing file, so option D is incorrect. The <code>2></code> character combination redirects error messages from a command to a file, so option E is incorrect.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      380,
      382,
      378,
      385,
      386
    ],
    "source": "316328_c25",
    "choice_e": "<code>2></code>"
  },
  {
    "id": 500,
    "question": "Henry needs to store the output from his script into a new log file that he can read later. What character or characters should he use to do that?",
    "choice_a": "<code>>></code>",
    "choice_b": "<code>#!</code>",
    "choice_c": "<code>|</code>",
    "choice_d": "<code>></code>",
    "correct_answer": "D",
    "explanation": "The <code>></code> character redirects all of the output from a command to a new file, or overwrites an existing file, so option D is correct. The <code>>></code> character combination appends all of the output from a command to an existing file, so option A is incorrect. The <code>#!</code> combination defines the shell to use, so option B is incorrect. The <code>|</code> character pipes output from one command to another command, so option C is incorrect. The <code>2></code> character combination redirects only error messages from a command to a new file, not all of the output, so option E is incorrect.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      378,
      379,
      380,
      382,
      385
    ],
    "source": "316328_c25",
    "choice_e": "<code>2></code>"
  },
  {
    "id": 501,
    "question": "Jasmine has created a new Bash shell script and wants to run it from the command line. What <code>chmod</code> permissions should she assign to the file to run it as a shell script?",
    "choice_a": "<code>644</code>",
    "choice_b": "<code>u+r</code>",
    "choice_c": "<code>u+x</code>",
    "choice_d": "<code>u+w</code>",
    "correct_answer": "C",
    "explanation": "The <code>u+x chmod</code> permission assign execute permissions to the file owner so you can run the file at the command prompt, which makes option C correct. The <code>644</code> octal permissions assigns only read and write permissions to the file owner, not execute permissions, so option A is incorrect. The <code>u+r</code> permission assigns read permissions, not execute permissions, so option B is incorrect. The <code>u+w</code> permission assigns only write permissions and not execute permissions, so option D is incorrect. The <code>u=wr</code> permission assigns both read and write permissions but not execute permissions to the file owner, so option E is incorrect.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      380,
      386,
      385,
      384,
      383
    ],
    "source": "316328_c25",
    "choice_e": "<code>u=wr</code>"
  },
  {
    "id": 502,
    "question": "What environment variable contains the username of the user who started the shell?",
    "choice_a": "<code>$USER</code>",
    "choice_b": "<code>$UID</code>",
    "choice_c": "<code>$HOME</code>",
    "choice_d": "<code>$BASH</code>",
    "correct_answer": "A",
    "explanation": "The <code>$USER</code> environment variable contains the text username of the user account that started the shell, so option A is correct. The <code>$UID</code> environment variable contains the numeric user ID, not the text username, so option B is incorrect. The <code>$HOME</code> environment variable contains the home directory location of the user account, not the username, so option C is incorrect. The <code>$BASH</code> environment variable contains the location of the Bash shell executable file, not the username of the user who started the shell, so option D is incorrect. The <code>$1</code> variable is a positional variable, not an environment variable. It\u2019s used to retrieve data from the command-line command that launched the shell, not identify the user who started the shell, so option E is incorrect.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      383,
      384,
      386,
      387,
      391
    ],
    "source": "316328_c25",
    "choice_e": "<code>$1</code>"
  },
  {
    "id": 503,
    "question": "Zuri is writing a Bash shell script and needs to assign a number to a variable. How should he do that?",
    "choice_a": "<code>var1=$(10)</code>",
    "choice_b": "<code>var1 = 10</code>",
    "choice_c": "<code>var1=10</code>",
    "choice_d": "<code>var1=\"10\"</code>",
    "correct_answer": "C",
    "explanation": "To assign a value to a variable, you use the equal sign, but no spaces must be used between the variable name, the equal sign, and the value, so option C is correct. Option A uses the command substitution format, which doesn\u2019t assign a value to a variable but to the output of a command, so option A is incorrect. Option B places spaces between the variable name, equal sign, and the value, so option B is incorrect. Option D places quotes around the value, making it a string value and not a numeric value, so option D is incorrect. Option E uses backtick characters around the value, which attempts to run it using command substitution, which is incorrect.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      383,
      387,
      382,
      388,
      384
    ],
    "source": "316328_c25",
    "choice_e": "<code>var1=`10`</code>"
  },
  {
    "id": 504,
    "question": "Cameron is writing a Bash shell script and needs to test if a file exists and that it\u2019s a file. What line of code should he write to do that?",
    "choice_a": "if [ <code>-e <i>file</i> ]</code>",
    "choice_b": "if [ <code>-f <i>file</i> ]</code>",
    "choice_c": "if [ <code>-d <i>file</i> ]</code>",
    "choice_d": "if [ <code>-x <i>file </i>]</code>",
    "correct_answer": "B",
    "explanation": "The <code>-f <i>file</i></code> test checks if the specified object exists, and if it\u2019s a file, so option B is correct. The <code>-e <i>file</i></code> test checks if the object exists, not the object type, so option A is incorrect. The <code>-d <i>file</i></code> test checks if the object exists but is a directory, not a file, so option C is incorrect. The <code>-x <i>file</i></code> test checks if the current user account has execute permissions for the file, not that the object exists and is a file, so option D is incorrect. The <code>-w</code> <i>file</i> test checks if the current user account has write permissions for the file, not that the object exists and is a file, so option E is incorrect.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      389,
      386,
      388,
      390,
      383
    ],
    "source": "316328_c25",
    "choice_e": "if [ <code>-w <i>file</i> ]</code>"
  },
  {
    "id": 505,
    "question": "What character or combination of characters do you use to redirect the output of one command to another command?",
    "choice_a": ">>",
    "choice_b": "#!",
    "choice_c": "|",
    "choice_d": ">",
    "correct_answer": "C",
    "explanation": "The bar character (<code>|</code>) pipes the output of one command to the input of another command, so option C is correct. The <code>>></code> character combination appends the output of a command to an existing file, not to another command, so option A is incorrect. The shebang (<code>#!</code>) is used to identify the shell to use to run the script, not redirect output from a command to another command, so option B is incorrect. The <code>></code> character redirects the output of a command to a new file, not to another command, so option D is incorrect. The <code>2></code> character combination redirects the error messages from a command to a new file, not to another command, so option E is incorrect.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      379,
      378,
      382,
      381,
      380
    ],
    "source": "316328_c25",
    "choice_e": "<code>2></code>"
  },
  {
    "id": 506,
    "question": "Christina is creating a Bash shell script and wants to make the script return a value of 2 if it fails. What statement should she add to do that?",
    "choice_a": "<code>#!2</code>",
    "choice_b": "<code>$?</code>",
    "choice_c": "<code>$1</code>",
    "choice_d": "<code>exit 2</code>",
    "correct_answer": "D",
    "explanation": "The <code>exit</code> command allows us to return a specific error status when the shell script exits, so option D is correct. The <code>#!</code> shebang defines the shell to use to run the shell script, not the exit status, so option A is incorrect. The <code>$?</code> character combination displays the exit status from the last command; it doesn\u2019t return a specific exit status, so option B is incorrect. The <code>$1</code> variable contains the first command-line parameter used when the shell script is launched from the command line; it doesn\u2019t set the exit status for the shell script, so option C is incorrect. The <code>while</code> command allows us to iterate through a set of commands until a specific condition is met; it doesn\u2019t return a specific exit status when the shell exits, so option E is incorrect.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      385,
      380,
      384,
      389,
      386
    ],
    "source": "316328_c25",
    "choice_e": "<code>while</code>"
  },
  {
    "id": 507,
    "question": "What command should you use to perform a command substitution to assign the output of a command to a variable in your shell script?",
    "choice_a": "<code>></code>",
    "choice_b": "<code>>></code>",
    "choice_c": "<code>$[]</code>",
    "choice_d": "<code>|</code>",
    "correct_answer": "E",
    "explanation": "The <code>$()</code> command assigns the output of a command to a specified variable in the shell script, so option E is correct. The <code>></code> character redirects the output of a command to a file, not to a variable, so option A is incorrect. The <code>>></code> character combination appends the output of a command to an existing file, not to a variable, so option B is incorrect. The <code>$[]</code> command performs integer mathematical operations in the Bash shell, so option C is incorrect. The <code>|</code> character redirects the output of a command to another command, not to a variable, so option D is incorrect.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      387,
      388,
      378,
      379,
      383
    ],
    "source": "316328_c25",
    "choice_e": "<code>$()</code>"
  },
  {
    "id": 508,
    "question": "What command should you use to perform a mathematical operation in your shell script?",
    "choice_a": "<code>></code>",
    "choice_b": "<code>>></code>",
    "choice_c": "<code>$[]</code>",
    "choice_d": "<code>|</code>",
    "correct_answer": "C",
    "explanation": "The <code>$[]</code> command performs simple integer mathematical operations in the Bash shell, so option C is correct. The <code>></code> character redirects the output of a command to a new file, so option A is incorrect. The <code>>></code> character combination appends the output of a command to an existing file, so option B is incorrect. The <code>|</code> character redirects the output of a command to another command, so option D is incorrect. The <code>$()</code> command redirects the output of a command to a variable in the shell script, so option E is incorrect.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      388,
      387,
      378,
      379,
      382
    ],
    "source": "316328_c25",
    "choice_e": "<code>$()</code>"
  },
  {
    "id": 509,
    "question": "What is the difference between a compiled program and an interpreted program?",
    "choice_a": "The interpreted program is converted to binary format to run directly on the CPU, while the compiled program must be run by another program.",
    "choice_b": "The interpreted program can access external code libraries while compiled code can\u2019t.",
    "choice_c": "The compiled program can access external code libraries while interpreted code can\u2019t.",
    "choice_d": "The compiled program is converted to binary format to run directly on the CPU, while the interpreted program must be run by another program.",
    "correct_answer": "D",
    "explanation": "Compiled programs are converted to binary code to run directly on the CPU. Interpreted programs require a separate program to read each statement and convert it to the binary code necessary to run on the CPU. Thus Option D is correct. Option A indicates the reverse, so it\u2019s not correct. Both compiled and interpreted programs can access code in external libraries, so Options B and C are both incorrect. Option E is incorrect as there is indeed a difference between compiled and interpreted programs.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      395,
      380,
      401,
      386,
      387
    ],
    "source": "316328_c26",
    "choice_e": "There is no difference between compiled and interpreted programs."
  },
  {
    "id": 510,
    "question": "What two features does Python provide for running programs?",
    "choice_a": "An interactive development environment",
    "choice_b": "A script interpreter program",
    "choice_c": "A text editor for entering code",
    "choice_d": "A debugging tool for examining error messages",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "The Python command-line tool provides both the ability to launch an interactive development environment, which processes one line of Python code at a time, and an interpreter program that can run an entire Python script, so options A and B are correct. The Python interactive development environment doesn\u2019t include a text editor nor debugger, so options C, D, and E are incorrect.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      395,
      396,
      398,
      399,
      400
    ],
    "source": "316328_c26",
    "choice_e": "A code syntax checker for correcting your code"
  },
  {
    "id": 511,
    "question": "How do you run your Python script file through the interpreter on the command line?",
    "choice_a": "<code>python3 > myscript.py</code>",
    "choice_b": "<code>myscript.py > python3</code>",
    "choice_c": "<code>python3 myscript.py</code>",
    "choice_d": "<code>myscript.py python3</code>",
    "correct_answer": "C",
    "explanation": "The <code>python3</code> command-line tool takes the name of the file to process as a command-line parameter, so option C is correct. You cannot redirect the output of the <code>python3</code> command-line tool, so option A is incorrect. You also cannot run the Python script directly on the command line and redirect the output to the <code>python3</code> program, so option B is incorrect. Since the script filename is a command-line parameter, it must be listed after the <code>python3</code> program name, so option D is incorrect. Since the Python script file can\u2019t run on the command line, you can\u2019t pipe it to the <code>python3</code> program, so option E is incorrect.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      395,
      394,
      384,
      378,
      380
    ],
    "source": "316328_c26",
    "choice_e": "<code>myscript.py | python3</code>"
  },
  {
    "id": 512,
    "question": "Once you start the interactive Python development environment, how to do exit back to the Linux shell?",
    "choice_a": "The Python <code>exit()</code> function",
    "choice_b": "The Python <code>print()</code> function",
    "choice_c": "The <code>exit</code> statement",
    "choice_d": "The <code>return</code> statement",
    "correct_answer": "A",
    "explanation": "The Python <code>exit()</code> function properly closes out the interactive development environment and returns you to the Linux command line, so option A is correct. The <code>print()</code> function displays output on the terminal STDOUT, but does not exit the interactive development environment, so option B is incorrect. The <code>exit()</code> function is a function and not a statement, so option C is incorrect. The <code>return</code> statement is used to return a value from a function defined in the Python program, not to exit the interactive development environment, so option D is incorrect. The <code>venv</code> option initializes a virtual Python environment\u2014it doesn\u2019t exit from the interactive development environment\u2014so option E is incorrect.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      395,
      398,
      401,
      394,
      403
    ],
    "source": "316328_c26",
    "choice_e": "The <code>venv</code> option"
  },
  {
    "id": 513,
    "question": "What function do you use to display output to the STDOUT on the Linux system?",
    "choice_a": "<code>exit()</code>",
    "choice_b": "<code>return</code>",
    "choice_c": "<code>input()</code>",
    "choice_d": "<code>import</code>",
    "correct_answer": "E",
    "explanation": "The <code>print()</code> function allows you to output text and variable values to the STDOUT of the Linux session, so option E is correct. The <code>exit()</code> function shuts down the interactive development environment without sending text to the output, so option A is incorrect. The <code>return</code> statement returns a value from a function to the main program, not to the output, so option B is incorrect. The <code>input()</code> function reads data entered from the STDIN of the session\u2014it doesn\u2019t output data\u2014so option C is incorrect. The <code>import</code> statement loads the functions contained in a module library\u2014it doesn\u2019t output data\u2014so option D is incorrect.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      398,
      401,
      385,
      395,
      400
    ],
    "source": "316328_c26",
    "choice_e": "<code>print()</code>"
  },
  {
    "id": 514,
    "question": "Which of these are valid variable names in Python?",
    "choice_a": "<code>myTest</code>",
    "choice_b": "<code>1Test</code>",
    "choice_c": "<code>_mytest</code>",
    "choice_d": "<code>test value</code>",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "Python requires that variable names start with a letter, number, or underscore, so options A, B, and C are correct. Option D contains a space in the variable name, which is not allowed in Python, so option D is incorrect. Option E starts with a dollar sign, which is not a valid character for Python variable names, so option E is incorrect.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      396,
      395,
      394,
      399,
      400
    ],
    "source": "316328_c26",
    "choice_e": "<code>$Test</code>"
  },
  {
    "id": 515,
    "question": "What Python data type allows you to store an ordered collection of data that can\u2019t be changed inside the program?",
    "choice_a": "List",
    "choice_b": "Tuple",
    "choice_c": "Dictionary",
    "choice_d": "Complex",
    "correct_answer": "B",
    "explanation": "The tuple data type allows you to store values in a variable in order, but you can\u2019t modify the values once they\u2019re stored, so option B is correct. The list data type allows you to store an ordered collection of data, but the values can be changed in the program, so option B is incorrect. The dictionary data type allows you to store unordered pairs of data as a key/pair that can be modified, so option C is incorrect. The complex data type is used for storing imaginary numbers, not multiple data values, so option D is incorrect. The string data type can just contain one data value, so option E is incorrect.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      396,
      400,
      401,
      395,
      398
    ],
    "source": "316328_c26",
    "choice_e": "String"
  },
  {
    "id": 516,
    "question": "Which Python math operator allows you to perform a binary <code>AND</code> operation?",
    "choice_a": "<code>and</code>",
    "choice_b": "<code>%</code>",
    "choice_c": "<code>&</code>",
    "choice_d": "<code>|</code>",
    "correct_answer": "C",
    "explanation": "The ampersand sign (<code>&</code>) provides the binary <code>AND</code> operation in Python, so option C is correct. The <code>and</code> operator performs a logical <code>AND</code>, not a binary <code>AND</code>, so option A is incorrect. The percent operator (<code>%</code>) returns the modules value of a division operation, not the binary <code>AND</code>, so option B is incorrect. The pipe symbol (<code>|</code>) performs the binary <code>OR</code> operation, not the binary <code>AND</code> operation, so option D is incorrect. The <code>**</code> symbol provides the exponentiation operation, not the binary <code>AND</code> operation, so option E is incorrect.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      397,
      398,
      399,
      400,
      401
    ],
    "source": "316328_c26",
    "choice_e": "<code>**</code>"
  },
  {
    "id": 517,
    "question": "How does Python delineate the statements contained in a <code>if</code> statement block?",
    "choice_a": "Using an ending <code>fi</code> statement",
    "choice_b": "Using and <code>end</code> statement",
    "choice_c": "Using curly braces",
    "choice_d": "Using brackets",
    "correct_answer": "E",
    "explanation": "Python groups statements together in an <code>if</code> statement by using indentation\u2014all of the statements must be indented from the <code>if</code> statement, so option E is correct. The other options show methods used by other programming languages and not Python; therefore, options A, B, C, and D are all incorrect.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      399,
      398,
      400,
      396,
      397
    ],
    "source": "316328_c26",
    "choice_e": "Using indentation"
  },
  {
    "id": 518,
    "question": "What program do you use to download and install a new Python module?",
    "choice_a": "<code>python</code>",
    "choice_b": "<code>python3</code>",
    "choice_c": "<code>pip</code>",
    "choice_d": "<code>venv</code>",
    "correct_answer": "C",
    "explanation": "The <code>pip</code> program contacts the <code>http://pypi.org</code> repository to download and install Python modules published in the repository, so option C is correct. The <code>python</code> and <code>python3</code> command-line programs start the Python program, not install modules, so options A and B are incorrect. The <code>venv</code> option creates a virtual Python environment but doesn\u2019t install modules, so option D is incorrect. The <code>source</code> command changes you current Python environment to the virtual environment\u2014it doesn\u2019t install modules\u2014so option E is incorrect.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      402,
      403,
      394,
      395,
      396
    ],
    "source": "316328_c26",
    "choice_e": "<code>source</code>"
  },
  {
    "id": 519,
    "question": "Frank wants to run his large number-crunching application in background mode on his console session. What command does he need to use to do that?",
    "choice_a": "<code>></code>",
    "choice_b": "<code>&</code>",
    "choice_c": "<code>|</code>",
    "choice_d": "<code>>></code>",
    "correct_answer": "B",
    "explanation": "The ampersand character (<code>&</code>) tells the shell to start the command in background mode from the console session, so option B is correct. The greater-than sign (>) redirects the output from the command to a file, so option A is incorrect. The pipe symbol (<code>|</code>) redirects the output from the command to another command, so option C is incorrect. The double greater-than sign (>>) appends the output from the command to a file, so option D is incorrect. The <code>nohup</code> command disconnects the session from the console session, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      404,
      408,
      415,
      409,
      18
    ],
    "source": "316328_c27",
    "choice_e": "<code>nohup</code>"
  },
  {
    "id": 520,
    "question": "What command do you use to disconnect a shell script from the current console so that it can continue to run after the console exits?",
    "choice_a": "<code>></code>",
    "choice_b": "<code>&</code>",
    "choice_c": "<code>|</code>",
    "choice_d": "<code>>></code>",
    "correct_answer": "E",
    "explanation": "The <code>nohup</code> command disconnects the shell script from the current console session, so option E is correct. The greater-than sign (>) redirects the output from the command to a file, so option A is incorrect. The ampersand sign (<code>&</code>) runs the shell script in background mode, so option B is incorrect. The pipe symbol (<code>|</code>) redirects the output from the command to another command, so option C is incorrect. The double greater-than symbol (>>) appends the output from the command to a file, so option D is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      405,
      404,
      415,
      408,
      18
    ],
    "source": "316328_c27",
    "choice_e": "<code>nohup</code>"
  },
  {
    "id": 521,
    "question": "When Melanie runs a shell script, she notices that it takes up all of the memory on her Linux system and she needs to stop it. How can she do that?",
    "choice_a": "Start it with the <code>nohup</code> command.",
    "choice_b": "Start it with the ampersand (<code>&</code>) command.",
    "choice_c": "Press Ctrl+C while the script is running.",
    "choice_d": "Redirect the output using the pipe symbol.",
    "correct_answer": "C",
    "explanation": "The Ctrl+C key combination stops the job currently running in foreground mode on the console session, so option C is correct. Starting a command with the <code>nohup</code> command disconnects the job from the console session, so you can\u2019t stop it from the console with a key command and option A is incorrect. Starting a job with the ampersand (<code>&</code>) command places the job in background mode but doesn\u2019t allow you to stop the job from running, so option B is incorrect. The pipe symbol redirects the output from a shell script to another command, so option D is incorrect. The <code>kill</code> command will stop a running shell script, but if the shell script is running in your console session, you won\u2019t be able to submit the <code>kill</code> command from the command prompt, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      406,
      408,
      415,
      404,
      405
    ],
    "source": "316328_c27",
    "choice_e": "Use the <code>kill</code> command to stop it."
  },
  {
    "id": 522,
    "question": "How can you temporarily pause a shell script from running in foreground mode in a console session?",
    "choice_a": "Press Ctrl+Z.",
    "choice_b": "Press Ctrl+C.",
    "choice_c": "Start the command with the <code>nohup</code> command.",
    "choice_d": "Start the command with the ampersand (<code>&</code>) command.",
    "correct_answer": "A",
    "explanation": "The Ctrl+Z key combination pauses the job currently running in foreground mode on the console session, so option A is correct. The Ctrl+C key combination stops the job currently running in foreground in the console session, rather than pauses it, so option B is incorrect. The <code>nohup</code> command disconnects a job from the console session but doesn\u2019t pause the job, so option C is incorrect. The ampersand sign (<code>&</code>) runs a job in background mode in the console session, so option D is incorrect. The <code>fg</code> command resumes a stopped job in foreground mode, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      406,
      408,
      415,
      407,
      409
    ],
    "source": "316328_c27",
    "choice_e": "Start the command with the <code>fg</code> command."
  },
  {
    "id": 523,
    "question": "How do you determine the default job running in a console session?",
    "choice_a": "By the PID number",
    "choice_b": "By the job number",
    "choice_c": "By a plus sign next to the job number in the <code>jobs</code> output",
    "choice_d": "By a minus sign next to the job number in the <code>jobs</code> output",
    "correct_answer": "C",
    "explanation": "When you list the current jobs using the <code>jobs</code> command, there will be a plus sign next to the default job number, so option C is correct. The minus sign next to a job number indicates the job next in line to become the default job, so option D is incorrect. Neither the PID nor job number indicate the default job, so options A and B are both incorrect. The <code>ps</code> command lists the running jobs but doesn\u2019t indicate the default job in a console session, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      409,
      408,
      415,
      404,
      406
    ],
    "source": "316328_c27",
    "choice_e": "Using the <code>ps</code> command"
  },
  {
    "id": 524,
    "question": "Barbara has an application running in background mode in her console session and needs to bring it to foreground mode. What command should she use to do that?",
    "choice_a": "<code>bg</code>",
    "choice_b": "<code>fg</code>",
    "choice_c": "<code>nohup</code>",
    "choice_d": "<code>&</code>",
    "correct_answer": "B",
    "explanation": "The <code>fg</code> command allows you to change a currently running or stopped job to run in foreground mode on the current console session, so option B is correct. The <code>bg</code> command changes a currently running or stopped job to run in background mode, so option A is incorrect. The <code>nohup</code> command disconnects a job from the console session, so option C is incorrect. The ampersand sign (<code>&</code>) places a job in background mode, not foreground mode, so option D is incorrect. The <code>at</code> command runs a job in background mode at a specific time, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      408,
      415,
      406,
      409,
      404
    ],
    "source": "316328_c27",
    "choice_e": "<code>at</code>"
  },
  {
    "id": 525,
    "question": "What command allows you to run a shell script at a specific time?",
    "choice_a": "<code>nohup</code>",
    "choice_b": "<code>&</code>",
    "choice_c": "<code>at</code>",
    "choice_d": "|",
    "correct_answer": "C",
    "explanation": "The <code>at</code> command allows you to schedule a job to run at a specific time, so option C is correct. The <code>nohup</code> command disconnects a job from the console session, so option A is incorrect. The ampersand sign (<code>&</code>) runs a job in background mode, so option B is incorrect. The pipe symbol (<code>|</code>) and the greater-than symbol redirect the job output to either a command or a file, so options D and E are both incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      410,
      414,
      411,
      412,
      413
    ],
    "source": "316328_c27",
    "choice_e": "<code>></code>"
  },
  {
    "id": 526,
    "question": "Nick needs to run a report at midnight every day on his Linux system. How should he do that?",
    "choice_a": "Use the <code>at</code> command to schedule the job.",
    "choice_b": "Run the job using the <code>nohup</code> command.",
    "choice_c": "Run the job using the ampersand (<code>&</code>) symbol.",
    "choice_d": "Schedule the job using <code>cron</code>.",
    "correct_answer": "D",
    "explanation": "The <code>cron</code> program checks the cron tables for each user account and runs any scheduled jobs automatically, so option D is correct. The <code>at</code> command only runs a specified command once at a scheduled time, so option A is incorrect. The <code>nohup</code> and ampersand (<code>&</code>) commands do not schedule jobs to run, so both options B and C are incorrect. The <code>atq</code> command displays the jobs already scheduled to run from the <code>at</code> command, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      412,
      410,
      411,
      404,
      405
    ],
    "source": "316328_c27",
    "choice_e": "Run the job using the <code>atq</code> command."
  },
  {
    "id": 527,
    "question": "When will the <code>cron</code> table entry <code>10 5 * * * myscript</code> run the specified shell script?",
    "choice_a": "At 10:05 a.m. every day",
    "choice_b": "On May 10th every year",
    "choice_c": "On October 5th every year",
    "choice_d": "At 5:10 p.m. every day",
    "correct_answer": "E",
    "explanation": "The times specified in the <code>cron</code> table is listed in the order of minute, hour, day of month, month, and day of week. The hour is in 24-hour format, so the specified entry would run the job at 5:10 a.m. every day, making option E correct. Options A, B, C, and D are all incorrect times based on the specified entry.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      412,
      414,
      411,
      408,
      415
    ],
    "source": "316328_c27",
    "choice_e": "At 5:10 a.m. every day"
  },
  {
    "id": 528,
    "question": "Jane needs to check on what jobs are scheduled to run automatically for her user account. What command should she use to list the <code>cron</code> table entries for her user account?",
    "choice_a": "<code>cron</code>",
    "choice_b": "<code>at</code>",
    "choice_c": "<code>crontab</code>",
    "choice_d": "<code>jobs</code>",
    "correct_answer": "C",
    "explanation": "The <code>crontab</code> command allows you to list or edit the cron table for your own user account, so option C is correct. The <code>cron</code> command is what reads the <code>cron</code> tables for each user account and runs the specified jobs; it doesn\u2019t list the jobs, so option A is incorrect. The <code>at</code> command allows you to schedule a job to run at a specific time, so option B is incorrect. The <code>jobs</code> command allows you to view the currently running or stopped jobs in your console session, so option D is incorrect. The <code>nohup</code> command disconnects the job from the console session, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      412,
      410,
      408,
      411,
      415
    ],
    "source": "316328_c27",
    "choice_e": "<code>nohup</code>"
  },
  {
    "id": 529,
    "question": "Which of the following is true concerning version control? (Choose all that apply.)",
    "choice_a": "Provides a common place to merge and store files",
    "choice_b": "Requires filenames to contain version numbers",
    "choice_c": "May be distributed or not distributed",
    "choice_d": "Helps to protect files from being overwritten",
    "correct_answer": [
      "A",
      "C",
      "D",
      "E"
    ],
    "explanation": "Answers A, C, D, and E all contain true statements concerning version control and are therefore correct answers. Version control does not require filenames to contain version numbers, and thus, option B is an incorrect choice.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      416,
      417,
      426,
      427,
      422
    ],
    "source": "316328_c28",
    "choice_e": "Can deal with files other than programs"
  },
  {
    "id": 530,
    "question": "Conceptually Git is broken up into distinct areas. Which of the following is one of those areas? (Choose all that apply.)",
    "choice_a": "Blob",
    "choice_b": "Local repository",
    "choice_c": "Remote repository",
    "choice_d": "Index",
    "correct_answer": [
      "B",
      "C",
      "D",
      "E"
    ],
    "explanation": "Conceptually Git is broken up into distinct areas, which are the working directory, the staging area (also called the index), the local repository, and the remote repository. Therefore, options B, C, D, and E are correct answers. A blob is another name for an object stored by Git in the <code>.git/objects/</code> directory. Thus, option A is an incorrect choice.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      417,
      420,
      419,
      425,
      423
    ],
    "source": "316328_c28",
    "choice_e": "Working directory"
  },
  {
    "id": 531,
    "question": "Which of the following are steps needed to set up a Git environment for the first time? (Choose all that apply.)",
    "choice_a": "Create a working directory.",
    "choice_b": "Initialize the <code>.git/</code> directory in the working directory.",
    "choice_c": "Set up the local repository options.",
    "choice_d": "Add files to the staging area when ready.",
    "correct_answer": [
      "A",
      "B",
      "C",
      "E"
    ],
    "explanation": "The steps listed in options A, B, C, and E are all involved in setting up setting up a Git environment for the first time. Adding files to the staging area is done after the environment is set up and files have been created in the working directory. Therefore, option D is the only incorrect choice.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      419,
      417,
      420,
      421,
      422
    ],
    "source": "316328_c28",
    "choice_e": "Establish the remote repository."
  },
  {
    "id": 532,
    "question": "Natasha has created her working directory for a new project. What should she do next to set up her Git project environment?",
    "choice_a": "Issue the <code>mkdir</code> command.",
    "choice_b": "Enter the <code>git config \u2013\u2013list</code> command.",
    "choice_c": "Set up her GitHub repository.",
    "choice_d": "Enter the <code>git init</code> command.",
    "correct_answer": "D",
    "explanation": "Because Natasha is setting up her Git environment, she should next create and initialize the <code>.git/</code> directory in her working directory, using the <code>git init</code> command. Therefore, option D is the correct answer. The <code>mkdir</code> command is employed to create the working directory, which is already done, so option A is a wrong answer. The <code>git config --list</code> command shows configuration data, which should be done after the <code>.git/</code> directory is initialized, so option B is a wrong choice. While Natasha could set up her GitHub repository now, it is not the best next step, so option C is a wrong answer. Starting to create program files is an incorrect choice since Natasha is still setting up her Git environment. Therefore, option E is incorrect.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      419,
      420,
      417,
      421,
      422
    ],
    "source": "316328_c28",
    "choice_e": "Start creating her program files."
  },
  {
    "id": 533,
    "question": "When setting his Git configuration options, Bruce employs the <code>\u2013\u2013global</code> option on his commands. What does this mean?",
    "choice_a": "The configuration information is stored on GitHub.",
    "choice_b": "The configuration information is stored in <code>~/.gitconfig</code>.",
    "choice_c": "The configuration information is stored in the working directory\u2019s <code>.git/config</code> file.",
    "choice_d": "The configuration information is stored in the working directory\u2019s <code>.git/index</code> file.",
    "correct_answer": "B",
    "explanation": "Since Bruce employed the <code>--global</code> option when setting his Git configuration options, the information is stored in the global <code>~/.gitconfig</code> file. Therefore, option B is the correct answer. This Git configuration information is not stored on GitHub and GitHub may not even be employed as the remote repository in this case, so option A is a wrong answer. The working directory\u2019s <code>.git/config</code> file is the local file, not the global one, so option C is a wrong choice. The <code>.git/index</code> file and the <code>.git/objects</code> directory do not store this type of data, so options D and E are incorrect choices.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      419,
      418,
      417,
      422,
      423
    ],
    "source": "316328_c28",
    "choice_e": "The configuration information is stored in the working directory\u2019s <code>.git/objects</code> directory."
  },
  {
    "id": 534,
    "question": "Bruce has set up his Git environment and finished working on his new <code>GreenMass.sh</code> script. What should he do next?",
    "choice_a": "Add the script to the staging area.",
    "choice_b": "Issue the <code>git init</code> command.",
    "choice_c": "Commit the script to the local repository.",
    "choice_d": "Issue the <code>git log</code> command.",
    "correct_answer": "A",
    "explanation": "The next step Bruce should take is to add his new script to the staging area (index) via the <code>git add GreenMass.sh</code> command. Therefore, option A is the correct answer. The <code>git init</code> command is used to initialize the <code>.git/</code> directory in the working directory and is part of setting up the Git environment, so option B is a wrong answer. The script cannot yet be committed to the local repository because it has not been added to the staging area. Thus, option C is an incorrect choice. The <code>git log</code> command shows the commit history and is not appropriate at this point, so option D is a wrong answer. The script cannot be committed to the remote repository until it is committed to the local repository. Therefore, option E is an incorrect choice.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      421,
      420,
      417,
      422,
      419
    ],
    "source": "316328_c28",
    "choice_e": "Commit the script to the remote repository."
  },
  {
    "id": 535,
    "question": "There are 25 files in Natasha\u2019s working directory and she only wants to add 22 of them to the index. She plans on using the <code>git add .</code> command to be efficient. What should she do?",
    "choice_a": "Move the three files out of her working directory.",
    "choice_b": "Add the 22 files individually via the <code>git add</code> command.",
    "choice_c": "Create a new working directory for the three files.",
    "choice_d": "Add the three files\u2019 names to a <code>.gitignore</code> file.",
    "correct_answer": "D",
    "explanation": "Natasha is being efficient by employing the <code>git add .</code> command, which will add all the files within the working directory to the staging area (index). To stay efficient, she should create a <code>.gitignore</code> file in the working directory and add the names of the three files that she wishes to keep out of the index to that file. This will prevent them from being added. Therefore, option D is the correct answer. While Natasha could move the three files out of her working directory, that is a sloppy and inefficient choice, so option A is a wrong answer. She also could add the 22 files individually to the index, but that too is very inefficient, as is creating a new working directory for the three files. Thus, options B and C are incorrect answers. Temporarily deleting the three files would force Natasha to re-create them after the other files are added to the index. This too is sloppy, and therefore option E is an incorrect choice.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      421,
      417,
      420,
      422,
      423
    ],
    "source": "316328_c28",
    "choice_e": "Temporarily delete the three files."
  },
  {
    "id": 536,
    "question": "Natasha has completed her open source project, which is set to be released to the public today. She has moved the files to the staging area, committed her work to the local repository, and configured the remote repository\u2019s address. What is her next step?",
    "choice_a": "Go home and relax. She deserves it.",
    "choice_b": "Clone the remote repository to her local system.",
    "choice_c": "Push her project to the remote repository.",
    "choice_d": "Pull her project from the remote repository.",
    "correct_answer": "C",
    "explanation": "Natasha is ready to push her project to the remote repository, so option C is the correct answer. While she may go home and relax later, if the project is released to the public, she must upload it to the remote repository first. Therefore, option A is a wrong answer. Cloning a remote repository is done when someone wants all the project files as well as the VCS history. In this scenario, Natasha already has that data, so option B is a wrong choice. Since the project is complete, there is no need to pull down any files from the remote repository. Therefore, option D is also an incorrect answer. The <code>remote add origin <i>URL</i></code> command is used to configure the remote repository\u2019s address (URL), which Natasha has already accomplished. Thus, option E is an incorrect choice.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      423,
      420,
      422,
      419,
      424
    ],
    "source": "316328_c28",
    "choice_e": "Use the <code>remote add origin <i>URL</i></code> command."
  },
  {
    "id": 537,
    "question": "Which of the following commands allows you to switch to a new Git branch called <code>testing</code>?",
    "choice_a": "<code>git branch testing</code>",
    "choice_b": "<code>git ls-tree \u2013\u2013name-only -r testing</code>",
    "choice_c": "<code>git branch</code>",
    "choice_d": "<code>git commit -m \"testing\"</code>",
    "correct_answer": "E",
    "explanation": "The <code>git checkout testing</code> command will allow you to switch to a new Git branch called <code>testing</code>. Thus, option E is the correct answer. The <code>git branch testing</code> command creates a new branch called <code>testing</code> instead of switching to it. Thus, option A is a wrong answer. The command in option B allows you to view any files\u2019 names managed by the <code>testing</code> branch, so it is an incorrect answer. The <code>git branch</code> command shows you the current branches within this project and designates which one is current via an asterisk, but it does not allow you to switch branches. Thus, option C is an incorrect answer. The command in option D will perform a commit to the local repository and add a comment of <code>testing</code> to the log file. Therefore, option D is also an incorrect choice.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      427,
      428,
      426,
      425,
      419
    ],
    "source": "316328_c28",
    "choice_e": "<code>git checkout testing</code>"
  },
  {
    "id": 538,
    "question": "Tony created a new branch of the StoneTracker project called <code>report</code>. He has completed and tested his work. He now needs to merge it with the StoneTracker project\u2019s <code>master</code> branch. After switching branches to the <code>master</code> branch, what command should he employ?",
    "choice_a": "<code>git merge master</code>",
    "choice_b": "<code>git merge report</code>",
    "choice_c": "<code>git rebase master</code>",
    "choice_d": "<code>git rebase report</code>",
    "correct_answer": "B",
    "explanation": "The <code>git merge report</code> command will merge the <code>report</code> branch into the <code>master</code> branch as desired, so option B is the correct answer. The <code>git merge master</code> command will attempt to merge the <code>master</code> branch into another branch, but since Tony is already in the <code>master</code> branch, this will not work (and is not desired), so option A is a wrong answer. The <code>rebase</code> arguments will attempt to perform a rebase instead of a merge. Thus, options C and D are incorrect answers. The <code>git checkout master</code> command was already used by Tony to reach the master branch, and thus option E is an incorrect choice.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      428,
      427,
      422,
      424,
      420
    ],
    "source": "316328_c28",
    "choice_e": "<code>git checkout master</code>"
  },
  {
    "id": 539,
    "question": "Which cloud service method utilizes only servers owned and operated by a third party?",
    "choice_a": "Private",
    "choice_b": "Public",
    "choice_c": "Hybrid",
    "choice_d": "Type II",
    "correct_answer": "B",
    "explanation": "Public cloud services use servers hosted by a third-party company, so option B is correct. Private cloud services use servers hosted internally by the company, not by a third party, so option A is incorrect. Hybrid cloud services use servers hosted both internally and externally, not just by a third party, so option C is incorrect. Type I and Type II are types of hypervisors and not cloud services, so options D and E are incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      430,
      429,
      432,
      437,
      441
    ],
    "source": "316328_c29",
    "choice_e": "Type I"
  },
  {
    "id": 540,
    "question": "Tom currently runs a cloud for his company on internal servers but needs some extra processing power to run a new application. What method of cloud service can he look into to leverage his existing cloud without needing to buy more internal servers?",
    "choice_a": "Private",
    "choice_b": "Public",
    "choice_c": "Hybrid",
    "choice_d": "Type I",
    "correct_answer": "C",
    "explanation": "A hybrid cloud service uses servers internal to the company as well as external at a third-party location. This provides an easy way to increase server capabilities without having to purchase your own hardware, so option C is correct. The entire private cloud is hosted internally, so Tom would need to purchase additional servers to support the application, so option A is incorrect. A public cloud is hosted in its entirety externally on a third-party network, so Tom wouldn\u2019t be able to use his current cloud servers, so option B is incorrect. Type I and Type II are types of hypervisors and not cloud services, so options D and E are incorrect.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      430,
      429,
      432,
      437,
      447
    ],
    "source": "316328_c29",
    "choice_e": "Type II"
  },
  {
    "id": 541,
    "question": "Sally is interested in developing her application in the cloud without having to worry about administering an operating system. What type of cloud service should she buy?",
    "choice_a": "PaaS",
    "choice_b": "Private cloud",
    "choice_c": "IaaS",
    "choice_d": "SaaS",
    "correct_answer": "A",
    "explanation": "The platform as a service (PaaS) cloud type provides a complete development environment for customers, so option A is correct. The private and hybrid clouds are methods of implementing a cloud and not types of clouds, so options B and E are incorrect. The infrastructure as a service (IaaS) cloud type provides only hardware to build an operating system, so Sally would need more to develop her applications, making option C incorrect. The software as a service (SaaS) cloud type provides the full application\u2014it doesn\u2019t allow you to develop your own applications\u2014so option D is incorrect.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      429,
      430,
      9,
      8,
      437
    ],
    "source": "316328_c29",
    "choice_e": "Hybrid cloud"
  },
  {
    "id": 542,
    "question": "Which type of cloud service allows you to spin up your own operating systems on infrastructure provided by the cloud?",
    "choice_a": "PaaS",
    "choice_b": "Private cloud",
    "choice_c": "IaaS",
    "choice_d": "SaaS",
    "correct_answer": "C",
    "explanation": "The infrastructure as a service (IaaS) cloud type allows you to install your own operating systems on the cloud hardware, so option C is correct. The private and hybrid clouds are methods of implementing clouds and not cloud types, so options B and E are incorrect. The platform as a service (PaaS) and software as a service (SaaS) cloud types provide the operating system, so you can\u2019t install your own, making options A and D incorrect.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      429,
      430,
      441,
      9,
      447
    ],
    "source": "316328_c29",
    "choice_e": "Hybrid cloud"
  },
  {
    "id": 543,
    "question": "Which type of hypervisor interfaces directly with the host system hardware?",
    "choice_a": "Private",
    "choice_b": "Public",
    "choice_c": "Type II",
    "choice_d": "Type I",
    "correct_answer": "D",
    "explanation": "Type I hypervisors interface directly with the system hardware and act as an intermediary controlling resources for the guest virtual machines, making option D correct. Type II hypervisors run on top of a host operating system and don\u2019t directly interface with the system hardware, so option C is incorrect. Private, public, and hybrid are methods for implementing cloud services and not hypervisors, so options A, B, and E are all incorrect.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      7,
      436,
      437,
      441,
      343
    ],
    "source": "316328_c29",
    "choice_e": "Hybrid"
  },
  {
    "id": 544,
    "question": "Henry already has installed Red Hat Linux on his server but now needs to install virtual machines. What type of hypervisor package should he use?",
    "choice_a": "Private",
    "choice_b": "Public",
    "choice_c": "Type II",
    "choice_d": "Type I",
    "correct_answer": "C",
    "explanation": "Type II hypervisors install on a host operating system and receive resources from the host operating system, so option C is correct. Type I hypervisors install directly on the server hardware without a host operating system, so option D is incorrect. Private, public, and hybrid are methods of implementing cloud services and not types of hypervisors, so options A, B, and E are all incorrect.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      7,
      436,
      432,
      12,
      446
    ],
    "source": "316328_c29",
    "choice_e": "Hybrid"
  },
  {
    "id": 545,
    "question": "Which type of hypervisor template bundles all of the configuration files into a single file for distribution?",
    "choice_a": "XML",
    "choice_b": "JSON",
    "choice_c": "OVA",
    "choice_d": "OVF",
    "correct_answer": "C",
    "explanation": "The Open Virtualization Appliance (OVA) file format bundles all of the virtual machine configuration files into a single <code>tar</code> file for distribution, so option C is correct. The Open Virtualization Format (OVF) format defines several separate files for storing configuration values, not a single file, so option D is incorrect. XML, JSON, and YAML are all configuration file formats and not methods to bundle the configuration files, so options A, B, and E are all incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      431,
      441,
      440,
      438,
      193
    ],
    "source": "316328_c29",
    "choice_e": "YAML"
  },
  {
    "id": 546,
    "question": "Fred wants to package his application so that it\u2019s guaranteed to run the same way no matter what Linux distribution his customers use. How can he do this?",
    "choice_a": "Package the application as a container.",
    "choice_b": "Package the application as a hypervisor.",
    "choice_c": "Deploy the application to a private cloud.",
    "choice_d": "Deploy the application as a virtual machine.",
    "correct_answer": "A",
    "explanation": "Containers bundle the application runtime files along with any library files required to run the application. This ensures that the application will run in any environment, so option A is correct. A hypervisor manages virtual machines on a system and doesn\u2019t deploy applications, so option B is incorrect. Deploying the application into a private cloud would make the application available to Fred\u2019s internal network, but customers outside of his network wouldn\u2019t be able to run the application, so option C is incorrect. Deploying the application as a virtual machine would make the application run consistently but would also require each customer to install the same hypervisor package on their operating system, so option D is incorrect. Bundling the application files as a <code>tar</code> file doesn\u2019t ensure that the required system library will be present on all of the customer workstations, so option E is incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      433,
      38,
      435,
      208,
      210
    ],
    "source": "316328_c29",
    "choice_e": "Bundle the application as a <code>tar</code> file and deploy it."
  },
  {
    "id": 547,
    "question": "What method should you use to easily move an application from a development environment to a production environment without having to duplicate the operating system?",
    "choice_a": "Public cloud",
    "choice_b": "Private cloud",
    "choice_c": "Type I hypervisor",
    "choice_d": "Type II hypervisor",
    "correct_answer": "E",
    "explanation": "Containers include all of the files necessary to run an application, no matter what the host system, so option E is the correct answer. Public and private clouds don\u2019t guarantee the same development and production environments directly, so options A and B are both incorrect. Type I and Type II hypervisors don\u2019t host applications directly but need a virtual machine, so options C and D are both incorrect.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      433,
      38,
      434,
      37,
      103
    ],
    "source": "316328_c29",
    "choice_e": "Container"
  },
  {
    "id": 548,
    "question": "Which Linux container package runs an engine as a process on the host operating system and provides a command-line interface to control containers?",
    "choice_a": "Snap",
    "choice_b": "Docker",
    "choice_c": "KVM",
    "choice_d": "XEN",
    "correct_answer": "B",
    "explanation": "The Docker container package runs as a process on the host operating system and provides a command-line interface for controlling containers, so option B is correct. The Snap package provides software application containers, but doesn\u2019t provide a command-line interface to control them, so option A is incorrect. The KVM, XEN, and VirtualBox packages are all hypervisor packages, not containers, so options C, D, and E are all incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      435,
      434,
      433,
      208,
      209
    ],
    "source": "316328_c29",
    "choice_e": "VirtualBox"
  },
  {
    "id": 549,
    "question": "Which of the following is true concerning the <code>libvirt</code> library software collection? (Choose all that apply.)",
    "choice_a": "Provides an API library for hypervisors",
    "choice_b": "Provides a complete hypervisor (VMM) application",
    "choice_c": "Provides the <code>virsh</code> and <code>virsh-install</code> utilities",
    "choice_d": "Provides the anaconda file used for bootstrapping",
    "correct_answer": [
      "A",
      "C",
      "E"
    ],
    "explanation": "Options A, C, and E all contain true statements concerning the <code>libvert</code> library software collection and are therefore correct answers. This software collection does not provide a complete hypervisor application (though many hypervisors incorporate it), so option B is a wrong answer. Also the <code>libvert</code> library does not provide an anaconda file. Thus, option D is also an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      436,
      437,
      441,
      8,
      7
    ],
    "source": "316328_c30",
    "choice_e": "Provides the <code>libvirtd</code> daemon for host systems"
  },
  {
    "id": 550,
    "question": "Carol wants to automate the management of her virtual machines via a Bash shell script. Which of the following utilities can she use in this script? (Choose all that apply.)",
    "choice_a": "<code>virsh</code>",
    "choice_b": "<code>virtinst</code>",
    "choice_c": "<code>virt-manage</code>",
    "choice_d": "<code>virt-install</code>",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "The <code>virsh</code> and <code>virt-install</code> utilities are ones that Carol can incorporate into her Bash shell script for managing her virtual machines. Therefore, options A and D are correct answers. The <code>virtinst</code> is the name of a package file, which provides utilities such as <code>virsh</code>, and thus, option B is a wrong answer. The <code>virt-manage</code> is a made-up utility. Therefore, option C is also an incorrect answer. The <code>setvcpus</code> is an argument you can use with the <code>virsh</code> utility, as opposed to a utility itself, so option E is an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      436,
      437,
      441,
      432,
      16
    ],
    "source": "316328_c30",
    "choice_e": "<code>setvcpus</code>"
  },
  {
    "id": 551,
    "question": "Nick is setting up a bootstrapping process on a RHEL system. He needs to store the installation tree. Which of the following are locations where he could store it? (Choose all that apply.)",
    "choice_a": "Network location",
    "choice_b": "USB flash drive",
    "choice_c": "On AutoYaST",
    "choice_d": "Within the preseed directory",
    "correct_answer": [
      "A",
      "B",
      "E"
    ],
    "explanation": "The question does not indicate whether this system will be a virtual one or not. Typically for a physical installation, using the kickstart method, the installation tree is stored in a network location or removable media, such as a USB flash drive. Therefore, options A and B are correct answers. For a virtual machine installation, often the installation tree (or ISO) is stored alongside the kickstart file. Thus, option E is also a correct choice. AutoYaST and preseed are alternatives to kickstart for the openSUSE and Ubuntu distributions, so options C and D are incorrect choices.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      381,
      382,
      383,
      385,
      388
    ],
    "source": "316328_c30",
    "choice_e": "With the kickstart file"
  },
  {
    "id": 552,
    "question": "Which of the following is true concerning the cloud-init product? (Choose all that apply.)",
    "choice_a": "It was created and maintained by Microsoft.",
    "choice_b": "It is usable by cloud-based virtualization services.",
    "choice_c": "It is usable by cloud-based management operating systems.",
    "choice_d": "It is supported by most major Linux distributions.",
    "correct_answer": [
      "B",
      "C",
      "D",
      "E"
    ],
    "explanation": "The statements in options B, C, D, and E are true concerning the cloud-init application and thus are correct options. The only untrue is statement is in option A. The cloud-init product was created and is maintained by Canonical.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      417,
      420,
      421,
      423,
      425
    ],
    "source": "316328_c30",
    "choice_e": "It is a bootstrap product."
  },
  {
    "id": 553,
    "question": "Ms. Danvers is designing a set of virtual machines for her company, Miracle. Currently, her host machine uses LVM but only has enough disk space for 1 TB of data. Her three VMs will need 200 GB of disk space immediately but are projected to grow to 300 GB each within the next year. What should she do?",
    "choice_a": "Configure the three VMs to use persistent storage.",
    "choice_b": "Configure the three VMs to use temporary storage.",
    "choice_c": "Configure the three VMs to use thick provisioned storage.",
    "choice_d": "Configure the three VMs to use thin provisioned storage.",
    "correct_answer": "D",
    "explanation": "Ms. Danvers\u2019 best choice is to configure the three virtual machines to use thin provisioned storage. This method will allow the VMs to immediately consume 600 GB of the 1 TB of host disk space and grow over time as needed (which is called overprovisioning). As the VMs\u2019 data grows, she can purchase additional disk space for her host machine and add it to the logical volume. Thus, option D is the correct answer. There is not enough information provided to determine whether or not the virtual machines\u2019 disks should be configured as permanent or temporary, so options A and B are wrong answers. Thick provisioning would cause the three virtual machines to allocate 1.2TB of disk space, which is not available, and thus, option C is an incorrect answer. Blob storage is used on Microsoft Azure virtual machines, and the question does not indicate that this is the cloud provider environment Ms. Danvers is using. Thus, option E is an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      443,
      175,
      432,
      444,
      437
    ],
    "source": "316328_c30",
    "choice_e": "Configure the three VMs to use blob storage."
  },
  {
    "id": 554,
    "question": "Mr. Fury is a programming professor at Galactic University. This next semester he has chosen to use virtual machines for his students\u2019 labs. The students will be creating a single program that they work on throughout the entire semester. What is the best choice of disk storage for Mr. Fury\u2019s student virtual machines?",
    "choice_a": "Persistent storage",
    "choice_b": "Temporary storage",
    "choice_c": "Thick provisioned storage",
    "choice_d": "Thin provisioned storage",
    "correct_answer": "A",
    "explanation": "Because Mr. Fury\u2019s programming students will be creating a single program that they are working on for the entire semester, the virtual machine storage needs to be configured as persistent. This will allow the students to access and modify their program on the virtual machine without having to re-create it each time their VM boots. Thus, option A is the correct choice. If Mr. Fury uses temporary storage, the students would have to re-create their program each time the VM boots, so option B is a wrong answer. Thickly or thinly provisioned storage needs are not discussed in this question, so options C and D are also incorrect answers. Blob storage is used on Microsoft Azure virtual machines, and the question does not indicate that this is the cloud provider environment Mr. Fury is using. Therefore, option E is an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      444,
      443,
      8,
      436,
      441
    ],
    "source": "316328_c30",
    "choice_e": "Blob block storage"
  },
  {
    "id": 555,
    "question": "Which of the following is true about an overlay network? (Choose all that apply.)",
    "choice_a": "It is a storage virtualization method.",
    "choice_b": "It is a network virtualization method.",
    "choice_c": "It is a method that employs encapsulation.",
    "choice_d": "It is a method that employs bandwidth tunneling.",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "Overlay networking is a network virtualization method that employs encapsulation as well as channel bandwidth tunneling. Therefore, options B, C, and D are correct answers. It is not a storage virtualization method, so option A is a wrong answer. Also, it does not employ page blobs (which are a Microsoft Azure platform storage option), so option E is also an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      447,
      429,
      432,
      444,
      441
    ],
    "source": "316328_c30",
    "choice_e": "It is a method that employs page blobs."
  },
  {
    "id": 556,
    "question": "Carol needs her virtual machines to all act as nodes on her host machine\u2019s LAN and get their own IP address that they will use to send/receive network traffic. Which virtual NIC type should she configure on them?",
    "choice_a": "Host-only",
    "choice_b": "Bridged",
    "choice_c": "NAT",
    "choice_d": "Multihomed",
    "correct_answer": "B",
    "explanation": "In order for Carol\u2019s virtual machines to all act as nodes on her host machine\u2019s LAN and get their own IP address that they will use to send/receive network traffic, she needs to configure them as bridged adapters. Thus, option B is the correct answer. A host-only configured NIC will not be able to communicate on the external network, so option A is a wrong answer. A NAT adapter will not allow the VMs to each operate as a node on the host machine\u2019s network, so option C is a wrong choice. Multihomed and dual-homed are descriptions of the number of NICS employed by a VM, so options D and E are incorrect choices.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      446,
      106,
      114,
      104,
      8
    ],
    "source": "316328_c30",
    "choice_e": "Dual-homed"
  },
  {
    "id": 557,
    "question": "Ms. Danvers wants her three virtual machines\u2019 IP address to be kept private, but she also wants them to communicate on the host machine\u2019s network using its IP address. Which virtual NIC type should she configure on them?",
    "choice_a": "Host-only",
    "choice_b": "Bridged",
    "choice_c": "NAT",
    "choice_d": "Multihomed",
    "correct_answer": "C",
    "explanation": "A virtual machine with a NAT configured adapter will have its IP address kept private and use the host machine\u2019s IP address to communicate on the host machine\u2019s network. Thus, option C is the correct answer. A host-only configured NIC will not be able to communicate on the external network, so option A is a wrong answer. A bridged adapter will not keep its assigned IP address private, so option B is also an incorrect answer. Multihomed and dual-homed are descriptions of the number of NICS employed by a VM, so options D and E are incorrect choices.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      446,
      8,
      437,
      441,
      431
    ],
    "source": "316328_c30",
    "choice_e": "Dual-homed"
  },
  {
    "id": 558,
    "question": "Nick has created five virtual machines on his host system. One virtual machine is employed as a firewall for the other four machines, which are confined with host-only adapters. The firewall VM operates on the host system\u2019s network as a node. Which of the following describe his firewall adapter configuration. (Choose all that apply.)",
    "choice_a": "Host-only",
    "choice_b": "Bridged",
    "choice_c": "NAT",
    "choice_d": "Multihomed",
    "correct_answer": [
      "A",
      "B",
      "E"
    ],
    "explanation": "For Nick\u2019s firewall VM to act as a firewall to the other four virtual machines, it would need both a host-only adapter to communicate with the other machines on the local internal network. The firewall VM would also need a bridged NIC to act as a node on the host machines network. Because this firewall VM has two virtual NICs, it is considered to be dual-homed. Thus, options A, B, and E are correct choices. The NAT configuration type is not needed or employed in this scenario, so option C is a wrong answer. Also, since there are no more than two virtual adapters needed, it is not a multihomed (more than two) configuration, and option D is an incorrect choice.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      448,
      446,
      436,
      8,
      432
    ],
    "source": "316328_c30",
    "choice_e": "Dual-homed"
  },
  {
    "id": 559,
    "question": "Which of the following can use orchestration? (Choose all that apply.)",
    "choice_a": "Software development",
    "choice_b": "Music production",
    "choice_c": "Server monitoring",
    "choice_d": "DevOps",
    "correct_answer": [
      "A",
      "B",
      "C",
      "D",
      "E"
    ],
    "explanation": "All these choices contain items that can use orchestration and are correct choices. Since orchestration refers to the organization of a process that is balanced and coordinated and achieves consistency in the results, there are not many things that cannot use orchestration. An exception would be a situation where you are trying to simulate random chaos.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      460,
      453,
      456,
      457,
      462
    ],
    "source": "316328_c31",
    "choice_e": "Containers"
  },
  {
    "id": 560,
    "question": "Connie, the tech ops lead, provides the development team with a development environment that currently matches the production environment. She insists that besides the app modifications, the environment should not change. What attribute should this development environment have to meet Connie\u2019s requirement?",
    "choice_a": "Self-replicating",
    "choice_b": "Immutable",
    "choice_c": "Kubernetes",
    "choice_d": "Infrastructure as code",
    "correct_answer": "B",
    "explanation": "To meet Connie\u2019s requirement, the development environment must be immutable (not modifiable). Therefore, option B is the correct answer. Self-replication will not assist in reaching Connie\u2019s requirement for an unchanging environment, so option A is a wrong answer. Kubernetes is an orchestration engine, not an attribute, so option C is also an incorrect choice. Infrastructure as code does not provide an unchanging environment, so option D is a wrong answer. In orchestration, self-healing refers to a different issue than an unchanging environment, so option E is also an incorrect choice.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      456,
      451,
      450,
      457,
      460
    ],
    "source": "316328_c31",
    "choice_e": "Self-healing"
  },
  {
    "id": 561,
    "question": "Bill, the software development team leader, understands Connie\u2019s (tech ops lead) desire for a static and matching development environment. However, since they are employing containers, Bill suggests a better improvement. Which of the following should he suggest?",
    "choice_a": "Modify the production container so it matches the development container when the app is ready for production.",
    "choice_b": "Move the app from the development container to the production container when the app is ready for production.",
    "choice_c": "Stop any software updates on the development container from occurring before the app is ready for production.",
    "choice_d": "Replace the production container with the development container when the app is ready for production.",
    "correct_answer": "D",
    "explanation": "With container orchestration and DevOps, to keep the production and development environment matching so that problems do not occur when an app is moved into production, you simply replace the old production environment with the development environment. In the case of containers, this means you stop the old production container and start the new development container as the production container in its place. Thus, option D is the correct answer and follows the \u201creplace, not update\u201d attribute. While the answer in option A would work, it is terribly tedious, time-consuming, and full of potential problems. Therefore, it is a wrong answer. The answer in option B is the old-school method of moving an app into production, and it does not meet Connie\u2019s desire for a static and matching environment. Thus, it is also an incorrect answer. If before the app is ready for production, you stop any software updates on the development container from occurring, that does not make the development environment match the production environment alone. Thus, option C is a wrong choice. Option E also would work but is even more tedious and full of potential problems than the answer in option A. Therefore, it too is an incorrect choice.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      452,
      451,
      457,
      455,
      450
    ],
    "source": "316328_c31",
    "choice_e": "Remove any updates on the development container that are not on the production container when the app is ready for production."
  },
  {
    "id": 562,
    "question": "Which of the following orchestrated container attributes best provides high availability to an app user?",
    "choice_a": "Immutability",
    "choice_b": "Version control",
    "choice_c": "Replication",
    "choice_d": "Automation",
    "correct_answer": "C",
    "explanation": "Replication allows an orchestrated container to be built and deployed in multiple copies automatically. This provides high availability when a container crashes as well as when a new app container is being deployed. Therefore, option C is the correct answer. Immutability prevents environment issues from causing application problems, but it is not the best proponent of high availability, and thus, option A is a wrong answer. Version control allows you to roll back and troubleshoot problems in a production environment, which does help provide higher availability, but again it\u2019s not the best attribute toward doing so. Therefore, option B is also an incorrect answer. Option D provides speed in the orchestrated environment, which also helps provide high availability to an app user, but it too is not the best advocate. Thus, option D is also a wrong answer. While documentation helps in the troubleshooting process and slightly contributes to higher availability, it is not the best either. Therefore, option E is also an incorrect choice.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      452,
      457,
      460,
      451,
      456
    ],
    "source": "316328_c31",
    "choice_e": "Documentation"
  },
  {
    "id": 563,
    "question": "In DevOps and container orchestration, non-hardware items such as the operating system and libraries and security policies are documented within the orchestration tool, implemented into the desired environment, and are called what?",
    "choice_a": "Marathon",
    "choice_b": "Build automation",
    "choice_c": "A development environment",
    "choice_d": "A container",
    "correct_answer": "E",
    "explanation": "<i>Infrastructure as code</i> is an umbrella term that encompasses both the configuration management settings (operating system, libraries, additional software) and the policy as code items (security policies, authentication settings). Thus, option E is the correct choice. Marathon is the orchestration tool used with the Mesos application. Therefore, option A is a wrong answer. Build automation uses infrastructure as code. Thus, option B is an incorrect answer. A development environment can be built using infrastructure as a code. Therefore, option C is also a wrong answer. A container also can be built using infrastructure as a code but is not the code itself, so option D is an incorrect choice too.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      456,
      450,
      458,
      461,
      460
    ],
    "source": "316328_c31",
    "choice_e": "Infrastructure as code"
  },
  {
    "id": 564,
    "question": "Ms. Ward needs to move an app container into production. She employs an orchestration tool, which uses the predefined infrastructure as code to deploy and replicate the needed production container images. What orchestration concept did Ms. Ward use?",
    "choice_a": "Monitoring",
    "choice_b": "Build automation",
    "choice_c": "Replication",
    "choice_d": "Version control",
    "correct_answer": "B",
    "explanation": "Ms. Ward is using build automation. Thus, option B is the correct answer. Monitoring comes after containers are deployed, so option A is a wrong answer. Replication is part of the process Ms. Ward used, but it does not describe the container deployment, so option C is not the best answer and is an incorrect choice. Version control was hopefully used by Ms. Ward so she can roll back or troubleshoot her application, if needed, but option D is not a correct answer. Docker Swarm is an orchestration system, and thus, option E is also an incorrect answer.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      458,
      456,
      453,
      457,
      460
    ],
    "source": "316328_c31",
    "choice_e": "Docker Swarm"
  },
  {
    "id": 565,
    "question": "Which of the following is a benefit of automated configuration management in container orchestration? (Choose all that apply.)",
    "choice_a": "Containers can be deployed automatically.",
    "choice_b": "Containers can be replicated automatically.",
    "choice_c": "Troubleshooting infrastructure issues is easier.",
    "choice_d": "Continuous software delivery is enabled.",
    "correct_answer": [
      "A",
      "B",
      "C",
      "E"
    ],
    "explanation": "In container orchestration, automated configuration management allows containers to be deployed and replicated automatically (build automation). Also, troubleshooting infrastructure issues is easier because the modifications are tracked in a version control system. Thus, options A, B, C, and E are all correct answers. While automated configuration management and orchestrated containers may be part of continuous software delivery, they are not directly related. Therefore, option D is the only incorrect choice.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      458,
      456,
      457,
      451,
      460
    ],
    "source": "316328_c31",
    "choice_e": "Infrastructure modifications are tracked."
  },
  {
    "id": 566,
    "question": "Mr. Abbot is recording requirements for the new orchestration tool. He needs the tool to automatically deploy and replicate any containers that have crashed. What is this called?",
    "choice_a": "Self-healing",
    "choice_b": "Build automation",
    "choice_c": "Continuous integration",
    "choice_d": "Infrastructure as code",
    "correct_answer": "A",
    "explanation": "Mr. Abbot needs an orchestration tool that can perform self-healing. Therefore, option A is the correct answer. Build automation may be involved in self-healing, but it does not describe the ability to deploy and replicate containers after they have crashed. Thus, option B is a wrong answer. Continuous integration is a DevOps software revision control method that encourages quickly integrating app changes into the main branch. Therefore, option C is an incorrect answer. Infrastructure as code may be employed by build automation but does not describe the ability to self-heal. Thus, option D is wrong choice. Pods are a component of the Kubernetes orchestration engine. Thus, option E is also an incorrect answer.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      460,
      453,
      457,
      458,
      452
    ],
    "source": "316328_c31",
    "choice_e": "Pod builds"
  },
  {
    "id": 567,
    "question": "Which of the following are items that may be collected, used, or watched by an orchestration monitoring tool? (Choose all that apply.)",
    "choice_a": "Version control errors",
    "choice_b": "App container performance",
    "choice_c": "App metrics",
    "choice_d": "App container health",
    "correct_answer": [
      "B",
      "C",
      "D",
      "E"
    ],
    "explanation": "App container performance, metrics, container health, and default states are all collected, watched, or used by an orchestration monitoring tool. Therefore, options B, C, D, and E are all correct answers. Option A is the only incorrect choice because the version control system is not used or watched by an orchestration monitoring utility.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      459,
      460,
      454,
      462,
      461
    ],
    "source": "316328_c31",
    "choice_e": "Default states"
  },
  {
    "id": 568,
    "question": "Connie has picked an agentless orchestration monitoring utility for her app containers. Which of the following reasons might she have used in reaching this decision? (Choose all that apply.)",
    "choice_a": "Connie wanted monitoring software installed on each app container.",
    "choice_b": "She did not want monitoring software installed on each app container.",
    "choice_c": "Connie was concerned about container performance being adversely affected by the monitoring software.",
    "choice_d": "She was not concerned about container performance being adversely affected by the monitoring software.",
    "correct_answer": [
      "B",
      "C",
      "D",
      "E"
    ],
    "explanation": "App container performance, metrics, container health, and default states are all collected, watched, or used by an orchestration monitoring tool. Therefore, options B, C, D, and E are all correct answers. Option A is the only incorrect choice because the version control system is not used or watched by an orchestration monitoring utility.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      459,
      454,
      460,
      462,
      458
    ],
    "source": "316328_c31",
    "choice_e": "Connie wanted to use what most companies use for orchestration monitoring."
  }
];
